import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
  JSONString: { input: string; output: string; }
  Time: { input: any; output: any; }
  UUID: { input: string; output: string; }
};

export type AcceptApplication = {
  readonly __typename?: 'AcceptApplication';
  readonly application?: Maybe<ApplicationNode>;
};

export type AcceptMessageSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type AcceptMessageSuggestionPayload = {
  readonly __typename?: 'AcceptMessageSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type AcceptServiceChargeWaiverInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly serviceChargeWaiverAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AcceptServiceChargeWaiverPayload = {
  readonly __typename?: 'AcceptServiceChargeWaiverPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly leaseholder?: Maybe<LeaseholderNode>;
};

export type AcceptTermsAndConditionsInput = {
  readonly acceptedAt: Scalars['DateTime']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptTermsAndConditionsPayload = {
  readonly __typename?: 'AcceptTermsAndConditionsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountTransactionNode = {
  readonly __typename?: 'AccountTransactionNode';
  readonly account?: Maybe<PaymentAccountNode>;
  readonly amount: Scalars['BigInt']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly status: PaymentsPaymentStatusChoices;
};

export type AccountTransactionNodeConnection = {
  readonly __typename?: 'AccountTransactionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AccountTransactionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AccountTransactionNode` and its cursor. */
export type AccountTransactionNodeEdge = {
  readonly __typename?: 'AccountTransactionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AccountTransactionNode>;
};

export type ActionObject = AmenityReservationNode | ApplicationNode | CommunityProductPurchaseNode | CommunityUpdateCommentNode | KeyholderNode;

export type ActivateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateGroupPayload = {
  readonly __typename?: 'ActivateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type Actor = ApplicantNode | ConciergeNode | ResidentNode | TenancyApplicantNode | UserType;

export type AddApplicationCommunity = {
  readonly __typename?: 'AddApplicationCommunity';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddApplicationHome = {
  readonly __typename?: 'AddApplicationHome';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddApplicationOwnershipType = {
  readonly __typename?: 'AddApplicationOwnershipType';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddDocumentSentStatus = {
  readonly __typename?: 'AddDocumentSentStatus';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddFeatureToClientInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureNames: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type AddFeatureToClientPayload = {
  readonly __typename?: 'AddFeatureToClientPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AddMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
};

export type AddMemberPayload = {
  readonly __typename?: 'AddMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type AddPackageToHomeInput = {
  readonly addressee?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home: Scalars['UUID']['input'];
  readonly manualHomeSearchQuery?: InputMaybe<Scalars['String']['input']>;
  readonly scanOutput?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddPackageToHomePayload = {
  readonly __typename?: 'AddPackageToHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly package?: Maybe<PackageNode>;
};

export type AddUnknownCommunityStatus = {
  readonly __typename?: 'AddUnknownCommunityStatus';
  readonly application?: Maybe<ApplicationNode>;
};

export type AgreementSignatureNode = {
  readonly __typename?: 'AgreementSignatureNode';
  readonly agreement: GeneratedAgreementNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly signatureType: AstGeneratorAgreementSignatureSignatureTypeChoices;
  readonly signedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status: AstGeneratorAgreementSignatureStatusChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type AgreementSignatureNodeConnection = {
  readonly __typename?: 'AgreementSignatureNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AgreementSignatureNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AgreementSignatureNode` and its cursor. */
export type AgreementSignatureNodeEdge = {
  readonly __typename?: 'AgreementSignatureNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AgreementSignatureNode>;
};

export type AgreementSignatureOutput = {
  readonly __typename?: 'AgreementSignatureOutput';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
};

export type AgreementSignaturesTenant = {
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type AgreementTenantNode = {
  readonly __typename?: 'AgreementTenantNode';
  readonly agreement: GeneratedAgreementNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type AgreementTenantNodeConnection = {
  readonly __typename?: 'AgreementTenantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AgreementTenantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AgreementTenantNode` and its cursor. */
export type AgreementTenantNodeEdge = {
  readonly __typename?: 'AgreementTenantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AgreementTenantNode>;
};

export type AmenityNode = {
  readonly __typename?: 'AmenityNode';
  readonly communities?: Maybe<ReadonlyArray<Maybe<CommunityNode>>>;
  readonly community?: Maybe<CommunityNode>;
  readonly daysAvailable: ReadonlyArray<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly endTime: Scalars['DateTime']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isCurrentlyReservable: Scalars['Boolean']['output'];
  readonly live: Scalars['Boolean']['output'];
  readonly maxAdvanceReservationDays: Scalars['Int']['output'];
  readonly maxCapacity?: Maybe<Scalars['Int']['output']>;
  readonly maxHours?: Maybe<Scalars['Int']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reservable: Scalars['Boolean']['output'];
  readonly reservations: AmenityReservationNodeConnection;
  readonly startTime: Scalars['DateTime']['output'];
  readonly status: AmenityStatusEnum;
  readonly unpaginatedReservations?: Maybe<AmenityReservationNodeConnection>;
};


export type AmenityNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AmenityNodeReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type AmenityNodeUnpaginatedReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type AmenityNodeConnection = {
  readonly __typename?: 'AmenityNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityNode` and its cursor. */
export type AmenityNodeEdge = {
  readonly __typename?: 'AmenityNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityNode>;
};

export type AmenityReservationNode = {
  readonly __typename?: 'AmenityReservationNode';
  readonly amenity?: Maybe<AmenityNode>;
  readonly cancellationMessage?: Maybe<Scalars['String']['output']>;
  readonly end: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isManager: Scalars['Boolean']['output'];
  readonly isMine?: Maybe<Scalars['Boolean']['output']>;
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly start: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type AmenityReservationNodeConnection = {
  readonly __typename?: 'AmenityReservationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityReservationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityReservationNode` and its cursor. */
export type AmenityReservationNodeEdge = {
  readonly __typename?: 'AmenityReservationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityReservationNode>;
};

/** An enumeration. */
export enum AmenityStatusEnum {
  Available = 'Available',
  Bookable = 'Bookable',
  NotAvailable = 'NotAvailable'
}

export type ApplicantNode = {
  readonly __typename?: 'ApplicantNode';
  readonly applications: ApplicationNodeConnection;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};


export type ApplicantNodeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type Applicants = {
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationAttemptNode = {
  readonly __typename?: 'ApplicationAttemptNode';
  readonly application: ApplicationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly proofOfAddress?: Maybe<Scalars['String']['output']>;
  readonly rejectedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly rejectionReason?: Maybe<Scalars['String']['output']>;
  readonly reviewer?: Maybe<ManagerType>;
};

export type ApplicationAttemptNodeConnection = {
  readonly __typename?: 'ApplicationAttemptNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationAttemptNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationAttemptNode` and its cursor. */
export type ApplicationAttemptNodeEdge = {
  readonly __typename?: 'ApplicationAttemptNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationAttemptNode>;
};

export type ApplicationHomeSearchNode = {
  readonly __typename?: 'ApplicationHomeSearchNode';
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
};

export type ApplicationHomeSearchNodeConnection = {
  readonly __typename?: 'ApplicationHomeSearchNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationHomeSearchNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationHomeSearchNode` and its cursor. */
export type ApplicationHomeSearchNodeEdge = {
  readonly __typename?: 'ApplicationHomeSearchNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationHomeSearchNode>;
};

export type ApplicationNode = {
  readonly __typename?: 'ApplicationNode';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly applicant: ApplicantNode;
  readonly applicationAttempts: ApplicationAttemptNodeConnection;
  readonly approvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly community?: Maybe<CommunityNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly findCommunities?: Maybe<CommunityNodeConnection>;
  readonly findHomes?: Maybe<ApplicationHomeSearchNodeConnection>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly isResident: Scalars['Boolean']['output'];
  readonly lastRejectionReason?: Maybe<Scalars['String']['output']>;
  readonly ownershipType?: Maybe<ResidentialManagementApplicationOwnershipTypeChoices>;
  readonly postcode: Scalars['String']['output'];
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly source: ResidentialManagementApplicationSourceChoices;
  readonly status: ResidentialManagementApplicationStatusChoices;
  readonly townOrCity?: Maybe<Scalars['String']['output']>;
};


export type ApplicationNodeApplicationAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeFindCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeFindHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationNodeConnection = {
  readonly __typename?: 'ApplicationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationNode` and its cursor. */
export type ApplicationNodeEdge = {
  readonly __typename?: 'ApplicationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationNode>;
};

export type ArchiveApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveApplicationPayload = {
  readonly __typename?: 'ArchiveApplicationPayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ArchiveKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveKeyPayload = {
  readonly __typename?: 'ArchiveKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type ArchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveKeyholderPayload = {
  readonly __typename?: 'ArchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ArchiveMarketplaceItemInput = {
  readonly archivedReason?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveMarketplaceItemPayload = {
  readonly __typename?: 'ArchiveMarketplaceItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
};

export type AssociateAgreementWithClient = {
  readonly __typename?: 'AssociateAgreementWithClient';
  readonly agreement?: Maybe<GeneratedAgreementType>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
};

export type AssociateAgreementWithClientInput = {
  readonly id: Scalars['String']['input'];
};

export type AssociateSection21WithClient = {
  readonly __typename?: 'AssociateSection21WithClient';
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly section21?: Maybe<GeneratedSection21Type>;
};

export type AssociateSection21WithClientInput = {
  readonly id: Scalars['String']['input'];
};

/** An enumeration. */
export enum AstGeneratorAgreementSignatureSignatureTypeChoices {
  /** Landlord */
  La = 'LA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum AstGeneratorAgreementSignatureStatusChoices {
  /** Signed */
  Si = 'SI',
  /** Void */
  Vo = 'VO',
  /** Waiting */
  Wa = 'WA'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementFurnishedChoices {
  /** Fully furnished */
  Ff = 'FF',
  /** Partially furnished */
  Pf = 'PF',
  /** Unfurnished */
  Uf = 'UF'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementPaymentFrequencyChoices {
  /** Monthly */
  Mo = 'MO',
  /** Weekly */
  We = 'WE'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementStatusChoices {
  /** Fully signed */
  Fs = 'FS',
  /** Generated */
  Ge = 'GE',
  /** Pending */
  Pe = 'PE',
  /** Sent for signing */
  Ss = 'SS',
  /** Tenants signed */
  Ts = 'TS'
}

export type AverageConversationRatingType = {
  readonly __typename?: 'AverageConversationRatingType';
  readonly averageRating?: Maybe<Scalars['Float']['output']>;
  readonly date?: Maybe<Scalars['Date']['output']>;
};

export type BacsPaymentType = {
  readonly __typename?: 'BACSPaymentType';
  readonly last4: Scalars['String']['output'];
  readonly sortCode: Scalars['String']['output'];
};

export type BlockComplianceRequirementItemAttachmentNode = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type BlockComplianceRequirementItemAttachmentNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementItemAttachmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementItemAttachmentNode` and its cursor. */
export type BlockComplianceRequirementItemAttachmentNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementItemAttachmentNode>;
};

export type BlockComplianceRequirementItemNode = {
  readonly __typename?: 'BlockComplianceRequirementItemNode';
  readonly attachments: BlockComplianceRequirementItemAttachmentNodeConnection;
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly expiryDate: Scalars['Date']['output'];
  readonly id: Scalars['UUID']['output'];
};


export type BlockComplianceRequirementItemNodeAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BlockComplianceRequirementItemNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockComplianceRequirementItemNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementItemNode` and its cursor. */
export type BlockComplianceRequirementItemNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementItemNode>;
};

export type BlockComplianceRequirementNode = {
  readonly __typename?: 'BlockComplianceRequirementNode';
  readonly actionDate: Scalars['Date']['output'];
  readonly block: BlockNode;
  readonly id: Scalars['UUID']['output'];
  readonly item?: Maybe<BlockComplianceRequirementItemNode>;
  readonly items: BlockComplianceRequirementItemNodeConnection;
  readonly requirement: BlocksComplianceRequirementNode;
  readonly status: BlockComplianceRequirementStatus;
};


export type BlockComplianceRequirementNodeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockComplianceRequirementNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementNode` and its cursor. */
export type BlockComplianceRequirementNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementNode>;
};

export enum BlockComplianceRequirementStatus {
  Checked = 'CHECKED',
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  Missing = 'MISSING'
}

export type BlockNode = {
  readonly __typename?: 'BlockNode';
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly community: CommunityNode;
  readonly homes: ReadonlyArray<HomeType>;
  readonly homesCount?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly shortCode?: Maybe<Scalars['String']['output']>;
};


export type BlockNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockNodeConnection = {
  readonly __typename?: 'BlockNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockNode` and its cursor. */
export type BlockNodeEdge = {
  readonly __typename?: 'BlockNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockNode>;
};

export type BlocksComplianceRequirementNode = {
  readonly __typename?: 'BlocksComplianceRequirementNode';
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly blocks: BlockNodeConnection;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly shared: Scalars['Boolean']['output'];
};


export type BlocksComplianceRequirementNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type BlocksComplianceRequirementNodeBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BookCommunityEventMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type BookCommunityEventMutationPayload = {
  readonly __typename?: 'BookCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
};

export type BookPaidCommunityEventMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type BookPaidCommunityEventMutationPayload = {
  readonly __typename?: 'BookPaidCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type CalendarLinkType = {
  readonly __typename?: 'CalendarLinkType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly lastChecked?: Maybe<Scalars['DateTime']['output']>;
  readonly manager: ManagerType;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type CancelAmenityReservationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CancelAmenityReservationPayload = {
  readonly __typename?: 'CancelAmenityReservationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type CancelPaymentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly payment: Scalars['UUID']['input'];
};

export type CancelPaymentPayload = {
  readonly __typename?: 'CancelPaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
};

export type CancelScheduledPublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CancelScheduledPublishCommunityUpdatePayload = {
  readonly __typename?: 'CancelScheduledPublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CardPaymentType = {
  readonly __typename?: 'CardPaymentType';
  readonly brand: Scalars['String']['output'];
  readonly last4: Scalars['String']['output'];
};

export type ChargeType = {
  readonly __typename?: 'ChargeType';
  readonly paymentMethodDetails: PaymentMethod;
};

export type CheckInKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckInKeyV2Payload = {
  readonly __typename?: 'CheckInKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type CheckOutKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currentKeyholder?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckOutKeyV2Payload = {
  readonly __typename?: 'CheckOutKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type ClientAdminNode = {
  readonly __typename?: 'ClientAdminNode';
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly user: UserType;
};


export type ClientAdminNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientType = {
  readonly __typename?: 'ClientType';
  readonly asanaWebFormUrl?: Maybe<Scalars['String']['output']>;
  readonly btlSubscriptionPerHomeCost?: Maybe<Scalars['Float']['output']>;
  readonly btlSubscriptionTotalCost?: Maybe<Scalars['Float']['output']>;
  readonly buttonColor?: Maybe<Scalars['String']['output']>;
  readonly clientType: PeopleClientClientTypeChoices;
  readonly emergencyNumber?: Maybe<Scalars['String']['output']>;
  readonly features: ReadonlyArray<FeatureType>;
  readonly hasAddedHome?: Maybe<Scalars['Boolean']['output']>;
  readonly hasCheckedCompliance?: Maybe<Scalars['Boolean']['output']>;
  readonly hasCreatedTenancy?: Maybe<Scalars['Boolean']['output']>;
  readonly hasPayments?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSentReference?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSetupRentCollection?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSignedAgreement?: Maybe<Scalars['Boolean']['output']>;
  readonly homes: ReadonlyArray<HomeType>;
  readonly homesCount?: Maybe<Scalars['Int']['output']>;
  readonly iconColor?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly integrations?: Maybe<IntegrationType>;
  readonly isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerType>;
  readonly name: Scalars['String']['output'];
  readonly paymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly referenceStartedOn?: Maybe<Scalars['Date']['output']>;
  readonly stripeAccountId?: Maybe<Scalars['String']['output']>;
  readonly stripeAccountLink?: Maybe<Scalars['String']['output']>;
  readonly stripeDashboardLink?: Maybe<Scalars['String']['output']>;
  readonly subscriptions?: Maybe<ReadonlyArray<Maybe<SubscriptionNode>>>;
  readonly tags?: Maybe<ConversationTagNodeConnection>;
  readonly textColor?: Maybe<Scalars['String']['output']>;
  readonly themeColor?: Maybe<Scalars['String']['output']>;
  readonly tierUpTo?: Maybe<Scalars['Int']['output']>;
  readonly tokens: Scalars['Int']['output'];
};


export type ClientTypeBtlSubscriptionTotalCostArgs = {
  includeSetupFee?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientTypeStripeAccountLinkArgs = {
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type ClientTypeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientUserNode = {
  readonly __typename?: 'ClientUserNode';
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly communityManager?: Maybe<CommunityManagerNode>;
  readonly concierge?: Maybe<ConciergeNode>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly manager?: Maybe<ManagerType>;
  readonly mfaEnabled: Scalars['Boolean']['output'];
};

export type ClientUserNodeConnection = {
  readonly __typename?: 'ClientUserNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientUserNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientUserNode` and its cursor. */
export type ClientUserNodeEdge = {
  readonly __typename?: 'ClientUserNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientUserNode>;
};

export type CloseConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type CloseConversationPayload = {
  readonly __typename?: 'CloseConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type CloseSurvey = {
  readonly __typename?: 'CloseSurvey';
  readonly survey?: Maybe<ResidentSurveyNode>;
};

export type CollectPackagesForHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home: Scalars['UUID']['input'];
  readonly user?: InputMaybe<Scalars['UUID']['input']>;
};

export type CollectPackagesForHomePayload = {
  readonly __typename?: 'CollectPackagesForHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeNode>;
};

export type CollectPackagesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly packageIds: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly userId: Scalars['UUID']['input'];
};

export type CollectPackagesPayload = {
  readonly __typename?: 'CollectPackagesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly packages: ReadonlyArray<Maybe<PackageNode>>;
};

export type CommunityDashboardType = {
  readonly __typename?: 'CommunityDashboardType';
  readonly activeResidentsDifference?: Maybe<Scalars['Int']['output']>;
  readonly allTimeSatisfaction?: Maybe<Scalars['Decimal']['output']>;
  readonly averageResponseTime?: Maybe<Scalars['Int']['output']>;
  readonly downloadRate?: Maybe<Scalars['Int']['output']>;
  readonly downloadRateOverTime?: Maybe<ReadonlyArray<Maybe<DownloadRateType>>>;
  readonly listEngagementScores?: Maybe<ReadonlyArray<CommunityEngagementScoreType>>;
  readonly monthlyActiveResidents?: Maybe<Scalars['Int']['output']>;
  readonly openCount?: Maybe<Scalars['Int']['output']>;
  readonly ratingsOverTime?: Maybe<ReadonlyArray<Maybe<AverageConversationRatingType>>>;
  readonly responseTimeDifference?: Maybe<Scalars['Int']['output']>;
  readonly responseTimeOverTime?: Maybe<ReadonlyArray<Maybe<ResponseTimeType>>>;
  readonly snoozedCount?: Maybe<Scalars['Int']['output']>;
};

export type CommunityDocumentNode = {
  readonly __typename?: 'CommunityDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<ManagerType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly totalPotentialViewers: Scalars['Int']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly viewers: ResidentialManagementCommunityDocumentViewersChoices;
  readonly views: CommunityDocumentViewNodeConnection;
};


export type CommunityDocumentNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityDocumentNodeConnection = {
  readonly __typename?: 'CommunityDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentNode` and its cursor. */
export type CommunityDocumentNodeEdge = {
  readonly __typename?: 'CommunityDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentNode>;
};

export type CommunityDocumentViewNode = {
  readonly __typename?: 'CommunityDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly user: UserType;
};

export type CommunityDocumentViewNodeConnection = {
  readonly __typename?: 'CommunityDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentViewNode` and its cursor. */
export type CommunityDocumentViewNodeEdge = {
  readonly __typename?: 'CommunityDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentViewNode>;
};

export type CommunityEngagementScoreType = {
  readonly __typename?: 'CommunityEngagementScoreType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly score: Scalars['Decimal']['output'];
};

export type CommunityEventNode = {
  readonly __typename?: 'CommunityEventNode';
  readonly attendanceFee?: Maybe<Scalars['Decimal']['output']>;
  readonly availableSpaces?: Maybe<Scalars['Int']['output']>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly end: Scalars['DateTime']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly guests?: Maybe<ContactNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isAttending?: Maybe<Scalars['Boolean']['output']>;
  readonly maxSpaces: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly start: Scalars['DateTime']['output'];
};


export type CommunityEventNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityEventNodeGuestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityEventNodeConnection = {
  readonly __typename?: 'CommunityEventNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityEventNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityEventNode` and its cursor. */
export type CommunityEventNodeEdge = {
  readonly __typename?: 'CommunityEventNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityEventNode>;
};

export type CommunityGroupNode = {
  readonly __typename?: 'CommunityGroupNode';
  readonly community?: Maybe<CommunityNode>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isAutomatic: Scalars['Boolean']['output'];
  readonly isCommunityManager?: Maybe<Scalars['Boolean']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly numUsers?: Maybe<Scalars['Int']['output']>;
  readonly users?: Maybe<ContactNodeConnection>;
};


export type CommunityGroupNodeHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityGroupNodeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityGroupNodeConnection = {
  readonly __typename?: 'CommunityGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityGroupNodeEdge>>;
  readonly locales?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityGroupNode` and its cursor. */
export type CommunityGroupNodeEdge = {
  readonly __typename?: 'CommunityGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityGroupNode>;
};

export type CommunityManagerNode = {
  readonly __typename?: 'CommunityManagerNode';
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
};


export type CommunityManagerNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityNode = {
  readonly __typename?: 'CommunityNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly appCoverImage?: Maybe<Scalars['String']['output']>;
  readonly asanaWebFormUrl?: Maybe<Scalars['String']['output']>;
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageRentAmount?: Maybe<Scalars['Float']['output']>;
  readonly averageResidencyLength?: Maybe<Scalars['Float']['output']>;
  readonly blocks: BlockNodeConnection;
  readonly buttonColor?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly commentsEnabled: Scalars['Boolean']['output'];
  readonly communityChatEnabled: Scalars['Boolean']['output'];
  readonly communityEvents: CommunityEventNodeConnection;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly engagementScore?: Maybe<Scalars['Decimal']['output']>;
  readonly engagementScoreDifference?: Maybe<Scalars['Float']['output']>;
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly hasAsanaIntegration: Scalars['Boolean']['output'];
  readonly homeCount: Scalars['Int']['output'];
  readonly iconColor?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isLeasehold: Scalars['Boolean']['output'];
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerType>;
  readonly marketplaceEnabled: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly officeHoursEnabled: Scalars['Boolean']['output'];
  readonly openConversationsCount?: Maybe<Scalars['Int']['output']>;
  readonly openPeriods?: Maybe<ReadonlyArray<CommunityOpenPeriodNode>>;
  readonly outOfOfficeMessage?: Maybe<Scalars['String']['output']>;
  readonly packageLocations: ReadonlyArray<Maybe<Scalars['String']['output']>>;
  readonly paymentsEnabled: Scalars['Boolean']['output'];
  readonly percentOccupied?: Maybe<Scalars['Float']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
  readonly recentUnresolvedConversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly referencingEnabled: Scalars['Boolean']['output'];
  readonly requisiteDate?: Maybe<Scalars['Date']['output']>;
  readonly residentCount: Scalars['Int']['output'];
  readonly satisfactionScore?: Maybe<Scalars['Float']['output']>;
  readonly settings: CommunitySettingsType;
  readonly statisticDataPoint?: Maybe<CommunityStatisticDataPointNode>;
  readonly statisticDataPoints?: Maybe<ReadonlyArray<Maybe<CommunityStatisticDataPointNode>>>;
  readonly statisticDifference?: Maybe<Scalars['Float']['output']>;
  readonly status: Scalars['String']['output'];
  readonly team?: Maybe<CommunityTeamNodeConnection>;
  readonly textColor?: Maybe<Scalars['String']['output']>;
  readonly themeColor?: Maybe<Scalars['String']['output']>;
  readonly unreadConversations: Scalars['Int']['output'];
  readonly updates?: Maybe<ReadonlyArray<CommunityUpdateType>>;
};


export type CommunityNodeBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityNodeCommunityEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type CommunityNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityNodeStatisticDataPointArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
};


export type CommunityNodeStatisticDataPointsArgs = {
  frequency: HistoricalDataFrequency;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CommunityNodeStatisticDifferenceArgs = {
  since?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
};


export type CommunityNodeTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityNodeConnection = {
  readonly __typename?: 'CommunityNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityNode` and its cursor. */
export type CommunityNodeEdge = {
  readonly __typename?: 'CommunityNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityNode>;
};

export type CommunityOpenPeriodNode = {
  readonly __typename?: 'CommunityOpenPeriodNode';
  readonly end: Scalars['Time']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly start: Scalars['Time']['output'];
  readonly weekdayIndex: Scalars['Int']['output'];
};

export type CommunityOpenPeriodSerializerInput = {
  readonly end: Scalars['Time']['input'];
  readonly start: Scalars['Time']['input'];
  readonly weekdayIndex: Scalars['Int']['input'];
};

export type CommunityProductNode = {
  readonly __typename?: 'CommunityProductNode';
  readonly active: Scalars['Boolean']['output'];
  readonly client?: Maybe<ClientType>;
  readonly communities: CommunityNodeConnection;
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly price?: Maybe<Scalars['Decimal']['output']>;
  readonly purchases: CommunityProductPurchaseNodeConnection;
};


export type CommunityProductNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityProductNodePurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityProductNodeConnection = {
  readonly __typename?: 'CommunityProductNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityProductNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityProductNode` and its cursor. */
export type CommunityProductNodeEdge = {
  readonly __typename?: 'CommunityProductNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityProductNode>;
};

export type CommunityProductPurchaseNode = {
  readonly __typename?: 'CommunityProductPurchaseNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly payment?: Maybe<PaymentNode>;
  readonly product?: Maybe<CommunityProductNode>;
  readonly user?: Maybe<UserType>;
};

export type CommunityProductPurchaseNodeConnection = {
  readonly __typename?: 'CommunityProductPurchaseNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityProductPurchaseNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityProductPurchaseNode` and its cursor. */
export type CommunityProductPurchaseNodeEdge = {
  readonly __typename?: 'CommunityProductPurchaseNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityProductPurchaseNode>;
};

export type CommunitySettingsType = {
  readonly __typename?: 'CommunitySettingsType';
  readonly abMessageSuggestion: Scalars['Boolean']['output'];
  readonly accounts: Scalars['Boolean']['output'];
  readonly bankAccountName?: Maybe<Scalars['String']['output']>;
  readonly bankAccountNumber?: Maybe<Scalars['String']['output']>;
  readonly bankSortCode?: Maybe<Scalars['String']['output']>;
  readonly compliance: Scalars['Boolean']['output'];
  readonly conversationForwardingEmails: ReadonlyArray<ConversationForwardingEmailType>;
  readonly documents: Scalars['Boolean']['output'];
  readonly events: Scalars['Boolean']['output'];
  readonly facilities: Scalars['Boolean']['output'];
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly fullMessageSuggestion: Scalars['Boolean']['output'];
  readonly marketplace: Scalars['Boolean']['output'];
  readonly messages: Scalars['Boolean']['output'];
  readonly newsfeed: Scalars['Boolean']['output'];
  readonly occupancySurvey: Scalars['Boolean']['output'];
  readonly packageLabels: Scalars['Boolean']['output'];
  readonly portalUrl?: Maybe<Scalars['String']['output']>;
  readonly products: Scalars['Boolean']['output'];
  readonly sendExternalIdToFixflo: Scalars['Boolean']['output'];
  readonly serviceChargeWaiver: Scalars['Boolean']['output'];
  readonly surveys: Scalars['Boolean']['output'];
  readonly termsAndConditions: Scalars['Boolean']['output'];
};

export type CommunityStatisticDataPointNode = {
  readonly __typename?: 'CommunityStatisticDataPointNode';
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly date: Scalars['Date']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly type: ResidentialManagementCommunityStatisticDataPointTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly value: Scalars['Float']['output'];
};

export type CommunityTeamNode = {
  readonly __typename?: 'CommunityTeamNode';
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isAdmin?: Maybe<Scalars['Boolean']['output']>;
  readonly isCommunityManager?: Maybe<Scalars['Boolean']['output']>;
  readonly isConcierge?: Maybe<Scalars['Boolean']['output']>;
  readonly isManager?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly publicUuid: Scalars['UUID']['output'];
};

export type CommunityTeamNodeConnection = {
  readonly __typename?: 'CommunityTeamNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityTeamNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityTeamNode` and its cursor. */
export type CommunityTeamNodeEdge = {
  readonly __typename?: 'CommunityTeamNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityTeamNode>;
};

export type CommunityUpdateCommentNode = {
  readonly __typename?: 'CommunityUpdateCommentNode';
  readonly author: UserType;
  readonly comment: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly userType: ResidentialManagementCommunityUpdateCommentUserTypeChoices;
};

export type CommunityUpdateCommentNodeConnection = {
  readonly __typename?: 'CommunityUpdateCommentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateCommentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateCommentNode` and its cursor. */
export type CommunityUpdateCommentNodeEdge = {
  readonly __typename?: 'CommunityUpdateCommentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateCommentNode>;
};

export type CommunityUpdateLikeType = {
  readonly __typename?: 'CommunityUpdateLikeType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly update: CommunityUpdateType;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};

export type CommunityUpdateLocaleVariantNode = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNode';
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly status: ResidentialManagementCommunityUpdateLocaleVariantStatusChoices;
  readonly summary?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type CommunityUpdateLocaleVariantNodeConnection = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateLocaleVariantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateLocaleVariantNode` and its cursor. */
export type CommunityUpdateLocaleVariantNodeEdge = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateLocaleVariantNode>;
};

export type CommunityUpdateNode = {
  readonly __typename?: 'CommunityUpdateNode';
  readonly attachment?: Maybe<Scalars['String']['output']>;
  readonly body: Scalars['String']['output'];
  readonly category: Scalars['String']['output'];
  readonly comments?: Maybe<CommunityUpdateCommentNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly groups?: Maybe<CommunityGroupNodeConnection>;
  readonly hasBookmarked?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly imageSearchTerm?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly isArk: Scalars['Boolean']['output'];
  readonly isLiked?: Maybe<Scalars['Boolean']['output']>;
  readonly numLikes?: Maybe<Scalars['Int']['output']>;
  readonly numberOfBookmarks?: Maybe<Scalars['Int']['output']>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residentLike?: Maybe<Scalars['UUID']['output']>;
  readonly scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  readonly stats: CommunityUpdateStatsType;
  readonly status: CommunityUpdateStatusEnum;
  readonly summary: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueReads?: Maybe<Scalars['Int']['output']>;
  readonly variants?: Maybe<CommunityUpdateLocaleVariantNodeConnection>;
};


export type CommunityUpdateNodeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityUpdateNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityUpdateNodeVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityUpdateNodeConnection = {
  readonly __typename?: 'CommunityUpdateNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateNode` and its cursor. */
export type CommunityUpdateNodeEdge = {
  readonly __typename?: 'CommunityUpdateNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateNode>;
};

export type CommunityUpdateStatsType = {
  readonly __typename?: 'CommunityUpdateStatsType';
  readonly totalComments: Scalars['Int']['output'];
  readonly totalLikes: Scalars['Int']['output'];
  readonly totalReads: Scalars['Int']['output'];
};

/** An enumeration. */
export enum CommunityUpdateStatusEnum {
  Dr = 'DR',
  Li = 'LI',
  Sc = 'SC'
}

export type CommunityUpdateType = {
  readonly __typename?: 'CommunityUpdateType';
  readonly attachment?: Maybe<Scalars['String']['output']>;
  readonly body: Scalars['String']['output'];
  readonly bookmarkedBy: ReadonlyArray<UserType>;
  readonly category: Scalars['String']['output'];
  readonly comments?: Maybe<CommunityUpdateCommentNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly creatorType: ResidentialManagementCommunityUpdateCreatorTypeChoices;
  readonly groups: CommunityGroupNodeConnection;
  readonly hasBookmarked?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly imageSearchTerm?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly isArk: Scalars['Boolean']['output'];
  readonly likes: ReadonlyArray<CommunityUpdateLikeType>;
  readonly numLikes?: Maybe<Scalars['Int']['output']>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residentLike?: Maybe<Scalars['UUID']['output']>;
  readonly scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  readonly stats: CommunityUpdateStatsType;
  readonly status: CommunityUpdateStatusEnum;
  readonly summary: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueReads?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updatedBy?: Maybe<UserType>;
  readonly variants?: Maybe<CommunityUpdateLocaleVariantNodeConnection>;
};


export type CommunityUpdateTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityUpdateTypeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityUpdateTypeVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityVisitorNode = {
  readonly __typename?: 'CommunityVisitorNode';
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reasonForVisit?: Maybe<Scalars['String']['output']>;
  readonly residentName?: Maybe<Scalars['String']['output']>;
  readonly signedOutAt?: Maybe<Scalars['DateTime']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly vehicleRegistration?: Maybe<Scalars['String']['output']>;
};

export type CommunityVisitorNodeConnection = {
  readonly __typename?: 'CommunityVisitorNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityVisitorNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityVisitorNode` and its cursor. */
export type CommunityVisitorNodeEdge = {
  readonly __typename?: 'CommunityVisitorNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityVisitorNode>;
};

/** An enumeration. */
export enum ComplianceAttachmentTypeChoices {
  /** Home */
  Ho = 'HO',
  /** Requirement item */
  Ri = 'RI'
}

/** An enumeration. */
export enum ComplianceComplianceRequirementTypeChoices {
  /** Custom */
  Cu = 'CU',
  /** Deposit Certificate */
  Dc = 'DC',
  /** Electrical Installation Condition Report */
  Ei = 'EI',
  /** Energy Performance Assessment */
  Ep = 'EP',
  /** Gas Safety Inspection */
  Gs = 'GS',
  /** Local Authority Licensing */
  La = 'LA',
  /** Portable Appliance Test */
  Pa = 'PA',
  /** Smoke Alarm & Carbon Monoxide */
  Sa = 'SA',
  /** Tenancy Agreement */
  Ta = 'TA'
}

/** An enumeration. */
export enum ComplianceComplianceUpdateActionRequirementChoices {
  /** Action */
  Ac = 'AC',
  /** Advice */
  Ad = 'AD'
}

export type ComplianceRequirementNode = {
  readonly __typename?: 'ComplianceRequirementNode';
  readonly actionDate?: Maybe<Scalars['String']['output']>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly currentItem?: Maybe<RequirementItemNode>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly frequencyText?: Maybe<Scalars['String']['output']>;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly items: RequirementItemNodeConnection;
  readonly name: Scalars['String']['output'];
  readonly residency?: Maybe<ResidencyType>;
  readonly shared: Scalars['Boolean']['output'];
  readonly status: Scalars['String']['output'];
  readonly type: ComplianceComplianceRequirementTypeChoices;
};


export type ComplianceRequirementNodeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplianceRequirementNodeConnection = {
  readonly __typename?: 'ComplianceRequirementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ComplianceRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ComplianceRequirementNode` and its cursor. */
export type ComplianceRequirementNodeEdge = {
  readonly __typename?: 'ComplianceRequirementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ComplianceRequirementNode>;
};

export type ComplianceUpdateReadType = {
  readonly __typename?: 'ComplianceUpdateReadType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly manager: ManagerType;
  readonly update: ComplianceUpdateType;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ComplianceUpdateType = {
  readonly __typename?: 'ComplianceUpdateType';
  readonly actionRequirement: ComplianceComplianceUpdateActionRequirementChoices;
  readonly actionText?: Maybe<Scalars['String']['output']>;
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dateText?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly infoSource?: Maybe<Scalars['String']['output']>;
  readonly reads: ReadonlyArray<ComplianceUpdateReadType>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly wasRead?: Maybe<Scalars['Boolean']['output']>;
};

export type ConciergeNode = {
  readonly __typename?: 'ConciergeNode';
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
};


export type ConciergeNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmResidencyWillRollInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmResidencyWillRollPayload = {
  readonly __typename?: 'ConfirmResidencyWillRollPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type ContactNode = {
  readonly __typename?: 'ContactNode';
  readonly applicant?: Maybe<ApplicantNode>;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastAppUse?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly leaseholder?: Maybe<LeaseholderNode>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly resident?: Maybe<ResidentNode>;
};


export type ContactNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ContactNodeConnection = {
  readonly __typename?: 'ContactNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ContactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContactNode` and its cursor. */
export type ContactNodeEdge = {
  readonly __typename?: 'ContactNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ContactNode>;
};

export type ConversationActionModelType = {
  readonly __typename?: 'ConversationActionModelType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly extra?: Maybe<Scalars['JSONString']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationAssignmentNode = {
  readonly __typename?: 'ConversationAssignmentNode';
  readonly assignedBy?: Maybe<UserType>;
  readonly assignedTo: UserType;
  readonly conversation: ConversationNode;
  readonly id: Scalars['UUID']['output'];
};

export type ConversationAssignmentNodeConnection = {
  readonly __typename?: 'ConversationAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationAssignmentNode` and its cursor. */
export type ConversationAssignmentNodeEdge = {
  readonly __typename?: 'ConversationAssignmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationAssignmentNode>;
};

export type ConversationEventType = ConversationActionModelType | ConversationMediaType | ConversationMessageType;

export type ConversationForwardingEmailType = {
  readonly __typename?: 'ConversationForwardingEmailType';
  readonly emails?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly id: Scalars['UUID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type ConversationMediaType = {
  readonly __typename?: 'ConversationMediaType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly sender: ResidentialManagementConversationMediaSenderChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type ConversationMessageType = {
  readonly __typename?: 'ConversationMessageType';
  readonly body: Scalars['String']['output'];
  readonly conversation: ConversationNode;
  readonly conversationsummarySet: ConversationSummaryNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly seen?: Maybe<Scalars['Boolean']['output']>;
  readonly sender: ResidentialManagementConversationMessageSenderChoices;
  readonly suggestion?: Maybe<MessageSuggestionType>;
  readonly suggestions: ReadonlyArray<MessageSuggestionType>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};


export type ConversationMessageTypeConversationsummarySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationNode = {
  readonly __typename?: 'ConversationNode';
  readonly actions: ReadonlyArray<ConversationActionModelType>;
  readonly asanaTaskId?: Maybe<Scalars['String']['output']>;
  readonly assignment?: Maybe<ConversationAssignmentNode>;
  readonly assignments: ConversationAssignmentNodeConnection;
  readonly availableTags?: Maybe<ConversationTagNodeConnection>;
  readonly category: ResidentialManagementConversationCategoryChoices;
  readonly closedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentStatus?: Maybe<Scalars['String']['output']>;
  readonly currentUrgency?: Maybe<Scalars['String']['output']>;
  readonly hasUnread: Scalars['Boolean']['output'];
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly latestEvent?: Maybe<ConversationEventType>;
  readonly latestMedia?: Maybe<ConversationMediaType>;
  readonly latestMessage?: Maybe<ConversationMessageType>;
  readonly latestOpen?: Maybe<ConversationOpenedType>;
  readonly latestStatus?: Maybe<ConversationStatusType>;
  readonly latestUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  readonly media: ReadonlyArray<ConversationMediaType>;
  readonly messages: ReadonlyArray<ConversationMessageType>;
  readonly notes?: Maybe<ConversationNoteNodeConnection>;
  readonly notifications?: Maybe<ReadonlyArray<Maybe<ManagerNotificationType>>>;
  readonly openedCount?: Maybe<Scalars['Int']['output']>;
  readonly opens: ReadonlyArray<ConversationOpenedType>;
  readonly rating?: Maybe<ConversationRatingType>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentNode>;
  readonly responseTime?: Maybe<Scalars['Int']['output']>;
  readonly snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  readonly statuses: ReadonlyArray<ConversationStatusType>;
  readonly subject: Scalars['String']['output'];
  readonly summaries: ConversationSummaryNodeConnection;
  readonly summary?: Maybe<ConversationSummaryNode>;
  readonly tagSuggestions: ConversationTagSuggestionNodeConnection;
  readonly tags?: Maybe<ConversationTagNodeConnection>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly urgencies: ReadonlyArray<ConversationUrgencyType>;
  readonly user?: Maybe<UserType>;
};


export type ConversationNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeAvailableTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationNodeConnection = {
  readonly __typename?: 'ConversationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ConversationNode` and its cursor. */
export type ConversationNodeEdge = {
  readonly __typename?: 'ConversationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationNode>;
};

export type ConversationNoteNode = {
  readonly __typename?: 'ConversationNoteNode';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly text: Scalars['String']['output'];
  readonly user: UserType;
};

export type ConversationNoteNodeConnection = {
  readonly __typename?: 'ConversationNoteNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationNoteNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationNoteNode` and its cursor. */
export type ConversationNoteNodeEdge = {
  readonly __typename?: 'ConversationNoteNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationNoteNode>;
};

export type ConversationOpenedType = {
  readonly __typename?: 'ConversationOpenedType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationRatingType = {
  readonly __typename?: 'ConversationRatingType';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly rating: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum ConversationRole {
  Concierge = 'Concierge',
  Leaseholder = 'Leaseholder',
  Manager = 'Manager',
  Resident = 'Resident'
}

export type ConversationStatusType = {
  readonly __typename?: 'ConversationStatusType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationSummaryNode = {
  readonly __typename?: 'ConversationSummaryNode';
  readonly conversation: ConversationNode;
  readonly editedBy?: Maybe<UserType>;
  readonly id: Scalars['UUID']['output'];
  readonly message: ConversationMessageType;
  readonly summary: Scalars['String']['output'];
};

export type ConversationSummaryNodeConnection = {
  readonly __typename?: 'ConversationSummaryNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationSummaryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationSummaryNode` and its cursor. */
export type ConversationSummaryNodeEdge = {
  readonly __typename?: 'ConversationSummaryNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationSummaryNode>;
};

export type ConversationTagNode = {
  readonly __typename?: 'ConversationTagNode';
  readonly client: ClientType;
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly conversations: ConversationNodeConnection;
  readonly deletedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isSelected?: Maybe<Scalars['Boolean']['output']>;
  readonly name: Scalars['String']['output'];
  readonly suggested?: Maybe<Scalars['Boolean']['output']>;
};


export type ConversationTagNodeConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationTagNodeConnection = {
  readonly __typename?: 'ConversationTagNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationTagNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ConversationTagNode` and its cursor. */
export type ConversationTagNodeEdge = {
  readonly __typename?: 'ConversationTagNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationTagNode>;
};

export type ConversationTagSuggestionNode = {
  readonly __typename?: 'ConversationTagSuggestionNode';
  readonly id: Scalars['UUID']['output'];
  readonly tag: ConversationTagNode;
};

export type ConversationTagSuggestionNodeConnection = {
  readonly __typename?: 'ConversationTagSuggestionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationTagSuggestionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationTagSuggestionNode` and its cursor. */
export type ConversationTagSuggestionNodeEdge = {
  readonly __typename?: 'ConversationTagSuggestionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationTagSuggestionNode>;
};

export type ConversationUrgencyType = {
  readonly __typename?: 'ConversationUrgencyType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly urgency?: Maybe<Scalars['String']['output']>;
};

export type CountersignAgreementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CountersignAgreementPayload = {
  readonly __typename?: 'CountersignAgreementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type CreateAgreementForTenancyInput = {
  readonly additionalTerms?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly furnished?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly residency?: InputMaybe<Scalars['String']['input']>;
  readonly utilitiesIncluded?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgreementForTenancyPayload = {
  readonly __typename?: 'CreateAgreementForTenancyPayload';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly furnished?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly residency?: Maybe<Scalars['String']['output']>;
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};

export type CreateAmenityReservationMutationInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly timeSlots: ReadonlyArray<InputMaybe<Scalars['DateTime']['input']>>;
};

export type CreateAmenityReservationMutationPayload = {
  readonly __typename?: 'CreateAmenityReservationMutationPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicantAndApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['UUID']['input'];
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly home: Scalars['UUID']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly ownershipType: Scalars['String']['input'];
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicantAndApplicationPayload = {
  readonly __typename?: 'CreateApplicantAndApplicationPayload';
  readonly applicant?: Maybe<ApplicantNode>;
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationInput = {
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isResident?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly moveInDate?: InputMaybe<Scalars['Date']['input']>;
  readonly ownershipType?: InputMaybe<Scalars['String']['input']>;
  readonly postcode: Scalars['String']['input'];
  readonly region?: InputMaybe<Scalars['String']['input']>;
  readonly townOrCity?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationPayload = {
  readonly __typename?: 'CreateApplicationPayload';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly isResident?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly moveInDate?: Maybe<Scalars['Date']['output']>;
  readonly ownershipType?: Maybe<Scalars['String']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly townOrCity?: Maybe<Scalars['String']['output']>;
};

export type CreateAttachmentOnHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttachmentOnHomePayload = {
  readonly __typename?: 'CreateAttachmentOnHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type CreateAttachmentOnRequirementItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requirementItemId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttachmentOnRequirementItemPayload = {
  readonly __typename?: 'CreateAttachmentOnRequirementItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly requirementItemId?: Maybe<Scalars['String']['output']>;
};

export type CreateBlockComplianceRequirementItemInput = {
  readonly blockComplianceRequirements: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expiryDate: Scalars['Date']['input'];
};

export type CreateBlockComplianceRequirementItemPayload = {
  readonly __typename?: 'CreateBlockComplianceRequirementItemPayload';
  readonly blockComplianceRequirementItem?: Maybe<BlockComplianceRequirementItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateBlocks = {
  readonly __typename?: 'CreateBlocks';
  readonly blocks?: Maybe<ReadonlyArray<Maybe<BlockNode>>>;
};

export type CreateBlocksComplianceRequirementInput = {
  readonly blocks: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly shared: Scalars['Boolean']['input'];
};

export type CreateBlocksComplianceRequirementPayload = {
  readonly __typename?: 'CreateBlocksComplianceRequirementPayload';
  readonly blocksComplianceRequirement?: Maybe<BlocksComplianceRequirementNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCheckoutLinkInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly subscription: Scalars['UUID']['input'];
};

export type CreateCheckoutLinkPayload = {
  readonly __typename?: 'CreateCheckoutLinkPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
};

export type CreateCommunityDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly viewers?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentPayload = {
  readonly __typename?: 'CreateCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentViewPayload = {
  readonly __typename?: 'CreateCommunityDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocumentView?: Maybe<CommunityDocumentViewNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityProductInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly description: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateCommunityProductPayload = {
  readonly __typename?: 'CreateCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityProductPaymentInput = {
  readonly amount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityProductId: Scalars['UUID']['input'];
};

export type CreateCommunityProductPaymentPayload = {
  readonly __typename?: 'CreateCommunityProductPaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type CreateCommunityUpdateReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityUpdate: Scalars['String']['input'];
};

export type CreateCommunityUpdateReadPayload = {
  readonly __typename?: 'CreateCommunityUpdateReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityVisitorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  readonly residentName?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
  readonly vehicleRegistration?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityVisitorPayload = {
  readonly __typename?: 'CreateCommunityVisitorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateComplianceRequirementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly frequencyText?: InputMaybe<Scalars['String']['input']>;
  readonly homes: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly name: Scalars['String']['input'];
  readonly renewalFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type CreateComplianceRequirementPayload = {
  readonly __typename?: 'CreateComplianceRequirementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly complianceRequirements?: Maybe<ReadonlyArray<Maybe<ComplianceRequirementNode>>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly frequencyText?: Maybe<Scalars['String']['output']>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly renewalFrequency?: Maybe<Scalars['String']['output']>;
};

export type CreateComplianceUpdateReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly update: Scalars['String']['input'];
};

export type CreateComplianceUpdateReadPayload = {
  readonly __typename?: 'CreateComplianceUpdateReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly update?: Maybe<Scalars['String']['output']>;
};

export type CreateConversation = {
  readonly __typename?: 'CreateConversation';
  readonly conversation?: Maybe<ConversationNode>;
};

export type CreateConversationActionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly extra?: InputMaybe<Scalars['JSONString']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly type: Scalars['String']['input'];
};

export type CreateConversationActionPayload = {
  readonly __typename?: 'CreateConversationActionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly extra?: Maybe<Scalars['JSONString']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type CreateConversationAndFirstMessage = {
  readonly __typename?: 'CreateConversationAndFirstMessage';
  readonly conversation?: Maybe<ConversationNode>;
};

export type CreateConversationAndFirstMessageInput = {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly homeId: Scalars['UUID']['input'];
};

export type CreateConversationAssignmentInput = {
  readonly assignedTo: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['UUID']['input'];
};

export type CreateConversationAssignmentPayload = {
  readonly __typename?: 'CreateConversationAssignmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationAssignment?: Maybe<ConversationAssignmentNode>;
};

export type CreateConversationInput = {
  readonly category: Scalars['String']['input'];
  readonly comments?: InputMaybe<Scalars['String']['input']>;
  readonly contactId?: InputMaybe<Scalars['UUID']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residentId?: InputMaybe<Scalars['UUID']['input']>;
  readonly subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationMessage = {
  readonly __typename?: 'CreateConversationMessage';
  readonly message?: Maybe<ConversationMessageType>;
};

export type CreateConversationMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly conversationId: Scalars['UUID']['input'];
  readonly suggestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateConversationNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly text: Scalars['String']['input'];
};

export type CreateConversationNotePayload = {
  readonly __typename?: 'CreateConversationNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationNote?: Maybe<ConversationNoteNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateConversationSummaryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly summary: Scalars['String']['input'];
};

export type CreateConversationSummaryPayload = {
  readonly __typename?: 'CreateConversationSummaryPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationSummary?: Maybe<ConversationSummaryNode>;
};

export type CreateConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationTagPayload = {
  readonly __typename?: 'CreateConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type CreateGroupChatMessageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupChat: Scalars['String']['input'];
  readonly text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupChatMessagePayload = {
  readonly __typename?: 'CreateGroupChatMessagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
};

export type CreateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateGroupPayload = {
  readonly __typename?: 'CreateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

export type CreateKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly image?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly reference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateKeyV2Payload = {
  readonly __typename?: 'CreateKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type CreateKeyholderV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly key: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateKeyholderV2Payload = {
  readonly __typename?: 'CreateKeyholderV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type CreateManagerConversationReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateManagerConversationReadPayload = {
  readonly __typename?: 'CreateManagerConversationReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly unread?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMarketplaceItemCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment: Scalars['String']['input'];
  readonly item: Scalars['String']['input'];
};

export type CreateMarketplaceItemCommentPayload = {
  readonly __typename?: 'CreateMarketplaceItemCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly item?: Maybe<Scalars['String']['output']>;
};

export type CreateNewDevice = {
  readonly __typename?: 'CreateNewDevice';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateNewDeviceInput = {
  readonly platform?: InputMaybe<Scalars['String']['input']>;
  readonly token: Scalars['String']['input'];
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOccupancySurvey = {
  readonly __typename?: 'CreateOccupancySurvey';
  readonly occupancySurvey?: Maybe<OccupancySurveyNode>;
};

export type CreateOpenedConversation = {
  readonly __typename?: 'CreateOpenedConversation';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOpenedConversationInput = {
  readonly conversationId: Scalars['UUID']['input'];
};

export type CreatePaymentInput = {
  readonly amount: Scalars['Decimal']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly paymentAccount?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreatePaymentPayload = {
  readonly __typename?: 'CreatePaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type CreateResidencyAndResidents = {
  readonly __typename?: 'CreateResidencyAndResidents';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
  readonly residency?: Maybe<ResidencyNode>;
};

export type CreateResidencyDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly residency: Scalars['String']['input'];
};

export type CreateResidencyDocumentPayload = {
  readonly __typename?: 'CreateResidencyDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocument?: Maybe<ResidencyDocumentNode>;
};

export type CreateResidencyDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResidencyDocumentViewPayload = {
  readonly __typename?: 'CreateResidencyDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocumentView?: Maybe<ResidencyDocumentViewNode>;
};

export type CreateResidencyDocuments = {
  readonly __typename?: 'CreateResidencyDocuments';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateResidencyDocumentsInput = {
  readonly complianceItems?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly customComplianceItems?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateResidencySubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly methods?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly paymentStartDate?: InputMaybe<Scalars['Date']['input']>;
  readonly residencyId: Scalars['String']['input'];
};

export type CreateResidencySubscriptionPayload = {
  readonly __typename?: 'CreateResidencySubscriptionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly methods?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly residencyId?: Maybe<Scalars['String']['output']>;
};

export type CreateStripeAccount = {
  readonly __typename?: 'CreateStripeAccount';
  readonly client?: Maybe<ClientType>;
};

export type CreateSurveyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly options?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly question: Scalars['String']['input'];
};

export type CreateSurveyPayload = {
  readonly __typename?: 'CreateSurveyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly options?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly question?: Maybe<Scalars['String']['output']>;
};

export type CreateTenancyApplicationInput = {
  readonly applicants?: InputMaybe<ReadonlyArray<InputMaybe<Applicants>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateTenancyApplicationPayload = {
  readonly __typename?: 'CreateTenancyApplicationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
};

export type CreateUpdateCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment: Scalars['String']['input'];
  readonly updateId: Scalars['UUID']['input'];
  readonly userType: Scalars['String']['input'];
};

export type CreateUpdateCommentPayload = {
  readonly __typename?: 'CreateUpdateCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdateComment?: Maybe<CommunityUpdateCommentNode>;
};

export type CreditCheckNode = {
  readonly __typename?: 'CreditCheckNode';
  readonly activeBankruptcies: Scalars['Int']['output'];
  readonly activeCountyCourtJudgements: Scalars['Int']['output'];
  readonly aliases: ReadonlyArray<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly riskLevel?: Maybe<Scalars['String']['output']>;
  readonly score: Scalars['Int']['output'];
  readonly totalBankruptcies: Scalars['Int']['output'];
  readonly totalCountyCourtJudgements: Scalars['Int']['output'];
};

export type DeactivateClientUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type DeactivateClientUserPayload = {
  readonly __typename?: 'DeactivateClientUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
};

export type DeactivateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateGroupPayload = {
  readonly __typename?: 'DeactivateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DebugSchema = {
  readonly __typename?: 'DebugSchema';
  readonly _debug?: Maybe<DjangoDebug>;
  readonly accountTransactions?: Maybe<AccountTransactionNodeConnection>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly agreements?: Maybe<GeneratedAgreementNodeConnection>;
  readonly amenities?: Maybe<AmenityNodeConnection>;
  readonly amenity?: Maybe<AmenityNode>;
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly amenityReservations?: Maybe<AmenityReservationNodeConnection>;
  readonly application?: Maybe<ApplicationNode>;
  readonly applications?: Maybe<ApplicationNodeConnection>;
  readonly block?: Maybe<BlockNode>;
  readonly blockComplianceRequirement?: Maybe<BlockComplianceRequirementNode>;
  readonly blockComplianceRequirements?: Maybe<BlockComplianceRequirementNodeConnection>;
  readonly blocks?: Maybe<BlockNodeConnection>;
  readonly clientUser?: Maybe<ClientUserNode>;
  readonly clientUsers?: Maybe<ClientUserNodeConnection>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly community?: Maybe<CommunityNode>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly communityDocuments?: Maybe<CommunityDocumentNodeConnection>;
  readonly communityEvent?: Maybe<CommunityEventNode>;
  readonly communityEvents?: Maybe<CommunityEventNodeConnection>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  readonly communityGroups?: Maybe<CommunityGroupNodeConnection>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  readonly communityProductPurchases?: Maybe<CommunityProductPurchaseNodeConnection>;
  readonly communityProducts?: Maybe<CommunityProductNodeConnection>;
  readonly communityUpdate?: Maybe<CommunityUpdateNode>;
  readonly communityUpdates?: Maybe<CommunityUpdateNodeConnection>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  readonly communityVisitors?: Maybe<CommunityVisitorNodeConnection>;
  readonly complianceRequirement?: Maybe<ComplianceRequirementNode>;
  readonly complianceRequirements?: Maybe<ComplianceRequirementNodeConnection>;
  readonly contact?: Maybe<ContactNode>;
  readonly contacts?: Maybe<ContactNodeConnection>;
  readonly conversation?: Maybe<ConversationNode>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
  readonly conversationTags?: Maybe<ConversationTagNodeConnection>;
  readonly conversations?: Maybe<ConversationNodeConnection>;
  readonly dashboard?: Maybe<CommunityDashboardType>;
  readonly document?: Maybe<DocumentNode>;
  readonly documents?: Maybe<DocumentNodeConnection>;
  readonly employerReference?: Maybe<EmployerReferenceNode>;
  readonly findComplianceUpdate?: Maybe<ComplianceUpdateType>;
  readonly findHome?: Maybe<HomeType>;
  readonly findSection21?: Maybe<GeneratedSection21Type>;
  readonly findTenancyAgreement?: Maybe<GeneratedAgreementType>;
  readonly getClient?: Maybe<ClientType>;
  readonly getClientAdmin?: Maybe<ClientAdminNode>;
  readonly getLandlord?: Maybe<LandlordNode>;
  readonly getLeaseholder?: Maybe<LeaseholderNode>;
  readonly getManager?: Maybe<ManagerType>;
  readonly getMe?: Maybe<ResidentType>;
  readonly getUser?: Maybe<UserType>;
  readonly groupChat?: Maybe<GroupChatNode>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
  readonly groupChatMessages?: Maybe<GroupChatMessageNodeConnection>;
  readonly groupChats?: Maybe<GroupChatNodeConnection>;
  readonly home?: Maybe<HomeNode>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly invoice?: Maybe<InvoiceNode>;
  readonly invoices?: Maybe<InvoiceNodeConnection>;
  readonly key?: Maybe<KeyNode>;
  readonly keyholder?: Maybe<KeyholderNode>;
  readonly keyholders?: Maybe<KeyholderNodeConnection>;
  readonly keys?: Maybe<KeyNodeConnection>;
  readonly landlordAttachment?: Maybe<LandlordAttachmentNode>;
  readonly landlordDocuments?: Maybe<ReadonlyArray<Maybe<LandlordDocumentNode>>>;
  readonly landlordReference?: Maybe<LandlordReferenceNode>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly leaseholds?: Maybe<LeaseholdNodeConnection>;
  readonly listComplianceUpdates?: Maybe<ReadonlyArray<ComplianceUpdateType>>;
  readonly listHomes?: Maybe<ReadonlyArray<HomeType>>;
  readonly listResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
  readonly marketplaceItems?: Maybe<MarketplaceItemNodeConnection>;
  readonly notification?: Maybe<NotificationNode>;
  readonly notifications?: Maybe<NotificationNodeConnection>;
  readonly occupancySurvey?: Maybe<OccupancySurveyNode>;
  readonly occupancySurveys?: Maybe<OccupancySurveyNodeConnection>;
  readonly package?: Maybe<PackageNode>;
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly paymentAccount?: Maybe<PaymentAccountNode>;
  readonly paymentAccounts?: Maybe<PaymentAccountNodeConnection>;
  readonly productCosts?: Maybe<ProductCosts>;
  readonly profile?: Maybe<ProfileType>;
  readonly residencies?: Maybe<ResidencyNodeConnection>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentNode>;
  readonly residents?: Maybe<ResidentNodeConnection>;
  readonly searchEpc?: Maybe<ReadonlyArray<EpcResponseType>>;
  readonly section21?: Maybe<GeneratedSection21Node>;
  readonly signature?: Maybe<AgreementSignatureNode>;
  readonly survey?: Maybe<ResidentSurveyNode>;
  readonly surveys?: Maybe<ResidentSurveyNodeConnection>;
  readonly tenancyApplicant?: Maybe<TenancyApplicantNode>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
  readonly tenancyApplications?: Maybe<TenancyApplicationNodeConnection>;
  readonly tenantReference?: Maybe<TenantReferenceNode>;
  readonly tenantReferences?: Maybe<TenantReferenceNodeConnection>;
};


export type DebugSchemaAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAgreementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaAmenitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaAmenityArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityReservationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaBlockArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockComplianceRequirementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityEventArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityGroupArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityProductArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityProductPurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityUpdateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['UUID']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userBookmarked?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityVisitorArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityVisitorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onSite?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedOut?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaComplianceRequirementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaContactArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaConversationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaConversationTagArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaConversationTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<ConversationRole>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaDashboardArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
};


export type DebugSchemaDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaEmployerReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindComplianceUpdateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindHomeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindSection21Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindTenancyAgreementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupChat?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaGroupChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaHomeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  packagesStatus?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trigramSearch?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaInvoiceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isCredit?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaKeyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaKeyholderArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaKeyholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaLandlordAttachmentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLandlordDocumentsArgs = {
  homeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLandlordReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeaseholdArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaListComplianceUpdatesArgs = {
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaListHomesArgs = {
  communityId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaListResidenciesArgs = {
  communityId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaNotificationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaOccupancySurveyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPaymentAccountArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPaymentAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communityActive?: InputMaybe<Scalars['Boolean']['input']>;
  communityPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaResidenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  referenceSent?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type DebugSchemaResidencyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  notDownloaded?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  scanData?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withRating?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaSearchEpcArgs = {
  homeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSection21Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSignatureArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSurveyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLink?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTenancyApplicantArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenancyApplicationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenancyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTenantReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenantReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteAmenityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAmenityPayload = {
  readonly __typename?: 'DeleteAmenityPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteApplicant = {
  readonly __typename?: 'DeleteApplicant';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAttachmentPayload = {
  readonly __typename?: 'DeleteAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityDocumentPayload = {
  readonly __typename?: 'DeleteCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityProductInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityProductPayload = {
  readonly __typename?: 'DeleteCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityUpdateCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityUpdateCommentPayload = {
  readonly __typename?: 'DeleteCommunityUpdateCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteCommunityUpdatePayload = {
  readonly __typename?: 'DeleteCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteComplianceRequirementV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteComplianceRequirementV2Payload = {
  readonly __typename?: 'DeleteComplianceRequirementV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type DeleteConversationTagPayload = {
  readonly __typename?: 'DeleteConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type DeleteHomeImageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteHomeImagePayload = {
  readonly __typename?: 'DeleteHomeImagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteHomePayload = {
  readonly __typename?: 'DeleteHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteMarketplaceItemImageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteMarketplaceItemImagePayload = {
  readonly __typename?: 'DeleteMarketplaceItemImagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItemImage?: Maybe<MarketplaceItemImageNode>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  readonly __typename?: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  readonly exceptions?: Maybe<ReadonlyArray<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  readonly sql?: Maybe<ReadonlyArray<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  readonly __typename?: 'DjangoDebugException';
  /** The class of the exception */
  readonly excType: Scalars['String']['output'];
  /** The message of the exception */
  readonly message: Scalars['String']['output'];
  /** The stack trace */
  readonly stack: Scalars['String']['output'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  readonly __typename?: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  readonly alias: Scalars['String']['output'];
  /** Duration of this database query in seconds. */
  readonly duration: Scalars['Float']['output'];
  /** Postgres connection encoding if available. */
  readonly encoding?: Maybe<Scalars['String']['output']>;
  /** Whether this database query was a SELECT. */
  readonly isSelect: Scalars['Boolean']['output'];
  /** Whether this database query took more than 10 seconds. */
  readonly isSlow: Scalars['Boolean']['output'];
  /** Postgres isolation level if available. */
  readonly isoLevel?: Maybe<Scalars['String']['output']>;
  /** JSON encoded database query parameters. */
  readonly params: Scalars['String']['output'];
  /** The raw SQL of this query, without params. */
  readonly rawSql: Scalars['String']['output'];
  /** The actual SQL sent to this database. */
  readonly sql?: Maybe<Scalars['String']['output']>;
  /** Start time of this database query. */
  readonly startTime: Scalars['Float']['output'];
  /** Stop time of this database query. */
  readonly stopTime: Scalars['Float']['output'];
  /** Postgres transaction ID if available. */
  readonly transId?: Maybe<Scalars['String']['output']>;
  /** Postgres transaction status if available. */
  readonly transStatus?: Maybe<Scalars['String']['output']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  readonly vendor: Scalars['String']['output'];
};

export type DocumentContent = CommunityDocumentNode | ResidencyDocumentNode;

export type DocumentNode = {
  readonly __typename?: 'DocumentNode';
  readonly contentObject?: Maybe<DocumentContent>;
  readonly id: Scalars['UUID']['output'];
};

export type DocumentNodeConnection = {
  readonly __typename?: 'DocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<DocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DocumentNode` and its cursor. */
export type DocumentNodeEdge = {
  readonly __typename?: 'DocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<DocumentNode>;
};

export type DownloadRateType = {
  readonly __typename?: 'DownloadRateType';
  readonly date?: Maybe<Scalars['Date']['output']>;
  readonly downloadRate?: Maybe<Scalars['Float']['output']>;
};

export type EpcResponseType = {
  readonly __typename?: 'EPCResponseType';
  readonly checkedDate: Scalars['String']['output'];
  readonly city: Scalars['String']['output'];
  readonly currentEnergyEfficiency: Scalars['String']['output'];
  readonly currentEnergyRating: Scalars['String']['output'];
  readonly expiryDate: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly postcode: Scalars['String']['output'];
  readonly potentialEnergyEfficiency: Scalars['String']['output'];
  readonly potentialEnergyRating: Scalars['String']['output'];
};

export type EditKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly image?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly reference?: InputMaybe<Scalars['String']['input']>;
};

export type EditKeyPayload = {
  readonly __typename?: 'EditKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type EditMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly email: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
};

export type EditMemberPayload = {
  readonly __typename?: 'EditMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type EmployerReferenceNode = {
  readonly __typename?: 'EmployerReferenceNode';
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employeeInputtedCompanyName?: Maybe<Scalars['String']['output']>;
  readonly employeeName?: Maybe<Scalars['String']['output']>;
  readonly employerEmploymentDetails?: Maybe<EmploymentDetailsNode>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<TenancyApplicationEmployerReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmployerUpdateEmploymentDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly employerReferenceId: Scalars['String']['input'];
  readonly employmentEnding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly employmentType?: InputMaybe<Scalars['String']['input']>;
  readonly fullOrPartTime?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly income?: InputMaybe<Scalars['Decimal']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type EmployerUpdateEmploymentDetailsPayload = {
  readonly __typename?: 'EmployerUpdateEmploymentDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly fullOrPartTime?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type EmployerUpdatePersonalDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type EmployerUpdatePersonalDetailsPayload = {
  readonly __typename?: 'EmployerUpdatePersonalDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDetailsNode = {
  readonly __typename?: 'EmploymentDetailsNode';
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType: TenancyApplicationEmploymentDetailsEmploymentTypeChoices;
  readonly fullOrPartTime?: Maybe<TenancyApplicationEmploymentDetailsFullOrPartTimeChoices>;
  readonly id: Scalars['UUID']['output'];
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<TenancyApplicationEmploymentDetailsPaymentFrequencyChoices>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type ErrorType = {
  readonly __typename?: 'ErrorType';
  readonly field: Scalars['String']['output'];
  readonly messages: ReadonlyArray<Scalars['String']['output']>;
};

export type FakeCreditCheckMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creditSafePayload: Scalars['String']['input'];
  readonly tenantReferenceId: Scalars['UUID']['input'];
};

export type FakeCreditCheckMutationPayload = {
  readonly __typename?: 'FakeCreditCheckMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenantReference: TenantReferenceNode;
};

export type FakeSendTenantReferenceRequestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly tenantReferenceId: Scalars['UUID']['input'];
};

export type FakeSendTenantReferenceRequestPayload = {
  readonly __typename?: 'FakeSendTenantReferenceRequestPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenantReference: TenantReferenceNode;
};

export type FakeStripeInvoicePaidEventInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly invoiceId: Scalars['String']['input'];
};

export type FakeStripeInvoicePaidEventPayload = {
  readonly __typename?: 'FakeStripeInvoicePaidEventPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly invoice?: Maybe<InvoiceNode>;
};

export type FeatureType = {
  readonly __typename?: 'FeatureType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isBeta: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type FixFloType = {
  readonly __typename?: 'FixFloType';
  readonly baseUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
};

export type GeneratedAgreementNode = {
  readonly __typename?: 'GeneratedAgreementNode';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly paidForByInvoice?: Maybe<Scalars['Boolean']['output']>;
  readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly residency?: Maybe<ResidencyType>;
  readonly residentNames?: Maybe<Scalars['String']['output']>;
  readonly signatures: AgreementSignatureNodeConnection;
  readonly status: AstGeneratorGeneratedAgreementStatusChoices;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmail?: Maybe<Scalars['String']['output']>;
  readonly tenantMobile?: Maybe<Scalars['String']['output']>;
  readonly tenants: AgreementTenantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};


export type GeneratedAgreementNodeSignaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GeneratedAgreementNodeTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratedAgreementNodeConnection = {
  readonly __typename?: 'GeneratedAgreementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GeneratedAgreementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GeneratedAgreementNode` and its cursor. */
export type GeneratedAgreementNodeEdge = {
  readonly __typename?: 'GeneratedAgreementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GeneratedAgreementNode>;
};

export type GeneratedAgreementType = {
  readonly __typename?: 'GeneratedAgreementType';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly residency?: Maybe<ResidencyType>;
  readonly residentNames?: Maybe<Scalars['String']['output']>;
  readonly signatures: AgreementSignatureNodeConnection;
  readonly status: AstGeneratorGeneratedAgreementStatusChoices;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmail?: Maybe<Scalars['String']['output']>;
  readonly tenantMobile?: Maybe<Scalars['String']['output']>;
  readonly tenants: AgreementTenantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};


export type GeneratedAgreementTypeSignaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GeneratedAgreementTypeTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratedSection21Node = {
  readonly __typename?: 'GeneratedSection21Node';
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided: Scalars['Boolean']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly remindLandlord: Scalars['Boolean']['output'];
  readonly serviceDate?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmails?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly viewedOnArk: Scalars['Boolean']['output'];
};

export type GeneratedSection21NodeConnection = {
  readonly __typename?: 'GeneratedSection21NodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GeneratedSection21NodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GeneratedSection21Node` and its cursor. */
export type GeneratedSection21NodeEdge = {
  readonly __typename?: 'GeneratedSection21NodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GeneratedSection21Node>;
};

export type GeneratedSection21Type = {
  readonly __typename?: 'GeneratedSection21Type';
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided: Scalars['Boolean']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly serviceDate?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly viewedOnArk: Scalars['Boolean']['output'];
};

export type GroupChatMessageNode = {
  readonly __typename?: 'GroupChatMessageNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly media?: Maybe<Scalars['String']['output']>;
  readonly text?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type GroupChatMessageNodeConnection = {
  readonly __typename?: 'GroupChatMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatMessageNode` and its cursor. */
export type GroupChatMessageNodeEdge = {
  readonly __typename?: 'GroupChatMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatMessageNode>;
};

export type GroupChatNode = {
  readonly __typename?: 'GroupChatNode';
  readonly community: CommunityNode;
  readonly id: Scalars['UUID']['output'];
};

export type GroupChatNodeConnection = {
  readonly __typename?: 'GroupChatNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatNode` and its cursor. */
export type GroupChatNodeEdge = {
  readonly __typename?: 'GroupChatNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatNode>;
};

export enum HistoricalDataFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum HistoricalDataPointType {
  ActiveResidentCount = 'ACTIVE_RESIDENT_COUNT',
  AveragePackageCollectionTime = 'AVERAGE_PACKAGE_COLLECTION_TIME',
  DownloadRatePercentage = 'DOWNLOAD_RATE_PERCENTAGE',
  FacilityBookingsCount = 'FACILITY_BOOKINGS_COUNT',
  IncomingMessagesCount = 'INCOMING_MESSAGES_COUNT',
  KeyInCount = 'KEY_IN_COUNT',
  KeyOutCount = 'KEY_OUT_COUNT',
  PackageCollectedCount = 'PACKAGE_COLLECTED_COUNT',
  PackageDeliveredCount = 'PACKAGE_DELIVERED_COUNT'
}

export type HomeDetailsType = {
  readonly __typename?: 'HomeDetailsType';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly furnishing?: Maybe<ResidentialManagementHomeDetailsFurnishingChoices>;
  readonly garden?: Maybe<Scalars['Boolean']['output']>;
  readonly home: HomeType;
  readonly kitchen?: Maybe<Scalars['Boolean']['output']>;
  readonly numBathrooms?: Maybe<Scalars['Int']['output']>;
  readonly numBedrooms?: Maybe<Scalars['Int']['output']>;
  readonly numEnsuites?: Maybe<Scalars['Int']['output']>;
  readonly numLivingRooms?: Maybe<Scalars['Int']['output']>;
  readonly office?: Maybe<Scalars['Boolean']['output']>;
  readonly parking?: Maybe<ResidentialManagementHomeDetailsParkingChoices>;
};

export type HomeImageType = {
  readonly __typename?: 'HomeImageType';
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
};

export type HomeImageTypeConnection = {
  readonly __typename?: 'HomeImageTypeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<HomeImageTypeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HomeImageType` and its cursor. */
export type HomeImageTypeEdge = {
  readonly __typename?: 'HomeImageTypeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<HomeImageType>;
};

export type HomeNode = {
  readonly __typename?: 'HomeNode';
  readonly HMO: Scalars['Boolean']['output'];
  readonly activeResidency?: Maybe<ResidencyNode>;
  readonly address: Scalars['String']['output'];
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly applications: ApplicationNodeConnection;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly community?: Maybe<CommunityNode>;
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly hasFixfloExternalId?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly images: HomeImageTypeConnection;
  readonly keys?: Maybe<KeyNodeConnection>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly name: Scalars['String']['output'];
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly postcode: Scalars['String']['output'];
  readonly residencies?: Maybe<ResidencyNodeConnection>;
  readonly similarity?: Maybe<Scalars['Float']['output']>;
  readonly uncollectedPackageCount: Scalars['Int']['output'];
};


export type HomeNodeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeNodeKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type HomeNodeResidenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeNodeConnection = {
  readonly __typename?: 'HomeNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<HomeNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HomeNode` and its cursor. */
export type HomeNodeEdge = {
  readonly __typename?: 'HomeNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<HomeNode>;
};

export type HomeType = {
  readonly __typename?: 'HomeType';
  readonly HMO: Scalars['Boolean']['output'];
  readonly activeResidencies?: Maybe<ReadonlyArray<Maybe<ResidencyType>>>;
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly applications: ApplicationNodeConnection;
  readonly archivedLeaseholds: LeaseholdNodeConnection;
  readonly block?: Maybe<BlockNode>;
  readonly cachedAddressees?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly community?: Maybe<CommunityNode>;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly conversations: ConversationNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentPackageCount?: Maybe<Scalars['Int']['output']>;
  readonly currentResidency?: Maybe<ResidencyType>;
  readonly details?: Maybe<HomeDetailsType>;
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly images: HomeImageTypeConnection;
  readonly keys: KeyNodeConnection;
  readonly latitude?: Maybe<Scalars['Decimal']['output']>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly longitude?: Maybe<Scalars['Decimal']['output']>;
  readonly name: Scalars['String']['output'];
  readonly numRooms: Scalars['Int']['output'];
  readonly packages: PackageNodeConnection;
  readonly postcode: Scalars['String']['output'];
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly section21s: GeneratedSection21NodeConnection;
  readonly shortCode?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplications: TenancyApplicationNodeConnection;
  readonly uncollectedPackageCount: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type HomeTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeArchivedLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type HomeTypeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type HomeTypeSection21sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeTenancyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type IdentityVerificationNode = {
  readonly __typename?: 'IdentityVerificationNode';
  readonly documentExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly documentNumber?: Maybe<Scalars['String']['output']>;
  readonly documentType?: Maybe<Scalars['String']['output']>;
  readonly hasRightToRent?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly nationality?: Maybe<Scalars['String']['output']>;
  readonly passport?: Maybe<Scalars['String']['output']>;
  readonly passportSelfie?: Maybe<Scalars['String']['output']>;
  readonly personaInquiryId: Scalars['String']['output'];
  readonly selfie?: Maybe<Scalars['String']['output']>;
  readonly status: TenancyApplicationIdentityVerificationStatusChoices;
};

export type IgnoreMessageSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type IgnoreMessageSuggestionPayload = {
  readonly __typename?: 'IgnoreMessageSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type InitializeSignup = {
  readonly __typename?: 'InitializeSignup';
  readonly landlord?: Maybe<LandlordNode>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationType = {
  readonly __typename?: 'IntegrationType';
  readonly fixflo?: Maybe<FixFloType>;
};

export type InviteDemoUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly email: Scalars['String']['input'];
};

export type InviteDemoUserPayload = {
  readonly __typename?: 'InviteDemoUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly residency: ResidencyNode;
};

export type InvoiceNode = {
  readonly __typename?: 'InvoiceNode';
  readonly id: Scalars['UUID']['output'];
  readonly isPaid: Scalars['Boolean']['output'];
};

export type InvoiceNodeConnection = {
  readonly __typename?: 'InvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<InvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceNode` and its cursor. */
export type InvoiceNodeEdge = {
  readonly __typename?: 'InvoiceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<InvoiceNode>;
};

export type Invoices = {
  readonly __typename?: 'Invoices';
  readonly amount: Scalars['Int']['output'];
  readonly charge?: Maybe<ChargeType>;
  readonly created: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly nextPaymentAttempt?: Maybe<Scalars['Date']['output']>;
  readonly number?: Maybe<Scalars['String']['output']>;
  readonly paidAt?: Maybe<Scalars['String']['output']>;
  readonly paymentIntent?: Maybe<PaymentIntentType>;
  readonly status: Scalars['String']['output'];
};

export type KeyEventNode = {
  readonly __typename?: 'KeyEventNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly key: KeyNode;
  readonly keyholder: KeyholderNode;
  readonly performedBy: UserType;
  readonly type: ResidentialManagementKeyEventTypeChoices;
};

export type KeyEventNodeConnection = {
  readonly __typename?: 'KeyEventNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyEventNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyEventNode` and its cursor. */
export type KeyEventNodeEdge = {
  readonly __typename?: 'KeyEventNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyEventNode>;
};

export type KeyNode = {
  readonly __typename?: 'KeyNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly checkoutDate?: Maybe<Scalars['DateTime']['output']>;
  readonly community: CommunityNode;
  readonly communityName: Scalars['String']['output'];
  readonly currentKeyholder?: Maybe<KeyholderNode>;
  readonly events: KeyEventNodeConnection;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly keyholders: KeyholderNodeConnection;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly reference?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
};


export type KeyNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyNodeKeyholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type KeyNodeConnection = {
  readonly __typename?: 'KeyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyNode` and its cursor. */
export type KeyNodeEdge = {
  readonly __typename?: 'KeyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyNode>;
};

export type KeyholderNode = {
  readonly __typename?: 'KeyholderNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly key: KeyNode;
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['DateTime']['output'];
  readonly type: Scalars['String']['output'];
};

export type KeyholderNodeConnection = {
  readonly __typename?: 'KeyholderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyholderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyholderNode` and its cursor. */
export type KeyholderNodeEdge = {
  readonly __typename?: 'KeyholderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyholderNode>;
};

export type LabelConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly tags: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type LabelConversationPayload = {
  readonly __typename?: 'LabelConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type LandlordAttachmentNode = {
  readonly __typename?: 'LandlordAttachmentNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly type: ComplianceAttachmentTypeChoices;
};

export type LandlordAttachmentType = {
  readonly __typename?: 'LandlordAttachmentType';
  readonly client: ClientType;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly type: ComplianceAttachmentTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type LandlordDocumentNode = GeneratedAgreementNode | GeneratedSection21Node | LandlordAttachmentNode;

export type LandlordNode = {
  readonly __typename?: 'LandlordNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly smsPreferences: Scalars['Boolean']['output'];
};

export type LandlordReferenceNode = {
  readonly __typename?: 'LandlordReferenceNode';
  readonly comments?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly hasOutstandingRent: TenancyApplicationLandlordReferenceHasOutstandingRentChoices;
  readonly id: Scalars['UUID']['output'];
  readonly landlordOrAgent: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile: Scalars['String']['output'];
  readonly monthlyRentAmount: Scalars['Decimal']['output'];
  readonly rentPaidOnTime: TenancyApplicationLandlordReferenceRentPaidOnTimeChoices;
  readonly step?: Maybe<TenancyApplicationLandlordReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tenancyType: TenancyApplicationLandlordReferenceTenancyTypeChoices;
  readonly tenantMoveInDate?: Maybe<Scalars['Date']['output']>;
  readonly tenantReference?: Maybe<TenantReferenceNode>;
  readonly treatedPropertyWell: TenancyApplicationLandlordReferenceTreatedPropertyWellChoices;
};

export type LandlordUpdateLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordOrAgent: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile: Scalars['String']['input'];
};

export type LandlordUpdateLandlordReferencePayload = {
  readonly __typename?: 'LandlordUpdateLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordOrAgent?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type LandlordUpdateRentalDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly hasOutstandingRent?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly monthlyRentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly rentPaidOnTime?: InputMaybe<Scalars['String']['input']>;
  readonly tenancyType?: InputMaybe<Scalars['String']['input']>;
  readonly tenantMoveInDate?: InputMaybe<Scalars['Date']['input']>;
  readonly treatedPropertyWell?: InputMaybe<Scalars['String']['input']>;
};

export type LandlordUpdateRentalDetailsPayload = {
  readonly __typename?: 'LandlordUpdateRentalDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly hasOutstandingRent?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly monthlyRentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly rentPaidOnTime?: Maybe<Scalars['String']['output']>;
  readonly tenancyType?: Maybe<Scalars['String']['output']>;
  readonly tenantMoveInDate?: Maybe<Scalars['Date']['output']>;
  readonly treatedPropertyWell?: Maybe<Scalars['String']['output']>;
};

export type LeaseholdNode = {
  readonly __typename?: 'LeaseholdNode';
  readonly balance?: Maybe<Scalars['Decimal']['output']>;
  readonly balanceLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly lastPayment?: Maybe<PaymentNode>;
  readonly leaseholder: LeaseholderNodeConnection;
};


export type LeaseholdNodeLeaseholderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaseholdNodeConnection = {
  readonly __typename?: 'LeaseholdNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholdNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholdNode` and its cursor. */
export type LeaseholdNodeEdge = {
  readonly __typename?: 'LeaseholdNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholdNode>;
};

export type LeaseholderNode = {
  readonly __typename?: 'LeaseholderNode';
  readonly id: Scalars['UUID']['output'];
  readonly leaseholds: LeaseholdNodeConnection;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly serviceChargeWaiverAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly user: UserType;
};


export type LeaseholderNodeLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaseholderNodeConnection = {
  readonly __typename?: 'LeaseholderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholderNode` and its cursor. */
export type LeaseholderNodeEdge = {
  readonly __typename?: 'LeaseholderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholderNode>;
};

export type LogDocumentReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LogDocumentReadPayload = {
  readonly __typename?: 'LogDocumentReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type LogManagerDashUse = {
  readonly __typename?: 'LogManagerDashUse';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type LogPublicDocumentReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LogPublicDocumentReadPayload = {
  readonly __typename?: 'LogPublicDocumentReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type LogUserAppUseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceBrand: Scalars['String']['input'];
  readonly deviceNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deviceType: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly locale?: InputMaybe<Scalars['String']['input']>;
  readonly systemName: Scalars['String']['input'];
};

export type LogUserAppUsePayload = {
  readonly __typename?: 'LogUserAppUsePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceBrand?: Maybe<Scalars['String']['output']>;
  readonly deviceNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deviceType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly systemName?: Maybe<Scalars['String']['output']>;
};

export type ManagerAddApplicationHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerAddApplicationHomePayload = {
  readonly __typename?: 'ManagerAddApplicationHomePayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerCancelAmenityReservationInput = {
  readonly cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerCancelAmenityReservationPayload = {
  readonly __typename?: 'ManagerCancelAmenityReservationPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerCreateAmenityReservationInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly reason: Scalars['String']['input'];
  readonly timeSlots: ReadonlyArray<InputMaybe<TimeSlot>>;
};

export type ManagerCreateAmenityReservationPayload = {
  readonly __typename?: 'ManagerCreateAmenityReservationPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ManagerNotificationType = {
  readonly __typename?: 'ManagerNotificationType';
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly contentObject?: Maybe<NotificationContentObjectType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly dismissed: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ManagerProfileType = {
  readonly __typename?: 'ManagerProfileType';
  readonly ASTPageViewed: Scalars['Boolean']['output'];
  readonly acceptedMarketing: Scalars['Boolean']['output'];
  readonly complianceEmailExplanation: Scalars['Boolean']['output'];
  readonly compliancePageViewed: Scalars['Boolean']['output'];
  readonly complianceUpdateEmails: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly manager: ManagerType;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly valueQuestionnaireAnswer?: Maybe<Scalars['Int']['output']>;
};

export type ManagerReserveAmenityInput = {
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly start: Scalars['DateTime']['input'];
};

export type ManagerReserveAmenityPayload = {
  readonly __typename?: 'ManagerReserveAmenityPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerType = {
  readonly __typename?: 'ManagerType';
  readonly applicationAttempts: ApplicationAttemptNodeConnection;
  readonly calendarLink?: Maybe<CalendarLinkType>;
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly community?: Maybe<CommunityNodeConnection>;
  readonly complianceUpdateReads: ReadonlyArray<ComplianceUpdateReadType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdDocuments: CommunityDocumentNodeConnection;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly profile?: Maybe<ManagerProfileType>;
  readonly residencydocumentSet: ResidencyDocumentNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ManagerTypeApplicationAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCommunityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCreatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeResidencydocumentSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceItemCommentNode = {
  readonly __typename?: 'MarketplaceItemCommentNode';
  readonly author?: Maybe<UserType>;
  readonly comment: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
};

export type MarketplaceItemCommentNodeConnection = {
  readonly __typename?: 'MarketplaceItemCommentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemCommentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemCommentNode` and its cursor. */
export type MarketplaceItemCommentNodeEdge = {
  readonly __typename?: 'MarketplaceItemCommentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemCommentNode>;
};

export type MarketplaceItemImageNode = {
  readonly __typename?: 'MarketplaceItemImageNode';
  readonly id: Scalars['UUID']['output'];
  readonly image: Scalars['String']['output'];
};

export type MarketplaceItemImageNodeConnection = {
  readonly __typename?: 'MarketplaceItemImageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemImageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemImageNode` and its cursor. */
export type MarketplaceItemImageNodeEdge = {
  readonly __typename?: 'MarketplaceItemImageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemImageNode>;
};

export type MarketplaceItemNode = {
  readonly __typename?: 'MarketplaceItemNode';
  readonly archivedBy?: Maybe<UserType>;
  readonly archivedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedReason?: Maybe<Scalars['String']['output']>;
  readonly closedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly comments: MarketplaceItemCommentNodeConnection;
  readonly community: CommunityNode;
  readonly condition?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly images: MarketplaceItemImageNodeConnection;
  readonly notifications?: Maybe<NotificationNodeConnection>;
  readonly price: Scalars['Decimal']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type MarketplaceItemNodeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MarketplaceItemNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MarketplaceItemNodeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketplaceItemNodeConnection = {
  readonly __typename?: 'MarketplaceItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemNode` and its cursor. */
export type MarketplaceItemNodeEdge = {
  readonly __typename?: 'MarketplaceItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemNode>;
};

export type MessageSuggestionType = {
  readonly __typename?: 'MessageSuggestionType';
  readonly action?: Maybe<ResidentialManagementMessageSuggestionActionChoices>;
  readonly alteredMessage?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly suggestion?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly version: Scalars['Int']['output'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly acceptApplication?: Maybe<AcceptApplication>;
  readonly acceptMessageSuggestion?: Maybe<AcceptMessageSuggestionPayload>;
  readonly acceptServiceChargeWaiver?: Maybe<AcceptServiceChargeWaiverPayload>;
  readonly acceptTermsAndConditions?: Maybe<AcceptTermsAndConditionsPayload>;
  readonly activateGroup?: Maybe<ActivateGroupPayload>;
  readonly addApplicationCommunity?: Maybe<AddApplicationCommunity>;
  readonly addApplicationHome?: Maybe<AddApplicationHome>;
  readonly addApplicationOwnershipType?: Maybe<AddApplicationOwnershipType>;
  readonly addDocumentSentStatus?: Maybe<AddDocumentSentStatus>;
  readonly addFeatureToClient?: Maybe<AddFeatureToClientPayload>;
  readonly addMember?: Maybe<AddMemberPayload>;
  readonly addPackageToHome?: Maybe<AddPackageToHomePayload>;
  readonly addUnknownCommunityStatus?: Maybe<AddUnknownCommunityStatus>;
  readonly archiveApplication?: Maybe<ArchiveApplicationPayload>;
  readonly archiveKey?: Maybe<ArchiveKeyPayload>;
  readonly archiveKeyholder?: Maybe<ArchiveKeyholderPayload>;
  readonly archiveMarketplaceItem?: Maybe<ArchiveMarketplaceItemPayload>;
  readonly associateAgreementWithClient?: Maybe<AssociateAgreementWithClient>;
  readonly associateSection21WithClient?: Maybe<AssociateSection21WithClient>;
  readonly bookCommunityEvent?: Maybe<BookCommunityEventMutationPayload>;
  readonly bookPaidCommunityEvent?: Maybe<BookPaidCommunityEventMutationPayload>;
  readonly cancelAmenityReservation?: Maybe<CancelAmenityReservationPayload>;
  readonly cancelPayment?: Maybe<CancelPaymentPayload>;
  readonly cancelScheduledPublishCommunityUpdate?: Maybe<CancelScheduledPublishCommunityUpdatePayload>;
  readonly checkInKeyV2?: Maybe<CheckInKeyV2Payload>;
  readonly checkOutKeyV2?: Maybe<CheckOutKeyV2Payload>;
  readonly closeConversation?: Maybe<CloseConversationPayload>;
  readonly closeSurvey?: Maybe<CloseSurvey>;
  readonly collectPackages?: Maybe<CollectPackagesPayload>;
  readonly collectPackagesForHome?: Maybe<CollectPackagesForHomePayload>;
  readonly confirmResidencyWillRoll?: Maybe<ConfirmResidencyWillRollPayload>;
  readonly countersignAgreement?: Maybe<CountersignAgreementPayload>;
  readonly createAgreementForTenancy?: Maybe<CreateAgreementForTenancyPayload>;
  readonly createAmenityReservation?: Maybe<CreateAmenityReservationMutationPayload>;
  readonly createApplicantAndApplication?: Maybe<CreateApplicantAndApplicationPayload>;
  readonly createApplication?: Maybe<CreateApplicationPayload>;
  readonly createAttachmentOnHome?: Maybe<CreateAttachmentOnHomePayload>;
  readonly createAttachmentOnRequirementItem?: Maybe<CreateAttachmentOnRequirementItemPayload>;
  readonly createBlockComplianceRequirementItem?: Maybe<CreateBlockComplianceRequirementItemPayload>;
  readonly createBlocks?: Maybe<CreateBlocks>;
  readonly createBlocksComplianceRequirement?: Maybe<CreateBlocksComplianceRequirementPayload>;
  readonly createCheckoutLink?: Maybe<CreateCheckoutLinkPayload>;
  readonly createCommunityDocument?: Maybe<CreateCommunityDocumentPayload>;
  readonly createCommunityDocumentView?: Maybe<CreateCommunityDocumentViewPayload>;
  readonly createCommunityProduct?: Maybe<CreateCommunityProductPayload>;
  readonly createCommunityProductPayment?: Maybe<CreateCommunityProductPaymentPayload>;
  readonly createCommunityUpdateRead?: Maybe<CreateCommunityUpdateReadPayload>;
  readonly createCommunityVisitor?: Maybe<CreateCommunityVisitorPayload>;
  readonly createComplianceRequirement?: Maybe<CreateComplianceRequirementPayload>;
  readonly createComplianceUpdateRead?: Maybe<CreateComplianceUpdateReadPayload>;
  readonly createConversation?: Maybe<CreateConversation>;
  readonly createConversationAction?: Maybe<CreateConversationActionPayload>;
  readonly createConversationAndFirstMessage?: Maybe<CreateConversationAndFirstMessage>;
  readonly createConversationAssignment?: Maybe<CreateConversationAssignmentPayload>;
  readonly createConversationMessage?: Maybe<CreateConversationMessage>;
  readonly createConversationNote?: Maybe<CreateConversationNotePayload>;
  readonly createConversationSummary?: Maybe<CreateConversationSummaryPayload>;
  readonly createConversationTag?: Maybe<CreateConversationTagPayload>;
  readonly createGroup?: Maybe<CreateGroupPayload>;
  readonly createGroupChatMessage?: Maybe<CreateGroupChatMessagePayload>;
  readonly createKeyV2?: Maybe<CreateKeyV2Payload>;
  readonly createKeyholderV2?: Maybe<CreateKeyholderV2Payload>;
  readonly createManagerConversationRead?: Maybe<CreateManagerConversationReadPayload>;
  readonly createMarketplaceItemComment?: Maybe<CreateMarketplaceItemCommentPayload>;
  readonly createNewDevice?: Maybe<CreateNewDevice>;
  readonly createOccupancySurvey?: Maybe<CreateOccupancySurvey>;
  readonly createOpenedConversation?: Maybe<CreateOpenedConversation>;
  readonly createPayment?: Maybe<CreatePaymentPayload>;
  readonly createResidencyAndResidents?: Maybe<CreateResidencyAndResidents>;
  readonly createResidencyDocument?: Maybe<CreateResidencyDocumentPayload>;
  readonly createResidencyDocumentView?: Maybe<CreateResidencyDocumentViewPayload>;
  readonly createResidencyDocuments?: Maybe<CreateResidencyDocuments>;
  readonly createResidencySubscription?: Maybe<CreateResidencySubscriptionPayload>;
  readonly createStripeAccount?: Maybe<CreateStripeAccount>;
  readonly createSurvey?: Maybe<CreateSurveyPayload>;
  readonly createTenancyApplication?: Maybe<CreateTenancyApplicationPayload>;
  readonly createUpdateComment?: Maybe<CreateUpdateCommentPayload>;
  readonly deactivateClientUser?: Maybe<DeactivateClientUserPayload>;
  readonly deactivateGroup?: Maybe<DeactivateGroupPayload>;
  readonly deleteAmenity?: Maybe<DeleteAmenityPayload>;
  readonly deleteApplicant?: Maybe<DeleteApplicant>;
  readonly deleteAttachment?: Maybe<DeleteAttachmentPayload>;
  readonly deleteCommunityDocument?: Maybe<DeleteCommunityDocumentPayload>;
  readonly deleteCommunityProduct?: Maybe<DeleteCommunityProductPayload>;
  readonly deleteCommunityUpdate?: Maybe<DeleteCommunityUpdatePayload>;
  readonly deleteComplianceRequirementV2?: Maybe<DeleteComplianceRequirementV2Payload>;
  readonly deleteConversationTag?: Maybe<DeleteConversationTagPayload>;
  readonly deleteHome?: Maybe<DeleteHomePayload>;
  readonly deleteHomeImage?: Maybe<DeleteHomeImagePayload>;
  readonly deleteMarketplaceItemImage?: Maybe<DeleteMarketplaceItemImagePayload>;
  readonly deleteUpdateComment?: Maybe<DeleteCommunityUpdateCommentPayload>;
  readonly editKey?: Maybe<EditKeyPayload>;
  readonly editMember?: Maybe<EditMemberPayload>;
  readonly employerUpdateEmploymentDetails?: Maybe<EmployerUpdateEmploymentDetailsPayload>;
  readonly employerUpdatePersonalDetails?: Maybe<EmployerUpdatePersonalDetailsPayload>;
  readonly fakeCreditCheck?: Maybe<FakeCreditCheckMutationPayload>;
  readonly fakeSendTenantReferenceRequest?: Maybe<FakeSendTenantReferenceRequestPayload>;
  readonly fakeStripeInvoicePaidEvent?: Maybe<FakeStripeInvoicePaidEventPayload>;
  readonly ignoreMessageSuggestion?: Maybe<IgnoreMessageSuggestionPayload>;
  readonly initializeCalendarLink?: Maybe<CalendarLinkType>;
  readonly initializeSignup?: Maybe<InitializeSignup>;
  readonly inviteDemoUser?: Maybe<InviteDemoUserPayload>;
  readonly labelConversation?: Maybe<LabelConversationPayload>;
  readonly landlordUpdateLandlordReference?: Maybe<LandlordUpdateLandlordReferencePayload>;
  readonly landlordUpdateRentalDetails?: Maybe<LandlordUpdateRentalDetailsPayload>;
  readonly logDocumentRead?: Maybe<LogDocumentReadPayload>;
  readonly logManagerDashUse?: Maybe<LogManagerDashUse>;
  readonly logPublicDocumentRead?: Maybe<LogPublicDocumentReadPayload>;
  readonly logUserAppUse?: Maybe<LogUserAppUsePayload>;
  readonly managerAddApplicationHome?: Maybe<ManagerAddApplicationHomePayload>;
  readonly managerCancelAmenityReservation?: Maybe<ManagerCancelAmenityReservationPayload>;
  readonly managerCreateAmenityReservation?: Maybe<ManagerCreateAmenityReservationPayload>;
  readonly managerReserveAmenity?: Maybe<ManagerReserveAmenityPayload>;
  readonly officiallyVerifyRightToRent?: Maybe<OfficiallyVerifyRightToRentPayload>;
  readonly orderConversationTags?: Maybe<OrderConversationTagsPayload>;
  readonly packageReminderToAll?: Maybe<PackageReminderToAll>;
  readonly packageReminderToHome?: Maybe<PackageReminderToHomePayload>;
  readonly payForDocument?: Maybe<PayForDocumentPayload>;
  readonly payForUnpaidApplicationReferences?: Maybe<PayForUnpaidApplicationReferencesPayload>;
  readonly publishCommunityUpdate?: Maybe<PublishCommunityUpdatePayload>;
  readonly rateConversation?: Maybe<RateConversationPayload>;
  readonly reOpenConversation?: Maybe<ReOpenConversationPayload>;
  readonly readAllNotifications?: Maybe<ReadAllNotificationsPayload>;
  readonly readAllNotificationsOnTarget?: Maybe<ReadAllNotificationsOnTargetPayload>;
  readonly readNotification?: Maybe<ReadNotificationPayload>;
  readonly referenceSignupError?: Maybe<ReferenceSignupErrorPayload>;
  readonly rejectApplication?: Maybe<RejectApplication>;
  readonly remindAllApplicants?: Maybe<RemindAllApplicants>;
  readonly remindApplicant?: Maybe<RemindApplicant>;
  readonly remindResident?: Maybe<RemindResidentPayload>;
  readonly removeConversationTag?: Maybe<RemoveConversationTagPayload>;
  readonly removeResidentFromUnpaidEvents?: Maybe<RemoveResidentFromUnpaidEventsPayload>;
  readonly removeResidentsFromResidency?: Maybe<RemoveResidentsFromResidencyPayload>;
  readonly resendMemberInviteEmail?: Maybe<ResendMemberInviteEmailPayload>;
  readonly reserveAmenity?: Maybe<ReserveAmenityPayload>;
  readonly residentArchiveKeyholder?: Maybe<ResidentArchiveKeyholderPayload>;
  readonly residentCreateKeyholder?: Maybe<ResidentCreateKeyholder>;
  readonly residentUnarchiveKeyholder?: Maybe<ResidentUnarchiveKeyholderPayload>;
  readonly residentUpdateKeyholder?: Maybe<ResidentUpdateKeyholderPayload>;
  readonly restartIdentityVerification?: Maybe<RestartIdentityVerificationPayload>;
  readonly revokeGeneratedAgreement?: Maybe<RevokeGeneratedAgreementPayload>;
  readonly saveAmenity?: Maybe<SaveAmenityPayload>;
  readonly saveCommunityEvent?: Maybe<SaveCommunityEventPayload>;
  readonly saveCommunityUpdate?: Maybe<SaveCommunityUpdatePayload>;
  readonly saveGeneratedAgreement?: Maybe<SaveGeneratedAgreementPayload>;
  readonly saveGeneratedSection21?: Maybe<SaveGeneratedSection21Payload>;
  readonly saveHome?: Maybe<SaveHomePayload>;
  readonly saveManagerProfile?: Maybe<SaveManagerProfilePayload>;
  readonly saveMarketplaceItem?: Maybe<SaveMarketplaceItemPayload>;
  readonly saveRequirementItem?: Maybe<SaveRequirementItemPayload>;
  readonly saveResidentSurveyAnswer?: Maybe<SaveResidentSurveyAnswerPayload>;
  readonly saveTenantEmploymentDetails?: Maybe<SaveTenantEmploymentDetailsPayload>;
  readonly schedulePublishCommunityUpdate?: Maybe<SchedulePublishCommunityUpdatePayload>;
  readonly sendAgreementForSigning?: Maybe<SendAgreementForSigning>;
  readonly sendDocument?: Maybe<SendDocument>;
  readonly sendManagerAmplitudeTest?: Maybe<SendManagerAmplitudeTestPayload>;
  readonly sendTenantReferenceRequests?: Maybe<SendTenantReferenceRequestsPayload>;
  readonly setResidencyCompletionDate?: Maybe<SetResidencyCompletionDatePayload>;
  readonly setUpManager?: Maybe<SetUpManagerPayload>;
  readonly shareComplianceRequirement?: Maybe<ShareComplianceRequirementPayload>;
  readonly signOutCommunityVisitor?: Maybe<SignOutCommunityVisitorPayload>;
  readonly snoozeConversation?: Maybe<SnoozeConversationPayload>;
  readonly submitEmployerReference?: Maybe<SubmitEmployerReferencePayload>;
  readonly submitIdentityVerification?: Maybe<SubmitIdentityVerificationPayload>;
  readonly submitLandlordReference?: Maybe<SubmitLandlordReferencePayload>;
  readonly submitTenantReference?: Maybe<SubmitTenantReferencePayload>;
  readonly subscribeLandlord?: Maybe<SubscribeLandlordPayload>;
  readonly subscribeToNotificationGroup?: Maybe<SubscribeToNotificationGroup>;
  readonly tagConversation?: Maybe<TagConversationPayload>;
  readonly toggleCommunityUpdateBookmark?: Maybe<ToggleCommunityUpdateBookmarkPayload>;
  readonly toggleCommunityUpdateLike?: Maybe<ToggleCommunityUpdateLikePayload>;
  readonly toggleMarketplaceItemClose?: Maybe<ToggleMarketplaceItemClosePayload>;
  readonly unarchiveApplication?: Maybe<UnarchiveApplicationPayload>;
  readonly unarchiveKey?: Maybe<UnarchiveKeyPayload>;
  readonly unarchiveKeyholder?: Maybe<UnarchiveKeyholderPayload>;
  readonly unbookCommunityEvent?: Maybe<UnbookCommunityEventMutationPayload>;
  readonly unlabelConversation?: Maybe<UnlabelConversationPayload>;
  readonly unsnoozeConversation?: Maybe<UnsnoozeConversationPayload>;
  readonly unsubscribeFromNotificationGroup?: Maybe<UnsubscribeFromNotificationGroup>;
  readonly updateAttachment?: Maybe<UpdateAttachmentPayload>;
  readonly updateClientAdmin?: Maybe<UpdateClientAdminPayload>;
  readonly updateCommunityDocument?: Maybe<UpdateCommunityDocumentPayload>;
  readonly updateCommunityProduct?: Maybe<UpdateCommunityProductPayload>;
  readonly updateCommunitySettings?: Maybe<UpdateCommunitySettingsPayload>;
  readonly updateConversationTag?: Maybe<UpdateConversationTagPayload>;
  readonly updateConversationTitle?: Maybe<UpdateConversationTitlePayload>;
  readonly updateConversationUrgency?: Maybe<UpdateConversationUrgency>;
  readonly updateEmployerReference?: Maybe<UpdateEmployerReferencePayload>;
  readonly updateEmployerReferenceStep?: Maybe<UpdateEmployerReferenceStepPayload>;
  readonly updateGroup?: Maybe<UpdateGroupPayload>;
  readonly updateHomeAddress?: Maybe<UpdateHomeAddressPayload>;
  readonly updateHomeDetails?: Maybe<UpdateHomeDetailsPayload>;
  readonly updateKeyholder?: Maybe<UpdateKeyholderPayload>;
  readonly updateLandlord?: Maybe<UpdateLandlordPayload>;
  readonly updateLandlordReference?: Maybe<UpdateLandlordReferencePayload>;
  readonly updateLandlordReferenceComments?: Maybe<UpdateLandlordReferenceCommentsPayload>;
  readonly updateLandlordReferenceStep?: Maybe<UpdateLandlordReferenceStepPayload>;
  readonly updateManager?: Maybe<UpdateManagerPayload>;
  readonly updateManagerNotificationSettings?: Maybe<UpdateManagerNotificationSettingsPayload>;
  readonly updateMobileNumber?: Maybe<UpdateUserMobileNumberPayload>;
  readonly updatePackageLocation?: Maybe<UpdatePackageLocationPayload>;
  readonly updateReferenceAddressHistory?: Maybe<UpdateReferenceAddressHistoryPayload>;
  readonly updateReferenceStartedOn?: Maybe<UpdateReferenceStartedOnPayload>;
  readonly updateResidencyAndResidents?: Maybe<UpdateResidencyAndResidents>;
  readonly updateResidencyDocument?: Maybe<UpdateResidencyDocumentPayload>;
  readonly updateRightToRent?: Maybe<UpdateRightToRentPayload>;
  readonly updateTenantReference?: Maybe<UpdateTenantReferencePayload>;
  readonly updateTenantReferenceStep?: Maybe<UpdateTenantReferenceStepPayload>;
  readonly updateUser?: Maybe<UpdateUserPayload>;
  readonly upgradeLandlordToSubscription?: Maybe<UpgradeLandlordToSubscriptionPayload>;
};


export type MutationAcceptApplicationArgs = {
  application: Scalars['UUID']['input'];
  home?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAcceptMessageSuggestionArgs = {
  input: AcceptMessageSuggestionInput;
};


export type MutationAcceptServiceChargeWaiverArgs = {
  input: AcceptServiceChargeWaiverInput;
};


export type MutationAcceptTermsAndConditionsArgs = {
  input: AcceptTermsAndConditionsInput;
};


export type MutationActivateGroupArgs = {
  input: ActivateGroupInput;
};


export type MutationAddApplicationCommunityArgs = {
  application: Scalars['UUID']['input'];
  community: Scalars['UUID']['input'];
};


export type MutationAddApplicationHomeArgs = {
  application: Scalars['ID']['input'];
  home: Scalars['UUID']['input'];
};


export type MutationAddApplicationOwnershipTypeArgs = {
  application: Scalars['ID']['input'];
  isResident: Scalars['Boolean']['input'];
  ownershipType: Scalars['String']['input'];
};


export type MutationAddDocumentSentStatusArgs = {
  application: Scalars['ID']['input'];
};


export type MutationAddFeatureToClientArgs = {
  input: AddFeatureToClientInput;
};


export type MutationAddMemberArgs = {
  input: AddMemberInput;
};


export type MutationAddPackageToHomeArgs = {
  input: AddPackageToHomeInput;
};


export type MutationAddUnknownCommunityStatusArgs = {
  application: Scalars['ID']['input'];
};


export type MutationArchiveApplicationArgs = {
  input: ArchiveApplicationInput;
};


export type MutationArchiveKeyArgs = {
  input: ArchiveKeyInput;
};


export type MutationArchiveKeyholderArgs = {
  input: ArchiveKeyholderInput;
};


export type MutationArchiveMarketplaceItemArgs = {
  input: ArchiveMarketplaceItemInput;
};


export type MutationAssociateAgreementWithClientArgs = {
  input: AssociateAgreementWithClientInput;
};


export type MutationAssociateSection21WithClientArgs = {
  input: AssociateSection21WithClientInput;
};


export type MutationBookCommunityEventArgs = {
  input: BookCommunityEventMutationInput;
};


export type MutationBookPaidCommunityEventArgs = {
  input: BookPaidCommunityEventMutationInput;
};


export type MutationCancelAmenityReservationArgs = {
  input: CancelAmenityReservationInput;
};


export type MutationCancelPaymentArgs = {
  input: CancelPaymentInput;
};


export type MutationCancelScheduledPublishCommunityUpdateArgs = {
  input: CancelScheduledPublishCommunityUpdateInput;
};


export type MutationCheckInKeyV2Args = {
  input: CheckInKeyV2Input;
};


export type MutationCheckOutKeyV2Args = {
  input: CheckOutKeyV2Input;
};


export type MutationCloseConversationArgs = {
  input: CloseConversationInput;
};


export type MutationCloseSurveyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCollectPackagesArgs = {
  input: CollectPackagesInput;
};


export type MutationCollectPackagesForHomeArgs = {
  input: CollectPackagesForHomeInput;
};


export type MutationConfirmResidencyWillRollArgs = {
  input: ConfirmResidencyWillRollInput;
};


export type MutationCountersignAgreementArgs = {
  input: CountersignAgreementInput;
};


export type MutationCreateAgreementForTenancyArgs = {
  input: CreateAgreementForTenancyInput;
};


export type MutationCreateAmenityReservationArgs = {
  input: CreateAmenityReservationMutationInput;
};


export type MutationCreateApplicantAndApplicationArgs = {
  input: CreateApplicantAndApplicationInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateAttachmentOnHomeArgs = {
  input: CreateAttachmentOnHomeInput;
};


export type MutationCreateAttachmentOnRequirementItemArgs = {
  input: CreateAttachmentOnRequirementItemInput;
};


export type MutationCreateBlockComplianceRequirementItemArgs = {
  input: CreateBlockComplianceRequirementItemInput;
};


export type MutationCreateBlocksArgs = {
  blockNames?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communityId: Scalars['UUID']['input'];
};


export type MutationCreateBlocksComplianceRequirementArgs = {
  input: CreateBlocksComplianceRequirementInput;
};


export type MutationCreateCheckoutLinkArgs = {
  input: CreateCheckoutLinkInput;
};


export type MutationCreateCommunityDocumentArgs = {
  input: CreateCommunityDocumentInput;
};


export type MutationCreateCommunityDocumentViewArgs = {
  input: CreateCommunityDocumentViewInput;
};


export type MutationCreateCommunityProductArgs = {
  input: CreateCommunityProductInput;
};


export type MutationCreateCommunityProductPaymentArgs = {
  input: CreateCommunityProductPaymentInput;
};


export type MutationCreateCommunityUpdateReadArgs = {
  input: CreateCommunityUpdateReadInput;
};


export type MutationCreateCommunityVisitorArgs = {
  input: CreateCommunityVisitorInput;
};


export type MutationCreateComplianceRequirementArgs = {
  input: CreateComplianceRequirementInput;
};


export type MutationCreateComplianceUpdateReadArgs = {
  input: CreateComplianceUpdateReadInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
  sender: ConversationRole;
};


export type MutationCreateConversationActionArgs = {
  input: CreateConversationActionInput;
};


export type MutationCreateConversationAndFirstMessageArgs = {
  input: CreateConversationAndFirstMessageInput;
};


export type MutationCreateConversationAssignmentArgs = {
  input: CreateConversationAssignmentInput;
};


export type MutationCreateConversationMessageArgs = {
  input: CreateConversationMessageInput;
  sender: ConversationRole;
};


export type MutationCreateConversationNoteArgs = {
  input: CreateConversationNoteInput;
};


export type MutationCreateConversationSummaryArgs = {
  input: CreateConversationSummaryInput;
};


export type MutationCreateConversationTagArgs = {
  input: CreateConversationTagInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupChatMessageArgs = {
  input: CreateGroupChatMessageInput;
};


export type MutationCreateKeyV2Args = {
  input: CreateKeyV2Input;
};


export type MutationCreateKeyholderV2Args = {
  input: CreateKeyholderV2Input;
};


export type MutationCreateManagerConversationReadArgs = {
  input: CreateManagerConversationReadInput;
};


export type MutationCreateMarketplaceItemCommentArgs = {
  input: CreateMarketplaceItemCommentInput;
};


export type MutationCreateNewDeviceArgs = {
  input: CreateNewDeviceInput;
};


export type MutationCreateOccupancySurveyArgs = {
  isOccupant: Scalars['Boolean']['input'];
  occupants?: InputMaybe<ReadonlyArray<InputMaybe<OccupantInput>>>;
  residencyId: Scalars['UUID']['input'];
};


export type MutationCreateOpenedConversationArgs = {
  input: CreateOpenedConversationInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateResidencyAndResidentsArgs = {
  input: ResidencyAndResidentsInput;
};


export type MutationCreateResidencyDocumentArgs = {
  input: CreateResidencyDocumentInput;
};


export type MutationCreateResidencyDocumentViewArgs = {
  input: CreateResidencyDocumentViewInput;
};


export type MutationCreateResidencyDocumentsArgs = {
  input: CreateResidencyDocumentsInput;
};


export type MutationCreateResidencySubscriptionArgs = {
  input: CreateResidencySubscriptionInput;
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateTenancyApplicationArgs = {
  input: CreateTenancyApplicationInput;
};


export type MutationCreateUpdateCommentArgs = {
  input: CreateUpdateCommentInput;
};


export type MutationDeactivateClientUserArgs = {
  input: DeactivateClientUserInput;
};


export type MutationDeactivateGroupArgs = {
  input: DeactivateGroupInput;
};


export type MutationDeleteAmenityArgs = {
  input: DeleteAmenityInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteCommunityDocumentArgs = {
  input: DeleteCommunityDocumentInput;
};


export type MutationDeleteCommunityProductArgs = {
  input: DeleteCommunityProductInput;
};


export type MutationDeleteCommunityUpdateArgs = {
  input: DeleteCommunityUpdateInput;
};


export type MutationDeleteComplianceRequirementV2Args = {
  input: DeleteComplianceRequirementV2Input;
};


export type MutationDeleteConversationTagArgs = {
  input: DeleteConversationTagInput;
};


export type MutationDeleteHomeArgs = {
  input: DeleteHomeInput;
};


export type MutationDeleteHomeImageArgs = {
  input: DeleteHomeImageInput;
};


export type MutationDeleteMarketplaceItemImageArgs = {
  input: DeleteMarketplaceItemImageInput;
};


export type MutationDeleteUpdateCommentArgs = {
  input: DeleteCommunityUpdateCommentInput;
};


export type MutationEditKeyArgs = {
  input: EditKeyInput;
};


export type MutationEditMemberArgs = {
  input: EditMemberInput;
};


export type MutationEmployerUpdateEmploymentDetailsArgs = {
  input: EmployerUpdateEmploymentDetailsInput;
};


export type MutationEmployerUpdatePersonalDetailsArgs = {
  input: EmployerUpdatePersonalDetailsInput;
};


export type MutationFakeCreditCheckArgs = {
  input: FakeCreditCheckMutationInput;
};


export type MutationFakeSendTenantReferenceRequestArgs = {
  input: FakeSendTenantReferenceRequestInput;
};


export type MutationFakeStripeInvoicePaidEventArgs = {
  input: FakeStripeInvoicePaidEventInput;
};


export type MutationIgnoreMessageSuggestionArgs = {
  input: IgnoreMessageSuggestionInput;
};


export type MutationInitializeSignupArgs = {
  acceptedMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  suppressWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInviteDemoUserArgs = {
  input: InviteDemoUserInput;
};


export type MutationLabelConversationArgs = {
  input: LabelConversationInput;
};


export type MutationLandlordUpdateLandlordReferenceArgs = {
  input: LandlordUpdateLandlordReferenceInput;
};


export type MutationLandlordUpdateRentalDetailsArgs = {
  input: LandlordUpdateRentalDetailsInput;
};


export type MutationLogDocumentReadArgs = {
  input: LogDocumentReadInput;
};


export type MutationLogPublicDocumentReadArgs = {
  input: LogPublicDocumentReadInput;
};


export type MutationLogUserAppUseArgs = {
  input: LogUserAppUseInput;
};


export type MutationManagerAddApplicationHomeArgs = {
  input: ManagerAddApplicationHomeInput;
};


export type MutationManagerCancelAmenityReservationArgs = {
  input: ManagerCancelAmenityReservationInput;
};


export type MutationManagerCreateAmenityReservationArgs = {
  input: ManagerCreateAmenityReservationInput;
};


export type MutationManagerReserveAmenityArgs = {
  input: ManagerReserveAmenityInput;
};


export type MutationOfficiallyVerifyRightToRentArgs = {
  input: OfficiallyVerifyRightToRentInput;
};


export type MutationOrderConversationTagsArgs = {
  input: OrderConversationTagsInput;
};


export type MutationPackageReminderToAllArgs = {
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};


export type MutationPackageReminderToHomeArgs = {
  input: PackageReminderToHomeInput;
};


export type MutationPayForDocumentArgs = {
  input: PayForDocumentInput;
};


export type MutationPayForUnpaidApplicationReferencesArgs = {
  input: PayForUnpaidApplicationReferencesInput;
};


export type MutationPublishCommunityUpdateArgs = {
  input: PublishCommunityUpdateInput;
};


export type MutationRateConversationArgs = {
  input: RateConversationInput;
};


export type MutationReOpenConversationArgs = {
  input: ReOpenConversationInput;
};


export type MutationReadAllNotificationsArgs = {
  input: ReadAllNotificationsInput;
};


export type MutationReadAllNotificationsOnTargetArgs = {
  input: ReadAllNotificationsOnTargetInput;
};


export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationReferenceSignupErrorArgs = {
  input: ReferenceSignupErrorInput;
};


export type MutationRejectApplicationArgs = {
  application: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
};


export type MutationRemindAllApplicantsArgs = {
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};


export type MutationRemindApplicantArgs = {
  application: Scalars['UUID']['input'];
};


export type MutationRemindResidentArgs = {
  input: RemindResidentInput;
};


export type MutationRemoveConversationTagArgs = {
  input: RemoveConversationTagInput;
};


export type MutationRemoveResidentFromUnpaidEventsArgs = {
  input: RemoveResidentFromUnpaidEventsInput;
};


export type MutationRemoveResidentsFromResidencyArgs = {
  input: RemoveResidentsFromResidencyInput;
};


export type MutationResendMemberInviteEmailArgs = {
  input: ResendMemberInviteEmailInput;
};


export type MutationReserveAmenityArgs = {
  input: ReserveAmenityInput;
};


export type MutationResidentArchiveKeyholderArgs = {
  input: ResidentArchiveKeyholderInput;
};


export type MutationResidentCreateKeyholderArgs = {
  input: ResidentCreateKeyholderInput;
};


export type MutationResidentUnarchiveKeyholderArgs = {
  input: ResidentUnarchiveKeyholderInput;
};


export type MutationResidentUpdateKeyholderArgs = {
  input: ResidentUpdateKeyholderInput;
};


export type MutationRestartIdentityVerificationArgs = {
  input: RestartIdentityVerificationInput;
};


export type MutationRevokeGeneratedAgreementArgs = {
  input: RevokeGeneratedAgreementInput;
};


export type MutationSaveAmenityArgs = {
  input: SaveAmenityInput;
};


export type MutationSaveCommunityEventArgs = {
  input: SaveCommunityEventInput;
};


export type MutationSaveCommunityUpdateArgs = {
  input: SaveCommunityUpdateInput;
};


export type MutationSaveGeneratedAgreementArgs = {
  input: SaveGeneratedAgreementInput;
};


export type MutationSaveGeneratedSection21Args = {
  input: SaveGeneratedSection21Input;
};


export type MutationSaveHomeArgs = {
  input: SaveHomeInput;
};


export type MutationSaveManagerProfileArgs = {
  input: SaveManagerProfileInput;
};


export type MutationSaveMarketplaceItemArgs = {
  input: SaveMarketplaceItemInput;
};


export type MutationSaveRequirementItemArgs = {
  input: SaveRequirementItemInput;
};


export type MutationSaveResidentSurveyAnswerArgs = {
  input: SaveResidentSurveyAnswerInput;
};


export type MutationSaveTenantEmploymentDetailsArgs = {
  input: SaveTenantEmploymentDetailsInput;
};


export type MutationSchedulePublishCommunityUpdateArgs = {
  input: SchedulePublishCommunityUpdateInput;
};


export type MutationSendAgreementForSigningArgs = {
  input: SendAgreementForSigningInput;
};


export type MutationSendDocumentArgs = {
  input: SendDocumentInput;
};


export type MutationSendManagerAmplitudeTestArgs = {
  input: SendManagerAmplitudeTestInput;
};


export type MutationSendTenantReferenceRequestsArgs = {
  input: SendTenantReferenceRequestsInput;
};


export type MutationSetResidencyCompletionDateArgs = {
  input: SetResidencyCompletionDateInput;
};


export type MutationSetUpManagerArgs = {
  input: SetUpManagerInput;
};


export type MutationShareComplianceRequirementArgs = {
  input: ShareComplianceRequirementInput;
};


export type MutationSignOutCommunityVisitorArgs = {
  input: SignOutCommunityVisitorInput;
};


export type MutationSnoozeConversationArgs = {
  input: SnoozeConversationInput;
};


export type MutationSubmitEmployerReferenceArgs = {
  input: SubmitEmployerReferenceInput;
};


export type MutationSubmitIdentityVerificationArgs = {
  input: SubmitIdentityVerificationInput;
};


export type MutationSubmitLandlordReferenceArgs = {
  input: SubmitLandlordReferenceInput;
};


export type MutationSubmitTenantReferenceArgs = {
  input: SubmitTenantReferenceInput;
};


export type MutationSubscribeLandlordArgs = {
  input: SubscribeLandlordInput;
};


export type MutationSubscribeToNotificationGroupArgs = {
  input: NotificationPreferencesInput;
};


export type MutationTagConversationArgs = {
  input: TagConversationInput;
};


export type MutationToggleCommunityUpdateBookmarkArgs = {
  input: ToggleCommunityUpdateBookmarkInput;
};


export type MutationToggleCommunityUpdateLikeArgs = {
  input: ToggleCommunityUpdateLikeInput;
};


export type MutationToggleMarketplaceItemCloseArgs = {
  input: ToggleMarketplaceItemCloseInput;
};


export type MutationUnarchiveApplicationArgs = {
  input: UnarchiveApplicationInput;
};


export type MutationUnarchiveKeyArgs = {
  input: UnarchiveKeyInput;
};


export type MutationUnarchiveKeyholderArgs = {
  input: UnarchiveKeyholderInput;
};


export type MutationUnbookCommunityEventArgs = {
  input: UnbookCommunityEventMutationInput;
};


export type MutationUnlabelConversationArgs = {
  input: UnlabelConversationInput;
};


export type MutationUnsnoozeConversationArgs = {
  input: UnsnoozeConversationInput;
};


export type MutationUnsubscribeFromNotificationGroupArgs = {
  input: NotificationPreferencesInput;
};


export type MutationUpdateAttachmentArgs = {
  input: UpdateAttachmentInput;
};


export type MutationUpdateClientAdminArgs = {
  input: UpdateClientAdminInput;
};


export type MutationUpdateCommunityDocumentArgs = {
  input: UpdateCommunityDocumentInput;
};


export type MutationUpdateCommunityProductArgs = {
  input: UpdateCommunityProductInput;
};


export type MutationUpdateCommunitySettingsArgs = {
  input: UpdateCommunitySettingsInput;
};


export type MutationUpdateConversationTagArgs = {
  input: UpdateConversationTagInput;
};


export type MutationUpdateConversationTitleArgs = {
  input: UpdateConversationTitleInput;
};


export type MutationUpdateConversationUrgencyArgs = {
  input: UpdateConversationUrgencyInput;
};


export type MutationUpdateEmployerReferenceArgs = {
  input: UpdateEmployerReferenceInput;
};


export type MutationUpdateEmployerReferenceStepArgs = {
  input: UpdateEmployerReferenceStepInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateHomeAddressArgs = {
  input: UpdateHomeAddressInput;
};


export type MutationUpdateHomeDetailsArgs = {
  input: UpdateHomeDetailsInput;
};


export type MutationUpdateKeyholderArgs = {
  input: UpdateKeyholderInput;
};


export type MutationUpdateLandlordArgs = {
  input: UpdateLandlordInput;
};


export type MutationUpdateLandlordReferenceArgs = {
  input: UpdateLandlordReferenceInput;
};


export type MutationUpdateLandlordReferenceCommentsArgs = {
  input: UpdateLandlordReferenceCommentsInput;
};


export type MutationUpdateLandlordReferenceStepArgs = {
  input: UpdateLandlordReferenceStepInput;
};


export type MutationUpdateManagerArgs = {
  input: UpdateManagerInput;
};


export type MutationUpdateManagerNotificationSettingsArgs = {
  input: UpdateManagerNotificationSettingsInput;
};


export type MutationUpdateMobileNumberArgs = {
  input: UpdateUserMobileNumberInput;
};


export type MutationUpdatePackageLocationArgs = {
  input: UpdatePackageLocationInput;
};


export type MutationUpdateReferenceAddressHistoryArgs = {
  input: UpdateReferenceAddressHistoryInput;
};


export type MutationUpdateReferenceStartedOnArgs = {
  input: UpdateReferenceStartedOnInput;
};


export type MutationUpdateResidencyAndResidentsArgs = {
  input: ResidencyAndResidentsInput;
};


export type MutationUpdateResidencyDocumentArgs = {
  input: UpdateResidencyDocumentInput;
};


export type MutationUpdateRightToRentArgs = {
  input: UpdateRightToRentInput;
};


export type MutationUpdateTenantReferenceArgs = {
  input: UpdateTenantReferenceInput;
};


export type MutationUpdateTenantReferenceStepArgs = {
  input: UpdateTenantReferenceStepInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpgradeLandlordToSubscriptionArgs = {
  input: UpgradeLandlordToSubscriptionInput;
};

export type NotificationContentObjectType = ConversationNode | ResidencyType;

export type NotificationNode = {
  readonly __typename?: 'NotificationNode';
  readonly actionObject?: Maybe<ActionObject>;
  readonly actor?: Maybe<Actor>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly read: Scalars['Boolean']['output'];
  readonly recipient: UserType;
  readonly target?: Maybe<Target>;
  readonly title: Scalars['String']['output'];
  readonly verb?: Maybe<Scalars['String']['output']>;
};

export type NotificationNodeConnection = {
  readonly __typename?: 'NotificationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<NotificationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `NotificationNode` and its cursor. */
export type NotificationNodeEdge = {
  readonly __typename?: 'NotificationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<NotificationNode>;
};

export type NotificationPreferencesInput = {
  readonly type: Scalars['String']['input'];
};

export type OccupancySurveyNode = {
  readonly __typename?: 'OccupancySurveyNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOccupant: Scalars['Boolean']['output'];
  readonly occupants: OccupantNodeConnection;
  readonly residency: ResidencyType;
  readonly user: UserType;
};


export type OccupancySurveyNodeOccupantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OccupancySurveyNodeConnection = {
  readonly __typename?: 'OccupancySurveyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OccupancySurveyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OccupancySurveyNode` and its cursor. */
export type OccupancySurveyNodeEdge = {
  readonly __typename?: 'OccupancySurveyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<OccupancySurveyNode>;
};

export type OccupantInput = {
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly first: Scalars['String']['input'];
  readonly last: Scalars['String']['input'];
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OccupantNode = {
  readonly __typename?: 'OccupantNode';
  readonly communicationNeeds?: Maybe<Scalars['String']['output']>;
  readonly first: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly last: Scalars['String']['output'];
  readonly mobilityNeeds?: Maybe<Scalars['String']['output']>;
  readonly occupancySurvey: OccupancySurveyNode;
  readonly user?: Maybe<UserType>;
};

export type OccupantNodeConnection = {
  readonly __typename?: 'OccupantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OccupantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OccupantNode` and its cursor. */
export type OccupantNodeEdge = {
  readonly __typename?: 'OccupantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<OccupantNode>;
};

export type OfficiallyVerifyRightToRentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly officialExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  readonly officialVerificationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type OfficiallyVerifyRightToRentPayload = {
  readonly __typename?: 'OfficiallyVerifyRightToRentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly officialExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly officialVerificationStatus?: Maybe<Scalars['String']['output']>;
};

export type OrderConversationTagsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type OrderConversationTagsPayload = {
  readonly __typename?: 'OrderConversationTagsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type PackageNode = {
  readonly __typename?: 'PackageNode';
  readonly addressee?: Maybe<Scalars['String']['output']>;
  readonly collectedBy?: Maybe<UserType>;
  readonly collectedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly label?: Maybe<Scalars['String']['output']>;
  readonly lastAction: Scalars['DateTime']['output'];
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly reminders?: Maybe<ReadonlyArray<PackageReminderNode>>;
  readonly residency?: Maybe<ResidencyType>;
  readonly resident?: Maybe<ResidentType>;
  readonly scannedInBy?: Maybe<UserType>;
  readonly status: ResidentialManagementPackageStatusChoices;
  readonly user?: Maybe<UserType>;
};

export type PackageNodeConnection = {
  readonly __typename?: 'PackageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PackageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PackageNode` and its cursor. */
export type PackageNodeEdge = {
  readonly __typename?: 'PackageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PackageNode>;
};

export type PackageReminderNode = {
  readonly __typename?: 'PackageReminderNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly user: UserType;
};

export type PackageReminderToAll = {
  readonly __typename?: 'PackageReminderToAll';
  readonly packages?: Maybe<ReadonlyArray<Maybe<PackageNode>>>;
};

export type PackageReminderToHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type PackageReminderToHomePayload = {
  readonly __typename?: 'PackageReminderToHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly home?: Maybe<HomeType>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

export type PayForDocumentInput = {
  readonly agreementId?: InputMaybe<Scalars['ID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly section21Id?: InputMaybe<Scalars['ID']['input']>;
  readonly type: Scalars['String']['input'];
};

export type PayForDocumentPayload = {
  readonly __typename?: 'PayForDocumentPayload';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly invoice?: Maybe<InvoiceNode>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PayForUnpaidApplicationReferencesInput = {
  readonly applicationUuid: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type PayForUnpaidApplicationReferencesPayload = {
  readonly __typename?: 'PayForUnpaidApplicationReferencesPayload';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountNode = {
  readonly __typename?: 'PaymentAccountNode';
  readonly balance: Scalars['Decimal']['output'];
  readonly balanceLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly lastPayment?: Maybe<PaymentNode>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly paymentReference?: Maybe<Scalars['String']['output']>;
  readonly payments?: Maybe<PaymentNodeConnection>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly unreconciledPaymentsTotal?: Maybe<Scalars['Float']['output']>;
};


export type PaymentAccountNodePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type PaymentAccountNodeConnection = {
  readonly __typename?: 'PaymentAccountNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PaymentAccountNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentAccountNode` and its cursor. */
export type PaymentAccountNodeEdge = {
  readonly __typename?: 'PaymentAccountNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PaymentAccountNode>;
};

export type PaymentIntentType = {
  readonly __typename?: 'PaymentIntentType';
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type PaymentMethod = {
  readonly __typename?: 'PaymentMethod';
  readonly bacsDebit?: Maybe<BacsPaymentType>;
  readonly card?: Maybe<CardPaymentType>;
  readonly type: Scalars['String']['output'];
};

export type PaymentNode = {
  readonly __typename?: 'PaymentNode';
  readonly amount: Scalars['BigInt']['output'];
  readonly clientSecret: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly paymentIntentId: Scalars['String']['output'];
  readonly status: PaymentsPaymentStatusChoices;
  readonly type: PaymentsPaymentTypeChoices;
};

export type PaymentNodeConnection = {
  readonly __typename?: 'PaymentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PaymentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentNode` and its cursor. */
export type PaymentNodeEdge = {
  readonly __typename?: 'PaymentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PaymentNode>;
};

/** An enumeration. */
export enum PaymentsPaymentStatusChoices {
  /** Canceled */
  Ca = 'CA',
  /** Created */
  Cr = 'CR',
  /** Payment failed */
  Fa = 'FA',
  /** Partially funded */
  Pf = 'PF',
  /** Processing */
  Pr = 'PR',
  /** Requires action */
  Ra = 'RA',
  /** Succeeded */
  Su = 'SU'
}

/** An enumeration. */
export enum PaymentsPaymentTypeChoices {
  /** AST trial */
  At = 'AT',
  /** Community event */
  Ce = 'CE',
  /** Community product */
  Cp = 'CP',
  /** Deposit */
  De = 'DE',
  /** Payment account */
  Pa = 'PA'
}

/** An enumeration. */
export enum PeopleClientClientTypeChoices {
  /** Buy to let */
  Btl = 'BTL',
  /** Enterprise */
  Ent = 'ENT'
}

/** An enumeration. */
export enum PeopleUnsubscribeNotificationGroupTypeChoices {
  /** RESIDENT_APP_AMENITY */
  ResidentAppAmenity = 'RESIDENT_APP_AMENITY',
  /** RESIDENT_APP_COMMUNITY_PRODUCT */
  ResidentAppCommunityProduct = 'RESIDENT_APP_COMMUNITY_PRODUCT',
  /** RESIDENT_APP_CONVERSATION */
  ResidentAppConversation = 'RESIDENT_APP_CONVERSATION',
  /** RESIDENT_APP_DOCUMENT */
  ResidentAppDocument = 'RESIDENT_APP_DOCUMENT',
  /** RESIDENT_APP_EVENT */
  ResidentAppEvent = 'RESIDENT_APP_EVENT',
  /** RESIDENT_APP_GROUP_CHAT */
  ResidentAppGroupChat = 'RESIDENT_APP_GROUP_CHAT',
  /** RESIDENT_APP_KEY */
  ResidentAppKey = 'RESIDENT_APP_KEY',
  /** RESIDENT_APP_MARKETPLACE */
  ResidentAppMarketplace = 'RESIDENT_APP_MARKETPLACE',
  /** RESIDENT_APP_NEWSFEED */
  ResidentAppNewsfeed = 'RESIDENT_APP_NEWSFEED',
  /** RESIDENT_APP_PACKAGE */
  ResidentAppPackage = 'RESIDENT_APP_PACKAGE'
}

export type ProductCosts = {
  readonly __typename?: 'ProductCosts';
  readonly astCost?: Maybe<Scalars['Float']['output']>;
  readonly s21Cost?: Maybe<Scalars['Float']['output']>;
};

export enum ProfileHomesEnum {
  Application = 'application',
  Leasehold = 'leasehold',
  Residency = 'residency'
}

export type ProfileType = {
  readonly __typename?: 'ProfileType';
  readonly homes: ReadonlyArray<HomeNode>;
  readonly inProgressApplication?: Maybe<ApplicationNode>;
};


export type ProfileTypeHomesArgs = {
  userLinkType: ProfileHomesEnum;
};

export type PublicResidencyDocumentType = {
  readonly __typename?: 'PublicResidencyDocumentType';
  readonly id: Scalars['UUID']['output'];
};

export type PublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type PublishCommunityUpdatePayload = {
  readonly __typename?: 'PublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type RateConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly rating: Scalars['Int']['input'];
};

export type RateConversationPayload = {
  readonly __typename?: 'RateConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly rating?: Maybe<Scalars['Int']['output']>;
};

export type ReOpenConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type ReOpenConversationPayload = {
  readonly __typename?: 'ReOpenConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type ReadAllNotificationsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ReadAllNotificationsOnTargetInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type ReadAllNotificationsOnTargetPayload = {
  readonly __typename?: 'ReadAllNotificationsOnTargetPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notifications: NotificationNodeConnection;
};


export type ReadAllNotificationsOnTargetPayloadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReadAllNotificationsPayload = {
  readonly __typename?: 'ReadAllNotificationsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ReadNotificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ReadNotificationPayload = {
  readonly __typename?: 'ReadNotificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly notification?: Maybe<NotificationNode>;
};

export type ReferenceHistoricalAddressNode = {
  readonly __typename?: 'ReferenceHistoricalAddressNode';
  readonly buildingName?: Maybe<Scalars['String']['output']>;
  readonly buildingNumber?: Maybe<Scalars['String']['output']>;
  readonly city: Scalars['String']['output'];
  readonly country: Scalars['String']['output'];
  readonly fullAddress?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly postcode: Scalars['String']['output'];
  readonly startDate: Scalars['Date']['output'];
  readonly street?: Maybe<Scalars['String']['output']>;
};

export type ReferenceHistoricalAddressNodeConnection = {
  readonly __typename?: 'ReferenceHistoricalAddressNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ReferenceHistoricalAddressNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ReferenceHistoricalAddressNode` and its cursor. */
export type ReferenceHistoricalAddressNodeEdge = {
  readonly __typename?: 'ReferenceHistoricalAddressNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ReferenceHistoricalAddressNode>;
};

export type ReferenceHistoricalAddressSerializerInput = {
  readonly buildingName?: InputMaybe<Scalars['String']['input']>;
  readonly buildingNumber?: InputMaybe<Scalars['String']['input']>;
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly postcode: Scalars['String']['input'];
  readonly startDate: Scalars['Date']['input'];
  readonly street?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceSignupErrorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
};

export type ReferenceSignupErrorPayload = {
  readonly __typename?: 'ReferenceSignupErrorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RejectApplication = {
  readonly __typename?: 'RejectApplication';
  readonly application?: Maybe<ApplicationNode>;
};

export type RemindAllApplicants = {
  readonly __typename?: 'RemindAllApplicants';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemindApplicant = {
  readonly __typename?: 'RemindApplicant';
  readonly application?: Maybe<ApplicationNode>;
};

export type RemindResidentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RemindResidentPayload = {
  readonly __typename?: 'RemindResidentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RemoveConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type RemoveConversationTagPayload = {
  readonly __typename?: 'RemoveConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type RemoveResidentFromUnpaidEventsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveResidentFromUnpaidEventsPayload = {
  readonly __typename?: 'RemoveResidentFromUnpaidEventsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveResidentsFromResidencyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly residents?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type RemoveResidentsFromResidencyPayload = {
  readonly __typename?: 'RemoveResidentsFromResidencyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residency?: Maybe<ResidencyType>;
};

export type RequirementItemNode = {
  readonly __typename?: 'RequirementItemNode';
  readonly attachment?: Maybe<LandlordAttachmentType>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly expiryDate?: Maybe<Scalars['Date']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly requirement: ComplianceRequirementNode;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type RequirementItemNodeConnection = {
  readonly __typename?: 'RequirementItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RequirementItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RequirementItemNode` and its cursor. */
export type RequirementItemNodeEdge = {
  readonly __typename?: 'RequirementItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RequirementItemNode>;
};

export type ResendMemberInviteEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type ResendMemberInviteEmailPayload = {
  readonly __typename?: 'ResendMemberInviteEmailPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
};

export type ReserveAmenityInput = {
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type ReserveAmenityPayload = {
  readonly __typename?: 'ReserveAmenityPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ResidencyAndResidentsInput = {
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly endDate?: InputMaybe<Scalars['Date']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly paymentFrequency: Scalars['String']['input'];
  readonly paymentStartDate?: InputMaybe<Scalars['Date']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly sendTenantWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants?: InputMaybe<ReadonlyArray<InputMaybe<Tenants>>>;
};

export type ResidencyDocumentNode = {
  readonly __typename?: 'ResidencyDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly residency: ResidencyType;
  readonly title: Scalars['String']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly views: ResidencyDocumentViewNodeConnection;
};


export type ResidencyDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidencyDocumentNodeConnection = {
  readonly __typename?: 'ResidencyDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyDocumentNode` and its cursor. */
export type ResidencyDocumentNodeEdge = {
  readonly __typename?: 'ResidencyDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyDocumentNode>;
};

export type ResidencyDocumentViewNode = {
  readonly __typename?: 'ResidencyDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly user: UserType;
};

export type ResidencyDocumentViewNodeConnection = {
  readonly __typename?: 'ResidencyDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyDocumentViewNode` and its cursor. */
export type ResidencyDocumentViewNodeEdge = {
  readonly __typename?: 'ResidencyDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyDocumentViewNode>;
};

export type ResidencyNode = {
  readonly __typename?: 'ResidencyNode';
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly depositPayment?: Maybe<PaymentNode>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly endDate: Scalars['Date']['output'];
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly occupancySurveys: OccupancySurveyNodeConnection;
  readonly packages: PackageNodeConnection;
  readonly paymentFrequency: Scalars['String']['output'];
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly publicDocuments: ReadonlyArray<PublicResidencyDocumentType>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly residents: ReadonlyArray<ResidentType>;
  readonly rollingConfirmed: Scalars['Boolean']['output'];
  readonly stage?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['Date']['output'];
  readonly subscription?: Maybe<SubscriptionNode>;
  readonly type?: Maybe<Scalars['String']['output']>;
};


export type ResidencyNodeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidencyNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResidencyNodeConnection = {
  readonly __typename?: 'ResidencyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyNode` and its cursor. */
export type ResidencyNodeEdge = {
  readonly __typename?: 'ResidencyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyNode>;
};

export type ResidencyType = {
  readonly __typename?: 'ResidencyType';
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly conversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly emergencyNumber?: Maybe<Scalars['String']['output']>;
  readonly endDate: Scalars['Date']['output'];
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly home: HomeType;
  readonly howToRentShared: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly notifications?: Maybe<ReadonlyArray<Maybe<ManagerNotificationType>>>;
  readonly occupancySurveys: OccupancySurveyNodeConnection;
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly paymentAccount?: Maybe<PaymentAccountNode>;
  readonly paymentFrequency: Scalars['String']['output'];
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly publicDocuments: ReadonlyArray<PublicResidencyDocumentType>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly residents: ReadonlyArray<ResidentType>;
  readonly rollingConfirmed: Scalars['Boolean']['output'];
  readonly stage?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['Date']['output'];
  readonly subscription?: Maybe<SubscriptionNode>;
  readonly tenancyapplicationSet: TenancyApplicationNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type ResidencyTypeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidencyTypeConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypeTenancyapplicationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ResidentArchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentArchiveKeyholderPayload = {
  readonly __typename?: 'ResidentArchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentCreateKeyholder = {
  readonly __typename?: 'ResidentCreateKeyholder';
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentCreateKeyholderInput = {
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate: Scalars['String']['input'];
};

export type ResidentNode = {
  readonly __typename?: 'ResidentNode';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageScore?: Maybe<Scalars['Float']['output']>;
  readonly conversation?: Maybe<ConversationNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasAcceptedArkTerms: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isLeaseholder?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly surveyAnswers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly tenancyapplicantSet: TenancyApplicantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ResidentNodeConversationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidentNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentNodeTenancyapplicantSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidentNodeConnection = {
  readonly __typename?: 'ResidentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentNode` and its cursor. */
export type ResidentNodeEdge = {
  readonly __typename?: 'ResidentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentNode>;
};

export type ResidentSurveyAnswerType = {
  readonly __typename?: 'ResidentSurveyAnswerType';
  readonly answer?: Maybe<ResidentSurveyOptionType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly resident?: Maybe<ResidentType>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type ResidentSurveyNode = {
  readonly __typename?: 'ResidentSurveyNode';
  readonly answers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly options: ReadonlyArray<ResidentSurveyOptionType>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly question: Scalars['String']['output'];
  readonly rawCsv: Scalars['String']['output'];
  readonly residentHasAnswered?: Maybe<Scalars['Boolean']['output']>;
  readonly status: Scalars['String']['output'];
  readonly totalResidents: Scalars['Int']['output'];
};


export type ResidentSurveyNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentSurveyNodeConnection = {
  readonly __typename?: 'ResidentSurveyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSurveyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSurveyNode` and its cursor. */
export type ResidentSurveyNodeEdge = {
  readonly __typename?: 'ResidentSurveyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSurveyNode>;
};

export type ResidentSurveyOptionType = {
  readonly __typename?: 'ResidentSurveyOptionType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly option?: Maybe<Scalars['String']['output']>;
  readonly residents: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly totalResidents: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ResidentType = {
  readonly __typename?: 'ResidentType';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageScore?: Maybe<Scalars['Float']['output']>;
  readonly conversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasAcceptedArkTerms: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isLeaseholder?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly surveyAnswers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly tenancyapplicantSet: TenancyApplicantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ResidentTypeConversationsArgs = {
  conversationLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentTypeTenancyapplicantSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidentUnarchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentUnarchiveKeyholderPayload = {
  readonly __typename?: 'ResidentUnarchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentUpdateKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ResidentUpdateKeyholderPayload = {
  readonly __typename?: 'ResidentUpdateKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
};

/** An enumeration. */
export enum ResidentialManagementApplicationOwnershipTypeChoices {
  /** Owned */
  Ow = 'OW',
  /** Renting */
  Re = 'RE',
  /** Shared Ownership */
  So = 'SO'
}

/** An enumeration. */
export enum ResidentialManagementApplicationSourceChoices {
  /** Applicant */
  Ap = 'AP',
  /** Concierge */
  Co = 'CO'
}

/** An enumeration. */
export enum ResidentialManagementApplicationStatusChoices {
  /** Approved */
  Ap = 'AP',
  /** Document Sent */
  Ds = 'DS',
  /** Multiple Communities */
  Mc = 'MC',
  /** Pending */
  Pe = 'PE',
  /** Rejected */
  Re = 'RE',
  /** Unknown Community */
  Uc = 'UC'
}

/** An enumeration. */
export enum ResidentialManagementCommunityDocumentViewersChoices {
  /** All */
  Al = 'AL',
  /** Leaseholders */
  Le = 'LE',
  /** Residents */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementCommunityStatisticDataPointTypeChoices {
  /** ACTIVE_RESIDENT_COUNT */
  ActiveResidentCount = 'ACTIVE_RESIDENT_COUNT',
  /** AVERAGE_PACKAGE_COLLECTION_TIME */
  AveragePackageCollectionTime = 'AVERAGE_PACKAGE_COLLECTION_TIME',
  /** DOWNLOAD_RATE_PERCENTAGE */
  DownloadRatePercentage = 'DOWNLOAD_RATE_PERCENTAGE',
  /** FACILITY_BOOKINGS_COUNT */
  FacilityBookingsCount = 'FACILITY_BOOKINGS_COUNT',
  /** INCOMING_MESSAGES_COUNT */
  IncomingMessagesCount = 'INCOMING_MESSAGES_COUNT',
  /** KEY_IN_COUNT */
  KeyInCount = 'KEY_IN_COUNT',
  /** KEY_OUT_COUNT */
  KeyOutCount = 'KEY_OUT_COUNT',
  /** PACKAGE_COLLECTED_COUNT */
  PackageCollectedCount = 'PACKAGE_COLLECTED_COUNT',
  /** PACKAGE_DELIVERED_COUNT */
  PackageDeliveredCount = 'PACKAGE_DELIVERED_COUNT'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateCommentUserTypeChoices {
  /** Concierge */
  Co = 'CO',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateCreatorTypeChoices {
  /** Concierge */
  Co = 'CO',
  /** Manager */
  Ma = 'MA'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateLocaleVariantStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Error */
  Error = 'ERROR',
  /** Loading */
  Loading = 'LOADING'
}

/** An enumeration. */
export enum ResidentialManagementConversationCategoryChoices {
  /** Concierge */
  Co = 'CO',
  /** Documents */
  Do = 'DO',
  /** Electric */
  El = 'EL',
  /** Heating */
  He = 'HE',
  /** Other */
  Ot = 'OT',
  /** Payment Queries */
  Pa = 'PA'
}

/** An enumeration. */
export enum ResidentialManagementConversationMediaSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementConversationMessageSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementHomeDetailsFurnishingChoices {
  /** Fully Furnished */
  Fu = 'FU',
  /** None */
  No = 'NO',
  /** Partially Furnished */
  Pa = 'PA',
  /** Unfurnished */
  Un = 'UN'
}

/** An enumeration. */
export enum ResidentialManagementHomeDetailsParkingChoices {
  /** Not Available */
  Na = 'NA',
  /** None */
  No = 'NO',
  /** Off-Street */
  Of = 'OF',
  /** On-Street */
  On = 'ON'
}

/** An enumeration. */
export enum ResidentialManagementKeyEventTypeChoices {
  /** Check in */
  In = 'IN',
  /** Check out */
  Ou = 'OU'
}

/** An enumeration. */
export enum ResidentialManagementMessageSuggestionActionChoices {
  /** Accepted */
  Ac = 'AC',
  /** Altered */
  Al = 'AL',
  /** Ignored */
  Ig = 'IG'
}

/** An enumeration. */
export enum ResidentialManagementPackageStatusChoices {
  /** Collected */
  Co = 'CO',
  /** Delivered */
  De = 'DE'
}

export type ResponseTimeType = {
  readonly __typename?: 'ResponseTimeType';
  readonly averageResponseTime?: Maybe<Scalars['Int']['output']>;
  readonly date?: Maybe<Scalars['Date']['output']>;
};

export type RestartIdentityVerificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RestartIdentityVerificationPayload = {
  readonly __typename?: 'RestartIdentityVerificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RevokeGeneratedAgreementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeGeneratedAgreementPayload = {
  readonly __typename?: 'RevokeGeneratedAgreementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type RightToRentNode = {
  readonly __typename?: 'RightToRentNode';
  readonly document?: Maybe<Scalars['String']['output']>;
  readonly hasShareCode: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly officialDocument?: Maybe<Scalars['String']['output']>;
  readonly officialExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly officialVerificationStatus?: Maybe<TenancyApplicationRightToRentOfficialVerificationStatusChoices>;
  readonly shareCode?: Maybe<Scalars['String']['output']>;
};

export type SaveAmenityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly daysAvailable: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly description: Scalars['String']['input'];
  readonly endTime: Scalars['DateTime']['input'];
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly live?: InputMaybe<Scalars['Boolean']['input']>;
  readonly maxAdvanceReservationDays?: InputMaybe<Scalars['Int']['input']>;
  readonly maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  readonly maxHours?: InputMaybe<Scalars['Int']['input']>;
  readonly name: Scalars['String']['input'];
  readonly reservable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startTime: Scalars['DateTime']['input'];
};

export type SaveAmenityPayload = {
  readonly __typename?: 'SaveAmenityPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly daysAvailable?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly endTime?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly live?: Maybe<Scalars['Boolean']['output']>;
  readonly maxAdvanceReservationDays?: Maybe<Scalars['Int']['output']>;
  readonly maxCapacity?: Maybe<Scalars['Int']['output']>;
  readonly maxHours?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly reservable?: Maybe<Scalars['Boolean']['output']>;
  readonly startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type SaveCommunityEventInput = {
  readonly attendanceFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description: Scalars['String']['input'];
  readonly end: Scalars['DateTime']['input'];
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly maxSpaces: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type SaveCommunityEventPayload = {
  readonly __typename?: 'SaveCommunityEventPayload';
  readonly attendanceFee?: Maybe<Scalars['Decimal']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly end?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly maxSpaces?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly start?: Maybe<Scalars['DateTime']['output']>;
};

export type SaveCommunityUpdateInput = {
  readonly body: Scalars['String']['input'];
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creatorType: Scalars['String']['input'];
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly summary?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCommunityUpdatePayload = {
  readonly __typename?: 'SaveCommunityUpdatePayload';
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly creatorType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly summary?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type SaveGeneratedAgreementInput = {
  readonly additionalTerms?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly furnished?: InputMaybe<Scalars['String']['input']>;
  readonly homeCity?: InputMaybe<Scalars['String']['input']>;
  readonly homeName?: InputMaybe<Scalars['String']['input']>;
  readonly homePostcode?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly landlordMobile?: InputMaybe<Scalars['String']['input']>;
  readonly landlordName?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly tenancyEnd?: InputMaybe<Scalars['Date']['input']>;
  readonly tenancyStart?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants: ReadonlyArray<InputMaybe<TenantSerializerInput>>;
  readonly utilitiesIncluded?: InputMaybe<Scalars['String']['input']>;
};

export type SaveGeneratedAgreementPayload = {
  readonly __typename?: 'SaveGeneratedAgreementPayload';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly furnished?: Maybe<Scalars['String']['output']>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<ReadonlyArray<Maybe<AgreementTenantNode>>>;
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};

export type SaveGeneratedSection21Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deadlineDate?: InputMaybe<Scalars['Date']['input']>;
  readonly depositCertificateProvided?: InputMaybe<Scalars['Boolean']['input']>;
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly homeCity?: InputMaybe<Scalars['String']['input']>;
  readonly homeName?: InputMaybe<Scalars['String']['input']>;
  readonly homePostcode?: InputMaybe<Scalars['String']['input']>;
  readonly homeRegion?: InputMaybe<Scalars['String']['input']>;
  readonly htrgProvided?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly inspectionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly landlordEmail?: InputMaybe<Scalars['String']['input']>;
  readonly landlordName?: InputMaybe<Scalars['String']['input']>;
  readonly landlordPhone?: InputMaybe<Scalars['String']['input']>;
  readonly leadTenantEmail?: InputMaybe<Scalars['String']['input']>;
  readonly possessionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants?: InputMaybe<Scalars['String']['input']>;
  readonly viewedOnArk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveGeneratedSection21Payload = {
  readonly __typename?: 'SaveGeneratedSection21Payload';
  readonly client?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<Scalars['String']['output']>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided?: Maybe<Scalars['Boolean']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly viewedOnArk?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveHomeInput = {
  readonly HMO?: InputMaybe<Scalars['Boolean']['input']>;
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly numRooms?: InputMaybe<Scalars['Int']['input']>;
  readonly postcode: Scalars['String']['input'];
};

export type SaveHomePayload = {
  readonly __typename?: 'SaveHomePayload';
  readonly HMO?: Maybe<Scalars['Boolean']['output']>;
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly numRooms?: Maybe<Scalars['Int']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type SaveManagerProfileInput = {
  readonly ASTPageViewed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly complianceEmailExplanation?: InputMaybe<Scalars['Boolean']['input']>;
  readonly compliancePageViewed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly complianceUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly valueQuestionnaireAnswer?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveManagerProfilePayload = {
  readonly __typename?: 'SaveManagerProfilePayload';
  readonly ASTPageViewed?: Maybe<Scalars['Boolean']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly complianceEmailExplanation?: Maybe<Scalars['Boolean']['output']>;
  readonly compliancePageViewed?: Maybe<Scalars['Boolean']['output']>;
  readonly complianceUpdateEmails?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly valueQuestionnaireAnswer?: Maybe<Scalars['Int']['output']>;
};

export type SaveMarketplaceItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly condition?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly price: Scalars['Decimal']['input'];
  readonly title: Scalars['String']['input'];
};

export type SaveMarketplaceItemPayload = {
  readonly __typename?: 'SaveMarketplaceItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly condition?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly price?: Maybe<Scalars['Decimal']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type SaveRequirementItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly expiryDate?: InputMaybe<Scalars['Date']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly requirement: Scalars['String']['input'];
};

export type SaveRequirementItemPayload = {
  readonly __typename?: 'SaveRequirementItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly expiryDate?: Maybe<Scalars['Date']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly requirement?: Maybe<Scalars['String']['output']>;
};

export type SaveResidentSurveyAnswerInput = {
  readonly answer?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly resident?: InputMaybe<Scalars['String']['input']>;
  readonly survey?: InputMaybe<Scalars['String']['input']>;
};

export type SaveResidentSurveyAnswerPayload = {
  readonly __typename?: 'SaveResidentSurveyAnswerPayload';
  readonly answer?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly resident?: Maybe<Scalars['String']['output']>;
  readonly survey?: Maybe<Scalars['String']['output']>;
};

export type SaveTenantEmploymentDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly employmentEnding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly employmentType?: InputMaybe<Scalars['String']['input']>;
  readonly fullOrPartTime?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly income?: InputMaybe<Scalars['Decimal']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenantReferenceId: Scalars['String']['input'];
};

export type SaveTenantEmploymentDetailsPayload = {
  readonly __typename?: 'SaveTenantEmploymentDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly fullOrPartTime?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type SchedulePublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchedulePublishCommunityUpdatePayload = {
  readonly __typename?: 'SchedulePublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SendAgreementForSigning = {
  readonly __typename?: 'SendAgreementForSigning';
  readonly tenants?: Maybe<ReadonlyArray<Maybe<AgreementSignatureOutput>>>;
};

export type SendAgreementForSigningInput = {
  readonly agreementId?: InputMaybe<Scalars['UUID']['input']>;
  readonly tenants?: InputMaybe<ReadonlyArray<InputMaybe<AgreementSignaturesTenant>>>;
};

export type SendDocument = {
  readonly __typename?: 'SendDocument';
  readonly section21?: Maybe<GeneratedSection21Type>;
};

export type SendDocumentInput = {
  readonly emails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id: Scalars['String']['input'];
};

export type SendManagerAmplitudeTestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SendManagerAmplitudeTestPayload = {
  readonly __typename?: 'SendManagerAmplitudeTestPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type SendTenantReferenceRequestsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SendTenantReferenceRequestsPayload = {
  readonly __typename?: 'SendTenantReferenceRequestsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
};

export type SetResidencyCompletionDateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly completionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SetResidencyCompletionDatePayload = {
  readonly __typename?: 'SetResidencyCompletionDatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SetUpManagerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly managerEmail: Scalars['String']['input'];
};

export type SetUpManagerPayload = {
  readonly __typename?: 'SetUpManagerPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ShareComplianceRequirementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ShareComplianceRequirementPayload = {
  readonly __typename?: 'ShareComplianceRequirementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SignOutCommunityVisitorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SignOutCommunityVisitorPayload = {
  readonly __typename?: 'SignOutCommunityVisitorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SnoozeConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly snoozeForSeconds: Scalars['Int']['input'];
};

export type SnoozeConversationPayload = {
  readonly __typename?: 'SnoozeConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type SubmitEmployerReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEmployerReferencePayload = {
  readonly __typename?: 'SubmitEmployerReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitIdentityVerificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitIdentityVerificationPayload = {
  readonly __typename?: 'SubmitIdentityVerificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitLandlordReferencePayload = {
  readonly __typename?: 'SubmitLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitTenantReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitTenantReferencePayload = {
  readonly __typename?: 'SubmitTenantReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubscribeLandlordInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly discountCode?: InputMaybe<Scalars['String']['input']>;
  readonly includeSetupFee?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeLandlordPayload = {
  readonly __typename?: 'SubscribeLandlordPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly discountCodeValid?: Maybe<Scalars['Boolean']['output']>;
  readonly firstMonthCost?: Maybe<Scalars['Float']['output']>;
  readonly monthlyCost?: Maybe<Scalars['Float']['output']>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
  readonly tierUpTo?: Maybe<Scalars['Int']['output']>;
};

export type SubscribeToNotificationGroup = {
  readonly __typename?: 'SubscribeToNotificationGroup';
  readonly unsubscribeNotificationGroup?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type SubscriptionDetails = {
  readonly __typename?: 'SubscriptionDetails';
  readonly endDate: Scalars['String']['output'];
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly price: Scalars['Float']['output'];
  readonly startDate: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type SubscriptionNode = {
  readonly __typename?: 'SubscriptionNode';
  readonly details?: Maybe<SubscriptionDetails>;
  readonly id: Scalars['UUID']['output'];
  readonly invoices?: Maybe<ReadonlyArray<Invoices>>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly upcomingInvoice?: Maybe<Invoices>;
};

export type TagConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type TagConversationPayload = {
  readonly __typename?: 'TagConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type Target = AmenityNode | ApplicationNode | CommunityEventNode | CommunityNode | CommunityProductNode | CommunityUpdateNode | ConversationAssignmentNode | ConversationNode | KeyNode | ResidentSurveyNode | TenantReferenceNode;

export type TenancyApplicantNode = {
  readonly __typename?: 'TenancyApplicantNode';
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reference?: Maybe<TenantReferenceNode>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplication: TenancyApplicationNode;
};

export type TenancyApplicantNodeConnection = {
  readonly __typename?: 'TenancyApplicantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenancyApplicantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenancyApplicantNode` and its cursor. */
export type TenancyApplicantNodeEdge = {
  readonly __typename?: 'TenancyApplicantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenancyApplicantNode>;
};

/** An enumeration. */
export enum TenancyApplicationEmployerReferenceStepChoices {
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** EMPLOYMENT */
  Employment = 'EMPLOYMENT',
  /** PERSONAL */
  Personal = 'PERSONAL'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsEmploymentTypeChoices {
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** EMPLOYED */
  Employed = 'EMPLOYED',
  /** SELF_EMPLOYED */
  SelfEmployed = 'SELF_EMPLOYED',
  /** UNEMPLOYED */
  Unemployed = 'UNEMPLOYED'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsFullOrPartTimeChoices {
  /** FULL_TIME */
  FullTime = 'FULL_TIME',
  /** PART_TIME */
  PartTime = 'PART_TIME'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsPaymentFrequencyChoices {
  /** MONTHLY */
  Monthly = 'MONTHLY',
  /** WEEKLY */
  Weekly = 'WEEKLY'
}

/** An enumeration. */
export enum TenancyApplicationIdentityVerificationStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** FAILED */
  Failed = 'FAILED',
  /** STARTED */
  Started = 'STARTED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceHasOutstandingRentChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceRentPaidOnTimeChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceStepChoices {
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** COMMENTS */
  Comments = 'COMMENTS',
  /** PERSONAL */
  Personal = 'PERSONAL',
  /** RENTAL_DETAILS */
  RentalDetails = 'RENTAL_DETAILS'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceTenancyTypeChoices {
  /** HMO */
  Hmo = 'HMO',
  /** PRIVATE_RESIDENTIAL */
  PrivateResidential = 'PRIVATE_RESIDENTIAL',
  /** SHARED */
  Shared = 'SHARED',
  /** SOCIAL_HOUSING */
  SocialHousing = 'SOCIAL_HOUSING'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceTreatedPropertyWellChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

export type TenancyApplicationNode = {
  readonly __typename?: 'TenancyApplicationNode';
  readonly affordabilityStatus: TenancyApplicationTenancyApplicationAffordabilityStatusChoices;
  readonly applicantNames?: Maybe<Scalars['String']['output']>;
  readonly applicants: TenancyApplicantNodeConnection;
  readonly combinedAffordability?: Maybe<Scalars['Int']['output']>;
  readonly completedOn?: Maybe<Scalars['Date']['output']>;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly references?: Maybe<ReadonlyArray<Maybe<TenantReferenceNode>>>;
  readonly rentAmount: Scalars['Decimal']['output'];
  readonly status: TenancyApplicationTenancyApplicationStatusChoices;
  readonly unpaidTenantReferenceCount?: Maybe<Scalars['Int']['output']>;
  readonly unpaidTenantReferencesTotalCost?: Maybe<Scalars['Float']['output']>;
};


export type TenancyApplicationNodeApplicantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TenancyApplicationNodeConnection = {
  readonly __typename?: 'TenancyApplicationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenancyApplicationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenancyApplicationNode` and its cursor. */
export type TenancyApplicationNodeEdge = {
  readonly __typename?: 'TenancyApplicationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenancyApplicationNode>;
};

/** An enumeration. */
export enum TenancyApplicationRightToRentOfficialVerificationStatusChoices {
  /** LIMITED */
  Limited = 'LIMITED',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** UNLIMITED */
  Unlimited = 'UNLIMITED'
}

/** An enumeration. */
export enum TenancyApplicationTenancyApplicationAffordabilityStatusChoices {
  /** CAUTION */
  Caution = 'CAUTION',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** WAITING */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum TenancyApplicationTenancyApplicationStatusChoices {
  /** CAUTION */
  Caution = 'CAUTION',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** WAITING */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum TenancyApplicationTenantReferenceStepChoices {
  /** ADDRESS_HISTORY */
  AddressHistory = 'ADDRESS_HISTORY',
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** EMPLOYER */
  Employer = 'EMPLOYER',
  /** EMPLOYMENT */
  Employment = 'EMPLOYMENT',
  /** IDENTITY */
  Identity = 'IDENTITY',
  /** LANDLORD */
  Landlord = 'LANDLORD',
  /** PERSONAL */
  Personal = 'PERSONAL',
  /** RIGHT_TO_RENT */
  RightToRent = 'RIGHT_TO_RENT'
}

/** An enumeration. */
export enum TenancyApplicationTenantReferenceTitleChoices {
  /** DR */
  Dr = 'DR',
  /** MISS */
  Miss = 'MISS',
  /** MR */
  Mr = 'MR',
  /** MRS */
  Mrs = 'MRS',
  /** MS */
  Ms = 'MS',
  /** MX */
  Mx = 'MX'
}

export type TenantReferenceNode = {
  readonly __typename?: 'TenantReferenceNode';
  readonly applicant: TenancyApplicantNode;
  readonly application: TenancyApplicationNode;
  readonly clientType?: Maybe<Scalars['String']['output']>;
  readonly creditCheck?: Maybe<CreditCheckNode>;
  readonly creditCheckPermission: Scalars['Boolean']['output'];
  readonly creditCheckStatus?: Maybe<Scalars['String']['output']>;
  readonly currentAddress?: Maybe<ReferenceHistoricalAddressNode>;
  readonly dateOfBirth?: Maybe<Scalars['Date']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employerReference?: Maybe<EmployerReferenceNode>;
  readonly employmentStatus?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly historicalAddresses: ReferenceHistoricalAddressNodeConnection;
  readonly home: HomeNode;
  readonly id: Scalars['UUID']['output'];
  readonly identityVerification?: Maybe<IdentityVerificationNode>;
  readonly identityVerificationStatus?: Maybe<Scalars['String']['output']>;
  readonly isPaid?: Maybe<Scalars['Boolean']['output']>;
  readonly landlordReference?: Maybe<LandlordReferenceNode>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly lettingHistoryStatus?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly rentAffordability?: Maybe<Scalars['Decimal']['output']>;
  readonly rightToRent?: Maybe<RightToRentNode>;
  readonly rightToRentStatus?: Maybe<Scalars['String']['output']>;
  readonly sentAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<TenancyApplicationTenantReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tenantEmploymentDetails?: Maybe<EmploymentDetailsNode>;
  readonly title?: Maybe<TenancyApplicationTenantReferenceTitleChoices>;
};


export type TenantReferenceNodeHistoricalAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantReferenceNodeConnection = {
  readonly __typename?: 'TenantReferenceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenantReferenceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenantReferenceNode` and its cursor. */
export type TenantReferenceNodeEdge = {
  readonly __typename?: 'TenantReferenceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenantReferenceNode>;
};

export type TenantSerializerInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type Tenants = {
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type TimeSlot = {
  readonly end?: InputMaybe<Scalars['DateTime']['input']>;
  readonly start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ToggleCommunityUpdateBookmarkInput = {
  readonly bookmarkedBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleCommunityUpdateBookmarkPayload = {
  readonly __typename?: 'ToggleCommunityUpdateBookmarkPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleCommunityUpdateLikeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type ToggleCommunityUpdateLikePayload = {
  readonly __typename?: 'ToggleCommunityUpdateLikePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly update?: Maybe<CommunityUpdateNode>;
};

export type ToggleMarketplaceItemCloseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleMarketplaceItemClosePayload = {
  readonly __typename?: 'ToggleMarketplaceItemClosePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
};

export type UnarchiveApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveApplicationPayload = {
  readonly __typename?: 'UnarchiveApplicationPayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UnarchiveKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveKeyPayload = {
  readonly __typename?: 'UnarchiveKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type UnarchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveKeyholderPayload = {
  readonly __typename?: 'UnarchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type UnbookCommunityEventMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type UnbookCommunityEventMutationPayload = {
  readonly __typename?: 'UnbookCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
};

export type UnlabelConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly tags: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type UnlabelConversationPayload = {
  readonly __typename?: 'UnlabelConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UnsnoozeConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type UnsnoozeConversationPayload = {
  readonly __typename?: 'UnsnoozeConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type UnsubscribeFromNotificationGroup = {
  readonly __typename?: 'UnsubscribeFromNotificationGroup';
  readonly unsubscribeNotificationGroup?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type UnsubscribeNotificationGroupNode = {
  readonly __typename?: 'UnsubscribeNotificationGroupNode';
  readonly id: Scalars['UUID']['output'];
  readonly type: PeopleUnsubscribeNotificationGroupTypeChoices;
  readonly users: ReadonlyArray<UserType>;
};

export type UnsubscribeNotificationGroupNodeConnection = {
  readonly __typename?: 'UnsubscribeNotificationGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UnsubscribeNotificationGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UnsubscribeNotificationGroupNode` and its cursor. */
export type UnsubscribeNotificationGroupNodeEdge = {
  readonly __typename?: 'UnsubscribeNotificationGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type UpdateAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAttachmentPayload = {
  readonly __typename?: 'UpdateAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type UpdateClientAdminInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateClientAdminPayload = {
  readonly __typename?: 'UpdateClientAdminPayload';
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCommunityDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly viewers?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityDocumentPayload = {
  readonly __typename?: 'UpdateCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateCommunityProductInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly description: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateCommunityProductPayload = {
  readonly __typename?: 'UpdateCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateCommunitySettingsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly commentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communityChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly marketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly officeHoursEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly openPeriods: ReadonlyArray<InputMaybe<CommunityOpenPeriodSerializerInput>>;
  readonly outOfOfficeMessage?: InputMaybe<Scalars['String']['input']>;
  readonly paymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly status: Scalars['String']['input'];
};

export type UpdateCommunitySettingsPayload = {
  readonly __typename?: 'UpdateCommunitySettingsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly communityChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly marketplaceEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly officeHoursEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly openPeriods?: Maybe<ReadonlyArray<Maybe<CommunityOpenPeriodNode>>>;
  readonly outOfOfficeMessage?: Maybe<Scalars['String']['output']>;
  readonly paymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type UpdateConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConversationTagPayload = {
  readonly __typename?: 'UpdateConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type UpdateConversationTitleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly subject: Scalars['String']['input'];
};

export type UpdateConversationTitlePayload = {
  readonly __typename?: 'UpdateConversationTitlePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationUrgency = {
  readonly __typename?: 'UpdateConversationUrgency';
  readonly conversation?: Maybe<ConversationNode>;
};

export type UpdateConversationUrgencyInput = {
  readonly conversationId: Scalars['UUID']['input'];
  readonly urgency: Scalars['String']['input'];
};

export type UpdateEmployerReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployerReferencePayload = {
  readonly __typename?: 'UpdateEmployerReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type UpdateEmployerReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployerReferenceStepPayload = {
  readonly __typename?: 'UpdateEmployerReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateGroupPayload = {
  readonly __typename?: 'UpdateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

export type UpdateHomeAddressInput = {
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly postcode: Scalars['String']['input'];
};

export type UpdateHomeAddressPayload = {
  readonly __typename?: 'UpdateHomeAddressPayload';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type UpdateHomeDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly furnishing?: InputMaybe<Scalars['String']['input']>;
  readonly garden?: InputMaybe<Scalars['Boolean']['input']>;
  readonly home: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  readonly numBathrooms?: InputMaybe<Scalars['Int']['input']>;
  readonly numBedrooms?: InputMaybe<Scalars['Int']['input']>;
  readonly numEnsuites?: InputMaybe<Scalars['Int']['input']>;
  readonly numLivingRooms?: InputMaybe<Scalars['Int']['input']>;
  readonly office?: InputMaybe<Scalars['Boolean']['input']>;
  readonly parking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomeDetailsPayload = {
  readonly __typename?: 'UpdateHomeDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly furnishing?: Maybe<Scalars['String']['output']>;
  readonly garden?: Maybe<Scalars['Boolean']['output']>;
  readonly home?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly kitchen?: Maybe<Scalars['Boolean']['output']>;
  readonly numBathrooms?: Maybe<Scalars['Int']['output']>;
  readonly numBedrooms?: Maybe<Scalars['Int']['output']>;
  readonly numEnsuites?: Maybe<Scalars['Int']['output']>;
  readonly numLivingRooms?: Maybe<Scalars['Int']['output']>;
  readonly office?: Maybe<Scalars['Boolean']['output']>;
  readonly parking?: Maybe<Scalars['String']['output']>;
};

export type UpdateKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateKeyholderPayload = {
  readonly __typename?: 'UpdateKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateLandlordInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly emailPreferences: Scalars['Boolean']['input'];
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly smsPreferences: Scalars['Boolean']['input'];
};

export type UpdateLandlordPayload = {
  readonly __typename?: 'UpdateLandlordPayload';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly smsPreferences?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLandlordReferenceCommentsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comments?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandlordReferenceCommentsPayload = {
  readonly __typename?: 'UpdateLandlordReferenceCommentsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comments?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type UpdateLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordOrAgent: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile: Scalars['String']['input'];
  readonly tenantReference: Scalars['String']['input'];
};

export type UpdateLandlordReferencePayload = {
  readonly __typename?: 'UpdateLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordOrAgent?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly tenantReference?: Maybe<Scalars['String']['output']>;
};

export type UpdateLandlordReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandlordReferenceStepPayload = {
  readonly __typename?: 'UpdateLandlordReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateManagerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateManagerNotificationSettingsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly emailPreferences: Scalars['Boolean']['input'];
};

export type UpdateManagerNotificationSettingsPayload = {
  readonly __typename?: 'UpdateManagerNotificationSettingsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type UpdateManagerPayload = {
  readonly __typename?: 'UpdateManagerPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type UpdatePackageLocationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly location?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePackageLocationPayload = {
  readonly __typename?: 'UpdatePackageLocationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly package?: Maybe<PackageNode>;
};

export type UpdateReferenceAddressHistoryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly historicalAddresses: ReadonlyArray<InputMaybe<ReferenceHistoricalAddressSerializerInput>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferenceAddressHistoryPayload = {
  readonly __typename?: 'UpdateReferenceAddressHistoryPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly historicalAddresses?: Maybe<ReadonlyArray<Maybe<ReferenceHistoricalAddressNode>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type UpdateReferenceStartedOnInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferenceStartedOnPayload = {
  readonly __typename?: 'UpdateReferenceStartedOnPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateResidencyAndResidents = {
  readonly __typename?: 'UpdateResidencyAndResidents';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateResidencyDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly residency: Scalars['String']['input'];
};

export type UpdateResidencyDocumentPayload = {
  readonly __typename?: 'UpdateResidencyDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocument?: Maybe<ResidencyDocumentNode>;
};

export type UpdateRightToRentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document?: InputMaybe<Scalars['String']['input']>;
  readonly hasShareCode?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly shareCode?: InputMaybe<Scalars['String']['input']>;
  readonly tenantReference: Scalars['String']['input'];
};

export type UpdateRightToRentPayload = {
  readonly __typename?: 'UpdateRightToRentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly hasShareCode?: Maybe<Scalars['Boolean']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly shareCode?: Maybe<Scalars['String']['output']>;
  readonly tenantReference?: Maybe<Scalars['String']['output']>;
};

export type UpdateTenantReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creditCheckPermission?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantReferencePayload = {
  readonly __typename?: 'UpdateTenantReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly creditCheckPermission?: Maybe<Scalars['Boolean']['output']>;
  readonly dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type UpdateTenantReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantReferenceStepPayload = {
  readonly __typename?: 'UpdateTenantReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateUserMobileNumberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly mobile: Scalars['String']['input'];
};

export type UpdateUserMobileNumberPayload = {
  readonly __typename?: 'UpdateUserMobileNumberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly error?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UpdateUserPayload = {
  readonly __typename?: 'UpdateUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UpgradeLandlordToSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly generatedAgreementUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradeLandlordToSubscriptionPayload = {
  readonly __typename?: 'UpgradeLandlordToSubscriptionPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UserAppUseNode = {
  readonly __typename?: 'UserAppUseNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deviceBrand: Scalars['String']['output'];
  readonly deviceNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deviceType: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly systemName: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type UserAppUseNodeConnection = {
  readonly __typename?: 'UserAppUseNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserAppUseNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserAppUseNode` and its cursor. */
export type UserAppUseNodeEdge = {
  readonly __typename?: 'UserAppUseNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserAppUseNode>;
};

export type UserType = {
  readonly __typename?: 'UserType';
  readonly appUses?: Maybe<UserAppUseNodeConnection>;
  readonly applicant?: Maybe<ApplicantNode>;
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly communityManager?: Maybe<CommunityManagerNode>;
  readonly concierge?: Maybe<ConciergeNode>;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasUsedApp: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isDemo: Scalars['Boolean']['output'];
  readonly landlord?: Maybe<LandlordNode>;
  readonly lastAppUse?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly leaseholder?: Maybe<LeaseholderNode>;
  readonly manager?: Maybe<ManagerType>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly resident?: Maybe<ResidentType>;
  readonly termsAndConditionsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly unsubscribeNotificationGroups?: Maybe<UnsubscribeNotificationGroupNodeConnection>;
};


export type UserTypeAppUsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeUnsubscribeNotificationGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBlocksMutationVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  blockNames: ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBlocksMutation = { readonly __typename?: 'Mutation', readonly createBlocks?: { readonly __typename?: 'CreateBlocks', readonly blocks?: ReadonlyArray<{ readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null> | null } | null };

export type ContactAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ContactAutocompleteQuery = { readonly __typename?: 'DebugSchema', readonly contacts?: { readonly __typename?: 'ContactNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string } | null } | null> } } | null } | null } | null> } | null };

export type GroupAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GroupAutocompleteQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type HomeAutocompleteQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomeAutocompleteQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string } | null } | null> } | null };

export type ConversationListItemFragment = { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly closedAt?: string | null, readonly hasUnread: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNodeEdge', readonly node?: { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly name: string, readonly email: string, readonly firstName: string, readonly lastName: string } | null } | null> } | null } | null, readonly client: { readonly __typename?: 'ClientType', readonly id: string, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly isSelected?: boolean | null, readonly suggested?: boolean | null } | null } | null> } | null } } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null, readonly extra?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string, readonly mediaSender: ResidentialManagementConversationMediaSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly messageSender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null } } | null };

export type HasAsanaIntegrationQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type HasAsanaIntegrationQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean } | null } | null } | null };

export type ConversationSummaryQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ConversationSummaryQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly summary?: { readonly __typename?: 'ConversationSummaryNode', readonly id: string, readonly summary: string } | null } | null };

export type CreateConversationSummaryMutationVariables = Exact<{
  input: CreateConversationSummaryInput;
}>;


export type CreateConversationSummaryMutation = { readonly __typename?: 'Mutation', readonly createConversationSummary?: { readonly __typename?: 'CreateConversationSummaryPayload', readonly conversationSummary?: { readonly __typename?: 'ConversationSummaryNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string, readonly summary?: { readonly __typename?: 'ConversationSummaryNode', readonly id: string, readonly summary: string } | null } } | null } | null };

export type CommunityTeamMembersQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type CommunityTeamMembersQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNodeEdge', readonly node?: { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly name: string, readonly firstName: string, readonly lastName: string, readonly email: string } | null } | null> } | null } | null };

export type ConversationAssignmentDataFragment = { readonly __typename?: 'ConversationNode', readonly id: string, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null };

export type ConversationAssignmentDataQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ConversationAssignmentDataQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } | null };

export type CreateConversationAssignmentMutationVariables = Exact<{
  input: CreateConversationAssignmentInput;
}>;


export type CreateConversationAssignmentMutation = { readonly __typename?: 'Mutation', readonly createConversationAssignment?: { readonly __typename?: 'CreateConversationAssignmentPayload', readonly conversationAssignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } } | null } | null };

export type ConversationForwardingEmailsQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ConversationForwardingEmailsQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly conversationForwardingEmails: ReadonlyArray<{ readonly __typename?: 'ConversationForwardingEmailType', readonly id: string, readonly name?: string | null, readonly emails?: ReadonlyArray<string> | null }> } } | null } | null } | null };

export type AvailableConversationLabelsQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type AvailableConversationLabelsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null } | null };

export type ConversationLabelFragment = { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null };

export type ActiveConversationLabelsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActiveConversationLabelsQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null };

export type LabelConversationMutationVariables = Exact<{
  input: LabelConversationInput;
}>;


export type LabelConversationMutation = { readonly __typename?: 'Mutation', readonly labelConversation?: { readonly __typename?: 'LabelConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly availableTags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null } | null };

export type UnlabelConversationMutationVariables = Exact<{
  input: UnlabelConversationInput;
}>;


export type UnlabelConversationMutation = { readonly __typename?: 'Mutation', readonly unlabelConversation?: { readonly __typename?: 'UnlabelConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly availableTags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null } | null };

export type UpdateConversationTitleMutationVariables = Exact<{
  input: UpdateConversationTitleInput;
}>;


export type UpdateConversationTitleMutation = { readonly __typename?: 'Mutation', readonly updateConversationTitle?: { readonly __typename?: 'UpdateConversationTitlePayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null } | null };

export type GetFixFloQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type GetFixFloQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null } } | null } | null } | null };

export type CreateManagerConversationReadMutationVariables = Exact<{
  input: CreateManagerConversationReadInput;
}>;


export type CreateManagerConversationReadMutation = { readonly __typename?: 'Mutation', readonly createManagerConversationRead?: { readonly __typename?: 'CreateManagerConversationReadPayload', readonly conversation?: string | null, readonly unread?: boolean | null } | null };

export type ListOtherConversationsQueryVariables = Exact<{
  currentConversationId?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ListOtherConversationsQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly closedAt?: string | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly createdAt: string } | { readonly __typename?: 'ConversationMediaType', readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly createdAt: string } | null } | null } | null> } | null };

export type OrderConversationTagsMutationVariables = Exact<{
  input: OrderConversationTagsInput;
}>;


export type OrderConversationTagsMutation = { readonly __typename?: 'Mutation', readonly orderConversationTags?: { readonly __typename?: 'OrderConversationTagsPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type CreateConversationNoteMutationVariables = Exact<{
  input: CreateConversationNoteInput;
}>;


export type CreateConversationNoteMutation = { readonly __typename?: 'Mutation', readonly createConversationNote?: { readonly __typename?: 'CreateConversationNotePayload', readonly conversationNote?: { readonly __typename?: 'ConversationNoteNode', readonly id: string, readonly text: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string }, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | null } | null };

export type AcceptMessageSuggestionMutationVariables = Exact<{
  input: AcceptMessageSuggestionInput;
}>;


export type AcceptMessageSuggestionMutation = { readonly __typename?: 'Mutation', readonly acceptMessageSuggestion?: { readonly __typename?: 'AcceptMessageSuggestionPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly messages: ReadonlyArray<{ readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly sender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null, readonly suggestion?: { readonly __typename?: 'MessageSuggestionType', readonly suggestion?: string | null, readonly action?: ResidentialManagementMessageSuggestionActionChoices | null } | null }> } | null } | null };

export type IgnoreMessageSuggestionMutationVariables = Exact<{
  input: IgnoreMessageSuggestionInput;
}>;


export type IgnoreMessageSuggestionMutation = { readonly __typename?: 'Mutation', readonly ignoreMessageSuggestion?: { readonly __typename?: 'IgnoreMessageSuggestionPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly messages: ReadonlyArray<{ readonly __typename?: 'ConversationMessageType', readonly suggestion?: { readonly __typename?: 'MessageSuggestionType', readonly id: string } | null }> } | null } | null };

export type CloseConversationMutationVariables = Exact<{
  input: CloseConversationInput;
}>;


export type CloseConversationMutation = { readonly __typename?: 'Mutation', readonly closeConversation?: { readonly __typename?: 'CloseConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type CreateConversationMutationVariables = Exact<{
  input: CreateConversationInput;
  sender: ConversationRole;
}>;


export type CreateConversationMutation = { readonly __typename?: 'Mutation', readonly createConversation?: { readonly __typename?: 'CreateConversation', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly name: string } | null } | null } | null };

export type CreateConversationActionMutationVariables = Exact<{
  input: CreateConversationActionInput;
}>;


export type CreateConversationActionMutation = { readonly __typename?: 'Mutation', readonly createConversationAction?: { readonly __typename?: 'CreateConversationActionPayload', readonly conversation?: string | null, readonly id?: string | null, readonly createdAt?: string | null, readonly type?: string | null, readonly extra?: string | null } | null };

export type CreateConversationMessageMutationVariables = Exact<{
  input: CreateConversationMessageInput;
  sender: ConversationRole;
}>;


export type CreateConversationMessageMutation = { readonly __typename?: 'Mutation', readonly createConversationMessage?: { readonly __typename?: 'CreateConversationMessage', readonly message?: { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly sender: ResidentialManagementConversationMessageSenderChoices } | null } | null };

export type FindConversationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindConversationQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly hasUnread: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string } | null } | null };

export type FindFullConversationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindFullConversationQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly closedAt?: string | null, readonly rating?: { readonly __typename?: 'ConversationRatingType', readonly id: string, readonly createdAt: string, readonly rating: number, readonly comment?: string | null } | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly resident?: { readonly __typename?: 'ResidentType', readonly id: string } | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null, readonly media: ReadonlyArray<{ readonly __typename?: 'ConversationMediaType', readonly id: string, readonly file: string, readonly createdAt: string, readonly sender: ResidentialManagementConversationMediaSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null }>, readonly messages: ReadonlyArray<{ readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly sender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null, readonly suggestion?: { readonly __typename?: 'MessageSuggestionType', readonly id: string, readonly suggestion?: string | null, readonly action?: ResidentialManagementMessageSuggestionActionChoices | null, readonly createdAt: string, readonly version: number } | null }>, readonly actions: ReadonlyArray<{ readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null, readonly extra?: string | null }>, readonly latestOpen?: { readonly __typename?: 'ConversationOpenedType', readonly id: string, readonly createdAt: string } | null, readonly notes?: { readonly __typename?: 'ConversationNoteNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNoteNodeEdge', readonly node?: { readonly __typename?: 'ConversationNoteNode', readonly id: string, readonly text: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } } | null } | null };

export type ReOpenConversationMutationVariables = Exact<{
  input: ReOpenConversationInput;
}>;


export type ReOpenConversationMutation = { readonly __typename?: 'Mutation', readonly reOpenConversation?: { readonly __typename?: 'ReOpenConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type SnoozeConversationMutationVariables = Exact<{
  input: SnoozeConversationInput;
}>;


export type SnoozeConversationMutation = { readonly __typename?: 'Mutation', readonly snoozeConversation?: { readonly __typename?: 'SnoozeConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type UnsnoozeConversationMutationVariables = Exact<{
  input: UnsnoozeConversationInput;
}>;


export type UnsnoozeConversationMutation = { readonly __typename?: 'Mutation', readonly unsnoozeConversation?: { readonly __typename?: 'UnsnoozeConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type UpdateConversationUrgencyMutationVariables = Exact<{
  input: UpdateConversationUrgencyInput;
}>;


export type UpdateConversationUrgencyMutation = { readonly __typename?: 'Mutation', readonly updateConversationUrgency?: { readonly __typename?: 'UpdateConversationUrgency', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly currentUrgency?: string | null } | null } | null };

export type ShouldShowPaywallQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShouldShowPaywallQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly isSubscribed?: boolean | null } | null, readonly invoices?: { readonly __typename?: 'InvoiceNodeConnection', readonly totalCount: number } | null };

export type AstCostQueryVariables = Exact<{ [key: string]: never; }>;


export type AstCostQuery = { readonly __typename?: 'DebugSchema', readonly productCosts?: { readonly __typename?: 'ProductCosts', readonly astCost?: number | null } | null };

export type PayForDocumentMutationVariables = Exact<{
  input: PayForDocumentInput;
}>;


export type PayForDocumentMutation = { readonly __typename?: 'Mutation', readonly payForDocument?: { readonly __typename?: 'PayForDocumentPayload', readonly stripeClientSecret?: string | null, readonly amount?: number | null, readonly invoice?: { readonly __typename?: 'InvoiceNode', readonly id: string } | null } | null };

export type S21CostQueryVariables = Exact<{ [key: string]: never; }>;


export type S21CostQuery = { readonly __typename?: 'DebugSchema', readonly productCosts?: { readonly __typename?: 'ProductCosts', readonly s21Cost?: number | null } | null };

export type InvoiceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type InvoiceQuery = { readonly __typename?: 'DebugSchema', readonly invoice?: { readonly __typename?: 'InvoiceNode', readonly isPaid: boolean } | null };

export type AgreementTenantCountQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AgreementTenantCountQuery = { readonly __typename?: 'DebugSchema', readonly agreement?: { readonly __typename?: 'GeneratedAgreementNode', readonly id: string, readonly tenants: { readonly __typename?: 'AgreementTenantNodeConnection', readonly totalCount: number } } | null };

export type SubscribeLandlordMutationVariables = Exact<{
  input: SubscribeLandlordInput;
}>;


export type SubscribeLandlordMutation = { readonly __typename?: 'Mutation', readonly subscribeLandlord?: { readonly __typename?: 'SubscribeLandlordPayload', readonly stripeClientSecret?: string | null, readonly firstMonthCost?: number | null, readonly monthlyCost?: number | null, readonly tierUpTo?: number | null, readonly discountCodeValid?: boolean | null } | null };

export type PayForUnpaidApplicationReferencesMutationVariables = Exact<{
  input: PayForUnpaidApplicationReferencesInput;
}>;


export type PayForUnpaidApplicationReferencesMutation = { readonly __typename?: 'Mutation', readonly payForUnpaidApplicationReferences?: { readonly __typename?: 'PayForUnpaidApplicationReferencesPayload', readonly stripeClientSecret?: string | null, readonly amount?: number | null } | null };

export type ReferencePriceQueryVariables = Exact<{
  applicationUUID: Scalars['UUID']['input'];
}>;


export type ReferencePriceQuery = { readonly __typename?: 'DebugSchema', readonly tenancyApplication?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly unpaidTenantReferencesTotalCost?: number | null, readonly unpaidTenantReferenceCount?: number | null } | null };

export type SendTenantReferenceRequestsMutationVariables = Exact<{
  input: SendTenantReferenceRequestsInput;
}>;


export type SendTenantReferenceRequestsMutation = { readonly __typename?: 'Mutation', readonly sendTenantReferenceRequests?: { readonly __typename?: 'SendTenantReferenceRequestsPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string> } | null> | null, readonly tenancyApplication?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly unpaidTenantReferenceCount?: number | null, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly isPaid?: boolean | null, readonly sentAt?: string | null } | null } | null } | null> } } | null } | null };

export type TenantReferenceQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type TenantReferenceQuery = { readonly __typename?: 'DebugSchema', readonly tenantReference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly submittedAt?: string | null, readonly status?: string | null, readonly dateOfBirth?: string | null, readonly employmentStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly rentAffordability?: string | null, readonly creditCheckStatus?: string | null, readonly identityVerificationStatus?: string | null, readonly rightToRentStatus?: string | null, readonly applicant: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly tenancyApplication: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly rentAmount: string, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly status?: string | null } | null } | null } | null> } } }, readonly currentAddress?: { readonly __typename?: 'ReferenceHistoricalAddressNode', readonly id: string, readonly fullAddress?: string | null } | null, readonly tenantEmploymentDetails?: { readonly __typename?: 'EmploymentDetailsNode', readonly income?: string | null, readonly id: string, readonly employmentType: TenancyApplicationEmploymentDetailsEmploymentTypeChoices, readonly jobTitle?: string | null, readonly companyName?: string | null, readonly fullOrPartTime?: TenancyApplicationEmploymentDetailsFullOrPartTimeChoices | null, readonly startDate?: string | null, readonly paymentFrequency?: TenancyApplicationEmploymentDetailsPaymentFrequencyChoices | null, readonly employmentEnding?: boolean | null } | null, readonly historicalAddresses: { readonly __typename?: 'ReferenceHistoricalAddressNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ReferenceHistoricalAddressNodeEdge', readonly node?: { readonly __typename?: 'ReferenceHistoricalAddressNode', readonly id: string, readonly fullAddress?: string | null } | null } | null> }, readonly creditCheck?: { readonly __typename?: 'CreditCheckNode', readonly id: string, readonly riskLevel?: string | null, readonly score: number, readonly aliases: ReadonlyArray<string>, readonly createdAt: string, readonly totalCountyCourtJudgements: number, readonly activeCountyCourtJudgements: number, readonly totalBankruptcies: number, readonly activeBankruptcies: number } | null, readonly identityVerification?: { readonly __typename?: 'IdentityVerificationNode', readonly id: string, readonly status: TenancyApplicationIdentityVerificationStatusChoices, readonly passport?: string | null, readonly passportSelfie?: string | null, readonly nationality?: string | null, readonly documentType?: string | null, readonly documentNumber?: string | null, readonly documentExpiryDate?: string | null, readonly selfie?: string | null, readonly hasRightToRent?: boolean | null } | null, readonly rightToRent?: { readonly __typename?: 'RightToRentNode', readonly id: string, readonly shareCode?: string | null, readonly document?: string | null, readonly officialVerificationStatus?: TenancyApplicationRightToRentOfficialVerificationStatusChoices | null, readonly officialExpiryDate?: string | null, readonly officialDocument?: string | null } | null, readonly employerReference?: { readonly __typename?: 'EmployerReferenceNode', readonly id: string, readonly submittedAt?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly jobTitle?: string | null, readonly mobile?: string | null, readonly email?: string | null, readonly companyName?: string | null, readonly employerEmploymentDetails?: { readonly __typename?: 'EmploymentDetailsNode', readonly id: string, readonly employmentType: TenancyApplicationEmploymentDetailsEmploymentTypeChoices, readonly jobTitle?: string | null, readonly fullOrPartTime?: TenancyApplicationEmploymentDetailsFullOrPartTimeChoices | null, readonly startDate?: string | null, readonly income?: string | null, readonly paymentFrequency?: TenancyApplicationEmploymentDetailsPaymentFrequencyChoices | null, readonly employmentEnding?: boolean | null, readonly companyName?: string | null } | null } | null, readonly landlordReference?: { readonly __typename?: 'LandlordReferenceNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly mobile: string, readonly email: string, readonly submittedAt?: string | null, readonly landlordOrAgent: string, readonly comments?: string | null, readonly tenantMoveInDate?: string | null, readonly tenancyType: TenancyApplicationLandlordReferenceTenancyTypeChoices, readonly monthlyRentAmount: string, readonly hasOutstandingRent: TenancyApplicationLandlordReferenceHasOutstandingRentChoices, readonly rentPaidOnTime: TenancyApplicationLandlordReferenceRentPaidOnTimeChoices, readonly treatedPropertyWell: TenancyApplicationLandlordReferenceTreatedPropertyWellChoices } | null } | null };

export type TenantDetailsHeaderQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type TenantDetailsHeaderQuery = { readonly __typename?: 'DebugSchema', readonly tenantReference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly applicant: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null }, readonly application: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly address?: string | null } } } | null };

export type RemoveResidentsFromResidencyMutationVariables = Exact<{
  input: RemoveResidentsFromResidencyInput;
}>;


export type RemoveResidentsFromResidencyMutation = { readonly __typename?: 'Mutation', readonly removeResidentsFromResidency?: { readonly __typename?: 'RemoveResidentsFromResidencyPayload', readonly residency?: { readonly __typename?: 'ResidencyType', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type FindAgreementStartDateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindAgreementStartDateQuery = { readonly __typename?: 'DebugSchema', readonly findTenancyAgreement?: { readonly __typename?: 'GeneratedAgreementType', readonly id: string, readonly tenancyStart?: string | null } | null };

export type DocumentSentApplicationsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type DocumentSentApplicationsQuery = { readonly __typename?: 'DebugSchema', readonly applications?: { readonly __typename?: 'ApplicationNodeConnection', readonly totalCount: number } | null };

export type UnansweredMessagesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnansweredMessagesQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly totalCount: number } | null };

export type ListHomesToSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomesToSelectQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string }> | null };

export type FormResidenciesQueryVariables = Exact<{
  home?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FormResidenciesQuery = { readonly __typename?: 'DebugSchema', readonly residencies?: { readonly __typename?: 'ResidencyNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyNodeEdge', readonly node?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null } | null> } | null };

export type HomeResidencyDatesQueryVariables = Exact<{
  homeId: Scalars['UUID']['input'];
}>;


export type HomeResidencyDatesQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly residencies?: { readonly __typename?: 'ResidencyNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyNodeEdge', readonly node?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly startDate: string, readonly endDate: string, readonly completionDate?: string | null } | null } | null> } | null } | null };

export type UserCommunityItemFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } };

export type ClientAdminItemFragment = { readonly __typename?: 'ClientAdminNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null };

export type ConciergeItemFragment = { readonly __typename?: 'ConciergeNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null };

export type ManagerItemFragment = { readonly __typename?: 'ManagerType', readonly id: string, readonly email?: string | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null };

export type GetUserTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTypeQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly mobile?: string | null, readonly clientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null } | null, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly email?: string | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null } | null, readonly communityManager?: { readonly __typename?: 'CommunityManagerNode', readonly id: string } | null } | null };

export type CommunitySettingsFragment = { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean };

export type NotificationHookFragment = { readonly __typename?: 'NotificationNode', readonly id: string, readonly verb?: string | null, readonly actor?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'ConciergeNode', readonly id: string } | { readonly __typename?: 'ResidentNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'TenancyApplicantNode' } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly target?: { readonly __typename?: 'AmenityNode' } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TenantReferenceNode' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode' } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'KeyholderNode', readonly id: string } | null };

export type CreateDeviceMutationVariables = Exact<{
  input: CreateNewDeviceInput;
}>;


export type CreateDeviceMutation = { readonly __typename?: 'Mutation', readonly createNewDevice?: { readonly __typename?: 'CreateNewDevice', readonly ok?: boolean | null } | null };

export type FindNotificationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindNotificationQuery = { readonly __typename?: 'DebugSchema', readonly notification?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly verb?: string | null, readonly actor?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'ConciergeNode', readonly id: string } | { readonly __typename?: 'ResidentNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'TenancyApplicantNode' } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly target?: { readonly __typename?: 'AmenityNode' } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TenantReferenceNode' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode' } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'KeyholderNode', readonly id: string } | null } | null };

export type LogManagerDashUseMutationVariables = Exact<{ [key: string]: never; }>;


export type LogManagerDashUseMutation = { readonly __typename?: 'Mutation', readonly logManagerDashUse?: { readonly __typename?: 'LogManagerDashUse', readonly ok?: boolean | null } | null };

export type GetClientTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientTypeQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly clientType: PeopleClientClientTypeChoices } | null };

export type GetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturesQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly features: ReadonlyArray<{ readonly __typename?: 'FeatureType', readonly id: string, readonly name?: string | null, readonly isBeta: boolean }> } | null };

export type IsSubscribedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsSubscribedQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly isSubscribed?: boolean | null } | null };

export type GetLandlordQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLandlordQuery = { readonly __typename?: 'DebugSchema', readonly getLandlord?: { readonly __typename?: 'LandlordNode', readonly id: string, readonly email?: string | null, readonly address?: string | null, readonly smsPreferences: boolean, readonly emailPreferences: boolean, readonly avatar?: string | null } | null, readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly mobile?: string | null } | null };

export type GetClientPaymentsEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientPaymentsEnabledQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly paymentsEnabled?: boolean | null } | null };

export type GetClientStripeLoginLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientStripeLoginLinkQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly stripeDashboardLink?: string | null } | null };

export type NotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationsQuery = { readonly __typename?: 'DebugSchema', readonly notifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'NotificationNodeEdge', readonly node?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'KeyholderNode', readonly id: string } | null } | null } | null> } | null };

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = { readonly __typename?: 'Mutation', readonly readAllNotifications?: { readonly __typename?: 'ReadAllNotificationsPayload', readonly clientMutationId?: string | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  input: ReadNotificationInput;
}>;


export type ReadNotificationMutation = { readonly __typename?: 'Mutation', readonly readNotification?: { readonly __typename?: 'ReadNotificationPayload', readonly notification?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly read: boolean } | null } | null };

export type UnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { readonly __typename?: 'DebugSchema', readonly notifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number } | null };

export type AddMemberMutationVariables = Exact<{
  input: AddMemberInput;
}>;


export type AddMemberMutation = { readonly __typename?: 'Mutation', readonly addMember?: { readonly __typename?: 'AddMemberPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeactivateClientUserMutationVariables = Exact<{
  input: DeactivateClientUserInput;
}>;


export type DeactivateClientUserMutation = { readonly __typename?: 'Mutation', readonly deactivateClientUser?: { readonly __typename?: 'DeactivateClientUserPayload', readonly clientUser?: { readonly __typename?: 'ClientUserNode', readonly id: string } | null } | null };

export type EditMemberMutationVariables = Exact<{
  input: EditMemberInput;
}>;


export type EditMemberMutation = { readonly __typename?: 'Mutation', readonly editMember?: { readonly __typename?: 'EditMemberPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ResendMemberInviteEmailMutationVariables = Exact<{
  input: ResendMemberInviteEmailInput;
}>;


export type ResendMemberInviteEmailMutation = { readonly __typename?: 'Mutation', readonly resendMemberInviteEmail?: { readonly __typename?: 'ResendMemberInviteEmailPayload', readonly clientUser?: { readonly __typename?: 'ClientUserNode', readonly id: string } | null } | null };

export type ClientUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ClientUsersQuery = { readonly __typename?: 'DebugSchema', readonly clientUsers?: { readonly __typename?: 'ClientUserNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientUserNodeEdge', readonly node?: { readonly __typename?: 'ClientUserNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mfaEnabled: boolean, readonly clientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string } | null, readonly communityManager?: { readonly __typename?: 'CommunityManagerNode', readonly id: string, readonly isActive?: boolean | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly isActive?: boolean | null, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null } | null, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string, readonly isActive?: boolean | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null } | null } | null } | null> } | null };

export type GetClientAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientAdminQuery = { readonly __typename?: 'DebugSchema', readonly getClientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly clientType: PeopleClientClientTypeChoices, readonly paymentsEnabled?: boolean | null } | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly mobile?: string | null }, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null } | null };

export type UpdateClientAdminMutationVariables = Exact<{
  input: UpdateClientAdminInput;
}>;


export type UpdateClientAdminMutation = { readonly __typename?: 'Mutation', readonly updateClientAdmin?: { readonly __typename?: 'UpdateClientAdminPayload', readonly clientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string } | null } | null };

export type ConversationTagQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ConversationTagQuery = { readonly __typename?: 'DebugSchema', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string } | null };

export type ConversationTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConversationTagsQuery = { readonly __typename?: 'DebugSchema', readonly conversationTags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly client: { readonly __typename?: 'ClientType', readonly name: string } } | null } | null> } | null };

export type CreateConversationTagMutationVariables = Exact<{
  input: CreateConversationTagInput;
}>;


export type CreateConversationTagMutation = { readonly __typename?: 'Mutation', readonly createConversationTag?: { readonly __typename?: 'CreateConversationTagPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeleteConversationTagMutationVariables = Exact<{
  input: DeleteConversationTagInput;
}>;


export type DeleteConversationTagMutation = { readonly __typename?: 'Mutation', readonly deleteConversationTag?: { readonly __typename?: 'DeleteConversationTagPayload', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string } | null } | null };

export type RemoveConversationTagMutationVariables = Exact<{
  input: RemoveConversationTagInput;
}>;


export type RemoveConversationTagMutation = { readonly __typename?: 'Mutation', readonly removeConversationTag?: { readonly __typename?: 'RemoveConversationTagPayload', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string } | null } | null };

export type TagConversationMutationVariables = Exact<{
  input: TagConversationInput;
}>;


export type TagConversationMutation = { readonly __typename?: 'Mutation', readonly tagConversation?: { readonly __typename?: 'TagConversationPayload', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string } | null } | null };

export type UpdateConversationTagMutationVariables = Exact<{
  input: UpdateConversationTagInput;
}>;


export type UpdateConversationTagMutation = { readonly __typename?: 'Mutation', readonly updateConversationTag?: { readonly __typename?: 'UpdateConversationTagPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ComplianceRequirementsAttentionCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ComplianceRequirementsAttentionCountsQuery = { readonly __typename?: 'DebugSchema', readonly missing?: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number } | null, readonly expiring?: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number } | null, readonly expired?: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number } | null };

export type CreateAttachmentOnRequirementItemMutationVariables = Exact<{
  input: CreateAttachmentOnRequirementItemInput;
}>;


export type CreateAttachmentOnRequirementItemMutation = { readonly __typename?: 'Mutation', readonly createAttachmentOnRequirementItem?: { readonly __typename?: 'CreateAttachmentOnRequirementItemPayload', readonly id?: string | null } | null };

export type CreateComplianceRequirementMutationVariables = Exact<{
  input: CreateComplianceRequirementInput;
}>;


export type CreateComplianceRequirementMutation = { readonly __typename?: 'Mutation', readonly createComplianceRequirement?: { readonly __typename?: 'CreateComplianceRequirementPayload', readonly complianceRequirements?: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNode', readonly id: string } | null> | null } | null };

export type DeleteComplianceRequirementV2MutationVariables = Exact<{
  input: DeleteComplianceRequirementV2Input;
}>;


export type DeleteComplianceRequirementV2Mutation = { readonly __typename?: 'Mutation', readonly deleteComplianceRequirementV2?: { readonly __typename?: 'DeleteComplianceRequirementV2Payload', readonly ok?: boolean | null } | null };

export type ComplianceRequirementQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ComplianceRequirementQuery = { readonly __typename?: 'DebugSchema', readonly complianceRequirement?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly status: string, readonly description?: string | null, readonly type: ComplianceComplianceRequirementTypeChoices, readonly shared: boolean, readonly actionDate?: string | null, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string }, readonly residency?: { readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string } | null, readonly currentItem?: { readonly __typename?: 'RequirementItemNode', readonly id: string, readonly expiryDate?: string | null, readonly comment?: string | null, readonly attachment?: { readonly __typename?: 'LandlordAttachmentType', readonly id: string, readonly file?: string | null, readonly name: string } | null } | null, readonly items: { readonly __typename?: 'RequirementItemNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RequirementItemNodeEdge', readonly node?: { readonly __typename?: 'RequirementItemNode', readonly id: string, readonly expiryDate?: string | null, readonly comment?: string | null, readonly attachment?: { readonly __typename?: 'LandlordAttachmentType', readonly id: string, readonly file?: string | null, readonly name: string } | null } | null } | null> }, readonly agreement?: { readonly __typename?: 'GeneratedAgreementNode', readonly id: string } | null } | null };

export type ComplianceRequirementsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ComplianceRequirementsQuery = { readonly __typename?: 'DebugSchema', readonly complianceRequirements?: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly frequencyText?: string | null, readonly status: string, readonly actionDate?: string | null, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string }, readonly residency?: { readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly endDate: string } | null, readonly currentItem?: { readonly __typename?: 'RequirementItemNode', readonly id: string, readonly expiryDate?: string | null } | null } | null } | null> } | null };

export type ListHomesForRequirementQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomesForRequirementQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string }> | null };

export type SaveRequirementItemMutationVariables = Exact<{
  input: SaveRequirementItemInput;
}>;


export type SaveRequirementItemMutation = { readonly __typename?: 'Mutation', readonly saveRequirementItem?: { readonly __typename?: 'SaveRequirementItemPayload', readonly id?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null };

export type ShareComplianceRequirementMutationVariables = Exact<{
  input: ShareComplianceRequirementInput;
}>;


export type ShareComplianceRequirementMutation = { readonly __typename?: 'Mutation', readonly shareComplianceRequirement?: { readonly __typename?: 'ShareComplianceRequirementPayload', readonly id?: string | null } | null };

export type ListHomesAndResidentsForNewConversationQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomesAndResidentsForNewConversationQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly currentResidency?: { readonly __typename?: 'ResidencyType', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null }> | null };

export type Section21PaidForQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type Section21PaidForQuery = { readonly __typename?: 'DebugSchema', readonly section21?: { readonly __typename?: 'GeneratedSection21Node', readonly id: string, readonly paidFor: boolean } | null, readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly isSubscribed?: boolean | null } | null };

export type AssociateSection21WithClientMutationVariables = Exact<{
  input: AssociateSection21WithClientInput;
}>;


export type AssociateSection21WithClientMutation = { readonly __typename?: 'Mutation', readonly associateSection21WithClient?: { readonly __typename?: 'AssociateSection21WithClient', readonly section21?: { readonly __typename?: 'GeneratedSection21Type', readonly id: string, readonly homeName?: string | null } | null } | null };

export type FindSection21QueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindSection21Query = { readonly __typename?: 'DebugSchema', readonly findSection21?: { readonly __typename?: 'GeneratedSection21Type', readonly id: string, readonly createdAt: string, readonly homeName?: string | null, readonly homeCity?: string | null, readonly homeRegion?: string | null, readonly homePostcode?: string | null, readonly tenants?: string | null, readonly leadTenantEmail?: string | null, readonly possessionDate?: string | null, readonly inspectionDate?: string | null, readonly deadlineDate?: string | null, readonly serviceDate?: string | null, readonly landlordName?: string | null, readonly landlordAddress?: string | null, readonly landlordPhone?: string | null, readonly landlordEmail?: string | null, readonly file?: string | null, readonly viewedOnArk: boolean, readonly htrgProvided: boolean, readonly depositCertificateProvided: boolean, readonly client?: { readonly __typename?: 'ClientType', readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly checked: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly type: ComplianceComplianceRequirementTypeChoices } | null } | null> }, readonly missing: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly type: ComplianceComplianceRequirementTypeChoices } | null } | null> }, readonly expired: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly type: ComplianceComplianceRequirementTypeChoices } | null } | null> }, readonly expiring: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly type: ComplianceComplianceRequirementTypeChoices } | null } | null> } } | null } | null };

export type ListHomesForSection21QueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomesForSection21Query = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly city?: string | null, readonly postcode: string }> | null };

export type SaveGeneratedSection21MutationVariables = Exact<{
  input: SaveGeneratedSection21Input;
}>;


export type SaveGeneratedSection21Mutation = { readonly __typename?: 'Mutation', readonly saveGeneratedSection21?: { readonly __typename?: 'SaveGeneratedSection21Payload', readonly id?: string | null, readonly file?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SendDocumentMutationVariables = Exact<{
  input: SendDocumentInput;
}>;


export type SendDocumentMutation = { readonly __typename?: 'Mutation', readonly sendDocument?: { readonly __typename?: 'SendDocument', readonly section21?: { readonly __typename?: 'GeneratedSection21Type', readonly id: string, readonly serviceDate?: string | null } | null } | null };

export type CreateAttachmentOnHomeMutationVariables = Exact<{
  input: CreateAttachmentOnHomeInput;
}>;


export type CreateAttachmentOnHomeMutation = { readonly __typename?: 'Mutation', readonly createAttachmentOnHome?: { readonly __typename?: 'CreateAttachmentOnHomePayload', readonly id?: string | null } | null };

export type DeleteAttachmentMutationVariables = Exact<{
  input: DeleteAttachmentInput;
}>;


export type DeleteAttachmentMutation = { readonly __typename?: 'Mutation', readonly deleteAttachment?: { readonly __typename?: 'DeleteAttachmentPayload', readonly id?: string | null } | null };

export type LandlordAttachmentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LandlordAttachmentQuery = { readonly __typename?: 'DebugSchema', readonly landlordAttachment?: { readonly __typename?: 'LandlordAttachmentNode', readonly id: string, readonly name: string, readonly createdAt: string, readonly file?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string } | null } | null };

export type LandlordDocumentsQueryVariables = Exact<{
  homeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type LandlordDocumentsQuery = { readonly __typename?: 'DebugSchema', readonly landlordDocuments?: ReadonlyArray<{ readonly __typename?: 'GeneratedAgreementNode', readonly id: string, readonly status: AstGeneratorGeneratedAgreementStatusChoices, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string } | null } | { readonly __typename?: 'GeneratedSection21Node', readonly id: string, readonly createdAt: string, readonly serviceDate?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string } | null } | { readonly __typename?: 'LandlordAttachmentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly name: string, readonly type: ComplianceAttachmentTypeChoices, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string } | null, readonly requirementItem?: { readonly __typename?: 'RequirementItemNode', readonly requirement: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string } } | null } | null> | null };

export type ListHomesForDocumentsFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomesForDocumentsFilterQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string }> | null };

export type UpdateAttachmentMutationVariables = Exact<{
  input: UpdateAttachmentInput;
}>;


export type UpdateAttachmentMutation = { readonly __typename?: 'Mutation', readonly updateAttachment?: { readonly __typename?: 'UpdateAttachmentPayload', readonly id?: string | null } | null };

export type AgreementPaidForByInvoiceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AgreementPaidForByInvoiceQuery = { readonly __typename?: 'DebugSchema', readonly agreement?: { readonly __typename?: 'GeneratedAgreementNode', readonly id: string, readonly paidForByInvoice?: boolean | null } | null };

export type UpgradeLandlordToSubscriptionMutationVariables = Exact<{
  input: UpgradeLandlordToSubscriptionInput;
}>;


export type UpgradeLandlordToSubscriptionMutation = { readonly __typename?: 'Mutation', readonly upgradeLandlordToSubscription?: { readonly __typename?: 'UpgradeLandlordToSubscriptionPayload', readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly isSubscribed?: boolean | null } | null } | null };

export type AgreementPaidForQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AgreementPaidForQuery = { readonly __typename?: 'DebugSchema', readonly agreement?: { readonly __typename?: 'GeneratedAgreementNode', readonly id: string, readonly paidFor: boolean } | null, readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly isSubscribed?: boolean | null } | null };

export type AstFormHomeDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AstFormHomeDetailsQuery = { readonly __typename?: 'DebugSchema', readonly findHome?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string, readonly city?: string | null } | null };

export type FindAgreementTenantsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindAgreementTenantsQuery = { readonly __typename?: 'DebugSchema', readonly findTenancyAgreement?: { readonly __typename?: 'GeneratedAgreementType', readonly homeName?: string | null, readonly homeCity?: string | null, readonly homePostcode?: string | null, readonly tenants: { readonly __typename?: 'AgreementTenantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AgreementTenantNodeEdge', readonly node?: { readonly __typename?: 'AgreementTenantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile: string } | null } | null> }, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null };

export type SendAgreementForSigningMutationVariables = Exact<{
  input: SendAgreementForSigningInput;
}>;


export type SendAgreementForSigningMutation = { readonly __typename?: 'Mutation', readonly sendAgreementForSigning?: { readonly __typename?: 'SendAgreementForSigning', readonly tenants?: ReadonlyArray<{ readonly __typename?: 'AgreementSignatureOutput', readonly name: string, readonly email: string } | null> | null } | null };

export type GeneratedAgreementFragment = { readonly __typename?: 'GeneratedAgreementType', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly homeName?: string | null, readonly homeCity?: string | null, readonly homePostcode?: string | null, readonly email?: string | null, readonly landlordName?: string | null, readonly landlordAddress?: string | null, readonly landlordMobile?: string | null, readonly tenancyStart?: string | null, readonly tenancyEnd?: string | null, readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices, readonly rentAmount?: string | null, readonly depositAmount?: string | null, readonly additionalTerms?: string | null, readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices, readonly utilitiesIncluded?: string | null };

export type AssociateAgreementWithClientMutationVariables = Exact<{
  input: AssociateAgreementWithClientInput;
}>;


export type AssociateAgreementWithClientMutation = { readonly __typename?: 'Mutation', readonly associateAgreementWithClient?: { readonly __typename?: 'AssociateAgreementWithClient', readonly homeId?: string | null, readonly agreement?: { readonly __typename?: 'GeneratedAgreementType', readonly id: string, readonly homeName?: string | null } | null } | null };

export type FindAgreementQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindAgreementQuery = { readonly __typename?: 'DebugSchema', readonly findTenancyAgreement?: { readonly __typename?: 'GeneratedAgreementType', readonly status: AstGeneratorGeneratedAgreementStatusChoices, readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly homeName?: string | null, readonly homeCity?: string | null, readonly homePostcode?: string | null, readonly email?: string | null, readonly landlordName?: string | null, readonly landlordAddress?: string | null, readonly landlordMobile?: string | null, readonly tenancyStart?: string | null, readonly tenancyEnd?: string | null, readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices, readonly rentAmount?: string | null, readonly depositAmount?: string | null, readonly additionalTerms?: string | null, readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices, readonly utilitiesIncluded?: string | null, readonly tenants: { readonly __typename?: 'AgreementTenantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AgreementTenantNodeEdge', readonly node?: { readonly __typename?: 'AgreementTenantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile: string } | null } | null> }, readonly client?: { readonly __typename?: 'ClientType', readonly id: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null, readonly residency?: { readonly __typename?: 'ResidencyType', readonly id: string } | null, readonly signatures: { readonly __typename?: 'AgreementSignatureNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AgreementSignatureNodeEdge', readonly node?: { readonly __typename?: 'AgreementSignatureNode', readonly id: string, readonly name: string, readonly email: string, readonly status: AstGeneratorAgreementSignatureStatusChoices, readonly signatureType: AstGeneratorAgreementSignatureSignatureTypeChoices, readonly signedAt?: string | null } | null } | null> } } | null };

export type RevokeGeneratedAgreementMutationVariables = Exact<{
  input: RevokeGeneratedAgreementInput;
}>;


export type RevokeGeneratedAgreementMutation = { readonly __typename?: 'Mutation', readonly revokeGeneratedAgreement?: { readonly __typename?: 'RevokeGeneratedAgreementPayload', readonly id?: string | null } | null };

export type SaveGeneratedAgreementMutationVariables = Exact<{
  input: SaveGeneratedAgreementInput;
}>;


export type SaveGeneratedAgreementMutation = { readonly __typename?: 'Mutation', readonly saveGeneratedAgreement?: { readonly __typename?: 'SaveGeneratedAgreementPayload', readonly id?: string | null, readonly file?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type LandlordToDoListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LandlordToDoListQuery = { readonly __typename?: 'DebugSchema', readonly complianceRequirements?: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly status: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } } | null } | null> } | null };

export type TasksFragment = { readonly __typename?: 'ClientType', readonly hasAddedHome?: boolean | null, readonly hasCreatedTenancy?: boolean | null, readonly hasSentReference?: boolean | null, readonly hasCheckedCompliance?: boolean | null, readonly hasSignedAgreement?: boolean | null, readonly hasSetupRentCollection?: boolean | null };

export type LandlordTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type LandlordTasksQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly hasAddedHome?: boolean | null, readonly hasCreatedTenancy?: boolean | null, readonly hasSentReference?: boolean | null, readonly hasCheckedCompliance?: boolean | null, readonly hasSignedAgreement?: boolean | null, readonly hasSetupRentCollection?: boolean | null } | null };

export type LandlordHomeFragment = { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string } | null, readonly images: { readonly __typename?: 'HomeImageTypeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeImageTypeEdge', readonly node?: { readonly __typename?: 'HomeImageType', readonly image?: string | null } | null } | null> } };

export type LandlordHomesQueryVariables = Exact<{ [key: string]: never; }>;


export type LandlordHomesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string } | null, readonly images: { readonly __typename?: 'HomeImageTypeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeImageTypeEdge', readonly node?: { readonly __typename?: 'HomeImageType', readonly image?: string | null } | null } | null> } } | null } | null> } | null };

export type ReferencesListDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferencesListDataQuery = { readonly __typename?: 'DebugSchema', readonly tenantReferences?: { readonly __typename?: 'TenantReferenceNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TenantReferenceNodeEdge', readonly node?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly sentAt?: string | null, readonly status?: string | null, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string }, readonly applicant: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type CurrentAndFutureTenanciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAndFutureTenanciesQuery = { readonly __typename?: 'DebugSchema', readonly residencies?: { readonly __typename?: 'ResidencyNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyNodeEdge', readonly node?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly stage?: string | null, readonly startDate: string, readonly rentAmount?: string | null, readonly paymentFrequency: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }>, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } } | null } | null> } | null };

export type InitializeSignupMutationVariables = Exact<{
  acceptedMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  suppressWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InitializeSignupMutation = { readonly __typename?: 'Mutation', readonly initializeSignup?: { readonly __typename?: 'InitializeSignup', readonly ok?: boolean | null, readonly landlord?: { readonly __typename?: 'LandlordNode', readonly id: string } | null } | null };

export type CreateComplianceUpdateReadMutationVariables = Exact<{
  input: CreateComplianceUpdateReadInput;
}>;


export type CreateComplianceUpdateReadMutation = { readonly __typename?: 'Mutation', readonly createComplianceUpdateRead?: { readonly __typename?: 'CreateComplianceUpdateReadPayload', readonly update?: string | null } | null };

export type FindComplianceUpdateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindComplianceUpdateQuery = { readonly __typename?: 'DebugSchema', readonly findComplianceUpdate?: { readonly __typename?: 'ComplianceUpdateType', readonly id: string, readonly image?: string | null, readonly title: string, readonly createdAt: string, readonly wasRead?: boolean | null, readonly dateText?: string | null, readonly actionRequirement: ComplianceComplianceUpdateActionRequirementChoices, readonly actionText?: string | null, readonly infoSource?: string | null, readonly body: string } | null };

export type ListComplianceUpdatesQueryVariables = Exact<{
  unread?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListComplianceUpdatesQuery = { readonly __typename?: 'DebugSchema', readonly listComplianceUpdates?: ReadonlyArray<{ readonly __typename?: 'ComplianceUpdateType', readonly id: string, readonly image?: string | null, readonly title: string, readonly createdAt: string, readonly wasRead?: boolean | null, readonly dateText?: string | null, readonly actionRequirement: ComplianceComplianceUpdateActionRequirementChoices, readonly actionText?: string | null, readonly infoSource?: string | null, readonly body: string }> | null };

export type ListResidenciesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListResidenciesQuery = { readonly __typename?: 'DebugSchema', readonly residencies?: { readonly __typename?: 'ResidencyNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyNodeEdge', readonly node?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly startDate: string, readonly endDate: string, readonly rentAmount?: string | null, readonly paymentStartDate?: string | null, readonly depositAmount?: string | null, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string }, readonly subscription?: { readonly __typename?: 'SubscriptionNode', readonly id: string } | null } | null } | null> } | null };

export type FindResidencyPaymentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindResidencyPaymentsQuery = { readonly __typename?: 'DebugSchema', readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly startDate: string, readonly rentAmount?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null } }> } | null };

export type CreateResidencySubscriptionMutationVariables = Exact<{
  input: CreateResidencySubscriptionInput;
}>;


export type CreateResidencySubscriptionMutation = { readonly __typename?: 'Mutation', readonly createResidencySubscription?: { readonly __typename?: 'CreateResidencySubscriptionPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateStripeAccountMutationVariables = Exact<{
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateStripeAccountMutation = { readonly __typename?: 'Mutation', readonly createStripeAccount?: { readonly __typename?: 'CreateStripeAccount', readonly client?: { readonly __typename?: 'ClientType', readonly clientType: PeopleClientClientTypeChoices, readonly stripeAccountLink?: string | null } | null } | null };

export type CreateStripeAccountLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateStripeAccountLinkQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly stripeAccountLink?: string | null } | null };

export type GetClientSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientSubscriptionsQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly paymentsEnabled?: boolean | null, readonly hasPayments?: boolean | null, readonly subscriptions?: ReadonlyArray<{ readonly __typename?: 'SubscriptionNode', readonly id: string, readonly details?: { readonly __typename?: 'SubscriptionDetails', readonly startDate: string, readonly endDate: string, readonly price: number, readonly status: string, readonly paymentMethod?: { readonly __typename?: 'PaymentMethod', readonly type: string, readonly card?: { readonly __typename?: 'CardPaymentType', readonly brand: string, readonly last4: string } | null, readonly bacsDebit?: { readonly __typename?: 'BACSPaymentType', readonly sortCode: string, readonly last4: string } | null } | null } | null, readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string }, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } }>, readonly depositPayment?: { readonly __typename?: 'PaymentNode', readonly id: string, readonly amount: any, readonly createdAt: string, readonly status: PaymentsPaymentStatusChoices } | null } | null, readonly invoices?: ReadonlyArray<{ readonly __typename?: 'Invoices', readonly id: string, readonly status: string, readonly amount: number, readonly created: string, readonly nextPaymentAttempt?: string | null, readonly paymentIntent?: { readonly __typename?: 'PaymentIntentType', readonly id: string, readonly status: string } | null, readonly charge?: { readonly __typename?: 'ChargeType', readonly paymentMethodDetails: { readonly __typename?: 'PaymentMethod', readonly type: string, readonly card?: { readonly __typename?: 'CardPaymentType', readonly brand: string, readonly last4: string } | null, readonly bacsDebit?: { readonly __typename?: 'BACSPaymentType', readonly sortCode: string, readonly last4: string } | null } } | null }> | null, readonly upcomingInvoice?: { readonly __typename?: 'Invoices', readonly status: string, readonly amount: number, readonly created: string } | null } | null> | null } | null };

export type AddTenancyMutationVariables = Exact<{
  input: ResidencyAndResidentsInput;
}>;


export type AddTenancyMutation = { readonly __typename?: 'Mutation', readonly createResidencyAndResidents?: { readonly __typename?: 'CreateResidencyAndResidents', readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string }> } | null } | null };

export type AddTenancyDataQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AddTenancyDataQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly city?: string | null } | null, readonly getLandlord?: { readonly __typename?: 'LandlordNode', readonly id: string, readonly name?: string | null, readonly email?: string | null } | null };

export type LandlordAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type LandlordAddressQuery = { readonly __typename?: 'DebugSchema', readonly getLandlord?: { readonly __typename?: 'LandlordNode', readonly address?: string | null } | null };

export type SetResidencyCompletionDateMutationVariables = Exact<{
  input: SetResidencyCompletionDateInput;
}>;


export type SetResidencyCompletionDateMutation = { readonly __typename?: 'Mutation', readonly setResidencyCompletionDate?: { readonly __typename?: 'SetResidencyCompletionDatePayload', readonly id?: string | null } | null };

export type RenewTenancyDataQueryVariables = Exact<{
  residencyId: Scalars['UUID']['input'];
}>;


export type RenewTenancyDataQuery = { readonly __typename?: 'DebugSchema', readonly residency?: { readonly __typename?: 'ResidencyNode', readonly rentAmount?: string | null, readonly depositAmount?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly mobile?: string | null }> } | null };

export type ConfirmResidencyWillRollMutationVariables = Exact<{
  input: ConfirmResidencyWillRollInput;
}>;


export type ConfirmResidencyWillRollMutation = { readonly __typename?: 'Mutation', readonly confirmResidencyWillRoll?: { readonly __typename?: 'ConfirmResidencyWillRollPayload', readonly id?: string | null } | null };

export type CountHomeTenanciesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CountHomeTenanciesQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly residencies?: { readonly __typename?: 'ResidencyNodeConnection', readonly totalCount: number } | null } | null };

export type TenancySectionDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TenancySectionDetailsQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly residencies?: { readonly __typename?: 'ResidencyNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyNodeEdge', readonly node?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly rentAmount?: string | null, readonly paymentFrequency: string, readonly stage?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null } | null> } | null } | null };

export type CreateAgreementForTenancyMutationVariables = Exact<{
  input: CreateAgreementForTenancyInput;
}>;


export type CreateAgreementForTenancyMutation = { readonly __typename?: 'Mutation', readonly createAgreementForTenancy?: { readonly __typename?: 'CreateAgreementForTenancyPayload', readonly id?: string | null } | null };

export type TenancySideDialogDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TenancySideDialogDetailsQuery = { readonly __typename?: 'DebugSchema', readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly stage?: string | null, readonly startDate: string, readonly endDate: string, readonly completionDate?: string | null, readonly type?: string | null, readonly rentAmount?: string | null, readonly depositAmount?: string | null, readonly paymentStartDate?: string | null, readonly rollingConfirmed: boolean, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null }, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string, readonly mobile?: string | null }>, readonly subscription?: { readonly __typename?: 'SubscriptionNode', readonly id: string, readonly details?: { readonly __typename?: 'SubscriptionDetails', readonly status: string } | null, readonly upcomingInvoice?: { readonly __typename?: 'Invoices', readonly nextPaymentAttempt?: string | null, readonly status: string } | null, readonly invoices?: ReadonlyArray<{ readonly __typename?: 'Invoices', readonly amount: number, readonly status: string }> | null } | null, readonly generatedAgreements: { readonly __typename?: 'GeneratedAgreementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'GeneratedAgreementNodeEdge', readonly node?: { readonly __typename?: 'GeneratedAgreementNode', readonly id: string, readonly file?: string | null } | null } | null> }, readonly complianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly currentItem?: { readonly __typename?: 'RequirementItemNode', readonly id: string, readonly attachment?: { readonly __typename?: 'LandlordAttachmentType', readonly id: string, readonly file?: string | null } | null } | null } | null } | null> } } | null };

export type CreateResidencyAndResidentsMutationVariables = Exact<{
  input: ResidencyAndResidentsInput;
}>;


export type CreateResidencyAndResidentsMutation = { readonly __typename?: 'Mutation', readonly createResidencyAndResidents?: { readonly __typename?: 'CreateResidencyAndResidents', readonly ok?: boolean | null, readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string } | null } | null };

export type UpdateHomeAddressMutationVariables = Exact<{
  input: UpdateHomeAddressInput;
}>;


export type UpdateHomeAddressMutation = { readonly __typename?: 'Mutation', readonly updateHomeAddress?: { readonly __typename?: 'UpdateHomeAddressPayload', readonly id?: string | null } | null };

export type UpdateResidencyAndResidentsMutationVariables = Exact<{
  input: ResidencyAndResidentsInput;
}>;


export type UpdateResidencyAndResidentsMutation = { readonly __typename?: 'Mutation', readonly updateResidencyAndResidents?: { readonly __typename?: 'UpdateResidencyAndResidents', readonly ok?: boolean | null } | null };

export type SubscriptionUpgradeWarningQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionUpgradeWarningQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly tierUpTo?: number | null, readonly homesCount?: number | null } | null };

export type CalendarLinkLastUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarLinkLastUpdateQuery = { readonly __typename?: 'DebugSchema', readonly getManager?: { readonly __typename?: 'ManagerType', readonly calendarLink?: { readonly __typename?: 'CalendarLinkType', readonly lastChecked?: string | null } | null } | null };

export type DeleteHomeMutationVariables = Exact<{
  input: DeleteHomeInput;
}>;


export type DeleteHomeMutation = { readonly __typename?: 'Mutation', readonly deleteHome?: { readonly __typename?: 'DeleteHomePayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string>, readonly field: string } | null> | null } | null };

export type DeleteHomeImageMutationVariables = Exact<{
  input: DeleteHomeImageInput;
}>;


export type DeleteHomeImageMutation = { readonly __typename?: 'Mutation', readonly deleteHomeImage?: { readonly __typename?: 'DeleteHomeImagePayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string>, readonly field: string } | null> | null } | null };

export type FindHomeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindHomeQuery = { readonly __typename?: 'DebugSchema', readonly findHome?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string, readonly city?: string | null, readonly addressLine1?: string | null, readonly latitude?: string | null, readonly longitude?: string | null, readonly activeResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string } | null> | null, readonly currentResidency?: { readonly __typename?: 'ResidencyType', readonly id: string } | null, readonly residencies: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string }>, readonly generatedAgreements: { readonly __typename?: 'GeneratedAgreementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'GeneratedAgreementNodeEdge', readonly node?: { readonly __typename?: 'GeneratedAgreementNode', readonly id: string, readonly tenancyStart?: string | null, readonly tenancyEnd?: string | null, readonly createdAt: string, readonly rentAmount?: string | null, readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices, readonly residentNames?: string | null, readonly status: AstGeneratorGeneratedAgreementStatusChoices } | null } | null> }, readonly details?: { readonly __typename?: 'HomeDetailsType', readonly description?: string | null, readonly numBedrooms?: number | null, readonly numBathrooms?: number | null, readonly numEnsuites?: number | null, readonly numLivingRooms?: number | null, readonly parking?: ResidentialManagementHomeDetailsParkingChoices | null, readonly garden?: boolean | null, readonly office?: boolean | null, readonly furnishing?: ResidentialManagementHomeDetailsFurnishingChoices | null, readonly kitchen?: boolean | null } | null, readonly images: { readonly __typename?: 'HomeImageTypeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeImageTypeEdge', readonly node?: { readonly __typename?: 'HomeImageType', readonly id: string, readonly image?: string | null } | null } | null> }, readonly missingComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiredComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiringSoonComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number }, readonly allComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'ComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly frequencyText?: string | null, readonly status: string, readonly currentItem?: { readonly __typename?: 'RequirementItemNode', readonly id: string, readonly expiryDate?: string | null } | null, readonly residency?: { readonly __typename?: 'ResidencyType', readonly startDate: string } | null } | null } | null> } } | null };

export type GetClientQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly clientType: PeopleClientClientTypeChoices, readonly paymentsEnabled?: boolean | null } | null };

export type GetManagerProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagerProfileQuery = { readonly __typename?: 'DebugSchema', readonly getManager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly email?: string | null, readonly profile?: { readonly __typename?: 'ManagerProfileType', readonly id: string, readonly complianceEmailExplanation: boolean, readonly complianceUpdateEmails: boolean, readonly valueQuestionnaireAnswer?: number | null, readonly ASTPageViewed: boolean, readonly compliancePageViewed: boolean } | null } | null };

export type InitializeCalendarLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type InitializeCalendarLinkMutation = { readonly __typename?: 'Mutation', readonly initializeCalendarLink?: { readonly __typename?: 'CalendarLinkType', readonly id: string, readonly lastChecked?: string | null } | null };

export type ListHomesForComplianceQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomesForComplianceQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string }> | null };

export type ListLandlordHomesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLandlordHomesQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly missingComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiredComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiringSoonComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number }, readonly allComplianceRequirements: { readonly __typename?: 'ComplianceRequirementNodeConnection', readonly totalCount: number }, readonly activeResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly subscription?: { readonly __typename?: 'SubscriptionNode', readonly id: string, readonly upcomingInvoice?: { readonly __typename?: 'Invoices', readonly nextPaymentAttempt?: string | null } | null } | null } | null> | null, readonly images: { readonly __typename?: 'HomeImageTypeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeImageTypeEdge', readonly node?: { readonly __typename?: 'HomeImageType', readonly image?: string | null } | null } | null> } }> | null };

export type SaveHomeMutationVariables = Exact<{
  input: SaveHomeInput;
}>;


export type SaveHomeMutation = { readonly __typename?: 'Mutation', readonly saveHome?: { readonly __typename?: 'SaveHomePayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SaveManagerProfileMutationVariables = Exact<{
  input: SaveManagerProfileInput;
}>;


export type SaveManagerProfileMutation = { readonly __typename?: 'Mutation', readonly saveManagerProfile?: { readonly __typename?: 'SaveManagerProfilePayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string>, readonly field: string } | null> | null } | null };

export type SearchEpcQueryVariables = Exact<{
  homeId: Scalars['UUID']['input'];
}>;


export type SearchEpcQuery = { readonly __typename?: 'DebugSchema', readonly searchEpc?: ReadonlyArray<{ readonly __typename?: 'EPCResponseType', readonly name: string, readonly city: string, readonly postcode: string, readonly expiryDate: string, readonly checkedDate: string, readonly currentEnergyRating: string, readonly potentialEnergyRating: string, readonly currentEnergyEfficiency: string, readonly potentialEnergyEfficiency: string }> | null };

export type UpdateHomeDetailsMutationVariables = Exact<{
  input: UpdateHomeDetailsInput;
}>;


export type UpdateHomeDetailsMutation = { readonly __typename?: 'Mutation', readonly updateHomeDetails?: { readonly __typename?: 'UpdateHomeDetailsPayload', readonly id?: string | null } | null };

export type UpdateLandlordMutationVariables = Exact<{
  input: UpdateLandlordInput;
}>;


export type UpdateLandlordMutation = { readonly __typename?: 'Mutation', readonly updateLandlord?: { readonly __typename?: 'UpdateLandlordPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ReferenceSignupHomesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReferenceSignupHomesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly city?: string | null, readonly images: { readonly __typename?: 'HomeImageTypeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeImageTypeEdge', readonly node?: { readonly __typename?: 'HomeImageType', readonly image?: string | null } | null } | null> } } | null } | null> } | null };

export type UpdateReferenceStartedOnMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateReferenceStartedOnMutation = { readonly __typename?: 'Mutation', readonly updateReferenceStartedOn?: { readonly __typename?: 'UpdateReferenceStartedOnPayload', readonly client?: { readonly __typename?: 'ClientType', readonly id: string } | null } | null };

export type ReferenceSignupCreateTenancyApplicationMutationVariables = Exact<{
  input: CreateTenancyApplicationInput;
}>;


export type ReferenceSignupCreateTenancyApplicationMutation = { readonly __typename?: 'Mutation', readonly createTenancyApplication?: { readonly __typename?: 'CreateTenancyApplicationPayload', readonly tenancyApplication?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly references?: ReadonlyArray<{ readonly __typename?: 'TenantReferenceNode', readonly id: string } | null> | null, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly isPaid?: boolean | null, readonly sentAt?: string | null } | null } | null } | null> } } | null } | null };

export type CountersignAgreementMutationVariables = Exact<{
  input: CountersignAgreementInput;
}>;


export type CountersignAgreementMutation = { readonly __typename?: 'Mutation', readonly countersignAgreement?: { readonly __typename?: 'CountersignAgreementPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type FindSignatureQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindSignatureQuery = { readonly __typename?: 'DebugSchema', readonly signature?: { readonly __typename?: 'AgreementSignatureNode', readonly id: string, readonly status: AstGeneratorAgreementSignatureStatusChoices, readonly agreement: { readonly __typename?: 'GeneratedAgreementNode', readonly id: string, readonly file?: string | null } } | null };

export type ReferenceItemFragment = { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly identityVerificationStatus?: string | null, readonly rightToRentStatus?: string | null, readonly creditCheckStatus?: string | null, readonly employmentStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly overallStatus?: string | null };

export type TenantApplicantFragment = { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly identityVerificationStatus?: string | null, readonly rightToRentStatus?: string | null, readonly creditCheckStatus?: string | null, readonly employmentStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly overallStatus?: string | null } | null };

export type LandlordTenancyApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LandlordTenancyApplicationsQuery = { readonly __typename?: 'DebugSchema', readonly tenancyApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicationNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly rentAmount: string, readonly combinedAffordability?: number | null, readonly affordabilityStatus: TenancyApplicationTenancyApplicationAffordabilityStatusChoices, readonly status: TenancyApplicationTenancyApplicationStatusChoices, readonly home: { readonly __typename?: 'HomeType', readonly name: string }, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly identityVerificationStatus?: string | null, readonly rightToRentStatus?: string | null, readonly creditCheckStatus?: string | null, readonly employmentStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly overallStatus?: string | null } | null } | null } | null> } } | null } | null> } | null };

export type AmenityAvailabilityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AmenityAvailabilityQuery = { readonly __typename?: 'DebugSchema', readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly daysAvailable: ReadonlyArray<string>, readonly startTime: string, readonly endTime: string, readonly reservations: { readonly __typename?: 'AmenityReservationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityReservationNodeEdge', readonly node?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string } | null } | null> } } | null };

export type ManagerReserveAmenityMutationVariables = Exact<{
  input: ManagerReserveAmenityInput;
}>;


export type ManagerReserveAmenityMutation = { readonly __typename?: 'Mutation', readonly managerReserveAmenity?: { readonly __typename?: 'ManagerReserveAmenityPayload', readonly amenityReservation?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type AmenityReservationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AmenityReservationQuery = { readonly __typename?: 'DebugSchema', readonly amenityReservation?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null };

export type ManagerCancelAmenityReservationMutationVariables = Exact<{
  input: ManagerCancelAmenityReservationInput;
}>;


export type ManagerCancelAmenityReservationMutation = { readonly __typename?: 'Mutation', readonly managerCancelAmenityReservation?: { readonly __typename?: 'ManagerCancelAmenityReservationPayload', readonly amenityReservation?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly cancellationMessage?: string | null } | null } | null };

export type AmenityReservationItemFragment = { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly reason?: string | null, readonly isManager: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null };

export type AmenityReservationsQueryVariables = Exact<{
  amenity: Scalars['UUID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AmenityReservationsQuery = { readonly __typename?: 'DebugSchema', readonly amenityReservations?: { readonly __typename?: 'AmenityReservationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityReservationNodeEdge', readonly node?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly reason?: string | null, readonly isManager: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type AmenityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AmenityQuery = { readonly __typename?: 'DebugSchema', readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly startTime: string, readonly endTime: string, readonly daysAvailable: ReadonlyArray<string>, readonly description: string, readonly image?: string | null, readonly reservable: boolean, readonly status: AmenityStatusEnum, readonly live: boolean, readonly maxHours?: number | null, readonly maxCapacity?: number | null, readonly maxAdvanceReservationDays: number, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null };

export type DeleteAmenityMutationVariables = Exact<{
  input: DeleteAmenityInput;
}>;


export type DeleteAmenityMutation = { readonly __typename?: 'Mutation', readonly deleteAmenity?: { readonly __typename?: 'DeleteAmenityPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SaveAmenityMutationVariables = Exact<{
  input: SaveAmenityInput;
}>;


export type SaveAmenityMutation = { readonly __typename?: 'Mutation', readonly saveAmenity?: { readonly __typename?: 'SaveAmenityPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type AmenitiesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AmenitiesQuery = { readonly __typename?: 'DebugSchema', readonly amenities?: { readonly __typename?: 'AmenityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityNodeEdge', readonly node?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly startTime: string, readonly endTime: string, readonly daysAvailable: ReadonlyArray<string>, readonly image?: string | null, readonly status: AmenityStatusEnum, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type AmenityItemFragment = { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly startTime: string, readonly endTime: string, readonly daysAvailable: ReadonlyArray<string>, readonly image?: string | null, readonly status: AmenityStatusEnum, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } };

export type AcceptApplicationMutationVariables = Exact<{
  application: Scalars['UUID']['input'];
  home?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AcceptApplicationMutation = { readonly __typename?: 'Mutation', readonly acceptApplication?: { readonly __typename?: 'AcceptApplication', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly approvedAt?: string | null } | null } | null };

export type RejectApplicationMutationVariables = Exact<{
  application: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
}>;


export type RejectApplicationMutation = { readonly __typename?: 'Mutation', readonly rejectApplication?: { readonly __typename?: 'RejectApplication', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly lastRejectionReason?: string | null } | null } | null };

export type RemindApplicantMutationVariables = Exact<{
  application: Scalars['UUID']['input'];
}>;


export type RemindApplicantMutation = { readonly __typename?: 'Mutation', readonly remindApplicant?: { readonly __typename?: 'RemindApplicant', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string } | null } | null };

export type ManagerAddApplicationHomeMutationVariables = Exact<{
  input: ManagerAddApplicationHomeInput;
}>;


export type ManagerAddApplicationHomeMutation = { readonly __typename?: 'Mutation', readonly managerAddApplicationHome?: { readonly __typename?: 'ManagerAddApplicationHomePayload', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SearchHomesQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['UUID']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchHomesQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null }> | null };

export type ApplicationAttemptsFragment = { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly rejectionReason?: string | null, readonly rejectedOn?: string | null, readonly reviewer?: { readonly __typename?: 'ManagerType', readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null } } | null } | null } | null> };

export type ApplicationFragment = { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly createdAt: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly townOrCity?: string | null, readonly region?: string | null, readonly postcode: string, readonly ownershipType?: ResidentialManagementApplicationOwnershipTypeChoices | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly lastRejectionReason?: string | null, readonly approvedAt?: string | null, readonly archivedAt?: string | null, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email?: string | null, readonly mobile?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string, readonly address?: string | null } | null, readonly applicationAttempts: { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly rejectionReason?: string | null, readonly rejectedOn?: string | null, readonly reviewer?: { readonly __typename?: 'ManagerType', readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null } } | null } | null } | null> } };

export type ApplicationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApplicationQuery = { readonly __typename?: 'DebugSchema', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly createdAt: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly townOrCity?: string | null, readonly region?: string | null, readonly postcode: string, readonly ownershipType?: ResidentialManagementApplicationOwnershipTypeChoices | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly lastRejectionReason?: string | null, readonly approvedAt?: string | null, readonly archivedAt?: string | null, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email?: string | null, readonly mobile?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string, readonly address?: string | null } | null, readonly applicationAttempts: { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly rejectionReason?: string | null, readonly rejectedOn?: string | null, readonly reviewer?: { readonly __typename?: 'ManagerType', readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null } } | null } | null } | null> } } | null };

export type ArchiveApplicationMutationVariables = Exact<{
  input: ArchiveApplicationInput;
}>;


export type ArchiveApplicationMutation = { readonly __typename?: 'Mutation', readonly archiveApplication?: { readonly __typename?: 'ArchiveApplicationPayload', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null } | null } | null };

export type UnarchiveApplicationMutationVariables = Exact<{
  input: UnarchiveApplicationInput;
}>;


export type UnarchiveApplicationMutation = { readonly __typename?: 'Mutation', readonly unarchiveApplication?: { readonly __typename?: 'UnarchiveApplicationPayload', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null } | null } | null };

export type ApplicationItemFragment = { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string } | null };

export type ApplicationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ApplicationsQuery = { readonly __typename?: 'DebugSchema', readonly applications?: { readonly __typename?: 'ApplicationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string } | null } | null } | null> } | null };

export type RemindAllApplicantsMutationVariables = Exact<{
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>;
}>;


export type RemindAllApplicantsMutation = { readonly __typename?: 'Mutation', readonly remindAllApplicants?: { readonly __typename?: 'RemindAllApplicants', readonly ok?: boolean | null } | null };

export type BlockItemFragment = { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly homesCount?: number | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type BlocksQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlocksQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly homesCount?: number | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type CommunityHeaderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityHeaderQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly avatar?: string | null, readonly name: string, readonly status: string, readonly postcode?: string | null } | null };

export type CommunitySettingsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunitySettingsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null };

export type CommunityOpenPeriodFragment = { readonly __typename?: 'CommunityOpenPeriodNode', readonly id: string, readonly start: any, readonly end: any, readonly weekdayIndex: number };

export type CommunitySettingsDialogQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunitySettingsDialogQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly deactivatedOn?: string | null, readonly avatar?: string | null, readonly commentsEnabled: boolean, readonly communityChatEnabled: boolean, readonly marketplaceEnabled: boolean, readonly paymentsEnabled: boolean, readonly officeHoursEnabled: boolean, readonly outOfOfficeMessage?: string | null, readonly openPeriods?: ReadonlyArray<{ readonly __typename?: 'CommunityOpenPeriodNode', readonly id: string, readonly start: any, readonly end: any, readonly weekdayIndex: number }> | null } | null };

export type UpdateCommunitySettingsMutationVariables = Exact<{
  input: UpdateCommunitySettingsInput;
}>;


export type UpdateCommunitySettingsMutation = { readonly __typename?: 'Mutation', readonly updateCommunitySettings?: { readonly __typename?: 'UpdateCommunitySettingsPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityStatsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityStatsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly engagementScore?: string | null, readonly satisfactionScore?: number | null, readonly engagementScoreDifference?: number | null, readonly downloadRateDifference?: number | null, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null };

export type TeamMemberItemFragment = { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly isManager?: boolean | null, readonly isAdmin?: boolean | null, readonly isConcierge?: boolean | null, readonly isCommunityManager?: boolean | null };

export type CommunityTeamQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityTeamQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNodeEdge', readonly node?: { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly isManager?: boolean | null, readonly isAdmin?: boolean | null, readonly isConcierge?: boolean | null, readonly isCommunityManager?: boolean | null } | null } | null> } | null } | null };

export type CommunityDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid: Scalars['UUID']['input'];
}>;


export type CommunityDetailsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly postcode?: string | null, readonly requisiteDate?: string | null, readonly engagementScore?: string | null, readonly openConversationsCount?: number | null, readonly satisfactionScore?: number | null, readonly homeCount: number, readonly residentCount: number, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null, readonly communityGroups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly totalCount: number }, readonly communityEvents: { readonly __typename?: 'CommunityEventNodeConnection', readonly totalCount: number }, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly totalCount: number } | null } | null, readonly contacts?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number } | null, readonly communityUpdates?: { readonly __typename?: 'CommunityUpdateNodeConnection', readonly totalCount: number } | null, readonly communityDocuments?: { readonly __typename?: 'CommunityDocumentNodeConnection', readonly totalCount: number } | null, readonly amenities?: { readonly __typename?: 'AmenityNodeConnection', readonly totalCount: number } | null, readonly surveys?: { readonly __typename?: 'ResidentSurveyNodeConnection', readonly totalCount: number } | null, readonly applications?: { readonly __typename?: 'ApplicationNodeConnection', readonly totalCount: number } | null, readonly communityProducts?: { readonly __typename?: 'CommunityProductNodeConnection', readonly totalCount: number } | null, readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number } | null, readonly keys?: { readonly __typename?: 'KeyNodeConnection', readonly totalCount: number } | null, readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly totalCount: number } | null };

export type CommunityNameQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityNameQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly postcode?: string | null } | null };

export type CommunitiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly postcode?: string | null, readonly avatar?: string | null, readonly homeCount: number, readonly residentCount: number, readonly engagementScore?: string | null, readonly openConversationsCount?: number | null, readonly status: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null };

export type CommunityProductsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityProductsQuery = { readonly __typename?: 'DebugSchema', readonly communityProducts?: { readonly __typename?: 'CommunityProductNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityProductNodeEdge', readonly node?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null } | null> } | null };

export type CreateCommunityProductMutationVariables = Exact<{
  input: CreateCommunityProductInput;
}>;


export type CreateCommunityProductMutation = { readonly __typename?: 'Mutation', readonly createCommunityProduct?: { readonly __typename?: 'CreateCommunityProductPayload', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeleteCommunityProductMutationVariables = Exact<{
  input: DeleteCommunityProductInput;
}>;


export type DeleteCommunityProductMutation = { readonly __typename?: 'Mutation', readonly deleteCommunityProduct?: { readonly __typename?: 'DeleteCommunityProductPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type FindCommunityProductDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindCommunityProductDetailsQuery = { readonly __typename?: 'DebugSchema', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null };

export type FindCommunityProductPurchasesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindCommunityProductPurchasesQuery = { readonly __typename?: 'DebugSchema', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly purchases: { readonly __typename?: 'CommunityProductPurchaseNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityProductPurchaseNodeEdge', readonly node?: { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string, readonly createdAt: string, readonly address?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } | null } | null } | null> } } | null };

export type UpdateCommunityProductMutationVariables = Exact<{
  input: UpdateCommunityProductInput;
}>;


export type UpdateCommunityProductMutation = { readonly __typename?: 'Mutation', readonly updateCommunityProduct?: { readonly __typename?: 'UpdateCommunityProductPayload', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ComplianceBlockItemFragment = { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly missingComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiredComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiringComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly checkedComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly totalComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number } };

export type ComplianceBlocksQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ComplianceBlocksQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly missingComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiredComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiringComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly checkedComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly totalComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number } } | null } | null> } | null };

export type CreateBlocksComplianceRequirementMutationVariables = Exact<{
  input: CreateBlocksComplianceRequirementInput;
}>;


export type CreateBlocksComplianceRequirementMutation = { readonly __typename?: 'Mutation', readonly createBlocksComplianceRequirement?: { readonly __typename?: 'CreateBlocksComplianceRequirementPayload', readonly blocksComplianceRequirement?: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly blocks: { readonly __typename?: 'BlockNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string } | null } | null> } } | null } | null };

export type BlockComplianceRequirementFragment = { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly shared: boolean }, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null };

export type BlockComplianceRequirementsQueryVariables = Exact<{
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type BlockComplianceRequirementsQuery = { readonly __typename?: 'DebugSchema', readonly blockComplianceRequirements?: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly shared: boolean }, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null } | null } | null> } | null };

export type CreateBlockComplianceRequirementItemMutationVariables = Exact<{
  input: CreateBlockComplianceRequirementItemInput;
}>;


export type CreateBlockComplianceRequirementItemMutation = { readonly __typename?: 'Mutation', readonly createBlockComplianceRequirementItem?: { readonly __typename?: 'CreateBlockComplianceRequirementItemPayload', readonly blockComplianceRequirementItem?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly blockComplianceRequirements: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null } | null } | null> } } | null } | null };

export type RequirementItemBlocksQueryVariables = Exact<{
  requirementId: Scalars['UUID']['input'];
}>;


export type RequirementItemBlocksQuery = { readonly __typename?: 'DebugSchema', readonly blockComplianceRequirement?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly blockComplianceRequirements: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } } | null } | null> } } } | null };

export type BlockComplianceRequirementQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BlockComplianceRequirementQuery = { readonly __typename?: 'DebugSchema', readonly blockComplianceRequirement?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly shared: boolean }, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null } | null };

export type BlockComplianceRequirementStatusFilterQueryVariables = Exact<{
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type BlockComplianceRequirementStatusFilterQuery = { readonly __typename?: 'DebugSchema', readonly blockComplianceRequirements?: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number } | null };

export type ContactConversationsQueryVariables = Exact<{
  contact: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactConversationsQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly closedAt?: string | null, readonly snoozedUntil?: string | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly createdAt: string } | null } | null } | null> } | null };

export type ContactApplicationItemFragment = { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null };

export type ContactProfileHeaderDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContactProfileHeaderDetailsQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly name?: string | null, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null } | null> } } | null, readonly communityGroups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly numUsers?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null };

export type ResidentItemFragment = { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null } }> | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null } };

export type ContactPageListItemFragment = { readonly __typename?: 'ContactNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null } | null> } } | null };

export type ListContactProfilesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListContactProfilesQuery = { readonly __typename?: 'DebugSchema', readonly contacts?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null } | null> } } | null } | null } | null> } | null };

export type NewContactConversationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  contact: Scalars['UUID']['input'];
}>;


export type NewContactConversationQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly email: string, readonly name?: string | null } | null, readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type CommunityStatusQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityStatusQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly status: string } | null };

export type ListHomesToMessageQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ListHomesToMessageQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string }> | null };

export type ListResidenciesWithResidentsQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ListResidenciesWithResidentsQuery = { readonly __typename?: 'DebugSchema', readonly listResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string }, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly hasUsedApp: boolean } }> }> | null };

export type ActiveResidentCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type ActiveResidentCountQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly activeResidentCountDifference?: number | null, readonly activeResidentCount?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null } | null> } | null };

export type ActiveResidentsHistoricalDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ActiveResidentsHistoricalDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type AverageDownloadRateQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type AverageDownloadRateQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly downloadRateDifference?: number | null, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null } | null> } | null };

export type AveragePackageCollectionTimeDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AveragePackageCollectionTimeDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type DashboardPageQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type DashboardPageQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly openCount?: number | null, readonly averageResponseTime?: number | null, readonly responseTimeDifference?: number | null, readonly allTimeSatisfaction?: string | null } | null };

export type DeliveredPackagesCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type DeliveredPackagesCountsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type GetDownloadRatePerCommunityQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetDownloadRatePerCommunityQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null } | null> } | null };

export type FacilityBookingsCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type FacilityBookingsCountQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type IncomingMessagesCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type IncomingMessagesCountsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type IncomingMessagesHistoricalDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type IncomingMessagesHistoricalDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type KeyOutCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type KeyOutCountsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type KeysGraphDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type KeysGraphDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly keyInStats?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null, readonly keyOutStats?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type KeysOutLiveCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type KeysOutLiveCountQuery = { readonly __typename?: 'DebugSchema', readonly keys?: { readonly __typename?: 'KeyNodeConnection', readonly totalCount: number } | null };

export type PackagesGraphDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type PackagesGraphDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly delivered?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null, readonly collected?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type PackagesHeldCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type PackagesHeldCountQuery = { readonly __typename?: 'DebugSchema', readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number } | null };

export type VisitorsOnsiteCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type VisitorsOnsiteCountQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly totalCount: number } | null };

export type ResponseTimeDashboardQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ResponseTimeDashboardQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly responseTime?: number | null, readonly closedAt?: string | null, readonly snoozedUntil?: string | null, readonly hasUnread: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string } | null } | null } | null> } | null };

export type GetAverageResponseTimeQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type GetAverageResponseTimeQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly responseTimeOverTime?: ReadonlyArray<{ readonly __typename?: 'ResponseTimeType', readonly date?: string | null, readonly averageResponseTime?: number | null } | null> | null } | null };

export type GetAverageSatisfactionScoresQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type GetAverageSatisfactionScoresQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly ratingsOverTime?: ReadonlyArray<{ readonly __typename?: 'AverageConversationRatingType', readonly date?: string | null, readonly averageRating?: number | null } | null> | null } | null };

export type GetDownloadRateQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type GetDownloadRateQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly downloadRateOverTime?: ReadonlyArray<{ readonly __typename?: 'DownloadRateType', readonly date?: string | null, readonly downloadRate?: number | null } | null> | null } | null };

export type ListDashboardResidentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListDashboardResidentsQuery = { readonly __typename?: 'DebugSchema', readonly residents?: { readonly __typename?: 'ResidentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentNodeEdge', readonly node?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly averageScore?: number | null, readonly email: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null }, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly city?: string | null } }> | null } | null } | null> } | null };

export type ListEngagementResidentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListEngagementResidentsQuery = { readonly __typename?: 'DebugSchema', readonly residents?: { readonly __typename?: 'ResidentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentNodeEdge', readonly node?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null } }> | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null } } | null } | null> } | null };

export type ListEngagementScoresQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type ListEngagementScoresQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly listEngagementScores?: ReadonlyArray<{ readonly __typename?: 'CommunityEngagementScoreType', readonly score: string, readonly createdAt: string }> | null } | null };

export type ListSatisfactionScoreResidentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  withRating?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListSatisfactionScoreResidentsQuery = { readonly __typename?: 'DebugSchema', readonly residents?: { readonly __typename?: 'ResidentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentNodeEdge', readonly node?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null } }> | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null } } | null } | null> } | null };

export type CreateCommunityDocumentMutationVariables = Exact<{
  input: CreateCommunityDocumentInput;
}>;


export type CreateCommunityDocumentMutation = { readonly __typename?: 'Mutation', readonly createCommunityDocument?: { readonly __typename?: 'CreateCommunityDocumentPayload', readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateResidencyDocumentMutationVariables = Exact<{
  input: CreateResidencyDocumentInput;
}>;


export type CreateResidencyDocumentMutation = { readonly __typename?: 'Mutation', readonly createResidencyDocument?: { readonly __typename?: 'CreateResidencyDocumentPayload', readonly residencyDocument?: { readonly __typename?: 'ResidencyDocumentNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateCommunityDocumentMutationVariables = Exact<{
  input: UpdateCommunityDocumentInput;
}>;


export type UpdateCommunityDocumentMutation = { readonly __typename?: 'Mutation', readonly updateCommunityDocument?: { readonly __typename?: 'UpdateCommunityDocumentPayload', readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateResidencyDocumentMutationVariables = Exact<{
  input: UpdateResidencyDocumentInput;
}>;


export type UpdateResidencyDocumentMutation = { readonly __typename?: 'Mutation', readonly updateResidencyDocument?: { readonly __typename?: 'UpdateResidencyDocumentPayload', readonly residencyDocument?: { readonly __typename?: 'ResidencyDocumentNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ResidencyDocumentFragment = { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string } }>, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly address?: string | null } }, readonly views: { readonly __typename?: 'ResidencyDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'ResidencyDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } };

export type CommunityDocumentFragment = { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly totalPotentialViewers: number, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'CommunityDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } };

export type DocumentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentQuery = { readonly __typename?: 'DebugSchema', readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly totalPotentialViewers: number, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'CommunityDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string } }>, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly address?: string | null } }, readonly views: { readonly __typename?: 'ResidencyDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'ResidencyDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | null } | null };

export type ResidencyDocumentListItemFragment = { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly url?: string | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly address?: string | null } } };

export type CommunityDocumentListItemFragment = { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } };

export type DocumentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentsQuery = { readonly __typename?: 'DebugSchema', readonly documents?: { readonly __typename?: 'DocumentNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'DocumentNodeEdge', readonly node?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly isActive: boolean, readonly url?: string | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly address?: string | null } } } | null } | null } | null> } | null };

export type CommunityEventItemFragment = { readonly __typename?: 'CommunityEventNode', readonly id: string, readonly name: string, readonly start: string, readonly end: string, readonly maxSpaces: number, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } };

export type CommunityEventQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityEventQuery = { readonly __typename?: 'DebugSchema', readonly communityEvent?: { readonly __typename?: 'CommunityEventNode', readonly description: string, readonly attendanceFee?: string | null, readonly id: string, readonly name: string, readonly start: string, readonly end: string, readonly maxSpaces: number, readonly guests?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly email: string } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null };

export type CommunityEventsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityEventsQuery = { readonly __typename?: 'DebugSchema', readonly communityEvents?: { readonly __typename?: 'CommunityEventNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityEventNodeEdge', readonly node?: { readonly __typename?: 'CommunityEventNode', readonly id: string, readonly name: string, readonly start: string, readonly end: string, readonly maxSpaces: number, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type SaveCommunityEventMutationVariables = Exact<{
  input: SaveCommunityEventInput;
}>;


export type SaveCommunityEventMutation = { readonly __typename?: 'Mutation', readonly saveCommunityEvent?: { readonly __typename?: 'SaveCommunityEventPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityGroupItemFragment = { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly numUsers?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null };

export type CommunityGroupsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityGroupsQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly numUsers?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type ContactItemFragment = { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string } | null } | null> } } | null };

export type CommunityGroupQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  homesAfter?: InputMaybe<Scalars['String']['input']>;
  contactsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityGroupQuery = { readonly __typename?: 'DebugSchema', readonly communityGroup?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly isAutomatic: boolean, readonly isCommunityManager?: boolean | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string } | null } | null> } | null, readonly users?: { readonly __typename?: 'ContactNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string } | null } | null> } } | null } | null } | null> } | null } | null };

export type CommunityManagerCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityManagerCommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null, readonly communityManager?: { readonly __typename?: 'CommunityManagerNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null } | null };

export type ActivateGroupMutationVariables = Exact<{
  input: ActivateGroupInput;
}>;


export type ActivateGroupMutation = { readonly __typename?: 'Mutation', readonly activateGroup?: { readonly __typename?: 'ActivateGroupPayload', readonly communityGroup?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly deactivatedOn?: string | null } | null } | null };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { readonly __typename?: 'Mutation', readonly createGroup?: { readonly __typename?: 'CreateGroupPayload', readonly id?: string | null, readonly name?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeactivateGroupMutationVariables = Exact<{
  input: DeactivateGroupInput;
}>;


export type DeactivateGroupMutation = { readonly __typename?: 'Mutation', readonly deactivateGroup?: { readonly __typename?: 'DeactivateGroupPayload', readonly communityGroup?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly deactivatedOn?: string | null } | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { readonly __typename?: 'Mutation', readonly updateGroup?: { readonly __typename?: 'UpdateGroupPayload', readonly id?: string | null, readonly name?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type HomeDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type HomeDetailsQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly averageScore?: number | null, readonly name?: string | null, readonly email: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly lastAppUse?: string | null } }> } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly lastAppUse?: string | null } } | null } | null> } } | null, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string } | null } | null } | null> }, readonly community?: { readonly __typename?: 'CommunityNode', readonly name: string } | null } | null };

export type HomeItemFragment = { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly name: string } | null, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly name?: string | null, readonly email: string }> } | null };

export type ListEntHomesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListEntHomesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly name: string } | null, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly name?: string | null, readonly email: string }> } | null } | null } | null> } | null };

export type KeyCommunityQueryVariables = Exact<{
  keyId: Scalars['UUID']['input'];
}>;


export type KeyCommunityQuery = { readonly __typename?: 'DebugSchema', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string } } | null };

export type OnSiteVisitorItemFragment = { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null };

export type OnSiteVisitorsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OnSiteVisitorsQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityVisitorNodeEdge', readonly node?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null } | null } | null> } | null };

export type CreateKeyholderV2MutationVariables = Exact<{
  input: CreateKeyholderV2Input;
}>;


export type CreateKeyholderV2Mutation = { readonly __typename?: 'Mutation', readonly createKeyholderV2?: { readonly __typename?: 'CreateKeyholderV2Payload', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly key: { readonly __typename?: 'KeyNode', readonly id: string, readonly keyholders: { readonly __typename?: 'KeyholderNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyholderNodeEdge', readonly node?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null> } } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateKeyholderMutationVariables = Exact<{
  input: UpdateKeyholderInput;
}>;


export type UpdateKeyholderMutation = { readonly __typename?: 'Mutation', readonly updateKeyholder?: { readonly __typename?: 'UpdateKeyholderPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type KeyholderItemFragment = { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null };

export type KeyEventItemFragment = { readonly __typename?: 'KeyEventNode', readonly id: string, readonly type: ResidentialManagementKeyEventTypeChoices, readonly createdAt: string, readonly keyholder: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string }, readonly performedBy: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } };

export type KeyHomeItemFragment = { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly address?: string | null, readonly postcode: string, readonly currentResidency?: { readonly __typename?: 'ResidencyType', readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string }> } | null };

export type KeyDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  keyholdersAfter?: InputMaybe<Scalars['String']['input']>;
  eventsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type KeyDetailsQuery = { readonly __typename?: 'DebugSchema', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly name?: string | null, readonly reference?: string | null, readonly checkoutDate?: string | null, readonly notes?: string | null, readonly status: string, readonly archivedAt?: string | null, readonly image?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly address?: string | null, readonly postcode: string, readonly currentResidency?: { readonly __typename?: 'ResidencyType', readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string }> } | null } | null, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null, readonly keyholders: { readonly __typename?: 'KeyholderNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyholderNodeEdge', readonly node?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null> }, readonly events: { readonly __typename?: 'KeyEventNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyEventNodeEdge', readonly node?: { readonly __typename?: 'KeyEventNode', readonly id: string, readonly type: ResidentialManagementKeyEventTypeChoices, readonly createdAt: string, readonly keyholder: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string }, readonly performedBy: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | null };

export type ArchiveKeyMutationVariables = Exact<{
  input: ArchiveKeyInput;
}>;


export type ArchiveKeyMutation = { readonly __typename?: 'Mutation', readonly archiveKey?: { readonly __typename?: 'ArchiveKeyPayload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly status: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ArchiveKeyholderMutationVariables = Exact<{
  input: ArchiveKeyholderInput;
}>;


export type ArchiveKeyholderMutation = { readonly __typename?: 'Mutation', readonly archiveKeyholder?: { readonly __typename?: 'ArchiveKeyholderPayload', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly archivedAt?: string | null, readonly type: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type AuthorisedKeyholdersQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthorisedKeyholdersQuery = { readonly __typename?: 'DebugSchema', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly keyholders: { readonly __typename?: 'KeyholderNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyholderNodeEdge', readonly node?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string } | null } | null> } } | null };

export type CheckInKeyV2MutationVariables = Exact<{
  input: CheckInKeyV2Input;
}>;


export type CheckInKeyV2Mutation = { readonly __typename?: 'Mutation', readonly checkInKeyV2?: { readonly __typename?: 'CheckInKeyV2Payload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly checkoutDate?: string | null, readonly status: string, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CheckOutKeyV2MutationVariables = Exact<{
  input: CheckOutKeyV2Input;
}>;


export type CheckOutKeyV2Mutation = { readonly __typename?: 'Mutation', readonly checkOutKeyV2?: { readonly __typename?: 'CheckOutKeyV2Payload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly checkoutDate?: string | null, readonly status: string, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateKeyMutationVariables = Exact<{
  input: CreateKeyV2Input;
}>;


export type CreateKeyMutation = { readonly __typename?: 'Mutation', readonly createKeyV2?: { readonly __typename?: 'CreateKeyV2Payload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type EditKeyMutationVariables = Exact<{
  input: EditKeyInput;
}>;


export type EditKeyMutation = { readonly __typename?: 'Mutation', readonly editKey?: { readonly __typename?: 'EditKeyPayload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly name?: string | null, readonly reference?: string | null, readonly notes?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UnarchiveKeyMutationVariables = Exact<{
  input: UnarchiveKeyInput;
}>;


export type UnarchiveKeyMutation = { readonly __typename?: 'Mutation', readonly unarchiveKey?: { readonly __typename?: 'UnarchiveKeyPayload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly status: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UnarchiveKeyholderMutationVariables = Exact<{
  input: UnarchiveKeyholderInput;
}>;


export type UnarchiveKeyholderMutation = { readonly __typename?: 'Mutation', readonly unarchiveKeyholder?: { readonly __typename?: 'UnarchiveKeyholderPayload', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly archivedAt?: string | null, readonly type: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type KeyholderQueryVariables = Exact<{
  keyholderId: Scalars['UUID']['input'];
  keyId: Scalars['UUID']['input'];
}>;


export type KeyholderQuery = { readonly __typename?: 'DebugSchema', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly startDate: string, readonly endDate?: string | null, readonly phoneNumber?: string | null, readonly type: string, readonly notes?: string | null, readonly email?: string | null, readonly company?: string | null, readonly archivedAt?: string | null } | null, readonly key?: { readonly __typename?: 'KeyNode', readonly checkoutDate?: string | null, readonly name?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string } | null } | null };

export type KeysQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type KeysQuery = { readonly __typename?: 'DebugSchema', readonly keys?: { readonly __typename?: 'KeyNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyNodeEdge', readonly node?: { readonly __typename?: 'KeyNode', readonly id: string, readonly name?: string | null, readonly reference?: string | null, readonly status: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type ArchiveMarketplaceItemMutationVariables = Exact<{
  input: ArchiveMarketplaceItemInput;
}>;


export type ArchiveMarketplaceItemMutation = { readonly __typename?: 'Mutation', readonly archiveMarketplaceItem?: { readonly __typename?: 'ArchiveMarketplaceItemPayload', readonly marketplaceItem?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type MarketplaceItemQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarketplaceItemQuery = { readonly __typename?: 'DebugSchema', readonly marketplaceItem?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly price: string, readonly condition?: string | null, readonly createdAt: string, readonly closedOn?: string | null, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly name: string }, readonly images: { readonly __typename?: 'MarketplaceItemImageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemImageNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemImageNode', readonly id: string, readonly image: string } | null } | null> }, readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly id: string }, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly totalCount: number }, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null };

export type MarketplaceItemCommentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketplaceItemCommentsQuery = { readonly __typename?: 'DebugSchema', readonly marketplaceItem?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemCommentNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string, readonly comment: string, readonly name: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string } | null } | null } | null> } } | null };

export type MarketplaceItemFragment = { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly price: string, readonly condition?: string | null, readonly createdAt: string, readonly closedOn?: string | null, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly name: string }, readonly images: { readonly __typename?: 'MarketplaceItemImageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemImageNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemImageNode', readonly id: string, readonly image: string } | null } | null> }, readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly id: string }, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly totalCount: number }, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null };

export type MarketplaceItemsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type MarketplaceItemsQuery = { readonly __typename?: 'DebugSchema', readonly marketplaceItems?: { readonly __typename?: 'MarketplaceItemNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly price: string, readonly condition?: string | null, readonly createdAt: string, readonly closedOn?: string | null, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly name: string }, readonly images: { readonly __typename?: 'MarketplaceItemImageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemImageNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemImageNode', readonly id: string, readonly image: string } | null } | null> }, readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly id: string }, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly totalCount: number }, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type CollectPackagesForHomeMutationVariables = Exact<{
  input: CollectPackagesForHomeInput;
}>;


export type CollectPackagesForHomeMutation = { readonly __typename?: 'Mutation', readonly collectPackagesForHome?: { readonly __typename?: 'CollectPackagesForHomePayload', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly uncollectedPackageCount: number, readonly uncollectedPackages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null, readonly createdAt: string } | null } | null> } | null, readonly collectedPackages?: { readonly __typename?: 'PackageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null, readonly collectedOn?: string | null } | null } | null> } | null } | null } | null };

export type HomePackagesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  collectedAfter?: InputMaybe<Scalars['String']['input']>;
  uncollectedAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomePackagesQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly uncollectedPackages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null, readonly createdAt: string, readonly location?: string | null } | null } | null> } | null, readonly collectedPackages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null, readonly collectedOn?: string | null, readonly location?: string | null } | null } | null> } | null } | null };

export type PackageReminderToHomeMutationVariables = Exact<{
  input: PackageReminderToHomeInput;
}>;


export type PackageReminderToHomeMutation = { readonly __typename?: 'Mutation', readonly packageReminderToHome?: { readonly __typename?: 'PackageReminderToHomePayload', readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null };

export type CreateApplicantAndApplicationMutationVariables = Exact<{
  input: CreateApplicantAndApplicationInput;
}>;


export type CreateApplicantAndApplicationMutation = { readonly __typename?: 'Mutation', readonly createApplicantAndApplication?: { readonly __typename?: 'CreateApplicantAndApplicationPayload', readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string } } | null } | null };

export type CollectPackagesMutationVariables = Exact<{
  input: CollectPackagesInput;
}>;


export type CollectPackagesMutation = { readonly __typename?: 'Mutation', readonly collectPackages?: { readonly __typename?: 'CollectPackagesPayload', readonly packages: ReadonlyArray<{ readonly __typename?: 'PackageNode', readonly id: string, readonly status: ResidentialManagementPackageStatusChoices, readonly collectedOn?: string | null, readonly collectedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly uncollectedPackageCount: number } | null } | null> } | null };

export type PackageQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PackageQuery = { readonly __typename?: 'DebugSchema', readonly package?: { readonly __typename?: 'PackageNode', readonly id: string, readonly createdAt: string, readonly status: ResidentialManagementPackageStatusChoices, readonly image?: string | null, readonly addressee?: string | null, readonly collectedOn?: string | null, readonly location?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly collectedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly scannedInBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly reminders?: ReadonlyArray<{ readonly __typename?: 'PackageReminderNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } }> | null } | null };

export type RemindResidentMutationVariables = Exact<{
  input: RemindResidentInput;
}>;


export type RemindResidentMutation = { readonly __typename?: 'Mutation', readonly remindResident?: { readonly __typename?: 'RemindResidentPayload', readonly id?: string | null } | null };

export type HomesWithPackagesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomesWithPackagesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly uncollectedPackageCount: number, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type ListPackagesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListPackagesQuery = { readonly __typename?: 'DebugSchema', readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly createdAt: string, readonly status: ResidentialManagementPackageStatusChoices, readonly collectedOn?: string | null, readonly addressee?: string | null, readonly location?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } | null };

export type PackageReminderToAllMutationVariables = Exact<{
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>;
}>;


export type PackageReminderToAllMutation = { readonly __typename?: 'Mutation', readonly packageReminderToAll?: { readonly __typename?: 'PackageReminderToAll', readonly packages?: ReadonlyArray<{ readonly __typename?: 'PackageNode', readonly id: string, readonly reminders?: ReadonlyArray<{ readonly __typename?: 'PackageReminderNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } }> | null } | null> | null } | null };

export type AccountTransactionItemFragment = { readonly __typename?: 'AccountTransactionNode', readonly id: string, readonly createdAt: string, readonly amount: any, readonly status: PaymentsPaymentStatusChoices, readonly account?: { readonly __typename?: 'PaymentAccountNode', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly externalId?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly externalId?: string | null, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null } | null };

export type AccountTransactionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AccountTransactionsQuery = { readonly __typename?: 'DebugSchema', readonly accountTransactions?: { readonly __typename?: 'AccountTransactionNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'AccountTransactionNodeEdge', readonly node?: { readonly __typename?: 'AccountTransactionNode', readonly id: string, readonly createdAt: string, readonly amount: any, readonly status: PaymentsPaymentStatusChoices, readonly account?: { readonly __typename?: 'PaymentAccountNode', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly externalId?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly externalId?: string | null, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null } | null } | null } | null> } | null };

export type ProfileNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileNotificationSettingsQuery = { readonly __typename?: 'DebugSchema', readonly getManager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly emailPreferences: boolean } | null };

export type UpdateManagerMutationVariables = Exact<{
  input: UpdateManagerInput;
}>;


export type UpdateManagerMutation = { readonly __typename?: 'Mutation', readonly updateManager?: { readonly __typename?: 'UpdateManagerPayload', readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null };

export type UpdateManagerNotificationSettingsMutationVariables = Exact<{
  input: UpdateManagerNotificationSettingsInput;
}>;


export type UpdateManagerNotificationSettingsMutation = { readonly __typename?: 'Mutation', readonly updateManagerNotificationSettings?: { readonly __typename?: 'UpdateManagerNotificationSettingsPayload', readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly emailPreferences: boolean } | null } | null };

export type UpdateMobileMutationVariables = Exact<{
  input: UpdateUserMobileNumberInput;
}>;


export type UpdateMobileMutation = { readonly __typename?: 'Mutation', readonly updateMobileNumber?: { readonly __typename?: 'UpdateUserMobileNumberPayload', readonly error?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly mobile?: string | null } | null } | null };

export type TenancyApplicantItemFragment = { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly status?: string | null, readonly identityVerificationStatus?: string | null, readonly creditCheckStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly employmentStatus?: string | null, readonly rightToRentStatus?: string | null } | null };

export type ApplicationDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ApplicationDetailsQuery = { readonly __typename?: 'DebugSchema', readonly tenancyApplication?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly applicantNames?: string | null, readonly combinedAffordability?: number | null, readonly affordabilityStatus: TenancyApplicationTenancyApplicationAffordabilityStatusChoices, readonly rentAmount: string, readonly completedOn?: string | null, readonly status: TenancyApplicationTenancyApplicationStatusChoices, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null }, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly status?: string | null, readonly identityVerificationStatus?: string | null, readonly creditCheckStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly employmentStatus?: string | null, readonly rightToRentStatus?: string | null } | null } | null } | null> } } | null };

export type CreateTenancyApplicationMutationVariables = Exact<{
  input: CreateTenancyApplicationInput;
}>;


export type CreateTenancyApplicationMutation = { readonly __typename?: 'Mutation', readonly createTenancyApplication?: { readonly __typename?: 'CreateTenancyApplicationPayload', readonly tenancyApplication?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string } | null } | null };

export type ReferencingDisabledCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferencingDisabledCommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null } | null };

export type TenancyApplicationCountsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TenancyApplicationCountsQuery = { readonly __typename?: 'DebugSchema', readonly waitingApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null, readonly issueApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null, readonly passedApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null, readonly totalApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null };

export type TenancyApplicationItemFragment = { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly status: TenancyApplicationTenancyApplicationStatusChoices, readonly applicantNames?: string | null, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string } | null } | null } | null> }, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } };

export type TenancyApplicationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TenancyApplicationsQuery = { readonly __typename?: 'DebugSchema', readonly tenancyApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicationNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly status: TenancyApplicationTenancyApplicationStatusChoices, readonly applicantNames?: string | null, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string } | null } | null } | null> }, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type CloseSurveyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CloseSurveyMutation = { readonly __typename?: 'Mutation', readonly closeSurvey?: { readonly __typename?: 'CloseSurvey', readonly survey?: { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly status: string } | null } | null };

export type CreateSurveyMutationVariables = Exact<{
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { readonly __typename?: 'Mutation', readonly createSurvey?: { readonly __typename?: 'CreateSurveyPayload', readonly id?: string | null, readonly question?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type FindSurveyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindSurveyQuery = { readonly __typename?: 'DebugSchema', readonly survey?: { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly question: string, readonly createdAt: string, readonly status: string, readonly link?: string | null, readonly totalResidents: number, readonly options: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyOptionType', readonly id: string, readonly option?: string | null, readonly totalResidents: number, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyAnswerType', readonly id: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string } | null }> }>, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly answers: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyAnswerType', readonly id: string }> } | null };

export type SurveyResultsCsvQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SurveyResultsCsvQuery = { readonly __typename?: 'DebugSchema', readonly survey?: { readonly __typename?: 'ResidentSurveyNode', readonly rawCsv: string } | null };

export type SurveyItemFragment = { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly createdAt: string, readonly question: string, readonly status: string, readonly link?: string | null, readonly options: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyOptionType', readonly id: string, readonly option?: string | null, readonly totalResidents: number }>, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } };

export type ListResidentSurveyQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListResidentSurveyQuery = { readonly __typename?: 'DebugSchema', readonly surveys?: { readonly __typename?: 'ResidentSurveyNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyNodeEdge', readonly node?: { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly createdAt: string, readonly question: string, readonly status: string, readonly link?: string | null, readonly options: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyOptionType', readonly id: string, readonly option?: string | null, readonly totalResidents: number }>, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type CommunityUpdateCommentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityUpdateCommentsQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateNode', readonly comments?: { readonly __typename?: 'CommunityUpdateCommentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateCommentNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string, readonly name: string, readonly comment: string, readonly createdAt: string, readonly userType: ResidentialManagementCommunityUpdateCommentUserTypeChoices } | null } | null> } | null } | null };

export type CreateUpdateCommentMutationVariables = Exact<{
  input: CreateUpdateCommentInput;
}>;


export type CreateUpdateCommentMutation = { readonly __typename?: 'Mutation', readonly createUpdateComment?: { readonly __typename?: 'CreateUpdateCommentPayload', readonly communityUpdateComment?: { readonly __typename?: 'CommunityUpdateCommentNode', readonly comment: string } | null } | null };

export type DeleteUpdateCommentMutationVariables = Exact<{
  input: DeleteCommunityUpdateCommentInput;
}>;


export type DeleteUpdateCommentMutation = { readonly __typename?: 'Mutation', readonly deleteUpdateComment?: { readonly __typename?: 'DeleteCommunityUpdateCommentPayload', readonly id?: string | null } | null };

export type CancelScheduledPublishCommunityUpdateMutationVariables = Exact<{
  input: CancelScheduledPublishCommunityUpdateInput;
}>;


export type CancelScheduledPublishCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly cancelScheduledPublishCommunityUpdate?: { readonly __typename?: 'CancelScheduledPublishCommunityUpdatePayload', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateType', readonly id: string, readonly status: CommunityUpdateStatusEnum } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type LocalesForGroupsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type LocalesForGroupsQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly locales?: ReadonlyArray<string | null> | null } | null };

export type PreviewCommunityUpdateVariantsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PreviewCommunityUpdateVariantsQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateNode', readonly id: string, readonly title: string, readonly body: string, readonly publishedAt?: string | null, readonly summary: string, readonly category: string, readonly image?: string | null, readonly attachment?: string | null, readonly imageUrl?: string | null, readonly stats: { readonly __typename?: 'CommunityUpdateStatsType', readonly totalLikes: number }, readonly variants?: { readonly __typename?: 'CommunityUpdateLocaleVariantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateLocaleVariantNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateLocaleVariantNode', readonly id: string, readonly locale?: string | null, readonly title?: string | null, readonly summary?: string | null, readonly body?: string | null, readonly status: ResidentialManagementCommunityUpdateLocaleVariantStatusChoices } | null } | null> } | null } | null };

export type PublishCommunityUpdateMutationVariables = Exact<{
  input: PublishCommunityUpdateInput;
}>;


export type PublishCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly publishCommunityUpdate?: { readonly __typename?: 'PublishCommunityUpdatePayload', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateType', readonly id: string, readonly status: CommunityUpdateStatusEnum, readonly publishedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SchedulePublishCommunityUpdateMutationVariables = Exact<{
  input: SchedulePublishCommunityUpdateInput;
}>;


export type SchedulePublishCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly schedulePublishCommunityUpdate?: { readonly __typename?: 'SchedulePublishCommunityUpdatePayload', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateType', readonly id: string, readonly status: CommunityUpdateStatusEnum } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityUpdateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityUpdateQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateNode', readonly id: string, readonly title: string, readonly body: string, readonly summary: string, readonly category: string, readonly image?: string | null, readonly attachment?: string | null, readonly isArk: boolean, readonly publishedAt?: string | null, readonly scheduledFor?: string | null, readonly imageUrl?: string | null, readonly imageSearchTerm?: string | null, readonly status: CommunityUpdateStatusEnum, readonly groups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly locales?: ReadonlyArray<string | null> | null, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly commentsEnabled: boolean } | null } | null } | null> } | null, readonly variants?: { readonly __typename?: 'CommunityUpdateLocaleVariantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateLocaleVariantNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateLocaleVariantNode', readonly id: string, readonly locale?: string | null } | null } | null> } | null, readonly stats: { readonly __typename?: 'CommunityUpdateStatsType', readonly totalLikes: number, readonly totalReads: number, readonly totalComments: number } } | null };

export type DeleteCommunityUpdateMutationVariables = Exact<{
  input: DeleteCommunityUpdateInput;
}>;


export type DeleteCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly deleteCommunityUpdate?: { readonly __typename?: 'DeleteCommunityUpdatePayload', readonly id?: string | null } | null };

export type SaveCommunityUpdateMutationVariables = Exact<{
  input: SaveCommunityUpdateInput;
}>;


export type SaveCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly saveCommunityUpdate?: { readonly __typename?: 'SaveCommunityUpdatePayload', readonly id?: string | null, readonly title?: string | null, readonly summary?: string | null, readonly body?: string | null, readonly category?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityUpdatesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityUpdatesQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdates?: { readonly __typename?: 'CommunityUpdateNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateNode', readonly id: string, readonly title: string, readonly summary: string, readonly image?: string | null, readonly imageUrl?: string | null, readonly category: string, readonly publishedAt?: string | null, readonly status: CommunityUpdateStatusEnum, readonly stats: { readonly __typename?: 'CommunityUpdateStatsType', readonly totalLikes: number, readonly totalReads: number, readonly totalComments: number }, readonly groups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly name: string } | null } | null } | null> } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type SignOutCommunityVisitorMutationVariables = Exact<{
  input: SignOutCommunityVisitorInput;
}>;


export type SignOutCommunityVisitorMutation = { readonly __typename?: 'Mutation', readonly signOutCommunityVisitor?: { readonly __typename?: 'SignOutCommunityVisitorPayload', readonly communityVisitor?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly signedOutAt?: string | null } | null } | null };

export type VisitorQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type VisitorQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitor?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null, readonly createdAt: string, readonly residentName?: string | null, readonly reasonForVisit?: string | null, readonly signedOutAt?: string | null, readonly vehicleRegistration?: string | null, readonly type?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null };

export type VisitorItemFragment = { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly createdAt: string, readonly residentName?: string | null, readonly signedOutAt?: string | null, readonly reasonForVisit?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type VisitorsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type VisitorsQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityVisitorNodeEdge', readonly node?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly createdAt: string, readonly residentName?: string | null, readonly signedOutAt?: string | null, readonly reasonForVisit?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type SendManagerAmplitudeTestMutationVariables = Exact<{
  input: SendManagerAmplitudeTestInput;
}>;


export type SendManagerAmplitudeTestMutation = { readonly __typename?: 'Mutation', readonly sendManagerAmplitudeTest?: { readonly __typename?: 'SendManagerAmplitudeTestPayload', readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null };

export type ReferencingEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferencingEnabledQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number } | null } | null } | null };

export const ConversationListItemFragmentDoc = gql`
    fragment ConversationListItem on ConversationNode {
  id
  subject
  snoozedUntil
  closedAt
  user {
    id
    firstName
    lastName
    email
  }
  home {
    id
    name
    community {
      id
      name
      team {
        edges {
          node {
            id
            name
            email
            firstName
            lastName
          }
        }
      }
    }
  }
  hasUnread
  latestEvent {
    ... on ConversationMessageType {
      id
      body
      createdAt
      messageSender: sender
      user {
        id
        firstName
        lastName
      }
    }
    ... on ConversationMediaType {
      id
      createdAt
      mediaSender: sender
      user {
        id
        firstName
        lastName
      }
    }
    ... on ConversationActionModelType {
      id
      createdAt
      type
      extra
    }
  }
  assignment {
    id
    assignedTo {
      id
      name
      email
      firstName
      lastName
    }
  }
  home {
    id
    client {
      id
      tags {
        edges {
          node {
            id
            name
            isSelected
            suggested
          }
        }
      }
    }
  }
}
    `;
export const ConversationAssignmentDataFragmentDoc = gql`
    fragment ConversationAssignmentData on ConversationNode {
  id
  assignment {
    id
    assignedTo {
      id
      name
      firstName
      lastName
      email
    }
  }
  home {
    id
    community {
      id
    }
  }
}
    `;
export const ConversationLabelFragmentDoc = gql`
    fragment ConversationLabel on ConversationTagNode {
  id
  name
  color
}
    `;
export const CommunitySettingsFragmentDoc = gql`
    fragment CommunitySettings on CommunitySettingsType {
  newsfeed
  messages
  surveys
  documents
  events
  facilities
  marketplace
  accounts
  products
}
    `;
export const UserCommunityItemFragmentDoc = gql`
    fragment UserCommunityItem on CommunityNode {
  id
  name
  settings {
    ...CommunitySettings
  }
}
    ${CommunitySettingsFragmentDoc}`;
export const ClientAdminItemFragmentDoc = gql`
    fragment ClientAdminItem on ClientAdminNode {
  id
  client {
    id
    name
    clientType
  }
  communities {
    edges {
      node {
        ...UserCommunityItem
      }
    }
    totalCount
  }
}
    ${UserCommunityItemFragmentDoc}`;
export const ConciergeItemFragmentDoc = gql`
    fragment ConciergeItem on ConciergeNode {
  id
  communities(orderBy: "name") {
    edges {
      node {
        ...UserCommunityItem
      }
    }
    totalCount
  }
  client {
    id
    name
    clientType
  }
}
    ${UserCommunityItemFragmentDoc}`;
export const ManagerItemFragmentDoc = gql`
    fragment ManagerItem on ManagerType {
  id
  email
  client {
    id
    name
    clientType
  }
  community(orderBy: "name") {
    totalCount
    edges {
      node {
        ...UserCommunityItem
      }
    }
  }
}
    ${UserCommunityItemFragmentDoc}`;
export const NotificationHookFragmentDoc = gql`
    fragment NotificationHook on NotificationNode {
  id
  verb
  actor {
    ... on ResidentNode {
      id
      firstName
      lastName
    }
    ... on ApplicantNode {
      id
      firstName
      lastName
    }
    ... on ConciergeNode {
      id
    }
    ... on UserType {
      id
      firstName
      lastName
    }
  }
  target {
    ... on CommunityUpdateNode {
      id
    }
    ... on ConversationNode {
      id
    }
    ... on ResidentSurveyNode {
      id
    }
    ... on ApplicationNode {
      id
    }
    ... on KeyNode {
      id
    }
    ... on CommunityProductNode {
      id
    }
    ... on CommunityEventNode {
      id
    }
    ... on ConversationAssignmentNode {
      id
    }
  }
  actionObject {
    ... on CommunityUpdateCommentNode {
      id
    }
    ... on ApplicationNode {
      id
    }
    ... on KeyholderNode {
      id
    }
    ... on CommunityProductPurchaseNode {
      id
    }
  }
}
    `;
export const GeneratedAgreementFragmentDoc = gql`
    fragment GeneratedAgreement on GeneratedAgreementType {
  id
  createdAt
  file
  homeName
  homeCity
  homePostcode
  email
  landlordName
  landlordAddress
  landlordMobile
  tenancyStart
  tenancyEnd
  paymentFrequency
  rentAmount
  depositAmount
  additionalTerms
  furnished
  utilitiesIncluded
}
    `;
export const TasksFragmentDoc = gql`
    fragment Tasks on ClientType {
  hasAddedHome
  hasCreatedTenancy
  hasSentReference
  hasCheckedCompliance
  hasSignedAgreement
  hasSetupRentCollection
}
    `;
export const LandlordHomeFragmentDoc = gql`
    fragment LandlordHome on HomeNode {
  id
  name
  addressLine1
  city
  postcode
  activeResidency {
    id
  }
  images {
    edges {
      node {
        image
      }
    }
  }
}
    `;
export const ReferenceItemFragmentDoc = gql`
    fragment ReferenceItem on TenantReferenceNode {
  id
  overallStatus: status
  identityVerificationStatus
  rightToRentStatus
  creditCheckStatus
  employmentStatus
  lettingHistoryStatus
}
    `;
export const TenantApplicantFragmentDoc = gql`
    fragment TenantApplicant on TenancyApplicantNode {
  id
  firstName
  lastName
  email
  mobile
  reference {
    ...ReferenceItem
  }
}
    ${ReferenceItemFragmentDoc}`;
export const AmenityReservationItemFragmentDoc = gql`
    fragment AmenityReservationItem on AmenityReservationNode {
  id
  start
  end
  cancellationMessage
  reason
  isManager
  user {
    id
    name
  }
}
    `;
export const AmenityItemFragmentDoc = gql`
    fragment AmenityItem on AmenityNode {
  id
  name
  startTime
  endTime
  daysAvailable
  image
  status
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;
export const ApplicationAttemptsFragmentDoc = gql`
    fragment ApplicationAttempts on ApplicationAttemptNodeConnection {
  totalCount
  pageInfo {
    endCursor
    hasNextPage
  }
  edges {
    node {
      id
      createdAt
      proofOfAddress
      rejectionReason
      rejectedOn
      reviewer {
        user {
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const ApplicationFragmentDoc = gql`
    fragment Application on ApplicationNode {
  id
  status
  createdAt
  addressLine1
  addressLine2
  townOrCity
  region
  postcode
  ownershipType
  source
  lastRejectionReason
  approvedAt
  archivedAt
  applicant {
    id
    firstName
    lastName
    email
    mobile
  }
  community {
    id
    name
  }
  home {
    id
    name
    postcode
    address
  }
  applicationAttempts(after: $after, orderBy: "-created_at") {
    ...ApplicationAttempts
  }
}
    ${ApplicationAttemptsFragmentDoc}`;
export const ApplicationItemFragmentDoc = gql`
    fragment ApplicationItem on ApplicationNode {
  id
  addressLine1
  postcode
  createdAt
  status
  archivedAt
  applicant {
    id
    firstName
    lastName
    email
  }
  community {
    id
    name
  }
  home {
    id
    name
    postcode
  }
  source
}
    `;
export const BlockItemFragmentDoc = gql`
    fragment BlockItem on BlockNode {
  id
  name
  community {
    id
    name
  }
  homesCount
}
    `;
export const CommunityOpenPeriodFragmentDoc = gql`
    fragment CommunityOpenPeriod on CommunityOpenPeriodNode {
  id
  start
  end
  weekdayIndex
}
    `;
export const TeamMemberItemFragmentDoc = gql`
    fragment TeamMemberItem on CommunityTeamNode {
  id
  firstName
  lastName
  email
  isManager
  isAdmin
  isConcierge
  isCommunityManager
}
    `;
export const ComplianceBlockItemFragmentDoc = gql`
    fragment ComplianceBlockItem on BlockNode {
  id
  name
  community {
    id
    name
  }
  missingComplianceCount: blockComplianceRequirements(status: "MISSING") {
    totalCount
  }
  expiredComplianceCount: blockComplianceRequirements(status: "EXPIRED") {
    totalCount
  }
  expiringComplianceCount: blockComplianceRequirements(status: "EXPIRING") {
    totalCount
  }
  checkedComplianceCount: blockComplianceRequirements(status: "CHECKED") {
    totalCount
  }
  totalComplianceCount: blockComplianceRequirements {
    totalCount
  }
}
    `;
export const BlockComplianceRequirementFragmentDoc = gql`
    fragment BlockComplianceRequirement on BlockComplianceRequirementNode {
  id
  status
  block {
    id
    name
    community {
      id
      name
    }
  }
  requirement {
    id
    name
    description
    shared
  }
  item {
    id
    expiryDate
    createdAt
    attachments {
      edges {
        node {
          id
          file
          url
          createdAt
        }
      }
    }
  }
}
    `;
export const ContactApplicationItemFragmentDoc = gql`
    fragment ContactApplicationItem on ApplicationNode {
  id
  home {
    id
  }
  addressLine1
  addressLine2
  approvedAt
  createdAt
  status
}
    `;
export const ResidentItemFragmentDoc = gql`
    fragment ResidentItem on ResidentNode {
  id
  name
  email
  avatar
  averageScore
  currentResidencies {
    home {
      id
      name
      addressLine1
      city
    }
  }
  user {
    id
    lastAppUse
  }
}
    `;
export const ContactPageListItemFragmentDoc = gql`
    fragment ContactPageListItem on ContactNode {
  id
  firstName
  lastName
  email
  lastAppUse
  resident {
    id
    avatar
    averageScore
  }
  leaseholder {
    id
    leaseholds {
      edges {
        node {
          id
          createdAt
          home {
            id
            address
            community {
              id
              name
            }
          }
        }
      }
    }
  }
  applicant {
    id
    applications {
      edges {
        node {
          id
          home {
            id
          }
          addressLine1
          addressLine2
          approvedAt
          createdAt
          status
        }
      }
    }
  }
}
    `;
export const ResidencyDocumentFragmentDoc = gql`
    fragment ResidencyDocument on ResidencyDocumentNode {
  id
  createdAt
  file
  link
  title
  isActive
  description
  url
  activatedOn
  community {
    id
    name
  }
  residency {
    id
    startDate
    completionDate
    residents {
      id
      name
      user {
        id
        email
      }
    }
    home {
      id
      name
      address
    }
  }
  views(after: $after) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        user {
          id
          name
        }
      }
    }
  }
}
    `;
export const CommunityDocumentFragmentDoc = gql`
    fragment CommunityDocument on CommunityDocumentNode {
  id
  createdAt
  file
  link
  title
  isActive
  description
  url
  activatedOn
  totalPotentialViewers
  community {
    id
    name
  }
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
  views(after: $after) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        user {
          id
          name
        }
      }
    }
  }
}
    `;
export const ResidencyDocumentListItemFragmentDoc = gql`
    fragment ResidencyDocumentListItem on ResidencyDocumentNode {
  id
  createdAt
  file
  link
  title
  isActive
  url
  residency {
    id
    home {
      id
      name
      address
    }
  }
}
    `;
export const CommunityDocumentListItemFragmentDoc = gql`
    fragment CommunityDocumentListItem on CommunityDocumentNode {
  id
  createdAt
  file
  link
  title
  isActive
  url
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;
export const CommunityEventItemFragmentDoc = gql`
    fragment CommunityEventItem on CommunityEventNode {
  id
  name
  start
  end
  maxSpaces
  community {
    id
    name
  }
  groups {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const CommunityGroupItemFragmentDoc = gql`
    fragment CommunityGroupItem on CommunityGroupNode {
  id
  name
  description
  deactivatedOn
  numUsers
  community {
    id
    name
  }
}
    `;
export const ContactItemFragmentDoc = gql`
    fragment ContactItem on ContactNode {
  id
  name
  firstName
  lastName
  email
  mobile
  lastAppUse
  resident {
    id
    avatar
    averageScore
    currentResidencies {
      id
      home {
        id
        address
      }
    }
  }
  leaseholder {
    id
    leaseholds {
      edges {
        node {
          id
          home {
            id
            address
          }
        }
      }
    }
  }
  applicant {
    id
    applications {
      edges {
        node {
          id
          addressLine1
          postcode
        }
      }
    }
  }
}
    `;
export const HomeItemFragmentDoc = gql`
    fragment HomeItem on HomeNode {
  id
  name
  addressLine1
  city
  postcode
  community {
    name
  }
  activeResidency {
    residents {
      name
      email
    }
  }
}
    `;
export const OnSiteVisitorItemFragmentDoc = gql`
    fragment OnSiteVisitorItem on CommunityVisitorNode {
  id
  name
  email
  mobile
}
    `;
export const KeyholderItemFragmentDoc = gql`
    fragment KeyholderItem on KeyholderNode {
  id
  name
  type
  phoneNumber
}
    `;
export const KeyEventItemFragmentDoc = gql`
    fragment KeyEventItem on KeyEventNode {
  id
  type
  createdAt
  keyholder {
    id
    name
  }
  performedBy {
    id
    name
  }
}
    `;
export const KeyHomeItemFragmentDoc = gql`
    fragment KeyHomeItem on HomeType {
  id
  name
  addressLine1
  address
  postcode
  currentResidency {
    residents {
      id
      name
      email
    }
  }
}
    `;
export const MarketplaceItemFragmentDoc = gql`
    fragment MarketplaceItem on MarketplaceItemNode {
  id
  title
  description
  price
  condition
  createdAt
  closedOn
  condition
  community {
    name
  }
  images {
    edges {
      node {
        id
        image
      }
    }
  }
  user {
    firstName
    lastName
    id
  }
  comments {
    totalCount
  }
  archivedBy {
    id
    name
  }
  archivedOn
  archivedReason
}
    `;
export const AccountTransactionItemFragmentDoc = gql`
    fragment AccountTransactionItem on AccountTransactionNode {
  id
  createdAt
  amount
  status
  account {
    home {
      id
      address
      community {
        id
        name
      }
    }
    residency {
      id
      externalId
      residents {
        id
        name
      }
    }
    leasehold {
      id
      externalId
      leaseholder {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const TenancyApplicantItemFragmentDoc = gql`
    fragment TenancyApplicantItem on TenancyApplicantNode {
  id
  firstName
  lastName
  email
  mobile
  reference {
    id
    status
    identityVerificationStatus
    creditCheckStatus
    lettingHistoryStatus
    employmentStatus
    rightToRentStatus
  }
}
    `;
export const TenancyApplicationItemFragmentDoc = gql`
    fragment TenancyApplicationItem on TenancyApplicationNode {
  id
  status
  applicantNames
  applicants {
    edges {
      node {
        id
        reference {
          id
        }
      }
    }
  }
  home {
    id
    address
    community {
      id
      name
    }
  }
}
    `;
export const SurveyItemFragmentDoc = gql`
    fragment SurveyItem on ResidentSurveyNode {
  id
  createdAt
  question
  status
  link
  options {
    id
    option
    totalResidents
  }
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;
export const VisitorItemFragmentDoc = gql`
    fragment VisitorItem on CommunityVisitorNode {
  id
  name
  createdAt
  residentName
  signedOutAt
  reasonForVisit
  community {
    id
    name
  }
}
    `;
export const CreateBlocksDocument = gql`
    mutation CreateBlocks($communityId: UUID!, $blockNames: [String]!) {
  createBlocks(communityId: $communityId, blockNames: $blockNames) {
    blocks {
      id
      name
    }
  }
}
    `;
export type CreateBlocksMutationFn = Apollo.MutationFunction<CreateBlocksMutation, CreateBlocksMutationVariables>;

/**
 * __useCreateBlocksMutation__
 *
 * To run a mutation, you first call `useCreateBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlocksMutation, { data, loading, error }] = useCreateBlocksMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      blockNames: // value for 'blockNames'
 *   },
 * });
 */
export function useCreateBlocksMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlocksMutation, CreateBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlocksMutation, CreateBlocksMutationVariables>(CreateBlocksDocument, options);
      }
export type CreateBlocksMutationHookResult = ReturnType<typeof useCreateBlocksMutation>;
export type CreateBlocksMutationResult = Apollo.MutationResult<CreateBlocksMutation>;
export type CreateBlocksMutationOptions = Apollo.BaseMutationOptions<CreateBlocksMutation, CreateBlocksMutationVariables>;
export const ContactAutocompleteDocument = gql`
    query ContactAutocomplete($after: String, $search: String, $community: UUID, $home: UUID) {
  contacts(
    after: $after
    community: $community
    search: $search
    home: $home
    orderBy: "firstName"
    allowApplicants: false
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...ContactItem
      }
    }
  }
}
    ${ContactItemFragmentDoc}`;

/**
 * __useContactAutocompleteQuery__
 *
 * To run a query within a React component, call `useContactAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      community: // value for 'community'
 *      home: // value for 'home'
 *   },
 * });
 */
export function useContactAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>(ContactAutocompleteDocument, options);
      }
export function useContactAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>(ContactAutocompleteDocument, options);
        }
export type ContactAutocompleteQueryHookResult = ReturnType<typeof useContactAutocompleteQuery>;
export type ContactAutocompleteLazyQueryHookResult = ReturnType<typeof useContactAutocompleteLazyQuery>;
export type ContactAutocompleteQueryResult = Apollo.QueryResult<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>;
export const GroupAutocompleteDocument = gql`
    query GroupAutocomplete($after: String, $search: String, $community: UUID) {
  communityGroups(
    after: $after
    search: $search
    community: $community
    active: true
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGroupAutocompleteQuery__
 *
 * To run a query within a React component, call `useGroupAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      community: // value for 'community'
 *   },
 * });
 */
export function useGroupAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>(GroupAutocompleteDocument, options);
      }
export function useGroupAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>(GroupAutocompleteDocument, options);
        }
export type GroupAutocompleteQueryHookResult = ReturnType<typeof useGroupAutocompleteQuery>;
export type GroupAutocompleteLazyQueryHookResult = ReturnType<typeof useGroupAutocompleteLazyQuery>;
export type GroupAutocompleteQueryResult = Apollo.QueryResult<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>;
export const HomeAutocompleteDocument = gql`
    query HomeAutocomplete($communities: [ID!], $after: String, $icontainsSearch: String) {
  homes(
    communities: $communities
    after: $after
    icontainsSearch: $icontainsSearch
    orderBy: "number_in_address,name"
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        address
      }
    }
  }
}
    `;

/**
 * __useHomeAutocompleteQuery__
 *
 * To run a query within a React component, call `useHomeAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeAutocompleteQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      icontainsSearch: // value for 'icontainsSearch'
 *   },
 * });
 */
export function useHomeAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>(HomeAutocompleteDocument, options);
      }
export function useHomeAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>(HomeAutocompleteDocument, options);
        }
export type HomeAutocompleteQueryHookResult = ReturnType<typeof useHomeAutocompleteQuery>;
export type HomeAutocompleteLazyQueryHookResult = ReturnType<typeof useHomeAutocompleteLazyQuery>;
export type HomeAutocompleteQueryResult = Apollo.QueryResult<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>;
export const HasAsanaIntegrationDocument = gql`
    query HasAsanaIntegration($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      id
      community {
        id
        hasAsanaIntegration
      }
    }
  }
}
    `;

/**
 * __useHasAsanaIntegrationQuery__
 *
 * To run a query within a React component, call `useHasAsanaIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasAsanaIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasAsanaIntegrationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useHasAsanaIntegrationQuery(baseOptions: Apollo.QueryHookOptions<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>(HasAsanaIntegrationDocument, options);
      }
export function useHasAsanaIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>(HasAsanaIntegrationDocument, options);
        }
export type HasAsanaIntegrationQueryHookResult = ReturnType<typeof useHasAsanaIntegrationQuery>;
export type HasAsanaIntegrationLazyQueryHookResult = ReturnType<typeof useHasAsanaIntegrationLazyQuery>;
export type HasAsanaIntegrationQueryResult = Apollo.QueryResult<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>;
export const ConversationSummaryDocument = gql`
    query ConversationSummary($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    summary {
      id
      summary
    }
  }
}
    `;

/**
 * __useConversationSummaryQuery__
 *
 * To run a query within a React component, call `useConversationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationSummaryQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationSummaryQuery(baseOptions: Apollo.QueryHookOptions<ConversationSummaryQuery, ConversationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationSummaryQuery, ConversationSummaryQueryVariables>(ConversationSummaryDocument, options);
      }
export function useConversationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationSummaryQuery, ConversationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationSummaryQuery, ConversationSummaryQueryVariables>(ConversationSummaryDocument, options);
        }
export type ConversationSummaryQueryHookResult = ReturnType<typeof useConversationSummaryQuery>;
export type ConversationSummaryLazyQueryHookResult = ReturnType<typeof useConversationSummaryLazyQuery>;
export type ConversationSummaryQueryResult = Apollo.QueryResult<ConversationSummaryQuery, ConversationSummaryQueryVariables>;
export const CreateConversationSummaryDocument = gql`
    mutation CreateConversationSummary($input: CreateConversationSummaryInput!) {
  createConversationSummary(input: $input) {
    conversationSummary {
      id
      conversation {
        id
        summary {
          id
          summary
        }
      }
    }
  }
}
    `;
export type CreateConversationSummaryMutationFn = Apollo.MutationFunction<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>;

/**
 * __useCreateConversationSummaryMutation__
 *
 * To run a mutation, you first call `useCreateConversationSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationSummaryMutation, { data, loading, error }] = useCreateConversationSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationSummaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>(CreateConversationSummaryDocument, options);
      }
export type CreateConversationSummaryMutationHookResult = ReturnType<typeof useCreateConversationSummaryMutation>;
export type CreateConversationSummaryMutationResult = Apollo.MutationResult<CreateConversationSummaryMutation>;
export type CreateConversationSummaryMutationOptions = Apollo.BaseMutationOptions<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>;
export const CommunityTeamMembersDocument = gql`
    query CommunityTeamMembers($communityId: UUID!) {
  community(id: $communityId) {
    id
    team {
      edges {
        node {
          id
          name
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;

/**
 * __useCommunityTeamMembersQuery__
 *
 * To run a query within a React component, call `useCommunityTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTeamMembersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunityTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>(CommunityTeamMembersDocument, options);
      }
export function useCommunityTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>(CommunityTeamMembersDocument, options);
        }
export type CommunityTeamMembersQueryHookResult = ReturnType<typeof useCommunityTeamMembersQuery>;
export type CommunityTeamMembersLazyQueryHookResult = ReturnType<typeof useCommunityTeamMembersLazyQuery>;
export type CommunityTeamMembersQueryResult = Apollo.QueryResult<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>;
export const ConversationAssignmentDataDocument = gql`
    query ConversationAssignmentData($conversationId: UUID!) {
  conversation(id: $conversationId) {
    ...ConversationAssignmentData
  }
}
    ${ConversationAssignmentDataFragmentDoc}`;

/**
 * __useConversationAssignmentDataQuery__
 *
 * To run a query within a React component, call `useConversationAssignmentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationAssignmentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationAssignmentDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationAssignmentDataQuery(baseOptions: Apollo.QueryHookOptions<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>(ConversationAssignmentDataDocument, options);
      }
export function useConversationAssignmentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>(ConversationAssignmentDataDocument, options);
        }
export type ConversationAssignmentDataQueryHookResult = ReturnType<typeof useConversationAssignmentDataQuery>;
export type ConversationAssignmentDataLazyQueryHookResult = ReturnType<typeof useConversationAssignmentDataLazyQuery>;
export type ConversationAssignmentDataQueryResult = Apollo.QueryResult<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>;
export const CreateConversationAssignmentDocument = gql`
    mutation CreateConversationAssignment($input: CreateConversationAssignmentInput!) {
  createConversationAssignment(input: $input) {
    conversationAssignment {
      id
      conversation {
        ...ConversationAssignmentData
      }
    }
  }
}
    ${ConversationAssignmentDataFragmentDoc}`;
export type CreateConversationAssignmentMutationFn = Apollo.MutationFunction<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>;

/**
 * __useCreateConversationAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateConversationAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationAssignmentMutation, { data, loading, error }] = useCreateConversationAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>(CreateConversationAssignmentDocument, options);
      }
export type CreateConversationAssignmentMutationHookResult = ReturnType<typeof useCreateConversationAssignmentMutation>;
export type CreateConversationAssignmentMutationResult = Apollo.MutationResult<CreateConversationAssignmentMutation>;
export type CreateConversationAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>;
export const ConversationForwardingEmailsDocument = gql`
    query ConversationForwardingEmails($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      id
      community {
        id
        settings {
          conversationForwardingEmails {
            id
            name
            emails
          }
        }
      }
    }
  }
}
    `;

/**
 * __useConversationForwardingEmailsQuery__
 *
 * To run a query within a React component, call `useConversationForwardingEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationForwardingEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationForwardingEmailsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationForwardingEmailsQuery(baseOptions: Apollo.QueryHookOptions<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>(ConversationForwardingEmailsDocument, options);
      }
export function useConversationForwardingEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>(ConversationForwardingEmailsDocument, options);
        }
export type ConversationForwardingEmailsQueryHookResult = ReturnType<typeof useConversationForwardingEmailsQuery>;
export type ConversationForwardingEmailsLazyQueryHookResult = ReturnType<typeof useConversationForwardingEmailsLazyQuery>;
export type ConversationForwardingEmailsQueryResult = Apollo.QueryResult<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>;
export const AvailableConversationLabelsDocument = gql`
    query AvailableConversationLabels($communityId: UUID!) {
  community(id: $communityId) {
    id
    client {
      id
      tags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;

/**
 * __useAvailableConversationLabelsQuery__
 *
 * To run a query within a React component, call `useAvailableConversationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableConversationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableConversationLabelsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useAvailableConversationLabelsQuery(baseOptions: Apollo.QueryHookOptions<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>(AvailableConversationLabelsDocument, options);
      }
export function useAvailableConversationLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>(AvailableConversationLabelsDocument, options);
        }
export type AvailableConversationLabelsQueryHookResult = ReturnType<typeof useAvailableConversationLabelsQuery>;
export type AvailableConversationLabelsLazyQueryHookResult = ReturnType<typeof useAvailableConversationLabelsLazyQuery>;
export type AvailableConversationLabelsQueryResult = Apollo.QueryResult<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>;
export const ActiveConversationLabelsDocument = gql`
    query ActiveConversationLabels($id: UUID!) {
  conversation(id: $id) {
    tags {
      totalCount
      edges {
        node {
          ...ConversationLabel
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;

/**
 * __useActiveConversationLabelsQuery__
 *
 * To run a query within a React component, call `useActiveConversationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveConversationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveConversationLabelsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActiveConversationLabelsQuery(baseOptions: Apollo.QueryHookOptions<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>(ActiveConversationLabelsDocument, options);
      }
export function useActiveConversationLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>(ActiveConversationLabelsDocument, options);
        }
export type ActiveConversationLabelsQueryHookResult = ReturnType<typeof useActiveConversationLabelsQuery>;
export type ActiveConversationLabelsLazyQueryHookResult = ReturnType<typeof useActiveConversationLabelsLazyQuery>;
export type ActiveConversationLabelsQueryResult = Apollo.QueryResult<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>;
export const LabelConversationDocument = gql`
    mutation LabelConversation($input: LabelConversationInput!) {
  labelConversation(input: $input) {
    conversation {
      id
      availableTags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
      tags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;
export type LabelConversationMutationFn = Apollo.MutationFunction<LabelConversationMutation, LabelConversationMutationVariables>;

/**
 * __useLabelConversationMutation__
 *
 * To run a mutation, you first call `useLabelConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLabelConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [labelConversationMutation, { data, loading, error }] = useLabelConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLabelConversationMutation(baseOptions?: Apollo.MutationHookOptions<LabelConversationMutation, LabelConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LabelConversationMutation, LabelConversationMutationVariables>(LabelConversationDocument, options);
      }
export type LabelConversationMutationHookResult = ReturnType<typeof useLabelConversationMutation>;
export type LabelConversationMutationResult = Apollo.MutationResult<LabelConversationMutation>;
export type LabelConversationMutationOptions = Apollo.BaseMutationOptions<LabelConversationMutation, LabelConversationMutationVariables>;
export const UnlabelConversationDocument = gql`
    mutation UnlabelConversation($input: UnlabelConversationInput!) {
  unlabelConversation(input: $input) {
    conversation {
      id
      availableTags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
      tags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;
export type UnlabelConversationMutationFn = Apollo.MutationFunction<UnlabelConversationMutation, UnlabelConversationMutationVariables>;

/**
 * __useUnlabelConversationMutation__
 *
 * To run a mutation, you first call `useUnlabelConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlabelConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlabelConversationMutation, { data, loading, error }] = useUnlabelConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlabelConversationMutation(baseOptions?: Apollo.MutationHookOptions<UnlabelConversationMutation, UnlabelConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlabelConversationMutation, UnlabelConversationMutationVariables>(UnlabelConversationDocument, options);
      }
export type UnlabelConversationMutationHookResult = ReturnType<typeof useUnlabelConversationMutation>;
export type UnlabelConversationMutationResult = Apollo.MutationResult<UnlabelConversationMutation>;
export type UnlabelConversationMutationOptions = Apollo.BaseMutationOptions<UnlabelConversationMutation, UnlabelConversationMutationVariables>;
export const UpdateConversationTitleDocument = gql`
    mutation UpdateConversationTitle($input: UpdateConversationTitleInput!) {
  updateConversationTitle(input: $input) {
    conversation {
      id
      subject
    }
  }
}
    `;
export type UpdateConversationTitleMutationFn = Apollo.MutationFunction<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>;

/**
 * __useUpdateConversationTitleMutation__
 *
 * To run a mutation, you first call `useUpdateConversationTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationTitleMutation, { data, loading, error }] = useUpdateConversationTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>(UpdateConversationTitleDocument, options);
      }
export type UpdateConversationTitleMutationHookResult = ReturnType<typeof useUpdateConversationTitleMutation>;
export type UpdateConversationTitleMutationResult = Apollo.MutationResult<UpdateConversationTitleMutation>;
export type UpdateConversationTitleMutationOptions = Apollo.BaseMutationOptions<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>;
export const GetFixFloDocument = gql`
    query GetFixFlo($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      id
      community {
        id
        settings {
          fixfloUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetFixFloQuery__
 *
 * To run a query within a React component, call `useGetFixFloQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixFloQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixFloQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetFixFloQuery(baseOptions: Apollo.QueryHookOptions<GetFixFloQuery, GetFixFloQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFixFloQuery, GetFixFloQueryVariables>(GetFixFloDocument, options);
      }
export function useGetFixFloLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFixFloQuery, GetFixFloQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFixFloQuery, GetFixFloQueryVariables>(GetFixFloDocument, options);
        }
export type GetFixFloQueryHookResult = ReturnType<typeof useGetFixFloQuery>;
export type GetFixFloLazyQueryHookResult = ReturnType<typeof useGetFixFloLazyQuery>;
export type GetFixFloQueryResult = Apollo.QueryResult<GetFixFloQuery, GetFixFloQueryVariables>;
export const CreateManagerConversationReadDocument = gql`
    mutation CreateManagerConversationRead($input: CreateManagerConversationReadInput!) {
  createManagerConversationRead(input: $input) {
    conversation
    unread
  }
}
    `;
export type CreateManagerConversationReadMutationFn = Apollo.MutationFunction<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>;

/**
 * __useCreateManagerConversationReadMutation__
 *
 * To run a mutation, you first call `useCreateManagerConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagerConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagerConversationReadMutation, { data, loading, error }] = useCreateManagerConversationReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManagerConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>(CreateManagerConversationReadDocument, options);
      }
export type CreateManagerConversationReadMutationHookResult = ReturnType<typeof useCreateManagerConversationReadMutation>;
export type CreateManagerConversationReadMutationResult = Apollo.MutationResult<CreateManagerConversationReadMutation>;
export type CreateManagerConversationReadMutationOptions = Apollo.BaseMutationOptions<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>;
export const ListOtherConversationsDocument = gql`
    query listOtherConversations($currentConversationId: UUID, $contact: UUID) {
  conversations(contact: $contact, excludeId: $currentConversationId, first: 3) {
    edges {
      node {
        id
        subject
        snoozedUntil
        closedAt
        latestEvent {
          ... on ConversationMessageType {
            createdAt
          }
          ... on ConversationMediaType {
            createdAt
          }
          ... on ConversationActionModelType {
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListOtherConversationsQuery__
 *
 * To run a query within a React component, call `useListOtherConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOtherConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOtherConversationsQuery({
 *   variables: {
 *      currentConversationId: // value for 'currentConversationId'
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useListOtherConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>(ListOtherConversationsDocument, options);
      }
export function useListOtherConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>(ListOtherConversationsDocument, options);
        }
export type ListOtherConversationsQueryHookResult = ReturnType<typeof useListOtherConversationsQuery>;
export type ListOtherConversationsLazyQueryHookResult = ReturnType<typeof useListOtherConversationsLazyQuery>;
export type ListOtherConversationsQueryResult = Apollo.QueryResult<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>;
export const OrderConversationTagsDocument = gql`
    mutation OrderConversationTags($input: OrderConversationTagsInput!) {
  orderConversationTags(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type OrderConversationTagsMutationFn = Apollo.MutationFunction<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>;

/**
 * __useOrderConversationTagsMutation__
 *
 * To run a mutation, you first call `useOrderConversationTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderConversationTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderConversationTagsMutation, { data, loading, error }] = useOrderConversationTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderConversationTagsMutation(baseOptions?: Apollo.MutationHookOptions<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>(OrderConversationTagsDocument, options);
      }
export type OrderConversationTagsMutationHookResult = ReturnType<typeof useOrderConversationTagsMutation>;
export type OrderConversationTagsMutationResult = Apollo.MutationResult<OrderConversationTagsMutation>;
export type OrderConversationTagsMutationOptions = Apollo.BaseMutationOptions<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>;
export const CreateConversationNoteDocument = gql`
    mutation CreateConversationNote($input: CreateConversationNoteInput!) {
  createConversationNote(input: $input) {
    conversationNote {
      id
      text
      user {
        id
        name
      }
      conversation {
        id
      }
    }
  }
}
    `;
export type CreateConversationNoteMutationFn = Apollo.MutationFunction<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>;

/**
 * __useCreateConversationNoteMutation__
 *
 * To run a mutation, you first call `useCreateConversationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationNoteMutation, { data, loading, error }] = useCreateConversationNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>(CreateConversationNoteDocument, options);
      }
export type CreateConversationNoteMutationHookResult = ReturnType<typeof useCreateConversationNoteMutation>;
export type CreateConversationNoteMutationResult = Apollo.MutationResult<CreateConversationNoteMutation>;
export type CreateConversationNoteMutationOptions = Apollo.BaseMutationOptions<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>;
export const AcceptMessageSuggestionDocument = gql`
    mutation AcceptMessageSuggestion($input: AcceptMessageSuggestionInput!) {
  acceptMessageSuggestion(input: $input) {
    conversation {
      id
      messages {
        id
        body
        createdAt
        sender
        user {
          id
          firstName
          lastName
          concierge {
            id
          }
          manager {
            id
          }
        }
        suggestion {
          suggestion
          action
        }
      }
    }
  }
}
    `;
export type AcceptMessageSuggestionMutationFn = Apollo.MutationFunction<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>;

/**
 * __useAcceptMessageSuggestionMutation__
 *
 * To run a mutation, you first call `useAcceptMessageSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptMessageSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptMessageSuggestionMutation, { data, loading, error }] = useAcceptMessageSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptMessageSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>(AcceptMessageSuggestionDocument, options);
      }
export type AcceptMessageSuggestionMutationHookResult = ReturnType<typeof useAcceptMessageSuggestionMutation>;
export type AcceptMessageSuggestionMutationResult = Apollo.MutationResult<AcceptMessageSuggestionMutation>;
export type AcceptMessageSuggestionMutationOptions = Apollo.BaseMutationOptions<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>;
export const IgnoreMessageSuggestionDocument = gql`
    mutation IgnoreMessageSuggestion($input: IgnoreMessageSuggestionInput!) {
  ignoreMessageSuggestion(input: $input) {
    conversation {
      id
      messages {
        suggestion {
          id
        }
      }
    }
  }
}
    `;
export type IgnoreMessageSuggestionMutationFn = Apollo.MutationFunction<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>;

/**
 * __useIgnoreMessageSuggestionMutation__
 *
 * To run a mutation, you first call `useIgnoreMessageSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreMessageSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreMessageSuggestionMutation, { data, loading, error }] = useIgnoreMessageSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIgnoreMessageSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>(IgnoreMessageSuggestionDocument, options);
      }
export type IgnoreMessageSuggestionMutationHookResult = ReturnType<typeof useIgnoreMessageSuggestionMutation>;
export type IgnoreMessageSuggestionMutationResult = Apollo.MutationResult<IgnoreMessageSuggestionMutation>;
export type IgnoreMessageSuggestionMutationOptions = Apollo.BaseMutationOptions<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>;
export const CloseConversationDocument = gql`
    mutation CloseConversation($input: CloseConversationInput!) {
  closeConversation(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type CloseConversationMutationFn = Apollo.MutationFunction<CloseConversationMutation, CloseConversationMutationVariables>;

/**
 * __useCloseConversationMutation__
 *
 * To run a mutation, you first call `useCloseConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeConversationMutation, { data, loading, error }] = useCloseConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseConversationMutation(baseOptions?: Apollo.MutationHookOptions<CloseConversationMutation, CloseConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseConversationMutation, CloseConversationMutationVariables>(CloseConversationDocument, options);
      }
export type CloseConversationMutationHookResult = ReturnType<typeof useCloseConversationMutation>;
export type CloseConversationMutationResult = Apollo.MutationResult<CloseConversationMutation>;
export type CloseConversationMutationOptions = Apollo.BaseMutationOptions<CloseConversationMutation, CloseConversationMutationVariables>;
export const CreateConversationDocument = gql`
    mutation CreateConversation($input: CreateConversationInput!, $sender: ConversationRole!) {
  createConversation(sender: $sender, input: $input) {
    conversation {
      id
      subject
      user {
        id
        firstName
        lastName
      }
      home {
        name
      }
    }
  }
}
    `;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sender: // value for 'sender'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const CreateConversationActionDocument = gql`
    mutation CreateConversationAction($input: CreateConversationActionInput!) {
  createConversationAction(input: $input) {
    conversation
    id
    createdAt
    type
    extra
  }
}
    `;
export type CreateConversationActionMutationFn = Apollo.MutationFunction<CreateConversationActionMutation, CreateConversationActionMutationVariables>;

/**
 * __useCreateConversationActionMutation__
 *
 * To run a mutation, you first call `useCreateConversationActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationActionMutation, { data, loading, error }] = useCreateConversationActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationActionMutation, CreateConversationActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationActionMutation, CreateConversationActionMutationVariables>(CreateConversationActionDocument, options);
      }
export type CreateConversationActionMutationHookResult = ReturnType<typeof useCreateConversationActionMutation>;
export type CreateConversationActionMutationResult = Apollo.MutationResult<CreateConversationActionMutation>;
export type CreateConversationActionMutationOptions = Apollo.BaseMutationOptions<CreateConversationActionMutation, CreateConversationActionMutationVariables>;
export const CreateConversationMessageDocument = gql`
    mutation CreateConversationMessage($input: CreateConversationMessageInput!, $sender: ConversationRole!) {
  createConversationMessage(input: $input, sender: $sender) {
    message {
      id
      body
      createdAt
      sender
    }
  }
}
    `;
export type CreateConversationMessageMutationFn = Apollo.MutationFunction<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>;

/**
 * __useCreateConversationMessageMutation__
 *
 * To run a mutation, you first call `useCreateConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMessageMutation, { data, loading, error }] = useCreateConversationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sender: // value for 'sender'
 *   },
 * });
 */
export function useCreateConversationMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>(CreateConversationMessageDocument, options);
      }
export type CreateConversationMessageMutationHookResult = ReturnType<typeof useCreateConversationMessageMutation>;
export type CreateConversationMessageMutationResult = Apollo.MutationResult<CreateConversationMessageMutation>;
export type CreateConversationMessageMutationOptions = Apollo.BaseMutationOptions<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>;
export const FindConversationDocument = gql`
    query FindConversation($id: UUID!) {
  conversation(id: $id) {
    id
    subject
    user {
      id
      firstName
      lastName
    }
    home {
      id
      name
    }
    hasUnread
    latestEvent {
      ... on ConversationMessageType {
        id
        body
        createdAt
      }
      ... on ConversationMediaType {
        id
        createdAt
      }
      ... on ConversationActionModelType {
        id
        createdAt
        type
      }
    }
  }
}
    `;

/**
 * __useFindConversationQuery__
 *
 * To run a query within a React component, call `useFindConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindConversationQuery(baseOptions: Apollo.QueryHookOptions<FindConversationQuery, FindConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindConversationQuery, FindConversationQueryVariables>(FindConversationDocument, options);
      }
export function useFindConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindConversationQuery, FindConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindConversationQuery, FindConversationQueryVariables>(FindConversationDocument, options);
        }
export type FindConversationQueryHookResult = ReturnType<typeof useFindConversationQuery>;
export type FindConversationLazyQueryHookResult = ReturnType<typeof useFindConversationLazyQuery>;
export type FindConversationQueryResult = Apollo.QueryResult<FindConversationQuery, FindConversationQueryVariables>;
export const FindFullConversationDocument = gql`
    query FindFullConversation($id: UUID!) {
  conversation(id: $id) {
    id
    subject
    snoozedUntil
    closedAt
    rating {
      id
      createdAt
      rating
      comment
    }
    user {
      resident {
        id
      }
      id
      name
      email
    }
    home {
      id
      name
      community {
        id
      }
    }
    media {
      id
      file
      createdAt
      sender
      user {
        id
        name
      }
    }
    messages {
      id
      body
      createdAt
      sender
      user {
        id
        name
        concierge {
          id
        }
        manager {
          id
        }
      }
      suggestion {
        id
        suggestion
        action
        createdAt
        version
      }
    }
    actions {
      id
      createdAt
      type
      extra
    }
    latestOpen {
      id
      createdAt
    }
    notes {
      edges {
        node {
          id
          text
          createdAt
          user {
            id
            name
          }
        }
      }
    }
    tags {
      totalCount
      edges {
        node {
          id
          name
          color
        }
      }
    }
    assignment {
      id
      assignedTo {
        id
        name
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useFindFullConversationQuery__
 *
 * To run a query within a React component, call `useFindFullConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFullConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFullConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindFullConversationQuery(baseOptions: Apollo.QueryHookOptions<FindFullConversationQuery, FindFullConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFullConversationQuery, FindFullConversationQueryVariables>(FindFullConversationDocument, options);
      }
export function useFindFullConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFullConversationQuery, FindFullConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFullConversationQuery, FindFullConversationQueryVariables>(FindFullConversationDocument, options);
        }
export type FindFullConversationQueryHookResult = ReturnType<typeof useFindFullConversationQuery>;
export type FindFullConversationLazyQueryHookResult = ReturnType<typeof useFindFullConversationLazyQuery>;
export type FindFullConversationQueryResult = Apollo.QueryResult<FindFullConversationQuery, FindFullConversationQueryVariables>;
export const ReOpenConversationDocument = gql`
    mutation ReOpenConversation($input: ReOpenConversationInput!) {
  reOpenConversation(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type ReOpenConversationMutationFn = Apollo.MutationFunction<ReOpenConversationMutation, ReOpenConversationMutationVariables>;

/**
 * __useReOpenConversationMutation__
 *
 * To run a mutation, you first call `useReOpenConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReOpenConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reOpenConversationMutation, { data, loading, error }] = useReOpenConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReOpenConversationMutation(baseOptions?: Apollo.MutationHookOptions<ReOpenConversationMutation, ReOpenConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReOpenConversationMutation, ReOpenConversationMutationVariables>(ReOpenConversationDocument, options);
      }
export type ReOpenConversationMutationHookResult = ReturnType<typeof useReOpenConversationMutation>;
export type ReOpenConversationMutationResult = Apollo.MutationResult<ReOpenConversationMutation>;
export type ReOpenConversationMutationOptions = Apollo.BaseMutationOptions<ReOpenConversationMutation, ReOpenConversationMutationVariables>;
export const SnoozeConversationDocument = gql`
    mutation SnoozeConversation($input: SnoozeConversationInput!) {
  snoozeConversation(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type SnoozeConversationMutationFn = Apollo.MutationFunction<SnoozeConversationMutation, SnoozeConversationMutationVariables>;

/**
 * __useSnoozeConversationMutation__
 *
 * To run a mutation, you first call `useSnoozeConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeConversationMutation, { data, loading, error }] = useSnoozeConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnoozeConversationMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeConversationMutation, SnoozeConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeConversationMutation, SnoozeConversationMutationVariables>(SnoozeConversationDocument, options);
      }
export type SnoozeConversationMutationHookResult = ReturnType<typeof useSnoozeConversationMutation>;
export type SnoozeConversationMutationResult = Apollo.MutationResult<SnoozeConversationMutation>;
export type SnoozeConversationMutationOptions = Apollo.BaseMutationOptions<SnoozeConversationMutation, SnoozeConversationMutationVariables>;
export const UnsnoozeConversationDocument = gql`
    mutation UnsnoozeConversation($input: UnsnoozeConversationInput!) {
  unsnoozeConversation(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type UnsnoozeConversationMutationFn = Apollo.MutationFunction<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>;

/**
 * __useUnsnoozeConversationMutation__
 *
 * To run a mutation, you first call `useUnsnoozeConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsnoozeConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsnoozeConversationMutation, { data, loading, error }] = useUnsnoozeConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsnoozeConversationMutation(baseOptions?: Apollo.MutationHookOptions<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>(UnsnoozeConversationDocument, options);
      }
export type UnsnoozeConversationMutationHookResult = ReturnType<typeof useUnsnoozeConversationMutation>;
export type UnsnoozeConversationMutationResult = Apollo.MutationResult<UnsnoozeConversationMutation>;
export type UnsnoozeConversationMutationOptions = Apollo.BaseMutationOptions<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>;
export const UpdateConversationUrgencyDocument = gql`
    mutation UpdateConversationUrgency($input: UpdateConversationUrgencyInput!) {
  updateConversationUrgency(input: $input) {
    conversation {
      id
      currentUrgency
    }
  }
}
    `;
export type UpdateConversationUrgencyMutationFn = Apollo.MutationFunction<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>;

/**
 * __useUpdateConversationUrgencyMutation__
 *
 * To run a mutation, you first call `useUpdateConversationUrgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationUrgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationUrgencyMutation, { data, loading, error }] = useUpdateConversationUrgencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationUrgencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>(UpdateConversationUrgencyDocument, options);
      }
export type UpdateConversationUrgencyMutationHookResult = ReturnType<typeof useUpdateConversationUrgencyMutation>;
export type UpdateConversationUrgencyMutationResult = Apollo.MutationResult<UpdateConversationUrgencyMutation>;
export type UpdateConversationUrgencyMutationOptions = Apollo.BaseMutationOptions<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>;
export const ShouldShowPaywallDocument = gql`
    query ShouldShowPaywall($type: String) {
  getClient {
    id
    isSubscribed
  }
  invoices(type: $type, isCredit: true, isPaid: true) {
    totalCount
  }
}
    `;

/**
 * __useShouldShowPaywallQuery__
 *
 * To run a query within a React component, call `useShouldShowPaywallQuery` and pass it any options that fit your needs.
 * When your component renders, `useShouldShowPaywallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShouldShowPaywallQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useShouldShowPaywallQuery(baseOptions?: Apollo.QueryHookOptions<ShouldShowPaywallQuery, ShouldShowPaywallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShouldShowPaywallQuery, ShouldShowPaywallQueryVariables>(ShouldShowPaywallDocument, options);
      }
export function useShouldShowPaywallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShouldShowPaywallQuery, ShouldShowPaywallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShouldShowPaywallQuery, ShouldShowPaywallQueryVariables>(ShouldShowPaywallDocument, options);
        }
export type ShouldShowPaywallQueryHookResult = ReturnType<typeof useShouldShowPaywallQuery>;
export type ShouldShowPaywallLazyQueryHookResult = ReturnType<typeof useShouldShowPaywallLazyQuery>;
export type ShouldShowPaywallQueryResult = Apollo.QueryResult<ShouldShowPaywallQuery, ShouldShowPaywallQueryVariables>;
export const AstCostDocument = gql`
    query ASTCost {
  productCosts {
    astCost
  }
}
    `;

/**
 * __useAstCostQuery__
 *
 * To run a query within a React component, call `useAstCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useAstCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAstCostQuery({
 *   variables: {
 *   },
 * });
 */
export function useAstCostQuery(baseOptions?: Apollo.QueryHookOptions<AstCostQuery, AstCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AstCostQuery, AstCostQueryVariables>(AstCostDocument, options);
      }
export function useAstCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AstCostQuery, AstCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AstCostQuery, AstCostQueryVariables>(AstCostDocument, options);
        }
export type AstCostQueryHookResult = ReturnType<typeof useAstCostQuery>;
export type AstCostLazyQueryHookResult = ReturnType<typeof useAstCostLazyQuery>;
export type AstCostQueryResult = Apollo.QueryResult<AstCostQuery, AstCostQueryVariables>;
export const PayForDocumentDocument = gql`
    mutation PayForDocument($input: PayForDocumentInput!) {
  payForDocument(input: $input) {
    stripeClientSecret
    amount
    invoice {
      id
    }
  }
}
    `;
export type PayForDocumentMutationFn = Apollo.MutationFunction<PayForDocumentMutation, PayForDocumentMutationVariables>;

/**
 * __usePayForDocumentMutation__
 *
 * To run a mutation, you first call `usePayForDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForDocumentMutation, { data, loading, error }] = usePayForDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayForDocumentMutation(baseOptions?: Apollo.MutationHookOptions<PayForDocumentMutation, PayForDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayForDocumentMutation, PayForDocumentMutationVariables>(PayForDocumentDocument, options);
      }
export type PayForDocumentMutationHookResult = ReturnType<typeof usePayForDocumentMutation>;
export type PayForDocumentMutationResult = Apollo.MutationResult<PayForDocumentMutation>;
export type PayForDocumentMutationOptions = Apollo.BaseMutationOptions<PayForDocumentMutation, PayForDocumentMutationVariables>;
export const S21CostDocument = gql`
    query S21Cost {
  productCosts {
    s21Cost
  }
}
    `;

/**
 * __useS21CostQuery__
 *
 * To run a query within a React component, call `useS21CostQuery` and pass it any options that fit your needs.
 * When your component renders, `useS21CostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useS21CostQuery({
 *   variables: {
 *   },
 * });
 */
export function useS21CostQuery(baseOptions?: Apollo.QueryHookOptions<S21CostQuery, S21CostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<S21CostQuery, S21CostQueryVariables>(S21CostDocument, options);
      }
export function useS21CostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<S21CostQuery, S21CostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<S21CostQuery, S21CostQueryVariables>(S21CostDocument, options);
        }
export type S21CostQueryHookResult = ReturnType<typeof useS21CostQuery>;
export type S21CostLazyQueryHookResult = ReturnType<typeof useS21CostLazyQuery>;
export type S21CostQueryResult = Apollo.QueryResult<S21CostQuery, S21CostQueryVariables>;
export const InvoiceDocument = gql`
    query Invoice($id: UUID!) {
  invoice(id: $id) {
    isPaid
  }
}
    `;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const AgreementTenantCountDocument = gql`
    query AgreementTenantCount($id: UUID!) {
  agreement(id: $id) {
    id
    tenants {
      totalCount
    }
  }
}
    `;

/**
 * __useAgreementTenantCountQuery__
 *
 * To run a query within a React component, call `useAgreementTenantCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementTenantCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementTenantCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgreementTenantCountQuery(baseOptions: Apollo.QueryHookOptions<AgreementTenantCountQuery, AgreementTenantCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgreementTenantCountQuery, AgreementTenantCountQueryVariables>(AgreementTenantCountDocument, options);
      }
export function useAgreementTenantCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementTenantCountQuery, AgreementTenantCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgreementTenantCountQuery, AgreementTenantCountQueryVariables>(AgreementTenantCountDocument, options);
        }
export type AgreementTenantCountQueryHookResult = ReturnType<typeof useAgreementTenantCountQuery>;
export type AgreementTenantCountLazyQueryHookResult = ReturnType<typeof useAgreementTenantCountLazyQuery>;
export type AgreementTenantCountQueryResult = Apollo.QueryResult<AgreementTenantCountQuery, AgreementTenantCountQueryVariables>;
export const SubscribeLandlordDocument = gql`
    mutation SubscribeLandlord($input: SubscribeLandlordInput!) {
  subscribeLandlord(input: $input) {
    stripeClientSecret
    firstMonthCost
    monthlyCost
    tierUpTo
    discountCodeValid
  }
}
    `;
export type SubscribeLandlordMutationFn = Apollo.MutationFunction<SubscribeLandlordMutation, SubscribeLandlordMutationVariables>;

/**
 * __useSubscribeLandlordMutation__
 *
 * To run a mutation, you first call `useSubscribeLandlordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeLandlordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeLandlordMutation, { data, loading, error }] = useSubscribeLandlordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeLandlordMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeLandlordMutation, SubscribeLandlordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeLandlordMutation, SubscribeLandlordMutationVariables>(SubscribeLandlordDocument, options);
      }
export type SubscribeLandlordMutationHookResult = ReturnType<typeof useSubscribeLandlordMutation>;
export type SubscribeLandlordMutationResult = Apollo.MutationResult<SubscribeLandlordMutation>;
export type SubscribeLandlordMutationOptions = Apollo.BaseMutationOptions<SubscribeLandlordMutation, SubscribeLandlordMutationVariables>;
export const PayForUnpaidApplicationReferencesDocument = gql`
    mutation PayForUnpaidApplicationReferences($input: PayForUnpaidApplicationReferencesInput!) {
  payForUnpaidApplicationReferences(input: $input) {
    stripeClientSecret
    amount
  }
}
    `;
export type PayForUnpaidApplicationReferencesMutationFn = Apollo.MutationFunction<PayForUnpaidApplicationReferencesMutation, PayForUnpaidApplicationReferencesMutationVariables>;

/**
 * __usePayForUnpaidApplicationReferencesMutation__
 *
 * To run a mutation, you first call `usePayForUnpaidApplicationReferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForUnpaidApplicationReferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForUnpaidApplicationReferencesMutation, { data, loading, error }] = usePayForUnpaidApplicationReferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayForUnpaidApplicationReferencesMutation(baseOptions?: Apollo.MutationHookOptions<PayForUnpaidApplicationReferencesMutation, PayForUnpaidApplicationReferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayForUnpaidApplicationReferencesMutation, PayForUnpaidApplicationReferencesMutationVariables>(PayForUnpaidApplicationReferencesDocument, options);
      }
export type PayForUnpaidApplicationReferencesMutationHookResult = ReturnType<typeof usePayForUnpaidApplicationReferencesMutation>;
export type PayForUnpaidApplicationReferencesMutationResult = Apollo.MutationResult<PayForUnpaidApplicationReferencesMutation>;
export type PayForUnpaidApplicationReferencesMutationOptions = Apollo.BaseMutationOptions<PayForUnpaidApplicationReferencesMutation, PayForUnpaidApplicationReferencesMutationVariables>;
export const ReferencePriceDocument = gql`
    query ReferencePrice($applicationUUID: UUID!) {
  tenancyApplication(id: $applicationUUID) {
    id
    unpaidTenantReferencesTotalCost
    unpaidTenantReferenceCount
  }
}
    `;

/**
 * __useReferencePriceQuery__
 *
 * To run a query within a React component, call `useReferencePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencePriceQuery({
 *   variables: {
 *      applicationUUID: // value for 'applicationUUID'
 *   },
 * });
 */
export function useReferencePriceQuery(baseOptions: Apollo.QueryHookOptions<ReferencePriceQuery, ReferencePriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencePriceQuery, ReferencePriceQueryVariables>(ReferencePriceDocument, options);
      }
export function useReferencePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencePriceQuery, ReferencePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencePriceQuery, ReferencePriceQueryVariables>(ReferencePriceDocument, options);
        }
export type ReferencePriceQueryHookResult = ReturnType<typeof useReferencePriceQuery>;
export type ReferencePriceLazyQueryHookResult = ReturnType<typeof useReferencePriceLazyQuery>;
export type ReferencePriceQueryResult = Apollo.QueryResult<ReferencePriceQuery, ReferencePriceQueryVariables>;
export const SendTenantReferenceRequestsDocument = gql`
    mutation SendTenantReferenceRequests($input: SendTenantReferenceRequestsInput!) {
  sendTenantReferenceRequests(input: $input) {
    errors {
      messages
    }
    tenancyApplication {
      id
      unpaidTenantReferenceCount
      applicants {
        edges {
          node {
            id
            reference {
              id
              isPaid
              sentAt
            }
          }
        }
      }
    }
  }
}
    `;
export type SendTenantReferenceRequestsMutationFn = Apollo.MutationFunction<SendTenantReferenceRequestsMutation, SendTenantReferenceRequestsMutationVariables>;

/**
 * __useSendTenantReferenceRequestsMutation__
 *
 * To run a mutation, you first call `useSendTenantReferenceRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTenantReferenceRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTenantReferenceRequestsMutation, { data, loading, error }] = useSendTenantReferenceRequestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTenantReferenceRequestsMutation(baseOptions?: Apollo.MutationHookOptions<SendTenantReferenceRequestsMutation, SendTenantReferenceRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTenantReferenceRequestsMutation, SendTenantReferenceRequestsMutationVariables>(SendTenantReferenceRequestsDocument, options);
      }
export type SendTenantReferenceRequestsMutationHookResult = ReturnType<typeof useSendTenantReferenceRequestsMutation>;
export type SendTenantReferenceRequestsMutationResult = Apollo.MutationResult<SendTenantReferenceRequestsMutation>;
export type SendTenantReferenceRequestsMutationOptions = Apollo.BaseMutationOptions<SendTenantReferenceRequestsMutation, SendTenantReferenceRequestsMutationVariables>;
export const TenantReferenceDocument = gql`
    query TenantReference($uuid: UUID!) {
  tenantReference(id: $uuid) {
    id
    firstName
    lastName
    submittedAt
    status
    dateOfBirth
    employmentStatus
    lettingHistoryStatus
    rentAffordability
    applicant {
      id
      tenancyApplication {
        id
        rentAmount
        applicants {
          edges {
            node {
              id
              firstName
              lastName
              reference {
                id
                status
              }
            }
          }
        }
      }
    }
    currentAddress {
      id
      fullAddress
    }
    tenantEmploymentDetails {
      income
    }
    historicalAddresses {
      edges {
        node {
          id
          fullAddress
        }
      }
    }
    creditCheck {
      id
      riskLevel
      score
      aliases
      createdAt
      totalCountyCourtJudgements
      activeCountyCourtJudgements
      totalBankruptcies
      activeBankruptcies
    }
    creditCheckStatus
    identityVerification {
      id
      status
      passport
      passportSelfie
      nationality
      documentType
      documentNumber
      documentExpiryDate
      selfie
      hasRightToRent
    }
    identityVerificationStatus
    rightToRent {
      id
      shareCode
      document
      officialVerificationStatus
      officialExpiryDate
      officialDocument
    }
    rightToRentStatus
    tenantEmploymentDetails {
      id
      employmentType
      jobTitle
      companyName
      fullOrPartTime
      startDate
      income
      paymentFrequency
      employmentEnding
    }
    employerReference {
      id
      submittedAt
      firstName
      lastName
      jobTitle
      mobile
      email
      companyName
      employerEmploymentDetails {
        id
        employmentType
        jobTitle
        fullOrPartTime
        startDate
        income
        paymentFrequency
        employmentEnding
        companyName
      }
    }
    landlordReference {
      id
      firstName
      lastName
      mobile
      email
      submittedAt
      landlordOrAgent
      comments
      tenantMoveInDate
      tenancyType
      monthlyRentAmount
      hasOutstandingRent
      rentPaidOnTime
      treatedPropertyWell
    }
  }
}
    `;

/**
 * __useTenantReferenceQuery__
 *
 * To run a query within a React component, call `useTenantReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantReferenceQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTenantReferenceQuery(baseOptions: Apollo.QueryHookOptions<TenantReferenceQuery, TenantReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantReferenceQuery, TenantReferenceQueryVariables>(TenantReferenceDocument, options);
      }
export function useTenantReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantReferenceQuery, TenantReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantReferenceQuery, TenantReferenceQueryVariables>(TenantReferenceDocument, options);
        }
export type TenantReferenceQueryHookResult = ReturnType<typeof useTenantReferenceQuery>;
export type TenantReferenceLazyQueryHookResult = ReturnType<typeof useTenantReferenceLazyQuery>;
export type TenantReferenceQueryResult = Apollo.QueryResult<TenantReferenceQuery, TenantReferenceQueryVariables>;
export const TenantDetailsHeaderDocument = gql`
    query TenantDetailsHeader($uuid: UUID!) {
  tenantReference(id: $uuid) {
    id
    applicant {
      id
      name
      email
      mobile
    }
    application {
      id
      home {
        address
      }
    }
  }
}
    `;

/**
 * __useTenantDetailsHeaderQuery__
 *
 * To run a query within a React component, call `useTenantDetailsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantDetailsHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantDetailsHeaderQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTenantDetailsHeaderQuery(baseOptions: Apollo.QueryHookOptions<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>(TenantDetailsHeaderDocument, options);
      }
export function useTenantDetailsHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>(TenantDetailsHeaderDocument, options);
        }
export type TenantDetailsHeaderQueryHookResult = ReturnType<typeof useTenantDetailsHeaderQuery>;
export type TenantDetailsHeaderLazyQueryHookResult = ReturnType<typeof useTenantDetailsHeaderLazyQuery>;
export type TenantDetailsHeaderQueryResult = Apollo.QueryResult<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>;
export const RemoveResidentsFromResidencyDocument = gql`
    mutation RemoveResidentsFromResidency($input: RemoveResidentsFromResidencyInput!) {
  removeResidentsFromResidency(input: $input) {
    residency {
      id
      residents {
        id
        name
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type RemoveResidentsFromResidencyMutationFn = Apollo.MutationFunction<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>;

/**
 * __useRemoveResidentsFromResidencyMutation__
 *
 * To run a mutation, you first call `useRemoveResidentsFromResidencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveResidentsFromResidencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeResidentsFromResidencyMutation, { data, loading, error }] = useRemoveResidentsFromResidencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveResidentsFromResidencyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>(RemoveResidentsFromResidencyDocument, options);
      }
export type RemoveResidentsFromResidencyMutationHookResult = ReturnType<typeof useRemoveResidentsFromResidencyMutation>;
export type RemoveResidentsFromResidencyMutationResult = Apollo.MutationResult<RemoveResidentsFromResidencyMutation>;
export type RemoveResidentsFromResidencyMutationOptions = Apollo.BaseMutationOptions<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>;
export const FindAgreementStartDateDocument = gql`
    query FindAgreementStartDate($id: UUID!) {
  findTenancyAgreement(id: $id) {
    id
    tenancyStart
  }
}
    `;

/**
 * __useFindAgreementStartDateQuery__
 *
 * To run a query within a React component, call `useFindAgreementStartDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAgreementStartDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAgreementStartDateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindAgreementStartDateQuery(baseOptions: Apollo.QueryHookOptions<FindAgreementStartDateQuery, FindAgreementStartDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAgreementStartDateQuery, FindAgreementStartDateQueryVariables>(FindAgreementStartDateDocument, options);
      }
export function useFindAgreementStartDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAgreementStartDateQuery, FindAgreementStartDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAgreementStartDateQuery, FindAgreementStartDateQueryVariables>(FindAgreementStartDateDocument, options);
        }
export type FindAgreementStartDateQueryHookResult = ReturnType<typeof useFindAgreementStartDateQuery>;
export type FindAgreementStartDateLazyQueryHookResult = ReturnType<typeof useFindAgreementStartDateLazyQuery>;
export type FindAgreementStartDateQueryResult = Apollo.QueryResult<FindAgreementStartDateQuery, FindAgreementStartDateQueryVariables>;
export const DocumentSentApplicationsDocument = gql`
    query DocumentSentApplications($communities: [ID]) {
  applications(communities: $communities, status: ["DS"]) {
    totalCount
  }
}
    `;

/**
 * __useDocumentSentApplicationsQuery__
 *
 * To run a query within a React component, call `useDocumentSentApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSentApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSentApplicationsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useDocumentSentApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>(DocumentSentApplicationsDocument, options);
      }
export function useDocumentSentApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>(DocumentSentApplicationsDocument, options);
        }
export type DocumentSentApplicationsQueryHookResult = ReturnType<typeof useDocumentSentApplicationsQuery>;
export type DocumentSentApplicationsLazyQueryHookResult = ReturnType<typeof useDocumentSentApplicationsLazyQuery>;
export type DocumentSentApplicationsQueryResult = Apollo.QueryResult<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>;
export const UnansweredMessagesDocument = gql`
    query UnansweredMessages($communities: [ID], $assignedTo: String) {
  conversations(
    communities: $communities
    status: ["OP"]
    assignedTo: $assignedTo
    unanswered: "unanswered"
  ) {
    totalCount
  }
}
    `;

/**
 * __useUnansweredMessagesQuery__
 *
 * To run a query within a React component, call `useUnansweredMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnansweredMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnansweredMessagesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      assignedTo: // value for 'assignedTo'
 *   },
 * });
 */
export function useUnansweredMessagesQuery(baseOptions?: Apollo.QueryHookOptions<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>(UnansweredMessagesDocument, options);
      }
export function useUnansweredMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>(UnansweredMessagesDocument, options);
        }
export type UnansweredMessagesQueryHookResult = ReturnType<typeof useUnansweredMessagesQuery>;
export type UnansweredMessagesLazyQueryHookResult = ReturnType<typeof useUnansweredMessagesLazyQuery>;
export type UnansweredMessagesQueryResult = Apollo.QueryResult<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>;
export const ListHomesToSelectDocument = gql`
    query ListHomesToSelect {
  listHomes {
    id
    name
  }
}
    `;

/**
 * __useListHomesToSelectQuery__
 *
 * To run a query within a React component, call `useListHomesToSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesToSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesToSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomesToSelectQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesToSelectQuery, ListHomesToSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesToSelectQuery, ListHomesToSelectQueryVariables>(ListHomesToSelectDocument, options);
      }
export function useListHomesToSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesToSelectQuery, ListHomesToSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesToSelectQuery, ListHomesToSelectQueryVariables>(ListHomesToSelectDocument, options);
        }
export type ListHomesToSelectQueryHookResult = ReturnType<typeof useListHomesToSelectQuery>;
export type ListHomesToSelectLazyQueryHookResult = ReturnType<typeof useListHomesToSelectLazyQuery>;
export type ListHomesToSelectQueryResult = Apollo.QueryResult<ListHomesToSelectQuery, ListHomesToSelectQueryVariables>;
export const FormResidenciesDocument = gql`
    query FormResidencies($home: UUID, $after: String) {
  residencies(home: $home, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        startDate
        completionDate
        residents {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFormResidenciesQuery__
 *
 * To run a query within a React component, call `useFormResidenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormResidenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormResidenciesQuery({
 *   variables: {
 *      home: // value for 'home'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFormResidenciesQuery(baseOptions?: Apollo.QueryHookOptions<FormResidenciesQuery, FormResidenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormResidenciesQuery, FormResidenciesQueryVariables>(FormResidenciesDocument, options);
      }
export function useFormResidenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormResidenciesQuery, FormResidenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormResidenciesQuery, FormResidenciesQueryVariables>(FormResidenciesDocument, options);
        }
export type FormResidenciesQueryHookResult = ReturnType<typeof useFormResidenciesQuery>;
export type FormResidenciesLazyQueryHookResult = ReturnType<typeof useFormResidenciesLazyQuery>;
export type FormResidenciesQueryResult = Apollo.QueryResult<FormResidenciesQuery, FormResidenciesQueryVariables>;
export const HomeResidencyDatesDocument = gql`
    query HomeResidencyDates($homeId: UUID!) {
  home(id: $homeId) {
    id
    residencies {
      edges {
        node {
          id
          startDate
          endDate
          completionDate
        }
      }
    }
  }
}
    `;

/**
 * __useHomeResidencyDatesQuery__
 *
 * To run a query within a React component, call `useHomeResidencyDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeResidencyDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeResidencyDatesQuery({
 *   variables: {
 *      homeId: // value for 'homeId'
 *   },
 * });
 */
export function useHomeResidencyDatesQuery(baseOptions: Apollo.QueryHookOptions<HomeResidencyDatesQuery, HomeResidencyDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeResidencyDatesQuery, HomeResidencyDatesQueryVariables>(HomeResidencyDatesDocument, options);
      }
export function useHomeResidencyDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeResidencyDatesQuery, HomeResidencyDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeResidencyDatesQuery, HomeResidencyDatesQueryVariables>(HomeResidencyDatesDocument, options);
        }
export type HomeResidencyDatesQueryHookResult = ReturnType<typeof useHomeResidencyDatesQuery>;
export type HomeResidencyDatesLazyQueryHookResult = ReturnType<typeof useHomeResidencyDatesLazyQuery>;
export type HomeResidencyDatesQueryResult = Apollo.QueryResult<HomeResidencyDatesQuery, HomeResidencyDatesQueryVariables>;
export const GetUserTypeDocument = gql`
    query GetUserType {
  getUser {
    id
    email
    mobile
    clientAdmin {
      ...ClientAdminItem
    }
    concierge {
      ...ConciergeItem
    }
    manager {
      ...ManagerItem
    }
    communityManager {
      id
    }
  }
}
    ${ClientAdminItemFragmentDoc}
${ConciergeItemFragmentDoc}
${ManagerItemFragmentDoc}`;

/**
 * __useGetUserTypeQuery__
 *
 * To run a query within a React component, call `useGetUserTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTypeQuery, GetUserTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTypeQuery, GetUserTypeQueryVariables>(GetUserTypeDocument, options);
      }
export function useGetUserTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTypeQuery, GetUserTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTypeQuery, GetUserTypeQueryVariables>(GetUserTypeDocument, options);
        }
export type GetUserTypeQueryHookResult = ReturnType<typeof useGetUserTypeQuery>;
export type GetUserTypeLazyQueryHookResult = ReturnType<typeof useGetUserTypeLazyQuery>;
export type GetUserTypeQueryResult = Apollo.QueryResult<GetUserTypeQuery, GetUserTypeQueryVariables>;
export const CreateDeviceDocument = gql`
    mutation CreateDevice($input: CreateNewDeviceInput!) {
  createNewDevice(input: $input) {
    ok
  }
}
    `;
export type CreateDeviceMutationFn = Apollo.MutationFunction<CreateDeviceMutation, CreateDeviceMutationVariables>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceMutation, CreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument, options);
      }
export type CreateDeviceMutationHookResult = ReturnType<typeof useCreateDeviceMutation>;
export type CreateDeviceMutationResult = Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const FindNotificationDocument = gql`
    query FindNotification($id: UUID!) {
  notification(id: $id) {
    ...NotificationHook
  }
}
    ${NotificationHookFragmentDoc}`;

/**
 * __useFindNotificationQuery__
 *
 * To run a query within a React component, call `useFindNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindNotificationQuery(baseOptions: Apollo.QueryHookOptions<FindNotificationQuery, FindNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindNotificationQuery, FindNotificationQueryVariables>(FindNotificationDocument, options);
      }
export function useFindNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindNotificationQuery, FindNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindNotificationQuery, FindNotificationQueryVariables>(FindNotificationDocument, options);
        }
export type FindNotificationQueryHookResult = ReturnType<typeof useFindNotificationQuery>;
export type FindNotificationLazyQueryHookResult = ReturnType<typeof useFindNotificationLazyQuery>;
export type FindNotificationQueryResult = Apollo.QueryResult<FindNotificationQuery, FindNotificationQueryVariables>;
export const LogManagerDashUseDocument = gql`
    mutation LogManagerDashUse {
  logManagerDashUse {
    ok
  }
}
    `;
export type LogManagerDashUseMutationFn = Apollo.MutationFunction<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>;

/**
 * __useLogManagerDashUseMutation__
 *
 * To run a mutation, you first call `useLogManagerDashUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogManagerDashUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logManagerDashUseMutation, { data, loading, error }] = useLogManagerDashUseMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogManagerDashUseMutation(baseOptions?: Apollo.MutationHookOptions<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>(LogManagerDashUseDocument, options);
      }
export type LogManagerDashUseMutationHookResult = ReturnType<typeof useLogManagerDashUseMutation>;
export type LogManagerDashUseMutationResult = Apollo.MutationResult<LogManagerDashUseMutation>;
export type LogManagerDashUseMutationOptions = Apollo.BaseMutationOptions<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>;
export const GetClientTypeDocument = gql`
    query GetClientType {
  getClient {
    id
    clientType
  }
}
    `;

/**
 * __useGetClientTypeQuery__
 *
 * To run a query within a React component, call `useGetClientTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetClientTypeQuery, GetClientTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientTypeQuery, GetClientTypeQueryVariables>(GetClientTypeDocument, options);
      }
export function useGetClientTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientTypeQuery, GetClientTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientTypeQuery, GetClientTypeQueryVariables>(GetClientTypeDocument, options);
        }
export type GetClientTypeQueryHookResult = ReturnType<typeof useGetClientTypeQuery>;
export type GetClientTypeLazyQueryHookResult = ReturnType<typeof useGetClientTypeLazyQuery>;
export type GetClientTypeQueryResult = Apollo.QueryResult<GetClientTypeQuery, GetClientTypeQueryVariables>;
export const GetFeaturesDocument = gql`
    query GetFeatures {
  getClient {
    id
    features {
      id
      name
      isBeta
    }
  }
}
    `;

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a React component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
      }
export function useGetFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export type GetFeaturesQueryHookResult = ReturnType<typeof useGetFeaturesQuery>;
export type GetFeaturesLazyQueryHookResult = ReturnType<typeof useGetFeaturesLazyQuery>;
export type GetFeaturesQueryResult = Apollo.QueryResult<GetFeaturesQuery, GetFeaturesQueryVariables>;
export const IsSubscribedDocument = gql`
    query IsSubscribed {
  getClient {
    id
    isSubscribed
  }
}
    `;

/**
 * __useIsSubscribedQuery__
 *
 * To run a query within a React component, call `useIsSubscribedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSubscribedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSubscribedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsSubscribedQuery(baseOptions?: Apollo.QueryHookOptions<IsSubscribedQuery, IsSubscribedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsSubscribedQuery, IsSubscribedQueryVariables>(IsSubscribedDocument, options);
      }
export function useIsSubscribedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsSubscribedQuery, IsSubscribedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsSubscribedQuery, IsSubscribedQueryVariables>(IsSubscribedDocument, options);
        }
export type IsSubscribedQueryHookResult = ReturnType<typeof useIsSubscribedQuery>;
export type IsSubscribedLazyQueryHookResult = ReturnType<typeof useIsSubscribedLazyQuery>;
export type IsSubscribedQueryResult = Apollo.QueryResult<IsSubscribedQuery, IsSubscribedQueryVariables>;
export const GetLandlordDocument = gql`
    query GetLandlord {
  getLandlord {
    id
    email
    address
    smsPreferences
    emailPreferences
    avatar
  }
  getUser {
    id
    firstName
    lastName
    mobile
  }
}
    `;

/**
 * __useGetLandlordQuery__
 *
 * To run a query within a React component, call `useGetLandlordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandlordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandlordQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLandlordQuery(baseOptions?: Apollo.QueryHookOptions<GetLandlordQuery, GetLandlordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandlordQuery, GetLandlordQueryVariables>(GetLandlordDocument, options);
      }
export function useGetLandlordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandlordQuery, GetLandlordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandlordQuery, GetLandlordQueryVariables>(GetLandlordDocument, options);
        }
export type GetLandlordQueryHookResult = ReturnType<typeof useGetLandlordQuery>;
export type GetLandlordLazyQueryHookResult = ReturnType<typeof useGetLandlordLazyQuery>;
export type GetLandlordQueryResult = Apollo.QueryResult<GetLandlordQuery, GetLandlordQueryVariables>;
export const GetClientPaymentsEnabledDocument = gql`
    query GetClientPaymentsEnabled {
  getClient {
    id
    paymentsEnabled
  }
}
    `;

/**
 * __useGetClientPaymentsEnabledQuery__
 *
 * To run a query within a React component, call `useGetClientPaymentsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPaymentsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPaymentsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientPaymentsEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>(GetClientPaymentsEnabledDocument, options);
      }
export function useGetClientPaymentsEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>(GetClientPaymentsEnabledDocument, options);
        }
export type GetClientPaymentsEnabledQueryHookResult = ReturnType<typeof useGetClientPaymentsEnabledQuery>;
export type GetClientPaymentsEnabledLazyQueryHookResult = ReturnType<typeof useGetClientPaymentsEnabledLazyQuery>;
export type GetClientPaymentsEnabledQueryResult = Apollo.QueryResult<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>;
export const GetClientStripeLoginLinkDocument = gql`
    query GetClientStripeLoginLink {
  getClient {
    id
    stripeDashboardLink
  }
}
    `;

/**
 * __useGetClientStripeLoginLinkQuery__
 *
 * To run a query within a React component, call `useGetClientStripeLoginLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientStripeLoginLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientStripeLoginLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientStripeLoginLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>(GetClientStripeLoginLinkDocument, options);
      }
export function useGetClientStripeLoginLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>(GetClientStripeLoginLinkDocument, options);
        }
export type GetClientStripeLoginLinkQueryHookResult = ReturnType<typeof useGetClientStripeLoginLinkQuery>;
export type GetClientStripeLoginLinkLazyQueryHookResult = ReturnType<typeof useGetClientStripeLoginLinkLazyQuery>;
export type GetClientStripeLoginLinkQueryResult = Apollo.QueryResult<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($after: String) {
  notifications(after: $after, platform: "manager-dashboard") {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        createdAt
        verb
        read
        title
        target {
          ... on CommunityUpdateNode {
            id
          }
          ... on ConversationNode {
            id
          }
          ... on ResidentSurveyNode {
            id
          }
          ... on ApplicationNode {
            id
          }
          ... on KeyNode {
            id
          }
          ... on CommunityProductNode {
            id
          }
          ... on AmenityNode {
            id
          }
          ... on CommunityEventNode {
            id
          }
          ... on TenantReferenceNode {
            uuid: id
          }
          ... on ConversationAssignmentNode {
            id
            conversation {
              id
            }
          }
        }
        actionObject {
          ... on CommunityUpdateCommentNode {
            id
          }
          ... on ApplicationNode {
            id
          }
          ... on KeyholderNode {
            id
          }
          ... on CommunityProductPurchaseNode {
            id
          }
          ... on AmenityReservationNode {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const ReadAllNotificationsDocument = gql`
    mutation ReadAllNotifications {
  readAllNotifications(input: {}) {
    clientMutationId
  }
}
    `;
export type ReadAllNotificationsMutationFn = Apollo.MutationFunction<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;

/**
 * __useReadAllNotificationsMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsMutation, { data, loading, error }] = useReadAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument, options);
      }
export type ReadAllNotificationsMutationHookResult = ReturnType<typeof useReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationResult = Apollo.MutationResult<ReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export const ReadNotificationDocument = gql`
    mutation ReadNotification($input: ReadNotificationInput!) {
  readNotification(input: $input) {
    notification {
      id
      read
    }
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const UnreadNotificationsCountDocument = gql`
    query UnreadNotificationsCount {
  notifications(read: false, platform: "manager-dashboard") {
    totalCount
  }
}
    `;

/**
 * __useUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
      }
export function useUnreadNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
        }
export type UnreadNotificationsCountQueryHookResult = ReturnType<typeof useUnreadNotificationsCountQuery>;
export type UnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useUnreadNotificationsCountLazyQuery>;
export type UnreadNotificationsCountQueryResult = Apollo.QueryResult<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>;
export const AddMemberDocument = gql`
    mutation AddMember($input: AddMemberInput!) {
  addMember(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const DeactivateClientUserDocument = gql`
    mutation DeactivateClientUser($input: DeactivateClientUserInput!) {
  deactivateClientUser(input: $input) {
    clientUser {
      id
    }
  }
}
    `;
export type DeactivateClientUserMutationFn = Apollo.MutationFunction<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>;

/**
 * __useDeactivateClientUserMutation__
 *
 * To run a mutation, you first call `useDeactivateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateClientUserMutation, { data, loading, error }] = useDeactivateClientUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateClientUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>(DeactivateClientUserDocument, options);
      }
export type DeactivateClientUserMutationHookResult = ReturnType<typeof useDeactivateClientUserMutation>;
export type DeactivateClientUserMutationResult = Apollo.MutationResult<DeactivateClientUserMutation>;
export type DeactivateClientUserMutationOptions = Apollo.BaseMutationOptions<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>;
export const EditMemberDocument = gql`
    mutation EditMember($input: EditMemberInput!) {
  editMember(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type EditMemberMutationFn = Apollo.MutationFunction<EditMemberMutation, EditMemberMutationVariables>;

/**
 * __useEditMemberMutation__
 *
 * To run a mutation, you first call `useEditMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMemberMutation, { data, loading, error }] = useEditMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMemberMutation(baseOptions?: Apollo.MutationHookOptions<EditMemberMutation, EditMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMemberMutation, EditMemberMutationVariables>(EditMemberDocument, options);
      }
export type EditMemberMutationHookResult = ReturnType<typeof useEditMemberMutation>;
export type EditMemberMutationResult = Apollo.MutationResult<EditMemberMutation>;
export type EditMemberMutationOptions = Apollo.BaseMutationOptions<EditMemberMutation, EditMemberMutationVariables>;
export const ResendMemberInviteEmailDocument = gql`
    mutation ResendMemberInviteEmail($input: ResendMemberInviteEmailInput!) {
  resendMemberInviteEmail(input: $input) {
    clientUser {
      id
    }
  }
}
    `;
export type ResendMemberInviteEmailMutationFn = Apollo.MutationFunction<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>;

/**
 * __useResendMemberInviteEmailMutation__
 *
 * To run a mutation, you first call `useResendMemberInviteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMemberInviteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMemberInviteEmailMutation, { data, loading, error }] = useResendMemberInviteEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendMemberInviteEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>(ResendMemberInviteEmailDocument, options);
      }
export type ResendMemberInviteEmailMutationHookResult = ReturnType<typeof useResendMemberInviteEmailMutation>;
export type ResendMemberInviteEmailMutationResult = Apollo.MutationResult<ResendMemberInviteEmailMutation>;
export type ResendMemberInviteEmailMutationOptions = Apollo.BaseMutationOptions<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>;
export const ClientUsersDocument = gql`
    query ClientUsers($after: String, $search: String, $communities: [ID!]) {
  clientUsers(after: $after, search: $search, communities: $communities) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        firstName
        lastName
        email
        mfaEnabled
        clientAdmin {
          id
        }
        communityManager {
          id
          isActive
          communities {
            edges {
              node {
                id
                name
              }
            }
          }
        }
        manager {
          id
          isActive
          community {
            edges {
              node {
                id
                name
              }
            }
          }
        }
        concierge {
          id
          isActive
          communities {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useClientUsersQuery__
 *
 * To run a query within a React component, call `useClientUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientUsersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useClientUsersQuery(baseOptions?: Apollo.QueryHookOptions<ClientUsersQuery, ClientUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientUsersQuery, ClientUsersQueryVariables>(ClientUsersDocument, options);
      }
export function useClientUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientUsersQuery, ClientUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientUsersQuery, ClientUsersQueryVariables>(ClientUsersDocument, options);
        }
export type ClientUsersQueryHookResult = ReturnType<typeof useClientUsersQuery>;
export type ClientUsersLazyQueryHookResult = ReturnType<typeof useClientUsersLazyQuery>;
export type ClientUsersQueryResult = Apollo.QueryResult<ClientUsersQuery, ClientUsersQueryVariables>;
export const GetClientAdminDocument = gql`
    query GetClientAdmin {
  getClientAdmin {
    id
    client {
      id
      clientType
      paymentsEnabled
    }
    user {
      id
      email
      mobile
    }
    communities {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientAdminQuery__
 *
 * To run a query within a React component, call `useGetClientAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetClientAdminQuery, GetClientAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientAdminQuery, GetClientAdminQueryVariables>(GetClientAdminDocument, options);
      }
export function useGetClientAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientAdminQuery, GetClientAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientAdminQuery, GetClientAdminQueryVariables>(GetClientAdminDocument, options);
        }
export type GetClientAdminQueryHookResult = ReturnType<typeof useGetClientAdminQuery>;
export type GetClientAdminLazyQueryHookResult = ReturnType<typeof useGetClientAdminLazyQuery>;
export type GetClientAdminQueryResult = Apollo.QueryResult<GetClientAdminQuery, GetClientAdminQueryVariables>;
export const UpdateClientAdminDocument = gql`
    mutation UpdateClientAdmin($input: UpdateClientAdminInput!) {
  updateClientAdmin(input: $input) {
    clientAdmin {
      id
    }
  }
}
    `;
export type UpdateClientAdminMutationFn = Apollo.MutationFunction<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>;

/**
 * __useUpdateClientAdminMutation__
 *
 * To run a mutation, you first call `useUpdateClientAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientAdminMutation, { data, loading, error }] = useUpdateClientAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>(UpdateClientAdminDocument, options);
      }
export type UpdateClientAdminMutationHookResult = ReturnType<typeof useUpdateClientAdminMutation>;
export type UpdateClientAdminMutationResult = Apollo.MutationResult<UpdateClientAdminMutation>;
export type UpdateClientAdminMutationOptions = Apollo.BaseMutationOptions<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>;
export const ConversationTagDocument = gql`
    query ConversationTag($id: UUID!) {
  conversationTag(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useConversationTagQuery__
 *
 * To run a query within a React component, call `useConversationTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConversationTagQuery(baseOptions: Apollo.QueryHookOptions<ConversationTagQuery, ConversationTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationTagQuery, ConversationTagQueryVariables>(ConversationTagDocument, options);
      }
export function useConversationTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationTagQuery, ConversationTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationTagQuery, ConversationTagQueryVariables>(ConversationTagDocument, options);
        }
export type ConversationTagQueryHookResult = ReturnType<typeof useConversationTagQuery>;
export type ConversationTagLazyQueryHookResult = ReturnType<typeof useConversationTagLazyQuery>;
export type ConversationTagQueryResult = Apollo.QueryResult<ConversationTagQuery, ConversationTagQueryVariables>;
export const ConversationTagsDocument = gql`
    query ConversationTags {
  conversationTags(deleted: false) {
    edges {
      node {
        id
        name
        client {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useConversationTagsQuery__
 *
 * To run a query within a React component, call `useConversationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConversationTagsQuery(baseOptions?: Apollo.QueryHookOptions<ConversationTagsQuery, ConversationTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationTagsQuery, ConversationTagsQueryVariables>(ConversationTagsDocument, options);
      }
export function useConversationTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationTagsQuery, ConversationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationTagsQuery, ConversationTagsQueryVariables>(ConversationTagsDocument, options);
        }
export type ConversationTagsQueryHookResult = ReturnType<typeof useConversationTagsQuery>;
export type ConversationTagsLazyQueryHookResult = ReturnType<typeof useConversationTagsLazyQuery>;
export type ConversationTagsQueryResult = Apollo.QueryResult<ConversationTagsQuery, ConversationTagsQueryVariables>;
export const CreateConversationTagDocument = gql`
    mutation CreateConversationTag($input: CreateConversationTagInput!) {
  createConversationTag(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateConversationTagMutationFn = Apollo.MutationFunction<CreateConversationTagMutation, CreateConversationTagMutationVariables>;

/**
 * __useCreateConversationTagMutation__
 *
 * To run a mutation, you first call `useCreateConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationTagMutation, { data, loading, error }] = useCreateConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationTagMutation, CreateConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationTagMutation, CreateConversationTagMutationVariables>(CreateConversationTagDocument, options);
      }
export type CreateConversationTagMutationHookResult = ReturnType<typeof useCreateConversationTagMutation>;
export type CreateConversationTagMutationResult = Apollo.MutationResult<CreateConversationTagMutation>;
export type CreateConversationTagMutationOptions = Apollo.BaseMutationOptions<CreateConversationTagMutation, CreateConversationTagMutationVariables>;
export const DeleteConversationTagDocument = gql`
    mutation DeleteConversationTag($input: DeleteConversationTagInput!) {
  deleteConversationTag(input: $input) {
    conversationTag {
      id
    }
  }
}
    `;
export type DeleteConversationTagMutationFn = Apollo.MutationFunction<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>;

/**
 * __useDeleteConversationTagMutation__
 *
 * To run a mutation, you first call `useDeleteConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversationTagMutation, { data, loading, error }] = useDeleteConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>(DeleteConversationTagDocument, options);
      }
export type DeleteConversationTagMutationHookResult = ReturnType<typeof useDeleteConversationTagMutation>;
export type DeleteConversationTagMutationResult = Apollo.MutationResult<DeleteConversationTagMutation>;
export type DeleteConversationTagMutationOptions = Apollo.BaseMutationOptions<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>;
export const RemoveConversationTagDocument = gql`
    mutation RemoveConversationTag($input: RemoveConversationTagInput!) {
  removeConversationTag(input: $input) {
    conversationTag {
      id
    }
  }
}
    `;
export type RemoveConversationTagMutationFn = Apollo.MutationFunction<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>;

/**
 * __useRemoveConversationTagMutation__
 *
 * To run a mutation, you first call `useRemoveConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConversationTagMutation, { data, loading, error }] = useRemoveConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>(RemoveConversationTagDocument, options);
      }
export type RemoveConversationTagMutationHookResult = ReturnType<typeof useRemoveConversationTagMutation>;
export type RemoveConversationTagMutationResult = Apollo.MutationResult<RemoveConversationTagMutation>;
export type RemoveConversationTagMutationOptions = Apollo.BaseMutationOptions<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>;
export const TagConversationDocument = gql`
    mutation TagConversation($input: TagConversationInput!) {
  tagConversation(input: $input) {
    conversationTag {
      id
    }
  }
}
    `;
export type TagConversationMutationFn = Apollo.MutationFunction<TagConversationMutation, TagConversationMutationVariables>;

/**
 * __useTagConversationMutation__
 *
 * To run a mutation, you first call `useTagConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagConversationMutation, { data, loading, error }] = useTagConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTagConversationMutation(baseOptions?: Apollo.MutationHookOptions<TagConversationMutation, TagConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagConversationMutation, TagConversationMutationVariables>(TagConversationDocument, options);
      }
export type TagConversationMutationHookResult = ReturnType<typeof useTagConversationMutation>;
export type TagConversationMutationResult = Apollo.MutationResult<TagConversationMutation>;
export type TagConversationMutationOptions = Apollo.BaseMutationOptions<TagConversationMutation, TagConversationMutationVariables>;
export const UpdateConversationTagDocument = gql`
    mutation UpdateConversationTag($input: UpdateConversationTagInput!) {
  updateConversationTag(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateConversationTagMutationFn = Apollo.MutationFunction<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>;

/**
 * __useUpdateConversationTagMutation__
 *
 * To run a mutation, you first call `useUpdateConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationTagMutation, { data, loading, error }] = useUpdateConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>(UpdateConversationTagDocument, options);
      }
export type UpdateConversationTagMutationHookResult = ReturnType<typeof useUpdateConversationTagMutation>;
export type UpdateConversationTagMutationResult = Apollo.MutationResult<UpdateConversationTagMutation>;
export type UpdateConversationTagMutationOptions = Apollo.BaseMutationOptions<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>;
export const ComplianceRequirementsAttentionCountsDocument = gql`
    query complianceRequirementsAttentionCounts {
  missing: complianceRequirements(status: "Missing") {
    totalCount
  }
  expiring: complianceRequirements(status: "Expiring Soon") {
    totalCount
  }
  expired: complianceRequirements(status: "Expired") {
    totalCount
  }
}
    `;

/**
 * __useComplianceRequirementsAttentionCountsQuery__
 *
 * To run a query within a React component, call `useComplianceRequirementsAttentionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceRequirementsAttentionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceRequirementsAttentionCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useComplianceRequirementsAttentionCountsQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceRequirementsAttentionCountsQuery, ComplianceRequirementsAttentionCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceRequirementsAttentionCountsQuery, ComplianceRequirementsAttentionCountsQueryVariables>(ComplianceRequirementsAttentionCountsDocument, options);
      }
export function useComplianceRequirementsAttentionCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceRequirementsAttentionCountsQuery, ComplianceRequirementsAttentionCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceRequirementsAttentionCountsQuery, ComplianceRequirementsAttentionCountsQueryVariables>(ComplianceRequirementsAttentionCountsDocument, options);
        }
export type ComplianceRequirementsAttentionCountsQueryHookResult = ReturnType<typeof useComplianceRequirementsAttentionCountsQuery>;
export type ComplianceRequirementsAttentionCountsLazyQueryHookResult = ReturnType<typeof useComplianceRequirementsAttentionCountsLazyQuery>;
export type ComplianceRequirementsAttentionCountsQueryResult = Apollo.QueryResult<ComplianceRequirementsAttentionCountsQuery, ComplianceRequirementsAttentionCountsQueryVariables>;
export const CreateAttachmentOnRequirementItemDocument = gql`
    mutation CreateAttachmentOnRequirementItem($input: CreateAttachmentOnRequirementItemInput!) {
  createAttachmentOnRequirementItem(input: $input) {
    id
  }
}
    `;
export type CreateAttachmentOnRequirementItemMutationFn = Apollo.MutationFunction<CreateAttachmentOnRequirementItemMutation, CreateAttachmentOnRequirementItemMutationVariables>;

/**
 * __useCreateAttachmentOnRequirementItemMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentOnRequirementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentOnRequirementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentOnRequirementItemMutation, { data, loading, error }] = useCreateAttachmentOnRequirementItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentOnRequirementItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentOnRequirementItemMutation, CreateAttachmentOnRequirementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentOnRequirementItemMutation, CreateAttachmentOnRequirementItemMutationVariables>(CreateAttachmentOnRequirementItemDocument, options);
      }
export type CreateAttachmentOnRequirementItemMutationHookResult = ReturnType<typeof useCreateAttachmentOnRequirementItemMutation>;
export type CreateAttachmentOnRequirementItemMutationResult = Apollo.MutationResult<CreateAttachmentOnRequirementItemMutation>;
export type CreateAttachmentOnRequirementItemMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentOnRequirementItemMutation, CreateAttachmentOnRequirementItemMutationVariables>;
export const CreateComplianceRequirementDocument = gql`
    mutation CreateComplianceRequirement($input: CreateComplianceRequirementInput!) {
  createComplianceRequirement(input: $input) {
    complianceRequirements {
      id
    }
  }
}
    `;
export type CreateComplianceRequirementMutationFn = Apollo.MutationFunction<CreateComplianceRequirementMutation, CreateComplianceRequirementMutationVariables>;

/**
 * __useCreateComplianceRequirementMutation__
 *
 * To run a mutation, you first call `useCreateComplianceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceRequirementMutation, { data, loading, error }] = useCreateComplianceRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComplianceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<CreateComplianceRequirementMutation, CreateComplianceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateComplianceRequirementMutation, CreateComplianceRequirementMutationVariables>(CreateComplianceRequirementDocument, options);
      }
export type CreateComplianceRequirementMutationHookResult = ReturnType<typeof useCreateComplianceRequirementMutation>;
export type CreateComplianceRequirementMutationResult = Apollo.MutationResult<CreateComplianceRequirementMutation>;
export type CreateComplianceRequirementMutationOptions = Apollo.BaseMutationOptions<CreateComplianceRequirementMutation, CreateComplianceRequirementMutationVariables>;
export const DeleteComplianceRequirementV2Document = gql`
    mutation DeleteComplianceRequirementV2($input: DeleteComplianceRequirementV2Input!) {
  deleteComplianceRequirementV2(input: $input) {
    ok
  }
}
    `;
export type DeleteComplianceRequirementV2MutationFn = Apollo.MutationFunction<DeleteComplianceRequirementV2Mutation, DeleteComplianceRequirementV2MutationVariables>;

/**
 * __useDeleteComplianceRequirementV2Mutation__
 *
 * To run a mutation, you first call `useDeleteComplianceRequirementV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComplianceRequirementV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComplianceRequirementV2Mutation, { data, loading, error }] = useDeleteComplianceRequirementV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteComplianceRequirementV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteComplianceRequirementV2Mutation, DeleteComplianceRequirementV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteComplianceRequirementV2Mutation, DeleteComplianceRequirementV2MutationVariables>(DeleteComplianceRequirementV2Document, options);
      }
export type DeleteComplianceRequirementV2MutationHookResult = ReturnType<typeof useDeleteComplianceRequirementV2Mutation>;
export type DeleteComplianceRequirementV2MutationResult = Apollo.MutationResult<DeleteComplianceRequirementV2Mutation>;
export type DeleteComplianceRequirementV2MutationOptions = Apollo.BaseMutationOptions<DeleteComplianceRequirementV2Mutation, DeleteComplianceRequirementV2MutationVariables>;
export const ComplianceRequirementDocument = gql`
    query complianceRequirement($id: UUID!) {
  complianceRequirement(id: $id) {
    id
    name
    status
    description
    type
    shared
    actionDate
    home {
      id
      name
      addressLine1
      city
      postcode
    }
    residency {
      id
      startDate
    }
    currentItem {
      id
      expiryDate
      attachment {
        id
        file
        name
      }
      comment
    }
    items {
      edges {
        node {
          id
          expiryDate
          attachment {
            id
            file
            name
          }
          comment
        }
      }
    }
    agreement {
      id
    }
  }
}
    `;

/**
 * __useComplianceRequirementQuery__
 *
 * To run a query within a React component, call `useComplianceRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceRequirementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useComplianceRequirementQuery(baseOptions: Apollo.QueryHookOptions<ComplianceRequirementQuery, ComplianceRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceRequirementQuery, ComplianceRequirementQueryVariables>(ComplianceRequirementDocument, options);
      }
export function useComplianceRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceRequirementQuery, ComplianceRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceRequirementQuery, ComplianceRequirementQueryVariables>(ComplianceRequirementDocument, options);
        }
export type ComplianceRequirementQueryHookResult = ReturnType<typeof useComplianceRequirementQuery>;
export type ComplianceRequirementLazyQueryHookResult = ReturnType<typeof useComplianceRequirementLazyQuery>;
export type ComplianceRequirementQueryResult = Apollo.QueryResult<ComplianceRequirementQuery, ComplianceRequirementQueryVariables>;
export const ComplianceRequirementsDocument = gql`
    query complianceRequirements($after: String, $orderBy: String, $status: [String], $search: String) {
  complianceRequirements(
    after: $after
    orderBy: $orderBy
    status: $status
    search: $search
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        description
        frequencyText
        status
        actionDate
        home {
          id
          name
          addressLine1
          city
          postcode
        }
        residency {
          id
          startDate
          endDate
        }
        currentItem {
          id
          expiryDate
        }
      }
    }
  }
}
    `;

/**
 * __useComplianceRequirementsQuery__
 *
 * To run a query within a React component, call `useComplianceRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceRequirementsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useComplianceRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceRequirementsQuery, ComplianceRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceRequirementsQuery, ComplianceRequirementsQueryVariables>(ComplianceRequirementsDocument, options);
      }
export function useComplianceRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceRequirementsQuery, ComplianceRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceRequirementsQuery, ComplianceRequirementsQueryVariables>(ComplianceRequirementsDocument, options);
        }
export type ComplianceRequirementsQueryHookResult = ReturnType<typeof useComplianceRequirementsQuery>;
export type ComplianceRequirementsLazyQueryHookResult = ReturnType<typeof useComplianceRequirementsLazyQuery>;
export type ComplianceRequirementsQueryResult = Apollo.QueryResult<ComplianceRequirementsQuery, ComplianceRequirementsQueryVariables>;
export const ListHomesForRequirementDocument = gql`
    query ListHomesForRequirement {
  listHomes {
    id
    name
  }
}
    `;

/**
 * __useListHomesForRequirementQuery__
 *
 * To run a query within a React component, call `useListHomesForRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesForRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesForRequirementQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomesForRequirementQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesForRequirementQuery, ListHomesForRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesForRequirementQuery, ListHomesForRequirementQueryVariables>(ListHomesForRequirementDocument, options);
      }
export function useListHomesForRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesForRequirementQuery, ListHomesForRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesForRequirementQuery, ListHomesForRequirementQueryVariables>(ListHomesForRequirementDocument, options);
        }
export type ListHomesForRequirementQueryHookResult = ReturnType<typeof useListHomesForRequirementQuery>;
export type ListHomesForRequirementLazyQueryHookResult = ReturnType<typeof useListHomesForRequirementLazyQuery>;
export type ListHomesForRequirementQueryResult = Apollo.QueryResult<ListHomesForRequirementQuery, ListHomesForRequirementQueryVariables>;
export const SaveRequirementItemDocument = gql`
    mutation SaveRequirementItem($input: SaveRequirementItemInput!) {
  saveRequirementItem(input: $input) {
    home {
      id
    }
    id
  }
}
    `;
export type SaveRequirementItemMutationFn = Apollo.MutationFunction<SaveRequirementItemMutation, SaveRequirementItemMutationVariables>;

/**
 * __useSaveRequirementItemMutation__
 *
 * To run a mutation, you first call `useSaveRequirementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRequirementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRequirementItemMutation, { data, loading, error }] = useSaveRequirementItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveRequirementItemMutation(baseOptions?: Apollo.MutationHookOptions<SaveRequirementItemMutation, SaveRequirementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRequirementItemMutation, SaveRequirementItemMutationVariables>(SaveRequirementItemDocument, options);
      }
export type SaveRequirementItemMutationHookResult = ReturnType<typeof useSaveRequirementItemMutation>;
export type SaveRequirementItemMutationResult = Apollo.MutationResult<SaveRequirementItemMutation>;
export type SaveRequirementItemMutationOptions = Apollo.BaseMutationOptions<SaveRequirementItemMutation, SaveRequirementItemMutationVariables>;
export const ShareComplianceRequirementDocument = gql`
    mutation ShareComplianceRequirement($input: ShareComplianceRequirementInput!) {
  shareComplianceRequirement(input: $input) {
    id
  }
}
    `;
export type ShareComplianceRequirementMutationFn = Apollo.MutationFunction<ShareComplianceRequirementMutation, ShareComplianceRequirementMutationVariables>;

/**
 * __useShareComplianceRequirementMutation__
 *
 * To run a mutation, you first call `useShareComplianceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareComplianceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareComplianceRequirementMutation, { data, loading, error }] = useShareComplianceRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareComplianceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<ShareComplianceRequirementMutation, ShareComplianceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareComplianceRequirementMutation, ShareComplianceRequirementMutationVariables>(ShareComplianceRequirementDocument, options);
      }
export type ShareComplianceRequirementMutationHookResult = ReturnType<typeof useShareComplianceRequirementMutation>;
export type ShareComplianceRequirementMutationResult = Apollo.MutationResult<ShareComplianceRequirementMutation>;
export type ShareComplianceRequirementMutationOptions = Apollo.BaseMutationOptions<ShareComplianceRequirementMutation, ShareComplianceRequirementMutationVariables>;
export const ListHomesAndResidentsForNewConversationDocument = gql`
    query ListHomesAndResidentsForNewConversation {
  listHomes {
    id
    name
    currentResidency {
      id
      residents {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListHomesAndResidentsForNewConversationQuery__
 *
 * To run a query within a React component, call `useListHomesAndResidentsForNewConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesAndResidentsForNewConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesAndResidentsForNewConversationQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomesAndResidentsForNewConversationQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesAndResidentsForNewConversationQuery, ListHomesAndResidentsForNewConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesAndResidentsForNewConversationQuery, ListHomesAndResidentsForNewConversationQueryVariables>(ListHomesAndResidentsForNewConversationDocument, options);
      }
export function useListHomesAndResidentsForNewConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesAndResidentsForNewConversationQuery, ListHomesAndResidentsForNewConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesAndResidentsForNewConversationQuery, ListHomesAndResidentsForNewConversationQueryVariables>(ListHomesAndResidentsForNewConversationDocument, options);
        }
export type ListHomesAndResidentsForNewConversationQueryHookResult = ReturnType<typeof useListHomesAndResidentsForNewConversationQuery>;
export type ListHomesAndResidentsForNewConversationLazyQueryHookResult = ReturnType<typeof useListHomesAndResidentsForNewConversationLazyQuery>;
export type ListHomesAndResidentsForNewConversationQueryResult = Apollo.QueryResult<ListHomesAndResidentsForNewConversationQuery, ListHomesAndResidentsForNewConversationQueryVariables>;
export const Section21PaidForDocument = gql`
    query Section21PaidFor($id: UUID!) {
  section21(id: $id) {
    id
    paidFor
  }
  getClient {
    id
    isSubscribed
  }
}
    `;

/**
 * __useSection21PaidForQuery__
 *
 * To run a query within a React component, call `useSection21PaidForQuery` and pass it any options that fit your needs.
 * When your component renders, `useSection21PaidForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSection21PaidForQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSection21PaidForQuery(baseOptions: Apollo.QueryHookOptions<Section21PaidForQuery, Section21PaidForQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Section21PaidForQuery, Section21PaidForQueryVariables>(Section21PaidForDocument, options);
      }
export function useSection21PaidForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Section21PaidForQuery, Section21PaidForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Section21PaidForQuery, Section21PaidForQueryVariables>(Section21PaidForDocument, options);
        }
export type Section21PaidForQueryHookResult = ReturnType<typeof useSection21PaidForQuery>;
export type Section21PaidForLazyQueryHookResult = ReturnType<typeof useSection21PaidForLazyQuery>;
export type Section21PaidForQueryResult = Apollo.QueryResult<Section21PaidForQuery, Section21PaidForQueryVariables>;
export const AssociateSection21WithClientDocument = gql`
    mutation AssociateSection21WithClient($input: AssociateSection21WithClientInput!) {
  associateSection21WithClient(input: $input) {
    section21 {
      id
      homeName
    }
  }
}
    `;
export type AssociateSection21WithClientMutationFn = Apollo.MutationFunction<AssociateSection21WithClientMutation, AssociateSection21WithClientMutationVariables>;

/**
 * __useAssociateSection21WithClientMutation__
 *
 * To run a mutation, you first call `useAssociateSection21WithClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateSection21WithClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateSection21WithClientMutation, { data, loading, error }] = useAssociateSection21WithClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateSection21WithClientMutation(baseOptions?: Apollo.MutationHookOptions<AssociateSection21WithClientMutation, AssociateSection21WithClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateSection21WithClientMutation, AssociateSection21WithClientMutationVariables>(AssociateSection21WithClientDocument, options);
      }
export type AssociateSection21WithClientMutationHookResult = ReturnType<typeof useAssociateSection21WithClientMutation>;
export type AssociateSection21WithClientMutationResult = Apollo.MutationResult<AssociateSection21WithClientMutation>;
export type AssociateSection21WithClientMutationOptions = Apollo.BaseMutationOptions<AssociateSection21WithClientMutation, AssociateSection21WithClientMutationVariables>;
export const FindSection21Document = gql`
    query FindSection21($id: UUID!) {
  findSection21(id: $id) {
    id
    createdAt
    homeName
    homeCity
    homeRegion
    homePostcode
    tenants
    leadTenantEmail
    possessionDate
    inspectionDate
    deadlineDate
    serviceDate
    landlordName
    landlordAddress
    landlordPhone
    landlordEmail
    file
    client {
      name
    }
    viewedOnArk
    home {
      id
      checked: complianceRequirements(type: ["GS", "EP"], status: "Checked") {
        totalCount
        edges {
          node {
            id
            name
            type
          }
        }
      }
      missing: complianceRequirements(type: ["GS", "EP"], status: "Missing") {
        totalCount
        edges {
          node {
            id
            name
            type
          }
        }
      }
      expired: complianceRequirements(type: ["GS", "EP"], status: "Expired") {
        totalCount
        edges {
          node {
            id
            name
            type
          }
        }
      }
      expiring: complianceRequirements(type: ["GS", "EP"], status: "Expiring Soon") {
        totalCount
        edges {
          node {
            id
            name
            type
          }
        }
      }
    }
    htrgProvided
    depositCertificateProvided
  }
}
    `;

/**
 * __useFindSection21Query__
 *
 * To run a query within a React component, call `useFindSection21Query` and pass it any options that fit your needs.
 * When your component renders, `useFindSection21Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSection21Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindSection21Query(baseOptions: Apollo.QueryHookOptions<FindSection21Query, FindSection21QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSection21Query, FindSection21QueryVariables>(FindSection21Document, options);
      }
export function useFindSection21LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSection21Query, FindSection21QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSection21Query, FindSection21QueryVariables>(FindSection21Document, options);
        }
export type FindSection21QueryHookResult = ReturnType<typeof useFindSection21Query>;
export type FindSection21LazyQueryHookResult = ReturnType<typeof useFindSection21LazyQuery>;
export type FindSection21QueryResult = Apollo.QueryResult<FindSection21Query, FindSection21QueryVariables>;
export const ListHomesForSection21Document = gql`
    query ListHomesForSection21 {
  listHomes {
    id
    name
    city
    postcode
  }
}
    `;

/**
 * __useListHomesForSection21Query__
 *
 * To run a query within a React component, call `useListHomesForSection21Query` and pass it any options that fit your needs.
 * When your component renders, `useListHomesForSection21Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesForSection21Query({
 *   variables: {
 *   },
 * });
 */
export function useListHomesForSection21Query(baseOptions?: Apollo.QueryHookOptions<ListHomesForSection21Query, ListHomesForSection21QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesForSection21Query, ListHomesForSection21QueryVariables>(ListHomesForSection21Document, options);
      }
export function useListHomesForSection21LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesForSection21Query, ListHomesForSection21QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesForSection21Query, ListHomesForSection21QueryVariables>(ListHomesForSection21Document, options);
        }
export type ListHomesForSection21QueryHookResult = ReturnType<typeof useListHomesForSection21Query>;
export type ListHomesForSection21LazyQueryHookResult = ReturnType<typeof useListHomesForSection21LazyQuery>;
export type ListHomesForSection21QueryResult = Apollo.QueryResult<ListHomesForSection21Query, ListHomesForSection21QueryVariables>;
export const SaveGeneratedSection21Document = gql`
    mutation SaveGeneratedSection21($input: SaveGeneratedSection21Input!) {
  saveGeneratedSection21(input: $input) {
    id
    file
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveGeneratedSection21MutationFn = Apollo.MutationFunction<SaveGeneratedSection21Mutation, SaveGeneratedSection21MutationVariables>;

/**
 * __useSaveGeneratedSection21Mutation__
 *
 * To run a mutation, you first call `useSaveGeneratedSection21Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGeneratedSection21Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGeneratedSection21Mutation, { data, loading, error }] = useSaveGeneratedSection21Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGeneratedSection21Mutation(baseOptions?: Apollo.MutationHookOptions<SaveGeneratedSection21Mutation, SaveGeneratedSection21MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGeneratedSection21Mutation, SaveGeneratedSection21MutationVariables>(SaveGeneratedSection21Document, options);
      }
export type SaveGeneratedSection21MutationHookResult = ReturnType<typeof useSaveGeneratedSection21Mutation>;
export type SaveGeneratedSection21MutationResult = Apollo.MutationResult<SaveGeneratedSection21Mutation>;
export type SaveGeneratedSection21MutationOptions = Apollo.BaseMutationOptions<SaveGeneratedSection21Mutation, SaveGeneratedSection21MutationVariables>;
export const SendDocumentDocument = gql`
    mutation SendDocument($input: SendDocumentInput!) {
  sendDocument(input: $input) {
    section21 {
      id
      serviceDate
    }
  }
}
    `;
export type SendDocumentMutationFn = Apollo.MutationFunction<SendDocumentMutation, SendDocumentMutationVariables>;

/**
 * __useSendDocumentMutation__
 *
 * To run a mutation, you first call `useSendDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentMutation, { data, loading, error }] = useSendDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SendDocumentMutation, SendDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDocumentMutation, SendDocumentMutationVariables>(SendDocumentDocument, options);
      }
export type SendDocumentMutationHookResult = ReturnType<typeof useSendDocumentMutation>;
export type SendDocumentMutationResult = Apollo.MutationResult<SendDocumentMutation>;
export type SendDocumentMutationOptions = Apollo.BaseMutationOptions<SendDocumentMutation, SendDocumentMutationVariables>;
export const CreateAttachmentOnHomeDocument = gql`
    mutation CreateAttachmentOnHome($input: CreateAttachmentOnHomeInput!) {
  createAttachmentOnHome(input: $input) {
    id
  }
}
    `;
export type CreateAttachmentOnHomeMutationFn = Apollo.MutationFunction<CreateAttachmentOnHomeMutation, CreateAttachmentOnHomeMutationVariables>;

/**
 * __useCreateAttachmentOnHomeMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentOnHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentOnHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentOnHomeMutation, { data, loading, error }] = useCreateAttachmentOnHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentOnHomeMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentOnHomeMutation, CreateAttachmentOnHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentOnHomeMutation, CreateAttachmentOnHomeMutationVariables>(CreateAttachmentOnHomeDocument, options);
      }
export type CreateAttachmentOnHomeMutationHookResult = ReturnType<typeof useCreateAttachmentOnHomeMutation>;
export type CreateAttachmentOnHomeMutationResult = Apollo.MutationResult<CreateAttachmentOnHomeMutation>;
export type CreateAttachmentOnHomeMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentOnHomeMutation, CreateAttachmentOnHomeMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($input: DeleteAttachmentInput!) {
  deleteAttachment(input: $input) {
    id
  }
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const LandlordAttachmentDocument = gql`
    query landlordAttachment($id: UUID!) {
  landlordAttachment(id: $id) {
    id
    name
    createdAt
    file
    home {
      id
      name
      addressLine1
      city
      postcode
    }
  }
}
    `;

/**
 * __useLandlordAttachmentQuery__
 *
 * To run a query within a React component, call `useLandlordAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordAttachmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLandlordAttachmentQuery(baseOptions: Apollo.QueryHookOptions<LandlordAttachmentQuery, LandlordAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordAttachmentQuery, LandlordAttachmentQueryVariables>(LandlordAttachmentDocument, options);
      }
export function useLandlordAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordAttachmentQuery, LandlordAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordAttachmentQuery, LandlordAttachmentQueryVariables>(LandlordAttachmentDocument, options);
        }
export type LandlordAttachmentQueryHookResult = ReturnType<typeof useLandlordAttachmentQuery>;
export type LandlordAttachmentLazyQueryHookResult = ReturnType<typeof useLandlordAttachmentLazyQuery>;
export type LandlordAttachmentQueryResult = Apollo.QueryResult<LandlordAttachmentQuery, LandlordAttachmentQueryVariables>;
export const LandlordDocumentsDocument = gql`
    query LandlordDocuments($homeId: UUID) {
  landlordDocuments(homeId: $homeId) {
    ... on GeneratedAgreementNode {
      id
      status
      createdAt
      home {
        id
        name
        addressLine1
        city
        postcode
      }
    }
    ... on GeneratedSection21Node {
      id
      createdAt
      serviceDate
      home {
        id
        name
        addressLine1
        city
        postcode
      }
    }
    ... on LandlordAttachmentNode {
      id
      createdAt
      file
      name
      type
      home {
        id
        name
        addressLine1
        city
        postcode
      }
      requirementItem {
        requirement {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useLandlordDocumentsQuery__
 *
 * To run a query within a React component, call `useLandlordDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordDocumentsQuery({
 *   variables: {
 *      homeId: // value for 'homeId'
 *   },
 * });
 */
export function useLandlordDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<LandlordDocumentsQuery, LandlordDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordDocumentsQuery, LandlordDocumentsQueryVariables>(LandlordDocumentsDocument, options);
      }
export function useLandlordDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordDocumentsQuery, LandlordDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordDocumentsQuery, LandlordDocumentsQueryVariables>(LandlordDocumentsDocument, options);
        }
export type LandlordDocumentsQueryHookResult = ReturnType<typeof useLandlordDocumentsQuery>;
export type LandlordDocumentsLazyQueryHookResult = ReturnType<typeof useLandlordDocumentsLazyQuery>;
export type LandlordDocumentsQueryResult = Apollo.QueryResult<LandlordDocumentsQuery, LandlordDocumentsQueryVariables>;
export const ListHomesForDocumentsFilterDocument = gql`
    query ListHomesForDocumentsFilter {
  listHomes {
    id
    name
  }
}
    `;

/**
 * __useListHomesForDocumentsFilterQuery__
 *
 * To run a query within a React component, call `useListHomesForDocumentsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesForDocumentsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesForDocumentsFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomesForDocumentsFilterQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesForDocumentsFilterQuery, ListHomesForDocumentsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesForDocumentsFilterQuery, ListHomesForDocumentsFilterQueryVariables>(ListHomesForDocumentsFilterDocument, options);
      }
export function useListHomesForDocumentsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesForDocumentsFilterQuery, ListHomesForDocumentsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesForDocumentsFilterQuery, ListHomesForDocumentsFilterQueryVariables>(ListHomesForDocumentsFilterDocument, options);
        }
export type ListHomesForDocumentsFilterQueryHookResult = ReturnType<typeof useListHomesForDocumentsFilterQuery>;
export type ListHomesForDocumentsFilterLazyQueryHookResult = ReturnType<typeof useListHomesForDocumentsFilterLazyQuery>;
export type ListHomesForDocumentsFilterQueryResult = Apollo.QueryResult<ListHomesForDocumentsFilterQuery, ListHomesForDocumentsFilterQueryVariables>;
export const UpdateAttachmentDocument = gql`
    mutation UpdateAttachment($input: UpdateAttachmentInput!) {
  updateAttachment(input: $input) {
    id
  }
}
    `;
export type UpdateAttachmentMutationFn = Apollo.MutationFunction<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>;

/**
 * __useUpdateAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttachmentMutation, { data, loading, error }] = useUpdateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>(UpdateAttachmentDocument, options);
      }
export type UpdateAttachmentMutationHookResult = ReturnType<typeof useUpdateAttachmentMutation>;
export type UpdateAttachmentMutationResult = Apollo.MutationResult<UpdateAttachmentMutation>;
export type UpdateAttachmentMutationOptions = Apollo.BaseMutationOptions<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>;
export const AgreementPaidForByInvoiceDocument = gql`
    query AgreementPaidForByInvoice($id: UUID!) {
  agreement(id: $id) {
    id
    paidForByInvoice
  }
}
    `;

/**
 * __useAgreementPaidForByInvoiceQuery__
 *
 * To run a query within a React component, call `useAgreementPaidForByInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementPaidForByInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementPaidForByInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgreementPaidForByInvoiceQuery(baseOptions: Apollo.QueryHookOptions<AgreementPaidForByInvoiceQuery, AgreementPaidForByInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgreementPaidForByInvoiceQuery, AgreementPaidForByInvoiceQueryVariables>(AgreementPaidForByInvoiceDocument, options);
      }
export function useAgreementPaidForByInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementPaidForByInvoiceQuery, AgreementPaidForByInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgreementPaidForByInvoiceQuery, AgreementPaidForByInvoiceQueryVariables>(AgreementPaidForByInvoiceDocument, options);
        }
export type AgreementPaidForByInvoiceQueryHookResult = ReturnType<typeof useAgreementPaidForByInvoiceQuery>;
export type AgreementPaidForByInvoiceLazyQueryHookResult = ReturnType<typeof useAgreementPaidForByInvoiceLazyQuery>;
export type AgreementPaidForByInvoiceQueryResult = Apollo.QueryResult<AgreementPaidForByInvoiceQuery, AgreementPaidForByInvoiceQueryVariables>;
export const UpgradeLandlordToSubscriptionDocument = gql`
    mutation UpgradeLandlordToSubscription($input: UpgradeLandlordToSubscriptionInput!) {
  upgradeLandlordToSubscription(input: $input) {
    client {
      id
      isSubscribed
    }
  }
}
    `;
export type UpgradeLandlordToSubscriptionMutationFn = Apollo.MutationFunction<UpgradeLandlordToSubscriptionMutation, UpgradeLandlordToSubscriptionMutationVariables>;

/**
 * __useUpgradeLandlordToSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeLandlordToSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeLandlordToSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeLandlordToSubscriptionMutation, { data, loading, error }] = useUpgradeLandlordToSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradeLandlordToSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeLandlordToSubscriptionMutation, UpgradeLandlordToSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeLandlordToSubscriptionMutation, UpgradeLandlordToSubscriptionMutationVariables>(UpgradeLandlordToSubscriptionDocument, options);
      }
export type UpgradeLandlordToSubscriptionMutationHookResult = ReturnType<typeof useUpgradeLandlordToSubscriptionMutation>;
export type UpgradeLandlordToSubscriptionMutationResult = Apollo.MutationResult<UpgradeLandlordToSubscriptionMutation>;
export type UpgradeLandlordToSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpgradeLandlordToSubscriptionMutation, UpgradeLandlordToSubscriptionMutationVariables>;
export const AgreementPaidForDocument = gql`
    query AgreementPaidFor($id: UUID!) {
  agreement(id: $id) {
    id
    paidFor
  }
  getClient {
    id
    isSubscribed
  }
}
    `;

/**
 * __useAgreementPaidForQuery__
 *
 * To run a query within a React component, call `useAgreementPaidForQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementPaidForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementPaidForQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgreementPaidForQuery(baseOptions: Apollo.QueryHookOptions<AgreementPaidForQuery, AgreementPaidForQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgreementPaidForQuery, AgreementPaidForQueryVariables>(AgreementPaidForDocument, options);
      }
export function useAgreementPaidForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementPaidForQuery, AgreementPaidForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgreementPaidForQuery, AgreementPaidForQueryVariables>(AgreementPaidForDocument, options);
        }
export type AgreementPaidForQueryHookResult = ReturnType<typeof useAgreementPaidForQuery>;
export type AgreementPaidForLazyQueryHookResult = ReturnType<typeof useAgreementPaidForLazyQuery>;
export type AgreementPaidForQueryResult = Apollo.QueryResult<AgreementPaidForQuery, AgreementPaidForQueryVariables>;
export const AstFormHomeDetailsDocument = gql`
    query ASTFormHomeDetails($id: UUID!) {
  findHome(id: $id) {
    id
    name
    postcode
    city
  }
}
    `;

/**
 * __useAstFormHomeDetailsQuery__
 *
 * To run a query within a React component, call `useAstFormHomeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAstFormHomeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAstFormHomeDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAstFormHomeDetailsQuery(baseOptions: Apollo.QueryHookOptions<AstFormHomeDetailsQuery, AstFormHomeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AstFormHomeDetailsQuery, AstFormHomeDetailsQueryVariables>(AstFormHomeDetailsDocument, options);
      }
export function useAstFormHomeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AstFormHomeDetailsQuery, AstFormHomeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AstFormHomeDetailsQuery, AstFormHomeDetailsQueryVariables>(AstFormHomeDetailsDocument, options);
        }
export type AstFormHomeDetailsQueryHookResult = ReturnType<typeof useAstFormHomeDetailsQuery>;
export type AstFormHomeDetailsLazyQueryHookResult = ReturnType<typeof useAstFormHomeDetailsLazyQuery>;
export type AstFormHomeDetailsQueryResult = Apollo.QueryResult<AstFormHomeDetailsQuery, AstFormHomeDetailsQueryVariables>;
export const FindAgreementTenantsDocument = gql`
    query FindAgreementTenants($id: UUID!) {
  findTenancyAgreement(id: $id) {
    tenants {
      edges {
        node {
          id
          firstName
          lastName
          email
          mobile
        }
      }
    }
    homeName
    homeCity
    homePostcode
    home {
      id
      name
    }
  }
}
    `;

/**
 * __useFindAgreementTenantsQuery__
 *
 * To run a query within a React component, call `useFindAgreementTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAgreementTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAgreementTenantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindAgreementTenantsQuery(baseOptions: Apollo.QueryHookOptions<FindAgreementTenantsQuery, FindAgreementTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAgreementTenantsQuery, FindAgreementTenantsQueryVariables>(FindAgreementTenantsDocument, options);
      }
export function useFindAgreementTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAgreementTenantsQuery, FindAgreementTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAgreementTenantsQuery, FindAgreementTenantsQueryVariables>(FindAgreementTenantsDocument, options);
        }
export type FindAgreementTenantsQueryHookResult = ReturnType<typeof useFindAgreementTenantsQuery>;
export type FindAgreementTenantsLazyQueryHookResult = ReturnType<typeof useFindAgreementTenantsLazyQuery>;
export type FindAgreementTenantsQueryResult = Apollo.QueryResult<FindAgreementTenantsQuery, FindAgreementTenantsQueryVariables>;
export const SendAgreementForSigningDocument = gql`
    mutation SendAgreementForSigning($input: SendAgreementForSigningInput!) {
  sendAgreementForSigning(input: $input) {
    tenants {
      name
      email
    }
  }
}
    `;
export type SendAgreementForSigningMutationFn = Apollo.MutationFunction<SendAgreementForSigningMutation, SendAgreementForSigningMutationVariables>;

/**
 * __useSendAgreementForSigningMutation__
 *
 * To run a mutation, you first call `useSendAgreementForSigningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAgreementForSigningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAgreementForSigningMutation, { data, loading, error }] = useSendAgreementForSigningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAgreementForSigningMutation(baseOptions?: Apollo.MutationHookOptions<SendAgreementForSigningMutation, SendAgreementForSigningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAgreementForSigningMutation, SendAgreementForSigningMutationVariables>(SendAgreementForSigningDocument, options);
      }
export type SendAgreementForSigningMutationHookResult = ReturnType<typeof useSendAgreementForSigningMutation>;
export type SendAgreementForSigningMutationResult = Apollo.MutationResult<SendAgreementForSigningMutation>;
export type SendAgreementForSigningMutationOptions = Apollo.BaseMutationOptions<SendAgreementForSigningMutation, SendAgreementForSigningMutationVariables>;
export const AssociateAgreementWithClientDocument = gql`
    mutation AssociateAgreementWithClient($input: AssociateAgreementWithClientInput!) {
  associateAgreementWithClient(input: $input) {
    agreement {
      id
      homeName
    }
    homeId
  }
}
    `;
export type AssociateAgreementWithClientMutationFn = Apollo.MutationFunction<AssociateAgreementWithClientMutation, AssociateAgreementWithClientMutationVariables>;

/**
 * __useAssociateAgreementWithClientMutation__
 *
 * To run a mutation, you first call `useAssociateAgreementWithClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateAgreementWithClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateAgreementWithClientMutation, { data, loading, error }] = useAssociateAgreementWithClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateAgreementWithClientMutation(baseOptions?: Apollo.MutationHookOptions<AssociateAgreementWithClientMutation, AssociateAgreementWithClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateAgreementWithClientMutation, AssociateAgreementWithClientMutationVariables>(AssociateAgreementWithClientDocument, options);
      }
export type AssociateAgreementWithClientMutationHookResult = ReturnType<typeof useAssociateAgreementWithClientMutation>;
export type AssociateAgreementWithClientMutationResult = Apollo.MutationResult<AssociateAgreementWithClientMutation>;
export type AssociateAgreementWithClientMutationOptions = Apollo.BaseMutationOptions<AssociateAgreementWithClientMutation, AssociateAgreementWithClientMutationVariables>;
export const FindAgreementDocument = gql`
    query FindAgreement($id: UUID!) {
  findTenancyAgreement(id: $id) {
    ...GeneratedAgreement
    tenants {
      edges {
        node {
          id
          firstName
          lastName
          email
          mobile
        }
      }
    }
    status
    client {
      id
    }
    home {
      id
      name
    }
    residency {
      id
    }
    signatures {
      edges {
        node {
          id
          name
          email
          status
          signatureType
          signedAt
        }
      }
    }
  }
}
    ${GeneratedAgreementFragmentDoc}`;

/**
 * __useFindAgreementQuery__
 *
 * To run a query within a React component, call `useFindAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindAgreementQuery(baseOptions: Apollo.QueryHookOptions<FindAgreementQuery, FindAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAgreementQuery, FindAgreementQueryVariables>(FindAgreementDocument, options);
      }
export function useFindAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAgreementQuery, FindAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAgreementQuery, FindAgreementQueryVariables>(FindAgreementDocument, options);
        }
export type FindAgreementQueryHookResult = ReturnType<typeof useFindAgreementQuery>;
export type FindAgreementLazyQueryHookResult = ReturnType<typeof useFindAgreementLazyQuery>;
export type FindAgreementQueryResult = Apollo.QueryResult<FindAgreementQuery, FindAgreementQueryVariables>;
export const RevokeGeneratedAgreementDocument = gql`
    mutation RevokeGeneratedAgreement($input: RevokeGeneratedAgreementInput!) {
  revokeGeneratedAgreement(input: $input) {
    id
  }
}
    `;
export type RevokeGeneratedAgreementMutationFn = Apollo.MutationFunction<RevokeGeneratedAgreementMutation, RevokeGeneratedAgreementMutationVariables>;

/**
 * __useRevokeGeneratedAgreementMutation__
 *
 * To run a mutation, you first call `useRevokeGeneratedAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeGeneratedAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeGeneratedAgreementMutation, { data, loading, error }] = useRevokeGeneratedAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeGeneratedAgreementMutation(baseOptions?: Apollo.MutationHookOptions<RevokeGeneratedAgreementMutation, RevokeGeneratedAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeGeneratedAgreementMutation, RevokeGeneratedAgreementMutationVariables>(RevokeGeneratedAgreementDocument, options);
      }
export type RevokeGeneratedAgreementMutationHookResult = ReturnType<typeof useRevokeGeneratedAgreementMutation>;
export type RevokeGeneratedAgreementMutationResult = Apollo.MutationResult<RevokeGeneratedAgreementMutation>;
export type RevokeGeneratedAgreementMutationOptions = Apollo.BaseMutationOptions<RevokeGeneratedAgreementMutation, RevokeGeneratedAgreementMutationVariables>;
export const SaveGeneratedAgreementDocument = gql`
    mutation SaveGeneratedAgreement($input: SaveGeneratedAgreementInput!) {
  saveGeneratedAgreement(input: $input) {
    id
    file
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveGeneratedAgreementMutationFn = Apollo.MutationFunction<SaveGeneratedAgreementMutation, SaveGeneratedAgreementMutationVariables>;

/**
 * __useSaveGeneratedAgreementMutation__
 *
 * To run a mutation, you first call `useSaveGeneratedAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGeneratedAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGeneratedAgreementMutation, { data, loading, error }] = useSaveGeneratedAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGeneratedAgreementMutation(baseOptions?: Apollo.MutationHookOptions<SaveGeneratedAgreementMutation, SaveGeneratedAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGeneratedAgreementMutation, SaveGeneratedAgreementMutationVariables>(SaveGeneratedAgreementDocument, options);
      }
export type SaveGeneratedAgreementMutationHookResult = ReturnType<typeof useSaveGeneratedAgreementMutation>;
export type SaveGeneratedAgreementMutationResult = Apollo.MutationResult<SaveGeneratedAgreementMutation>;
export type SaveGeneratedAgreementMutationOptions = Apollo.BaseMutationOptions<SaveGeneratedAgreementMutation, SaveGeneratedAgreementMutationVariables>;
export const LandlordToDoListDocument = gql`
    query LandlordToDoList($after: String) {
  complianceRequirements(
    status: ["Expiring Soon", "Missing", "Expired"]
    after: $after
    orderBy: "action_date"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        status
        home {
          id
          address
        }
      }
    }
  }
}
    `;

/**
 * __useLandlordToDoListQuery__
 *
 * To run a query within a React component, call `useLandlordToDoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordToDoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordToDoListQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLandlordToDoListQuery(baseOptions?: Apollo.QueryHookOptions<LandlordToDoListQuery, LandlordToDoListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordToDoListQuery, LandlordToDoListQueryVariables>(LandlordToDoListDocument, options);
      }
export function useLandlordToDoListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordToDoListQuery, LandlordToDoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordToDoListQuery, LandlordToDoListQueryVariables>(LandlordToDoListDocument, options);
        }
export type LandlordToDoListQueryHookResult = ReturnType<typeof useLandlordToDoListQuery>;
export type LandlordToDoListLazyQueryHookResult = ReturnType<typeof useLandlordToDoListLazyQuery>;
export type LandlordToDoListQueryResult = Apollo.QueryResult<LandlordToDoListQuery, LandlordToDoListQueryVariables>;
export const LandlordTasksDocument = gql`
    query LandlordTasks {
  getClient {
    id
    ...Tasks
  }
}
    ${TasksFragmentDoc}`;

/**
 * __useLandlordTasksQuery__
 *
 * To run a query within a React component, call `useLandlordTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandlordTasksQuery(baseOptions?: Apollo.QueryHookOptions<LandlordTasksQuery, LandlordTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordTasksQuery, LandlordTasksQueryVariables>(LandlordTasksDocument, options);
      }
export function useLandlordTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordTasksQuery, LandlordTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordTasksQuery, LandlordTasksQueryVariables>(LandlordTasksDocument, options);
        }
export type LandlordTasksQueryHookResult = ReturnType<typeof useLandlordTasksQuery>;
export type LandlordTasksLazyQueryHookResult = ReturnType<typeof useLandlordTasksLazyQuery>;
export type LandlordTasksQueryResult = Apollo.QueryResult<LandlordTasksQuery, LandlordTasksQueryVariables>;
export const LandlordHomesDocument = gql`
    query LandlordHomes {
  homes {
    totalCount
    edges {
      node {
        ...LandlordHome
      }
    }
  }
}
    ${LandlordHomeFragmentDoc}`;

/**
 * __useLandlordHomesQuery__
 *
 * To run a query within a React component, call `useLandlordHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordHomesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandlordHomesQuery(baseOptions?: Apollo.QueryHookOptions<LandlordHomesQuery, LandlordHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordHomesQuery, LandlordHomesQueryVariables>(LandlordHomesDocument, options);
      }
export function useLandlordHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordHomesQuery, LandlordHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordHomesQuery, LandlordHomesQueryVariables>(LandlordHomesDocument, options);
        }
export type LandlordHomesQueryHookResult = ReturnType<typeof useLandlordHomesQuery>;
export type LandlordHomesLazyQueryHookResult = ReturnType<typeof useLandlordHomesLazyQuery>;
export type LandlordHomesQueryResult = Apollo.QueryResult<LandlordHomesQuery, LandlordHomesQueryVariables>;
export const ReferencesListDataDocument = gql`
    query ReferencesListData {
  tenantReferences(hasBeenSent: true) {
    totalCount
    edges {
      node {
        id
        home {
          id
          address
        }
        applicant {
          id
          name
        }
        sentAt
        status
      }
    }
  }
}
    `;

/**
 * __useReferencesListDataQuery__
 *
 * To run a query within a React component, call `useReferencesListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencesListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencesListDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferencesListDataQuery(baseOptions?: Apollo.QueryHookOptions<ReferencesListDataQuery, ReferencesListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencesListDataQuery, ReferencesListDataQueryVariables>(ReferencesListDataDocument, options);
      }
export function useReferencesListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencesListDataQuery, ReferencesListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencesListDataQuery, ReferencesListDataQueryVariables>(ReferencesListDataDocument, options);
        }
export type ReferencesListDataQueryHookResult = ReturnType<typeof useReferencesListDataQuery>;
export type ReferencesListDataLazyQueryHookResult = ReturnType<typeof useReferencesListDataLazyQuery>;
export type ReferencesListDataQueryResult = Apollo.QueryResult<ReferencesListDataQuery, ReferencesListDataQueryVariables>;
export const CurrentAndFutureTenanciesDocument = gql`
    query CurrentAndFutureTenancies {
  residencies(stage: ["Current", "Future"]) {
    edges {
      node {
        id
        stage
        startDate
        rentAmount
        paymentFrequency
        residents {
          id
          name
        }
        home {
          id
          address
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentAndFutureTenanciesQuery__
 *
 * To run a query within a React component, call `useCurrentAndFutureTenanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAndFutureTenanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAndFutureTenanciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAndFutureTenanciesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAndFutureTenanciesQuery, CurrentAndFutureTenanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAndFutureTenanciesQuery, CurrentAndFutureTenanciesQueryVariables>(CurrentAndFutureTenanciesDocument, options);
      }
export function useCurrentAndFutureTenanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAndFutureTenanciesQuery, CurrentAndFutureTenanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAndFutureTenanciesQuery, CurrentAndFutureTenanciesQueryVariables>(CurrentAndFutureTenanciesDocument, options);
        }
export type CurrentAndFutureTenanciesQueryHookResult = ReturnType<typeof useCurrentAndFutureTenanciesQuery>;
export type CurrentAndFutureTenanciesLazyQueryHookResult = ReturnType<typeof useCurrentAndFutureTenanciesLazyQuery>;
export type CurrentAndFutureTenanciesQueryResult = Apollo.QueryResult<CurrentAndFutureTenanciesQuery, CurrentAndFutureTenanciesQueryVariables>;
export const InitializeSignupDocument = gql`
    mutation InitializeSignup($acceptedMarketing: Boolean, $suppressWelcomeEmail: Boolean) {
  initializeSignup(
    acceptedMarketing: $acceptedMarketing
    suppressWelcomeEmail: $suppressWelcomeEmail
  ) {
    ok
    landlord {
      id
    }
  }
}
    `;
export type InitializeSignupMutationFn = Apollo.MutationFunction<InitializeSignupMutation, InitializeSignupMutationVariables>;

/**
 * __useInitializeSignupMutation__
 *
 * To run a mutation, you first call `useInitializeSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeSignupMutation, { data, loading, error }] = useInitializeSignupMutation({
 *   variables: {
 *      acceptedMarketing: // value for 'acceptedMarketing'
 *      suppressWelcomeEmail: // value for 'suppressWelcomeEmail'
 *   },
 * });
 */
export function useInitializeSignupMutation(baseOptions?: Apollo.MutationHookOptions<InitializeSignupMutation, InitializeSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeSignupMutation, InitializeSignupMutationVariables>(InitializeSignupDocument, options);
      }
export type InitializeSignupMutationHookResult = ReturnType<typeof useInitializeSignupMutation>;
export type InitializeSignupMutationResult = Apollo.MutationResult<InitializeSignupMutation>;
export type InitializeSignupMutationOptions = Apollo.BaseMutationOptions<InitializeSignupMutation, InitializeSignupMutationVariables>;
export const CreateComplianceUpdateReadDocument = gql`
    mutation CreateComplianceUpdateRead($input: CreateComplianceUpdateReadInput!) {
  createComplianceUpdateRead(input: $input) {
    update
  }
}
    `;
export type CreateComplianceUpdateReadMutationFn = Apollo.MutationFunction<CreateComplianceUpdateReadMutation, CreateComplianceUpdateReadMutationVariables>;

/**
 * __useCreateComplianceUpdateReadMutation__
 *
 * To run a mutation, you first call `useCreateComplianceUpdateReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceUpdateReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceUpdateReadMutation, { data, loading, error }] = useCreateComplianceUpdateReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComplianceUpdateReadMutation(baseOptions?: Apollo.MutationHookOptions<CreateComplianceUpdateReadMutation, CreateComplianceUpdateReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateComplianceUpdateReadMutation, CreateComplianceUpdateReadMutationVariables>(CreateComplianceUpdateReadDocument, options);
      }
export type CreateComplianceUpdateReadMutationHookResult = ReturnType<typeof useCreateComplianceUpdateReadMutation>;
export type CreateComplianceUpdateReadMutationResult = Apollo.MutationResult<CreateComplianceUpdateReadMutation>;
export type CreateComplianceUpdateReadMutationOptions = Apollo.BaseMutationOptions<CreateComplianceUpdateReadMutation, CreateComplianceUpdateReadMutationVariables>;
export const FindComplianceUpdateDocument = gql`
    query FindComplianceUpdate($id: UUID!) {
  findComplianceUpdate(id: $id) {
    id
    image
    title
    createdAt
    wasRead
    dateText
    actionRequirement
    actionText
    infoSource
    body
  }
}
    `;

/**
 * __useFindComplianceUpdateQuery__
 *
 * To run a query within a React component, call `useFindComplianceUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindComplianceUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindComplianceUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindComplianceUpdateQuery(baseOptions: Apollo.QueryHookOptions<FindComplianceUpdateQuery, FindComplianceUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindComplianceUpdateQuery, FindComplianceUpdateQueryVariables>(FindComplianceUpdateDocument, options);
      }
export function useFindComplianceUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindComplianceUpdateQuery, FindComplianceUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindComplianceUpdateQuery, FindComplianceUpdateQueryVariables>(FindComplianceUpdateDocument, options);
        }
export type FindComplianceUpdateQueryHookResult = ReturnType<typeof useFindComplianceUpdateQuery>;
export type FindComplianceUpdateLazyQueryHookResult = ReturnType<typeof useFindComplianceUpdateLazyQuery>;
export type FindComplianceUpdateQueryResult = Apollo.QueryResult<FindComplianceUpdateQuery, FindComplianceUpdateQueryVariables>;
export const ListComplianceUpdatesDocument = gql`
    query ListComplianceUpdates($unread: Boolean) {
  listComplianceUpdates(unread: $unread) {
    id
    image
    title
    createdAt
    wasRead
    dateText
    actionRequirement
    actionText
    infoSource
    body
  }
}
    `;

/**
 * __useListComplianceUpdatesQuery__
 *
 * To run a query within a React component, call `useListComplianceUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListComplianceUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListComplianceUpdatesQuery({
 *   variables: {
 *      unread: // value for 'unread'
 *   },
 * });
 */
export function useListComplianceUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<ListComplianceUpdatesQuery, ListComplianceUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListComplianceUpdatesQuery, ListComplianceUpdatesQueryVariables>(ListComplianceUpdatesDocument, options);
      }
export function useListComplianceUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListComplianceUpdatesQuery, ListComplianceUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListComplianceUpdatesQuery, ListComplianceUpdatesQueryVariables>(ListComplianceUpdatesDocument, options);
        }
export type ListComplianceUpdatesQueryHookResult = ReturnType<typeof useListComplianceUpdatesQuery>;
export type ListComplianceUpdatesLazyQueryHookResult = ReturnType<typeof useListComplianceUpdatesLazyQuery>;
export type ListComplianceUpdatesQueryResult = Apollo.QueryResult<ListComplianceUpdatesQuery, ListComplianceUpdatesQueryVariables>;
export const ListResidenciesDocument = gql`
    query ListResidencies($after: String) {
  residencies(after: $after, completed: false) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        startDate
        endDate
        rentAmount
        paymentStartDate
        depositAmount
        home {
          id
          name
          addressLine1
          city
          postcode
        }
        subscription {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useListResidenciesQuery__
 *
 * To run a query within a React component, call `useListResidenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResidenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResidenciesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListResidenciesQuery(baseOptions?: Apollo.QueryHookOptions<ListResidenciesQuery, ListResidenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResidenciesQuery, ListResidenciesQueryVariables>(ListResidenciesDocument, options);
      }
export function useListResidenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResidenciesQuery, ListResidenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResidenciesQuery, ListResidenciesQueryVariables>(ListResidenciesDocument, options);
        }
export type ListResidenciesQueryHookResult = ReturnType<typeof useListResidenciesQuery>;
export type ListResidenciesLazyQueryHookResult = ReturnType<typeof useListResidenciesLazyQuery>;
export type ListResidenciesQueryResult = Apollo.QueryResult<ListResidenciesQuery, ListResidenciesQueryVariables>;
export const FindResidencyPaymentsDocument = gql`
    query FindResidencyPayments($id: UUID!) {
  residency(id: $id) {
    id
    startDate
    rentAmount
    residents {
      user {
        id
        email
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useFindResidencyPaymentsQuery__
 *
 * To run a query within a React component, call `useFindResidencyPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindResidencyPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindResidencyPaymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindResidencyPaymentsQuery(baseOptions: Apollo.QueryHookOptions<FindResidencyPaymentsQuery, FindResidencyPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindResidencyPaymentsQuery, FindResidencyPaymentsQueryVariables>(FindResidencyPaymentsDocument, options);
      }
export function useFindResidencyPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindResidencyPaymentsQuery, FindResidencyPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindResidencyPaymentsQuery, FindResidencyPaymentsQueryVariables>(FindResidencyPaymentsDocument, options);
        }
export type FindResidencyPaymentsQueryHookResult = ReturnType<typeof useFindResidencyPaymentsQuery>;
export type FindResidencyPaymentsLazyQueryHookResult = ReturnType<typeof useFindResidencyPaymentsLazyQuery>;
export type FindResidencyPaymentsQueryResult = Apollo.QueryResult<FindResidencyPaymentsQuery, FindResidencyPaymentsQueryVariables>;
export const CreateResidencySubscriptionDocument = gql`
    mutation CreateResidencySubscription($input: CreateResidencySubscriptionInput!) {
  createResidencySubscription(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateResidencySubscriptionMutationFn = Apollo.MutationFunction<CreateResidencySubscriptionMutation, CreateResidencySubscriptionMutationVariables>;

/**
 * __useCreateResidencySubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateResidencySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResidencySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResidencySubscriptionMutation, { data, loading, error }] = useCreateResidencySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResidencySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateResidencySubscriptionMutation, CreateResidencySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResidencySubscriptionMutation, CreateResidencySubscriptionMutationVariables>(CreateResidencySubscriptionDocument, options);
      }
export type CreateResidencySubscriptionMutationHookResult = ReturnType<typeof useCreateResidencySubscriptionMutation>;
export type CreateResidencySubscriptionMutationResult = Apollo.MutationResult<CreateResidencySubscriptionMutation>;
export type CreateResidencySubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateResidencySubscriptionMutation, CreateResidencySubscriptionMutationVariables>;
export const CreateStripeAccountDocument = gql`
    mutation CreateStripeAccount($returnUrl: String) {
  createStripeAccount {
    client {
      clientType
      stripeAccountLink(returnUrl: $returnUrl)
    }
  }
}
    `;
export type CreateStripeAccountMutationFn = Apollo.MutationFunction<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>;

/**
 * __useCreateStripeAccountMutation__
 *
 * To run a mutation, you first call `useCreateStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeAccountMutation, { data, loading, error }] = useCreateStripeAccountMutation({
 *   variables: {
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useCreateStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>(CreateStripeAccountDocument, options);
      }
export type CreateStripeAccountMutationHookResult = ReturnType<typeof useCreateStripeAccountMutation>;
export type CreateStripeAccountMutationResult = Apollo.MutationResult<CreateStripeAccountMutation>;
export type CreateStripeAccountMutationOptions = Apollo.BaseMutationOptions<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>;
export const CreateStripeAccountLinkDocument = gql`
    query CreateStripeAccountLink {
  getClient {
    id
    stripeAccountLink
  }
}
    `;

/**
 * __useCreateStripeAccountLinkQuery__
 *
 * To run a query within a React component, call `useCreateStripeAccountLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeAccountLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateStripeAccountLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateStripeAccountLinkQuery(baseOptions?: Apollo.QueryHookOptions<CreateStripeAccountLinkQuery, CreateStripeAccountLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateStripeAccountLinkQuery, CreateStripeAccountLinkQueryVariables>(CreateStripeAccountLinkDocument, options);
      }
export function useCreateStripeAccountLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateStripeAccountLinkQuery, CreateStripeAccountLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateStripeAccountLinkQuery, CreateStripeAccountLinkQueryVariables>(CreateStripeAccountLinkDocument, options);
        }
export type CreateStripeAccountLinkQueryHookResult = ReturnType<typeof useCreateStripeAccountLinkQuery>;
export type CreateStripeAccountLinkLazyQueryHookResult = ReturnType<typeof useCreateStripeAccountLinkLazyQuery>;
export type CreateStripeAccountLinkQueryResult = Apollo.QueryResult<CreateStripeAccountLinkQuery, CreateStripeAccountLinkQueryVariables>;
export const GetClientSubscriptionsDocument = gql`
    query GetClientSubscriptions {
  getClient {
    id
    paymentsEnabled
    hasPayments
    subscriptions {
      id
      details {
        startDate
        endDate
        price
        status
        paymentMethod {
          type
          card {
            brand
            last4
          }
          bacsDebit {
            sortCode
            last4
          }
        }
      }
      residency {
        id
        startDate
        completionDate
        home {
          id
          name
          addressLine1
          postcode
        }
        residents {
          id
          user {
            id
            firstName
            lastName
          }
        }
        depositPayment {
          id
          amount
          createdAt
          status
        }
      }
      invoices {
        id
        status
        amount
        created
        nextPaymentAttempt
        paymentIntent {
          id
          status
        }
        charge {
          paymentMethodDetails {
            type
            card {
              brand
              last4
            }
            bacsDebit {
              sortCode
              last4
            }
          }
        }
      }
      upcomingInvoice {
        status
        amount
        created
      }
    }
  }
}
    `;

/**
 * __useGetClientSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetClientSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientSubscriptionsQuery, GetClientSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientSubscriptionsQuery, GetClientSubscriptionsQueryVariables>(GetClientSubscriptionsDocument, options);
      }
export function useGetClientSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientSubscriptionsQuery, GetClientSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientSubscriptionsQuery, GetClientSubscriptionsQueryVariables>(GetClientSubscriptionsDocument, options);
        }
export type GetClientSubscriptionsQueryHookResult = ReturnType<typeof useGetClientSubscriptionsQuery>;
export type GetClientSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetClientSubscriptionsLazyQuery>;
export type GetClientSubscriptionsQueryResult = Apollo.QueryResult<GetClientSubscriptionsQuery, GetClientSubscriptionsQueryVariables>;
export const AddTenancyDocument = gql`
    mutation AddTenancy($input: ResidencyAndResidentsInput!) {
  createResidencyAndResidents(input: $input) {
    residency {
      id
      residents {
        id
      }
    }
  }
}
    `;
export type AddTenancyMutationFn = Apollo.MutationFunction<AddTenancyMutation, AddTenancyMutationVariables>;

/**
 * __useAddTenancyMutation__
 *
 * To run a mutation, you first call `useAddTenancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTenancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTenancyMutation, { data, loading, error }] = useAddTenancyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTenancyMutation(baseOptions?: Apollo.MutationHookOptions<AddTenancyMutation, AddTenancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTenancyMutation, AddTenancyMutationVariables>(AddTenancyDocument, options);
      }
export type AddTenancyMutationHookResult = ReturnType<typeof useAddTenancyMutation>;
export type AddTenancyMutationResult = Apollo.MutationResult<AddTenancyMutation>;
export type AddTenancyMutationOptions = Apollo.BaseMutationOptions<AddTenancyMutation, AddTenancyMutationVariables>;
export const AddTenancyDataDocument = gql`
    query AddTenancyData($id: UUID!) {
  home(id: $id) {
    id
    name
    addressLine1
    postcode
    city
  }
  getLandlord {
    id
    name
    email
  }
}
    `;

/**
 * __useAddTenancyDataQuery__
 *
 * To run a query within a React component, call `useAddTenancyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddTenancyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddTenancyDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddTenancyDataQuery(baseOptions: Apollo.QueryHookOptions<AddTenancyDataQuery, AddTenancyDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddTenancyDataQuery, AddTenancyDataQueryVariables>(AddTenancyDataDocument, options);
      }
export function useAddTenancyDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddTenancyDataQuery, AddTenancyDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddTenancyDataQuery, AddTenancyDataQueryVariables>(AddTenancyDataDocument, options);
        }
export type AddTenancyDataQueryHookResult = ReturnType<typeof useAddTenancyDataQuery>;
export type AddTenancyDataLazyQueryHookResult = ReturnType<typeof useAddTenancyDataLazyQuery>;
export type AddTenancyDataQueryResult = Apollo.QueryResult<AddTenancyDataQuery, AddTenancyDataQueryVariables>;
export const LandlordAddressDocument = gql`
    query LandlordAddress {
  getLandlord {
    address
  }
}
    `;

/**
 * __useLandlordAddressQuery__
 *
 * To run a query within a React component, call `useLandlordAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandlordAddressQuery(baseOptions?: Apollo.QueryHookOptions<LandlordAddressQuery, LandlordAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordAddressQuery, LandlordAddressQueryVariables>(LandlordAddressDocument, options);
      }
export function useLandlordAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordAddressQuery, LandlordAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordAddressQuery, LandlordAddressQueryVariables>(LandlordAddressDocument, options);
        }
export type LandlordAddressQueryHookResult = ReturnType<typeof useLandlordAddressQuery>;
export type LandlordAddressLazyQueryHookResult = ReturnType<typeof useLandlordAddressLazyQuery>;
export type LandlordAddressQueryResult = Apollo.QueryResult<LandlordAddressQuery, LandlordAddressQueryVariables>;
export const SetResidencyCompletionDateDocument = gql`
    mutation SetResidencyCompletionDate($input: SetResidencyCompletionDateInput!) {
  setResidencyCompletionDate(input: $input) {
    id
  }
}
    `;
export type SetResidencyCompletionDateMutationFn = Apollo.MutationFunction<SetResidencyCompletionDateMutation, SetResidencyCompletionDateMutationVariables>;

/**
 * __useSetResidencyCompletionDateMutation__
 *
 * To run a mutation, you first call `useSetResidencyCompletionDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetResidencyCompletionDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setResidencyCompletionDateMutation, { data, loading, error }] = useSetResidencyCompletionDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetResidencyCompletionDateMutation(baseOptions?: Apollo.MutationHookOptions<SetResidencyCompletionDateMutation, SetResidencyCompletionDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResidencyCompletionDateMutation, SetResidencyCompletionDateMutationVariables>(SetResidencyCompletionDateDocument, options);
      }
export type SetResidencyCompletionDateMutationHookResult = ReturnType<typeof useSetResidencyCompletionDateMutation>;
export type SetResidencyCompletionDateMutationResult = Apollo.MutationResult<SetResidencyCompletionDateMutation>;
export type SetResidencyCompletionDateMutationOptions = Apollo.BaseMutationOptions<SetResidencyCompletionDateMutation, SetResidencyCompletionDateMutationVariables>;
export const RenewTenancyDataDocument = gql`
    query RenewTenancyData($residencyId: UUID!) {
  residency(id: $residencyId) {
    rentAmount
    depositAmount
    residents {
      firstName
      lastName
      email
      mobile
    }
  }
}
    `;

/**
 * __useRenewTenancyDataQuery__
 *
 * To run a query within a React component, call `useRenewTenancyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewTenancyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewTenancyDataQuery({
 *   variables: {
 *      residencyId: // value for 'residencyId'
 *   },
 * });
 */
export function useRenewTenancyDataQuery(baseOptions: Apollo.QueryHookOptions<RenewTenancyDataQuery, RenewTenancyDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewTenancyDataQuery, RenewTenancyDataQueryVariables>(RenewTenancyDataDocument, options);
      }
export function useRenewTenancyDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewTenancyDataQuery, RenewTenancyDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewTenancyDataQuery, RenewTenancyDataQueryVariables>(RenewTenancyDataDocument, options);
        }
export type RenewTenancyDataQueryHookResult = ReturnType<typeof useRenewTenancyDataQuery>;
export type RenewTenancyDataLazyQueryHookResult = ReturnType<typeof useRenewTenancyDataLazyQuery>;
export type RenewTenancyDataQueryResult = Apollo.QueryResult<RenewTenancyDataQuery, RenewTenancyDataQueryVariables>;
export const ConfirmResidencyWillRollDocument = gql`
    mutation ConfirmResidencyWillRoll($input: ConfirmResidencyWillRollInput!) {
  confirmResidencyWillRoll(input: $input) {
    id
  }
}
    `;
export type ConfirmResidencyWillRollMutationFn = Apollo.MutationFunction<ConfirmResidencyWillRollMutation, ConfirmResidencyWillRollMutationVariables>;

/**
 * __useConfirmResidencyWillRollMutation__
 *
 * To run a mutation, you first call `useConfirmResidencyWillRollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmResidencyWillRollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmResidencyWillRollMutation, { data, loading, error }] = useConfirmResidencyWillRollMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmResidencyWillRollMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmResidencyWillRollMutation, ConfirmResidencyWillRollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmResidencyWillRollMutation, ConfirmResidencyWillRollMutationVariables>(ConfirmResidencyWillRollDocument, options);
      }
export type ConfirmResidencyWillRollMutationHookResult = ReturnType<typeof useConfirmResidencyWillRollMutation>;
export type ConfirmResidencyWillRollMutationResult = Apollo.MutationResult<ConfirmResidencyWillRollMutation>;
export type ConfirmResidencyWillRollMutationOptions = Apollo.BaseMutationOptions<ConfirmResidencyWillRollMutation, ConfirmResidencyWillRollMutationVariables>;
export const CountHomeTenanciesDocument = gql`
    query CountHomeTenancies($id: UUID!) {
  home(id: $id) {
    id
    residencies {
      totalCount
    }
  }
}
    `;

/**
 * __useCountHomeTenanciesQuery__
 *
 * To run a query within a React component, call `useCountHomeTenanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountHomeTenanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountHomeTenanciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountHomeTenanciesQuery(baseOptions: Apollo.QueryHookOptions<CountHomeTenanciesQuery, CountHomeTenanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountHomeTenanciesQuery, CountHomeTenanciesQueryVariables>(CountHomeTenanciesDocument, options);
      }
export function useCountHomeTenanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountHomeTenanciesQuery, CountHomeTenanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountHomeTenanciesQuery, CountHomeTenanciesQueryVariables>(CountHomeTenanciesDocument, options);
        }
export type CountHomeTenanciesQueryHookResult = ReturnType<typeof useCountHomeTenanciesQuery>;
export type CountHomeTenanciesLazyQueryHookResult = ReturnType<typeof useCountHomeTenanciesLazyQuery>;
export type CountHomeTenanciesQueryResult = Apollo.QueryResult<CountHomeTenanciesQuery, CountHomeTenanciesQueryVariables>;
export const TenancySectionDetailsDocument = gql`
    query TenancySectionDetails($id: UUID!) {
  home(id: $id) {
    id
    residencies {
      edges {
        node {
          id
          startDate
          completionDate
          rentAmount
          paymentFrequency
          stage
          residents {
            id
            name
          }
          residents {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTenancySectionDetailsQuery__
 *
 * To run a query within a React component, call `useTenancySectionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenancySectionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenancySectionDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTenancySectionDetailsQuery(baseOptions: Apollo.QueryHookOptions<TenancySectionDetailsQuery, TenancySectionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenancySectionDetailsQuery, TenancySectionDetailsQueryVariables>(TenancySectionDetailsDocument, options);
      }
export function useTenancySectionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenancySectionDetailsQuery, TenancySectionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenancySectionDetailsQuery, TenancySectionDetailsQueryVariables>(TenancySectionDetailsDocument, options);
        }
export type TenancySectionDetailsQueryHookResult = ReturnType<typeof useTenancySectionDetailsQuery>;
export type TenancySectionDetailsLazyQueryHookResult = ReturnType<typeof useTenancySectionDetailsLazyQuery>;
export type TenancySectionDetailsQueryResult = Apollo.QueryResult<TenancySectionDetailsQuery, TenancySectionDetailsQueryVariables>;
export const CreateAgreementForTenancyDocument = gql`
    mutation CreateAgreementForTenancy($input: CreateAgreementForTenancyInput!) {
  createAgreementForTenancy(input: $input) {
    id
  }
}
    `;
export type CreateAgreementForTenancyMutationFn = Apollo.MutationFunction<CreateAgreementForTenancyMutation, CreateAgreementForTenancyMutationVariables>;

/**
 * __useCreateAgreementForTenancyMutation__
 *
 * To run a mutation, you first call `useCreateAgreementForTenancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementForTenancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgreementForTenancyMutation, { data, loading, error }] = useCreateAgreementForTenancyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgreementForTenancyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgreementForTenancyMutation, CreateAgreementForTenancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgreementForTenancyMutation, CreateAgreementForTenancyMutationVariables>(CreateAgreementForTenancyDocument, options);
      }
export type CreateAgreementForTenancyMutationHookResult = ReturnType<typeof useCreateAgreementForTenancyMutation>;
export type CreateAgreementForTenancyMutationResult = Apollo.MutationResult<CreateAgreementForTenancyMutation>;
export type CreateAgreementForTenancyMutationOptions = Apollo.BaseMutationOptions<CreateAgreementForTenancyMutation, CreateAgreementForTenancyMutationVariables>;
export const TenancySideDialogDetailsDocument = gql`
    query TenancySideDialogDetails($id: UUID!) {
  residency(id: $id) {
    id
    stage
    startDate
    endDate
    completionDate
    type
    rentAmount
    depositAmount
    paymentStartDate
    rollingConfirmed
    home {
      id
      address
    }
    residents {
      id
      name
      email
      mobile
    }
    subscription {
      id
      details {
        status
      }
      upcomingInvoice {
        nextPaymentAttempt
        status
      }
      invoices {
        amount
        status
      }
    }
    generatedAgreements {
      edges {
        node {
          id
          file
        }
      }
    }
    complianceRequirements(type: "TA") {
      edges {
        node {
          id
          currentItem {
            id
            attachment {
              id
              file
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTenancySideDialogDetailsQuery__
 *
 * To run a query within a React component, call `useTenancySideDialogDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenancySideDialogDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenancySideDialogDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTenancySideDialogDetailsQuery(baseOptions: Apollo.QueryHookOptions<TenancySideDialogDetailsQuery, TenancySideDialogDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenancySideDialogDetailsQuery, TenancySideDialogDetailsQueryVariables>(TenancySideDialogDetailsDocument, options);
      }
export function useTenancySideDialogDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenancySideDialogDetailsQuery, TenancySideDialogDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenancySideDialogDetailsQuery, TenancySideDialogDetailsQueryVariables>(TenancySideDialogDetailsDocument, options);
        }
export type TenancySideDialogDetailsQueryHookResult = ReturnType<typeof useTenancySideDialogDetailsQuery>;
export type TenancySideDialogDetailsLazyQueryHookResult = ReturnType<typeof useTenancySideDialogDetailsLazyQuery>;
export type TenancySideDialogDetailsQueryResult = Apollo.QueryResult<TenancySideDialogDetailsQuery, TenancySideDialogDetailsQueryVariables>;
export const CreateResidencyAndResidentsDocument = gql`
    mutation CreateResidencyAndResidents($input: ResidencyAndResidentsInput!) {
  createResidencyAndResidents(input: $input) {
    ok
    residency {
      id
    }
  }
}
    `;
export type CreateResidencyAndResidentsMutationFn = Apollo.MutationFunction<CreateResidencyAndResidentsMutation, CreateResidencyAndResidentsMutationVariables>;

/**
 * __useCreateResidencyAndResidentsMutation__
 *
 * To run a mutation, you first call `useCreateResidencyAndResidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResidencyAndResidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResidencyAndResidentsMutation, { data, loading, error }] = useCreateResidencyAndResidentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResidencyAndResidentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateResidencyAndResidentsMutation, CreateResidencyAndResidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResidencyAndResidentsMutation, CreateResidencyAndResidentsMutationVariables>(CreateResidencyAndResidentsDocument, options);
      }
export type CreateResidencyAndResidentsMutationHookResult = ReturnType<typeof useCreateResidencyAndResidentsMutation>;
export type CreateResidencyAndResidentsMutationResult = Apollo.MutationResult<CreateResidencyAndResidentsMutation>;
export type CreateResidencyAndResidentsMutationOptions = Apollo.BaseMutationOptions<CreateResidencyAndResidentsMutation, CreateResidencyAndResidentsMutationVariables>;
export const UpdateHomeAddressDocument = gql`
    mutation UpdateHomeAddress($input: UpdateHomeAddressInput!) {
  updateHomeAddress(input: $input) {
    id
  }
}
    `;
export type UpdateHomeAddressMutationFn = Apollo.MutationFunction<UpdateHomeAddressMutation, UpdateHomeAddressMutationVariables>;

/**
 * __useUpdateHomeAddressMutation__
 *
 * To run a mutation, you first call `useUpdateHomeAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHomeAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHomeAddressMutation, { data, loading, error }] = useUpdateHomeAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHomeAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHomeAddressMutation, UpdateHomeAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHomeAddressMutation, UpdateHomeAddressMutationVariables>(UpdateHomeAddressDocument, options);
      }
export type UpdateHomeAddressMutationHookResult = ReturnType<typeof useUpdateHomeAddressMutation>;
export type UpdateHomeAddressMutationResult = Apollo.MutationResult<UpdateHomeAddressMutation>;
export type UpdateHomeAddressMutationOptions = Apollo.BaseMutationOptions<UpdateHomeAddressMutation, UpdateHomeAddressMutationVariables>;
export const UpdateResidencyAndResidentsDocument = gql`
    mutation UpdateResidencyAndResidents($input: ResidencyAndResidentsInput!) {
  updateResidencyAndResidents(input: $input) {
    ok
  }
}
    `;
export type UpdateResidencyAndResidentsMutationFn = Apollo.MutationFunction<UpdateResidencyAndResidentsMutation, UpdateResidencyAndResidentsMutationVariables>;

/**
 * __useUpdateResidencyAndResidentsMutation__
 *
 * To run a mutation, you first call `useUpdateResidencyAndResidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResidencyAndResidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResidencyAndResidentsMutation, { data, loading, error }] = useUpdateResidencyAndResidentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResidencyAndResidentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResidencyAndResidentsMutation, UpdateResidencyAndResidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResidencyAndResidentsMutation, UpdateResidencyAndResidentsMutationVariables>(UpdateResidencyAndResidentsDocument, options);
      }
export type UpdateResidencyAndResidentsMutationHookResult = ReturnType<typeof useUpdateResidencyAndResidentsMutation>;
export type UpdateResidencyAndResidentsMutationResult = Apollo.MutationResult<UpdateResidencyAndResidentsMutation>;
export type UpdateResidencyAndResidentsMutationOptions = Apollo.BaseMutationOptions<UpdateResidencyAndResidentsMutation, UpdateResidencyAndResidentsMutationVariables>;
export const SubscriptionUpgradeWarningDocument = gql`
    query SubscriptionUpgradeWarning {
  getClient {
    id
    tierUpTo
    homesCount
  }
}
    `;

/**
 * __useSubscriptionUpgradeWarningQuery__
 *
 * To run a query within a React component, call `useSubscriptionUpgradeWarningQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionUpgradeWarningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionUpgradeWarningQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionUpgradeWarningQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionUpgradeWarningQuery, SubscriptionUpgradeWarningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionUpgradeWarningQuery, SubscriptionUpgradeWarningQueryVariables>(SubscriptionUpgradeWarningDocument, options);
      }
export function useSubscriptionUpgradeWarningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionUpgradeWarningQuery, SubscriptionUpgradeWarningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionUpgradeWarningQuery, SubscriptionUpgradeWarningQueryVariables>(SubscriptionUpgradeWarningDocument, options);
        }
export type SubscriptionUpgradeWarningQueryHookResult = ReturnType<typeof useSubscriptionUpgradeWarningQuery>;
export type SubscriptionUpgradeWarningLazyQueryHookResult = ReturnType<typeof useSubscriptionUpgradeWarningLazyQuery>;
export type SubscriptionUpgradeWarningQueryResult = Apollo.QueryResult<SubscriptionUpgradeWarningQuery, SubscriptionUpgradeWarningQueryVariables>;
export const CalendarLinkLastUpdateDocument = gql`
    query CalendarLinkLastUpdate {
  getManager {
    calendarLink {
      lastChecked
    }
  }
}
    `;

/**
 * __useCalendarLinkLastUpdateQuery__
 *
 * To run a query within a React component, call `useCalendarLinkLastUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarLinkLastUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarLinkLastUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarLinkLastUpdateQuery(baseOptions?: Apollo.QueryHookOptions<CalendarLinkLastUpdateQuery, CalendarLinkLastUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarLinkLastUpdateQuery, CalendarLinkLastUpdateQueryVariables>(CalendarLinkLastUpdateDocument, options);
      }
export function useCalendarLinkLastUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarLinkLastUpdateQuery, CalendarLinkLastUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarLinkLastUpdateQuery, CalendarLinkLastUpdateQueryVariables>(CalendarLinkLastUpdateDocument, options);
        }
export type CalendarLinkLastUpdateQueryHookResult = ReturnType<typeof useCalendarLinkLastUpdateQuery>;
export type CalendarLinkLastUpdateLazyQueryHookResult = ReturnType<typeof useCalendarLinkLastUpdateLazyQuery>;
export type CalendarLinkLastUpdateQueryResult = Apollo.QueryResult<CalendarLinkLastUpdateQuery, CalendarLinkLastUpdateQueryVariables>;
export const DeleteHomeDocument = gql`
    mutation DeleteHome($input: DeleteHomeInput!) {
  deleteHome(input: $input) {
    id
    errors {
      messages
      field
    }
  }
}
    `;
export type DeleteHomeMutationFn = Apollo.MutationFunction<DeleteHomeMutation, DeleteHomeMutationVariables>;

/**
 * __useDeleteHomeMutation__
 *
 * To run a mutation, you first call `useDeleteHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHomeMutation, { data, loading, error }] = useDeleteHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteHomeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHomeMutation, DeleteHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHomeMutation, DeleteHomeMutationVariables>(DeleteHomeDocument, options);
      }
export type DeleteHomeMutationHookResult = ReturnType<typeof useDeleteHomeMutation>;
export type DeleteHomeMutationResult = Apollo.MutationResult<DeleteHomeMutation>;
export type DeleteHomeMutationOptions = Apollo.BaseMutationOptions<DeleteHomeMutation, DeleteHomeMutationVariables>;
export const DeleteHomeImageDocument = gql`
    mutation DeleteHomeImage($input: DeleteHomeImageInput!) {
  deleteHomeImage(input: $input) {
    errors {
      messages
      field
    }
  }
}
    `;
export type DeleteHomeImageMutationFn = Apollo.MutationFunction<DeleteHomeImageMutation, DeleteHomeImageMutationVariables>;

/**
 * __useDeleteHomeImageMutation__
 *
 * To run a mutation, you first call `useDeleteHomeImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHomeImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHomeImageMutation, { data, loading, error }] = useDeleteHomeImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteHomeImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHomeImageMutation, DeleteHomeImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHomeImageMutation, DeleteHomeImageMutationVariables>(DeleteHomeImageDocument, options);
      }
export type DeleteHomeImageMutationHookResult = ReturnType<typeof useDeleteHomeImageMutation>;
export type DeleteHomeImageMutationResult = Apollo.MutationResult<DeleteHomeImageMutation>;
export type DeleteHomeImageMutationOptions = Apollo.BaseMutationOptions<DeleteHomeImageMutation, DeleteHomeImageMutationVariables>;
export const FindHomeDocument = gql`
    query FindHome($id: UUID!) {
  findHome(id: $id) {
    id
    name
    postcode
    city
    addressLine1
    latitude
    longitude
    activeResidencies {
      id
    }
    currentResidency {
      id
    }
    residencies {
      id
      startDate
    }
    generatedAgreements {
      edges {
        node {
          id
          tenancyStart
          tenancyEnd
          createdAt
          rentAmount
          paymentFrequency
          residentNames
          status
        }
      }
    }
    details {
      description
      numBedrooms
      numBathrooms
      numEnsuites
      numLivingRooms
      parking
      garden
      office
      furnishing
      kitchen
    }
    images {
      edges {
        node {
          id
          image
        }
      }
    }
    missingComplianceRequirements: complianceRequirements(status: "Missing") {
      totalCount
    }
    expiredComplianceRequirements: complianceRequirements(status: "Expired") {
      totalCount
    }
    expiringSoonComplianceRequirements: complianceRequirements(
      status: "Expiring Soon"
    ) {
      totalCount
    }
    allComplianceRequirements: complianceRequirements {
      totalCount
      edges {
        node {
          id
          name
          description
          frequencyText
          status
          currentItem {
            id
            expiryDate
          }
          residency {
            startDate
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindHomeQuery__
 *
 * To run a query within a React component, call `useFindHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHomeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindHomeQuery(baseOptions: Apollo.QueryHookOptions<FindHomeQuery, FindHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHomeQuery, FindHomeQueryVariables>(FindHomeDocument, options);
      }
export function useFindHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHomeQuery, FindHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHomeQuery, FindHomeQueryVariables>(FindHomeDocument, options);
        }
export type FindHomeQueryHookResult = ReturnType<typeof useFindHomeQuery>;
export type FindHomeLazyQueryHookResult = ReturnType<typeof useFindHomeLazyQuery>;
export type FindHomeQueryResult = Apollo.QueryResult<FindHomeQuery, FindHomeQueryVariables>;
export const GetClientDocument = gql`
    query GetClient {
  getClient {
    id
    clientType
    paymentsEnabled
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientQuery(baseOptions?: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetManagerProfileDocument = gql`
    query GetManagerProfile {
  getManager {
    id
    email
    profile {
      id
      complianceEmailExplanation
      complianceUpdateEmails
      valueQuestionnaireAnswer
      ASTPageViewed
      compliancePageViewed
    }
  }
}
    `;

/**
 * __useGetManagerProfileQuery__
 *
 * To run a query within a React component, call `useGetManagerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerProfileQuery, GetManagerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerProfileQuery, GetManagerProfileQueryVariables>(GetManagerProfileDocument, options);
      }
export function useGetManagerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerProfileQuery, GetManagerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerProfileQuery, GetManagerProfileQueryVariables>(GetManagerProfileDocument, options);
        }
export type GetManagerProfileQueryHookResult = ReturnType<typeof useGetManagerProfileQuery>;
export type GetManagerProfileLazyQueryHookResult = ReturnType<typeof useGetManagerProfileLazyQuery>;
export type GetManagerProfileQueryResult = Apollo.QueryResult<GetManagerProfileQuery, GetManagerProfileQueryVariables>;
export const InitializeCalendarLinkDocument = gql`
    mutation InitializeCalendarLink {
  initializeCalendarLink {
    id
    lastChecked
  }
}
    `;
export type InitializeCalendarLinkMutationFn = Apollo.MutationFunction<InitializeCalendarLinkMutation, InitializeCalendarLinkMutationVariables>;

/**
 * __useInitializeCalendarLinkMutation__
 *
 * To run a mutation, you first call `useInitializeCalendarLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeCalendarLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeCalendarLinkMutation, { data, loading, error }] = useInitializeCalendarLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitializeCalendarLinkMutation(baseOptions?: Apollo.MutationHookOptions<InitializeCalendarLinkMutation, InitializeCalendarLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeCalendarLinkMutation, InitializeCalendarLinkMutationVariables>(InitializeCalendarLinkDocument, options);
      }
export type InitializeCalendarLinkMutationHookResult = ReturnType<typeof useInitializeCalendarLinkMutation>;
export type InitializeCalendarLinkMutationResult = Apollo.MutationResult<InitializeCalendarLinkMutation>;
export type InitializeCalendarLinkMutationOptions = Apollo.BaseMutationOptions<InitializeCalendarLinkMutation, InitializeCalendarLinkMutationVariables>;
export const ListHomesForComplianceDocument = gql`
    query ListHomesForCompliance {
  listHomes {
    id
    name
  }
}
    `;

/**
 * __useListHomesForComplianceQuery__
 *
 * To run a query within a React component, call `useListHomesForComplianceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesForComplianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesForComplianceQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomesForComplianceQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesForComplianceQuery, ListHomesForComplianceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesForComplianceQuery, ListHomesForComplianceQueryVariables>(ListHomesForComplianceDocument, options);
      }
export function useListHomesForComplianceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesForComplianceQuery, ListHomesForComplianceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesForComplianceQuery, ListHomesForComplianceQueryVariables>(ListHomesForComplianceDocument, options);
        }
export type ListHomesForComplianceQueryHookResult = ReturnType<typeof useListHomesForComplianceQuery>;
export type ListHomesForComplianceLazyQueryHookResult = ReturnType<typeof useListHomesForComplianceLazyQuery>;
export type ListHomesForComplianceQueryResult = Apollo.QueryResult<ListHomesForComplianceQuery, ListHomesForComplianceQueryVariables>;
export const ListLandlordHomesDocument = gql`
    query ListLandlordHomes {
  listHomes {
    id
    name
    addressLine1
    city
    postcode
    missingComplianceRequirements: complianceRequirements(status: "Missing") {
      totalCount
    }
    expiredComplianceRequirements: complianceRequirements(status: "Expired") {
      totalCount
    }
    expiringSoonComplianceRequirements: complianceRequirements(
      status: "Expiring Soon"
    ) {
      totalCount
    }
    allComplianceRequirements: complianceRequirements {
      totalCount
    }
    activeResidencies {
      id
      subscription {
        id
        upcomingInvoice {
          nextPaymentAttempt
        }
      }
    }
    images {
      edges {
        node {
          image
        }
      }
    }
  }
}
    `;

/**
 * __useListLandlordHomesQuery__
 *
 * To run a query within a React component, call `useListLandlordHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLandlordHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLandlordHomesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListLandlordHomesQuery(baseOptions?: Apollo.QueryHookOptions<ListLandlordHomesQuery, ListLandlordHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLandlordHomesQuery, ListLandlordHomesQueryVariables>(ListLandlordHomesDocument, options);
      }
export function useListLandlordHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLandlordHomesQuery, ListLandlordHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLandlordHomesQuery, ListLandlordHomesQueryVariables>(ListLandlordHomesDocument, options);
        }
export type ListLandlordHomesQueryHookResult = ReturnType<typeof useListLandlordHomesQuery>;
export type ListLandlordHomesLazyQueryHookResult = ReturnType<typeof useListLandlordHomesLazyQuery>;
export type ListLandlordHomesQueryResult = Apollo.QueryResult<ListLandlordHomesQuery, ListLandlordHomesQueryVariables>;
export const SaveHomeDocument = gql`
    mutation SaveHome($input: SaveHomeInput!) {
  saveHome(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveHomeMutationFn = Apollo.MutationFunction<SaveHomeMutation, SaveHomeMutationVariables>;

/**
 * __useSaveHomeMutation__
 *
 * To run a mutation, you first call `useSaveHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHomeMutation, { data, loading, error }] = useSaveHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHomeMutation(baseOptions?: Apollo.MutationHookOptions<SaveHomeMutation, SaveHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHomeMutation, SaveHomeMutationVariables>(SaveHomeDocument, options);
      }
export type SaveHomeMutationHookResult = ReturnType<typeof useSaveHomeMutation>;
export type SaveHomeMutationResult = Apollo.MutationResult<SaveHomeMutation>;
export type SaveHomeMutationOptions = Apollo.BaseMutationOptions<SaveHomeMutation, SaveHomeMutationVariables>;
export const SaveManagerProfileDocument = gql`
    mutation SaveManagerProfile($input: SaveManagerProfileInput!) {
  saveManagerProfile(input: $input) {
    id
    errors {
      messages
      field
    }
  }
}
    `;
export type SaveManagerProfileMutationFn = Apollo.MutationFunction<SaveManagerProfileMutation, SaveManagerProfileMutationVariables>;

/**
 * __useSaveManagerProfileMutation__
 *
 * To run a mutation, you first call `useSaveManagerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveManagerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveManagerProfileMutation, { data, loading, error }] = useSaveManagerProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveManagerProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveManagerProfileMutation, SaveManagerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveManagerProfileMutation, SaveManagerProfileMutationVariables>(SaveManagerProfileDocument, options);
      }
export type SaveManagerProfileMutationHookResult = ReturnType<typeof useSaveManagerProfileMutation>;
export type SaveManagerProfileMutationResult = Apollo.MutationResult<SaveManagerProfileMutation>;
export type SaveManagerProfileMutationOptions = Apollo.BaseMutationOptions<SaveManagerProfileMutation, SaveManagerProfileMutationVariables>;
export const SearchEpcDocument = gql`
    query SearchEpc($homeId: UUID!) {
  searchEpc(homeId: $homeId) {
    name
    city
    postcode
    expiryDate
    checkedDate
    currentEnergyRating
    potentialEnergyRating
    currentEnergyEfficiency
    potentialEnergyEfficiency
  }
}
    `;

/**
 * __useSearchEpcQuery__
 *
 * To run a query within a React component, call `useSearchEpcQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEpcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEpcQuery({
 *   variables: {
 *      homeId: // value for 'homeId'
 *   },
 * });
 */
export function useSearchEpcQuery(baseOptions: Apollo.QueryHookOptions<SearchEpcQuery, SearchEpcQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEpcQuery, SearchEpcQueryVariables>(SearchEpcDocument, options);
      }
export function useSearchEpcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEpcQuery, SearchEpcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEpcQuery, SearchEpcQueryVariables>(SearchEpcDocument, options);
        }
export type SearchEpcQueryHookResult = ReturnType<typeof useSearchEpcQuery>;
export type SearchEpcLazyQueryHookResult = ReturnType<typeof useSearchEpcLazyQuery>;
export type SearchEpcQueryResult = Apollo.QueryResult<SearchEpcQuery, SearchEpcQueryVariables>;
export const UpdateHomeDetailsDocument = gql`
    mutation UpdateHomeDetails($input: UpdateHomeDetailsInput!) {
  updateHomeDetails(input: $input) {
    id
  }
}
    `;
export type UpdateHomeDetailsMutationFn = Apollo.MutationFunction<UpdateHomeDetailsMutation, UpdateHomeDetailsMutationVariables>;

/**
 * __useUpdateHomeDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateHomeDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHomeDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHomeDetailsMutation, { data, loading, error }] = useUpdateHomeDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHomeDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHomeDetailsMutation, UpdateHomeDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHomeDetailsMutation, UpdateHomeDetailsMutationVariables>(UpdateHomeDetailsDocument, options);
      }
export type UpdateHomeDetailsMutationHookResult = ReturnType<typeof useUpdateHomeDetailsMutation>;
export type UpdateHomeDetailsMutationResult = Apollo.MutationResult<UpdateHomeDetailsMutation>;
export type UpdateHomeDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateHomeDetailsMutation, UpdateHomeDetailsMutationVariables>;
export const UpdateLandlordDocument = gql`
    mutation UpdateLandlord($input: UpdateLandlordInput!) {
  updateLandlord(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateLandlordMutationFn = Apollo.MutationFunction<UpdateLandlordMutation, UpdateLandlordMutationVariables>;

/**
 * __useUpdateLandlordMutation__
 *
 * To run a mutation, you first call `useUpdateLandlordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandlordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandlordMutation, { data, loading, error }] = useUpdateLandlordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLandlordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandlordMutation, UpdateLandlordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandlordMutation, UpdateLandlordMutationVariables>(UpdateLandlordDocument, options);
      }
export type UpdateLandlordMutationHookResult = ReturnType<typeof useUpdateLandlordMutation>;
export type UpdateLandlordMutationResult = Apollo.MutationResult<UpdateLandlordMutation>;
export type UpdateLandlordMutationOptions = Apollo.BaseMutationOptions<UpdateLandlordMutation, UpdateLandlordMutationVariables>;
export const ReferenceSignupHomesDocument = gql`
    query ReferenceSignupHomes($after: String) {
  homes(after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        addressLine1
        postcode
        city
        images(first: 1) {
          edges {
            node {
              image
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReferenceSignupHomesQuery__
 *
 * To run a query within a React component, call `useReferenceSignupHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferenceSignupHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferenceSignupHomesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReferenceSignupHomesQuery(baseOptions?: Apollo.QueryHookOptions<ReferenceSignupHomesQuery, ReferenceSignupHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferenceSignupHomesQuery, ReferenceSignupHomesQueryVariables>(ReferenceSignupHomesDocument, options);
      }
export function useReferenceSignupHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferenceSignupHomesQuery, ReferenceSignupHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferenceSignupHomesQuery, ReferenceSignupHomesQueryVariables>(ReferenceSignupHomesDocument, options);
        }
export type ReferenceSignupHomesQueryHookResult = ReturnType<typeof useReferenceSignupHomesQuery>;
export type ReferenceSignupHomesLazyQueryHookResult = ReturnType<typeof useReferenceSignupHomesLazyQuery>;
export type ReferenceSignupHomesQueryResult = Apollo.QueryResult<ReferenceSignupHomesQuery, ReferenceSignupHomesQueryVariables>;
export const UpdateReferenceStartedOnDocument = gql`
    mutation UpdateReferenceStartedOn {
  updateReferenceStartedOn(input: {}) {
    client {
      id
    }
  }
}
    `;
export type UpdateReferenceStartedOnMutationFn = Apollo.MutationFunction<UpdateReferenceStartedOnMutation, UpdateReferenceStartedOnMutationVariables>;

/**
 * __useUpdateReferenceStartedOnMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceStartedOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceStartedOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceStartedOnMutation, { data, loading, error }] = useUpdateReferenceStartedOnMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateReferenceStartedOnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceStartedOnMutation, UpdateReferenceStartedOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceStartedOnMutation, UpdateReferenceStartedOnMutationVariables>(UpdateReferenceStartedOnDocument, options);
      }
export type UpdateReferenceStartedOnMutationHookResult = ReturnType<typeof useUpdateReferenceStartedOnMutation>;
export type UpdateReferenceStartedOnMutationResult = Apollo.MutationResult<UpdateReferenceStartedOnMutation>;
export type UpdateReferenceStartedOnMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceStartedOnMutation, UpdateReferenceStartedOnMutationVariables>;
export const ReferenceSignupCreateTenancyApplicationDocument = gql`
    mutation ReferenceSignupCreateTenancyApplication($input: CreateTenancyApplicationInput!) {
  createTenancyApplication(input: $input) {
    tenancyApplication {
      id
      references {
        id
      }
      applicants {
        edges {
          node {
            id
            firstName
            lastName
            reference {
              id
              isPaid
              sentAt
            }
          }
        }
      }
    }
  }
}
    `;
export type ReferenceSignupCreateTenancyApplicationMutationFn = Apollo.MutationFunction<ReferenceSignupCreateTenancyApplicationMutation, ReferenceSignupCreateTenancyApplicationMutationVariables>;

/**
 * __useReferenceSignupCreateTenancyApplicationMutation__
 *
 * To run a mutation, you first call `useReferenceSignupCreateTenancyApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReferenceSignupCreateTenancyApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceSignupCreateTenancyApplicationMutation, { data, loading, error }] = useReferenceSignupCreateTenancyApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReferenceSignupCreateTenancyApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ReferenceSignupCreateTenancyApplicationMutation, ReferenceSignupCreateTenancyApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReferenceSignupCreateTenancyApplicationMutation, ReferenceSignupCreateTenancyApplicationMutationVariables>(ReferenceSignupCreateTenancyApplicationDocument, options);
      }
export type ReferenceSignupCreateTenancyApplicationMutationHookResult = ReturnType<typeof useReferenceSignupCreateTenancyApplicationMutation>;
export type ReferenceSignupCreateTenancyApplicationMutationResult = Apollo.MutationResult<ReferenceSignupCreateTenancyApplicationMutation>;
export type ReferenceSignupCreateTenancyApplicationMutationOptions = Apollo.BaseMutationOptions<ReferenceSignupCreateTenancyApplicationMutation, ReferenceSignupCreateTenancyApplicationMutationVariables>;
export const CountersignAgreementDocument = gql`
    mutation CountersignAgreement($input: CountersignAgreementInput!) {
  countersignAgreement(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type CountersignAgreementMutationFn = Apollo.MutationFunction<CountersignAgreementMutation, CountersignAgreementMutationVariables>;

/**
 * __useCountersignAgreementMutation__
 *
 * To run a mutation, you first call `useCountersignAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountersignAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countersignAgreementMutation, { data, loading, error }] = useCountersignAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCountersignAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CountersignAgreementMutation, CountersignAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CountersignAgreementMutation, CountersignAgreementMutationVariables>(CountersignAgreementDocument, options);
      }
export type CountersignAgreementMutationHookResult = ReturnType<typeof useCountersignAgreementMutation>;
export type CountersignAgreementMutationResult = Apollo.MutationResult<CountersignAgreementMutation>;
export type CountersignAgreementMutationOptions = Apollo.BaseMutationOptions<CountersignAgreementMutation, CountersignAgreementMutationVariables>;
export const FindSignatureDocument = gql`
    query FindSignature($id: UUID!) {
  signature(id: $id) {
    id
    status
    agreement {
      id
      file
    }
  }
}
    `;

/**
 * __useFindSignatureQuery__
 *
 * To run a query within a React component, call `useFindSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSignatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindSignatureQuery(baseOptions: Apollo.QueryHookOptions<FindSignatureQuery, FindSignatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSignatureQuery, FindSignatureQueryVariables>(FindSignatureDocument, options);
      }
export function useFindSignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSignatureQuery, FindSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSignatureQuery, FindSignatureQueryVariables>(FindSignatureDocument, options);
        }
export type FindSignatureQueryHookResult = ReturnType<typeof useFindSignatureQuery>;
export type FindSignatureLazyQueryHookResult = ReturnType<typeof useFindSignatureLazyQuery>;
export type FindSignatureQueryResult = Apollo.QueryResult<FindSignatureQuery, FindSignatureQueryVariables>;
export const LandlordTenancyApplicationsDocument = gql`
    query LandlordTenancyApplications {
  tenancyApplications(hasBeenSent: true) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        id
        home {
          name
        }
        rentAmount
        combinedAffordability
        affordabilityStatus
        status
        applicants {
          edges {
            node {
              ...TenantApplicant
            }
          }
        }
      }
    }
  }
}
    ${TenantApplicantFragmentDoc}`;

/**
 * __useLandlordTenancyApplicationsQuery__
 *
 * To run a query within a React component, call `useLandlordTenancyApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordTenancyApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordTenancyApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandlordTenancyApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<LandlordTenancyApplicationsQuery, LandlordTenancyApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordTenancyApplicationsQuery, LandlordTenancyApplicationsQueryVariables>(LandlordTenancyApplicationsDocument, options);
      }
export function useLandlordTenancyApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordTenancyApplicationsQuery, LandlordTenancyApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordTenancyApplicationsQuery, LandlordTenancyApplicationsQueryVariables>(LandlordTenancyApplicationsDocument, options);
        }
export type LandlordTenancyApplicationsQueryHookResult = ReturnType<typeof useLandlordTenancyApplicationsQuery>;
export type LandlordTenancyApplicationsLazyQueryHookResult = ReturnType<typeof useLandlordTenancyApplicationsLazyQuery>;
export type LandlordTenancyApplicationsQueryResult = Apollo.QueryResult<LandlordTenancyApplicationsQuery, LandlordTenancyApplicationsQueryVariables>;
export const AmenityAvailabilityDocument = gql`
    query AmenityAvailability($id: UUID!, $date: Date) {
  amenity(id: $id) {
    id
    daysAvailable
    startTime
    endTime
    reservations(date: $date, cancelled: false) {
      edges {
        node {
          id
          start
          end
        }
      }
    }
  }
}
    `;

/**
 * __useAmenityAvailabilityQuery__
 *
 * To run a query within a React component, call `useAmenityAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAmenityAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>(AmenityAvailabilityDocument, options);
      }
export function useAmenityAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>(AmenityAvailabilityDocument, options);
        }
export type AmenityAvailabilityQueryHookResult = ReturnType<typeof useAmenityAvailabilityQuery>;
export type AmenityAvailabilityLazyQueryHookResult = ReturnType<typeof useAmenityAvailabilityLazyQuery>;
export type AmenityAvailabilityQueryResult = Apollo.QueryResult<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>;
export const ManagerReserveAmenityDocument = gql`
    mutation ManagerReserveAmenity($input: ManagerReserveAmenityInput!) {
  managerReserveAmenity(input: $input) {
    amenityReservation {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ManagerReserveAmenityMutationFn = Apollo.MutationFunction<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>;

/**
 * __useManagerReserveAmenityMutation__
 *
 * To run a mutation, you first call `useManagerReserveAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerReserveAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerReserveAmenityMutation, { data, loading, error }] = useManagerReserveAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManagerReserveAmenityMutation(baseOptions?: Apollo.MutationHookOptions<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>(ManagerReserveAmenityDocument, options);
      }
export type ManagerReserveAmenityMutationHookResult = ReturnType<typeof useManagerReserveAmenityMutation>;
export type ManagerReserveAmenityMutationResult = Apollo.MutationResult<ManagerReserveAmenityMutation>;
export type ManagerReserveAmenityMutationOptions = Apollo.BaseMutationOptions<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>;
export const AmenityReservationDocument = gql`
    query AmenityReservation($id: UUID!) {
  amenityReservation(id: $id) {
    id
    start
    end
    cancellationMessage
    user {
      id
      name
    }
  }
}
    `;

/**
 * __useAmenityReservationQuery__
 *
 * To run a query within a React component, call `useAmenityReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityReservationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmenityReservationQuery(baseOptions: Apollo.QueryHookOptions<AmenityReservationQuery, AmenityReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityReservationQuery, AmenityReservationQueryVariables>(AmenityReservationDocument, options);
      }
export function useAmenityReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityReservationQuery, AmenityReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityReservationQuery, AmenityReservationQueryVariables>(AmenityReservationDocument, options);
        }
export type AmenityReservationQueryHookResult = ReturnType<typeof useAmenityReservationQuery>;
export type AmenityReservationLazyQueryHookResult = ReturnType<typeof useAmenityReservationLazyQuery>;
export type AmenityReservationQueryResult = Apollo.QueryResult<AmenityReservationQuery, AmenityReservationQueryVariables>;
export const ManagerCancelAmenityReservationDocument = gql`
    mutation ManagerCancelAmenityReservation($input: ManagerCancelAmenityReservationInput!) {
  managerCancelAmenityReservation(input: $input) {
    amenityReservation {
      id
      cancellationMessage
    }
  }
}
    `;
export type ManagerCancelAmenityReservationMutationFn = Apollo.MutationFunction<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>;

/**
 * __useManagerCancelAmenityReservationMutation__
 *
 * To run a mutation, you first call `useManagerCancelAmenityReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerCancelAmenityReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerCancelAmenityReservationMutation, { data, loading, error }] = useManagerCancelAmenityReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManagerCancelAmenityReservationMutation(baseOptions?: Apollo.MutationHookOptions<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>(ManagerCancelAmenityReservationDocument, options);
      }
export type ManagerCancelAmenityReservationMutationHookResult = ReturnType<typeof useManagerCancelAmenityReservationMutation>;
export type ManagerCancelAmenityReservationMutationResult = Apollo.MutationResult<ManagerCancelAmenityReservationMutation>;
export type ManagerCancelAmenityReservationMutationOptions = Apollo.BaseMutationOptions<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>;
export const AmenityReservationsDocument = gql`
    query AmenityReservations($amenity: UUID!, $fromDate: Date, $toDate: Date, $after: String) {
  amenityReservations(
    amenity: $amenity
    fromDate: $fromDate
    toDate: $toDate
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...AmenityReservationItem
      }
    }
  }
}
    ${AmenityReservationItemFragmentDoc}`;

/**
 * __useAmenityReservationsQuery__
 *
 * To run a query within a React component, call `useAmenityReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityReservationsQuery({
 *   variables: {
 *      amenity: // value for 'amenity'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAmenityReservationsQuery(baseOptions: Apollo.QueryHookOptions<AmenityReservationsQuery, AmenityReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityReservationsQuery, AmenityReservationsQueryVariables>(AmenityReservationsDocument, options);
      }
export function useAmenityReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityReservationsQuery, AmenityReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityReservationsQuery, AmenityReservationsQueryVariables>(AmenityReservationsDocument, options);
        }
export type AmenityReservationsQueryHookResult = ReturnType<typeof useAmenityReservationsQuery>;
export type AmenityReservationsLazyQueryHookResult = ReturnType<typeof useAmenityReservationsLazyQuery>;
export type AmenityReservationsQueryResult = Apollo.QueryResult<AmenityReservationsQuery, AmenityReservationsQueryVariables>;
export const AmenityDocument = gql`
    query Amenity($id: UUID!) {
  amenity(id: $id) {
    id
    name
    startTime
    endTime
    daysAvailable
    description
    image
    reservable
    status
    live
    maxHours
    maxCapacity
    maxAdvanceReservationDays
    groups {
      edges {
        node {
          id
          name
          community {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAmenityQuery__
 *
 * To run a query within a React component, call `useAmenityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmenityQuery(baseOptions: Apollo.QueryHookOptions<AmenityQuery, AmenityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityQuery, AmenityQueryVariables>(AmenityDocument, options);
      }
export function useAmenityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityQuery, AmenityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityQuery, AmenityQueryVariables>(AmenityDocument, options);
        }
export type AmenityQueryHookResult = ReturnType<typeof useAmenityQuery>;
export type AmenityLazyQueryHookResult = ReturnType<typeof useAmenityLazyQuery>;
export type AmenityQueryResult = Apollo.QueryResult<AmenityQuery, AmenityQueryVariables>;
export const DeleteAmenityDocument = gql`
    mutation DeleteAmenity($input: DeleteAmenityInput!) {
  deleteAmenity(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteAmenityMutationFn = Apollo.MutationFunction<DeleteAmenityMutation, DeleteAmenityMutationVariables>;

/**
 * __useDeleteAmenityMutation__
 *
 * To run a mutation, you first call `useDeleteAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAmenityMutation, { data, loading, error }] = useDeleteAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAmenityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAmenityMutation, DeleteAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAmenityMutation, DeleteAmenityMutationVariables>(DeleteAmenityDocument, options);
      }
export type DeleteAmenityMutationHookResult = ReturnType<typeof useDeleteAmenityMutation>;
export type DeleteAmenityMutationResult = Apollo.MutationResult<DeleteAmenityMutation>;
export type DeleteAmenityMutationOptions = Apollo.BaseMutationOptions<DeleteAmenityMutation, DeleteAmenityMutationVariables>;
export const SaveAmenityDocument = gql`
    mutation SaveAmenity($input: SaveAmenityInput!) {
  saveAmenity(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveAmenityMutationFn = Apollo.MutationFunction<SaveAmenityMutation, SaveAmenityMutationVariables>;

/**
 * __useSaveAmenityMutation__
 *
 * To run a mutation, you first call `useSaveAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAmenityMutation, { data, loading, error }] = useSaveAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAmenityMutation(baseOptions?: Apollo.MutationHookOptions<SaveAmenityMutation, SaveAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAmenityMutation, SaveAmenityMutationVariables>(SaveAmenityDocument, options);
      }
export type SaveAmenityMutationHookResult = ReturnType<typeof useSaveAmenityMutation>;
export type SaveAmenityMutationResult = Apollo.MutationResult<SaveAmenityMutation>;
export type SaveAmenityMutationOptions = Apollo.BaseMutationOptions<SaveAmenityMutation, SaveAmenityMutationVariables>;
export const AmenitiesDocument = gql`
    query Amenities($communities: [ID!], $after: String) {
  amenities(communities: $communities, after: $after) {
    edges {
      node {
        ...AmenityItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${AmenityItemFragmentDoc}`;

/**
 * __useAmenitiesQuery__
 *
 * To run a query within a React component, call `useAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenitiesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAmenitiesQuery(baseOptions?: Apollo.QueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
      }
export function useAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
        }
export type AmenitiesQueryHookResult = ReturnType<typeof useAmenitiesQuery>;
export type AmenitiesLazyQueryHookResult = ReturnType<typeof useAmenitiesLazyQuery>;
export type AmenitiesQueryResult = Apollo.QueryResult<AmenitiesQuery, AmenitiesQueryVariables>;
export const AcceptApplicationDocument = gql`
    mutation AcceptApplication($application: UUID!, $home: UUID) {
  acceptApplication(application: $application, home: $home) {
    application {
      id
      status
      approvedAt
    }
  }
}
    `;
export type AcceptApplicationMutationFn = Apollo.MutationFunction<AcceptApplicationMutation, AcceptApplicationMutationVariables>;

/**
 * __useAcceptApplicationMutation__
 *
 * To run a mutation, you first call `useAcceptApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptApplicationMutation, { data, loading, error }] = useAcceptApplicationMutation({
 *   variables: {
 *      application: // value for 'application'
 *      home: // value for 'home'
 *   },
 * });
 */
export function useAcceptApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptApplicationMutation, AcceptApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptApplicationMutation, AcceptApplicationMutationVariables>(AcceptApplicationDocument, options);
      }
export type AcceptApplicationMutationHookResult = ReturnType<typeof useAcceptApplicationMutation>;
export type AcceptApplicationMutationResult = Apollo.MutationResult<AcceptApplicationMutation>;
export type AcceptApplicationMutationOptions = Apollo.BaseMutationOptions<AcceptApplicationMutation, AcceptApplicationMutationVariables>;
export const RejectApplicationDocument = gql`
    mutation RejectApplication($application: UUID!, $rejectionReason: String!) {
  rejectApplication(application: $application, rejectionReason: $rejectionReason) {
    application {
      id
      status
      lastRejectionReason
    }
  }
}
    `;
export type RejectApplicationMutationFn = Apollo.MutationFunction<RejectApplicationMutation, RejectApplicationMutationVariables>;

/**
 * __useRejectApplicationMutation__
 *
 * To run a mutation, you first call `useRejectApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectApplicationMutation, { data, loading, error }] = useRejectApplicationMutation({
 *   variables: {
 *      application: // value for 'application'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useRejectApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RejectApplicationMutation, RejectApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectApplicationMutation, RejectApplicationMutationVariables>(RejectApplicationDocument, options);
      }
export type RejectApplicationMutationHookResult = ReturnType<typeof useRejectApplicationMutation>;
export type RejectApplicationMutationResult = Apollo.MutationResult<RejectApplicationMutation>;
export type RejectApplicationMutationOptions = Apollo.BaseMutationOptions<RejectApplicationMutation, RejectApplicationMutationVariables>;
export const RemindApplicantDocument = gql`
    mutation RemindApplicant($application: UUID!) {
  remindApplicant(application: $application) {
    application {
      id
    }
  }
}
    `;
export type RemindApplicantMutationFn = Apollo.MutationFunction<RemindApplicantMutation, RemindApplicantMutationVariables>;

/**
 * __useRemindApplicantMutation__
 *
 * To run a mutation, you first call `useRemindApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindApplicantMutation, { data, loading, error }] = useRemindApplicantMutation({
 *   variables: {
 *      application: // value for 'application'
 *   },
 * });
 */
export function useRemindApplicantMutation(baseOptions?: Apollo.MutationHookOptions<RemindApplicantMutation, RemindApplicantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemindApplicantMutation, RemindApplicantMutationVariables>(RemindApplicantDocument, options);
      }
export type RemindApplicantMutationHookResult = ReturnType<typeof useRemindApplicantMutation>;
export type RemindApplicantMutationResult = Apollo.MutationResult<RemindApplicantMutation>;
export type RemindApplicantMutationOptions = Apollo.BaseMutationOptions<RemindApplicantMutation, RemindApplicantMutationVariables>;
export const ManagerAddApplicationHomeDocument = gql`
    mutation ManagerAddApplicationHome($input: ManagerAddApplicationHomeInput!) {
  managerAddApplicationHome(input: $input) {
    application {
      id
      home {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ManagerAddApplicationHomeMutationFn = Apollo.MutationFunction<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>;

/**
 * __useManagerAddApplicationHomeMutation__
 *
 * To run a mutation, you first call `useManagerAddApplicationHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerAddApplicationHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerAddApplicationHomeMutation, { data, loading, error }] = useManagerAddApplicationHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManagerAddApplicationHomeMutation(baseOptions?: Apollo.MutationHookOptions<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>(ManagerAddApplicationHomeDocument, options);
      }
export type ManagerAddApplicationHomeMutationHookResult = ReturnType<typeof useManagerAddApplicationHomeMutation>;
export type ManagerAddApplicationHomeMutationResult = Apollo.MutationResult<ManagerAddApplicationHomeMutation>;
export type ManagerAddApplicationHomeMutationOptions = Apollo.BaseMutationOptions<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>;
export const SearchHomesDocument = gql`
    query SearchHomes($communityId: UUID, $postcode: String) {
  listHomes(communityId: $communityId, postcode: $postcode) {
    id
    name
    addressLine1
  }
}
    `;

/**
 * __useSearchHomesQuery__
 *
 * To run a query within a React component, call `useSearchHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchHomesQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useSearchHomesQuery(baseOptions?: Apollo.QueryHookOptions<SearchHomesQuery, SearchHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchHomesQuery, SearchHomesQueryVariables>(SearchHomesDocument, options);
      }
export function useSearchHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchHomesQuery, SearchHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchHomesQuery, SearchHomesQueryVariables>(SearchHomesDocument, options);
        }
export type SearchHomesQueryHookResult = ReturnType<typeof useSearchHomesQuery>;
export type SearchHomesLazyQueryHookResult = ReturnType<typeof useSearchHomesLazyQuery>;
export type SearchHomesQueryResult = Apollo.QueryResult<SearchHomesQuery, SearchHomesQueryVariables>;
export const ApplicationDocument = gql`
    query Application($id: UUID!, $after: String) {
  application(id: $id) {
    ...Application
  }
}
    ${ApplicationFragmentDoc}`;

/**
 * __useApplicationQuery__
 *
 * To run a query within a React component, call `useApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useApplicationQuery(baseOptions: Apollo.QueryHookOptions<ApplicationQuery, ApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationQuery, ApplicationQueryVariables>(ApplicationDocument, options);
      }
export function useApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationQuery, ApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationQuery, ApplicationQueryVariables>(ApplicationDocument, options);
        }
export type ApplicationQueryHookResult = ReturnType<typeof useApplicationQuery>;
export type ApplicationLazyQueryHookResult = ReturnType<typeof useApplicationLazyQuery>;
export type ApplicationQueryResult = Apollo.QueryResult<ApplicationQuery, ApplicationQueryVariables>;
export const ArchiveApplicationDocument = gql`
    mutation ArchiveApplication($input: ArchiveApplicationInput!) {
  archiveApplication(input: $input) {
    application {
      id
      status
      archivedAt
    }
  }
}
    `;
export type ArchiveApplicationMutationFn = Apollo.MutationFunction<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>;

/**
 * __useArchiveApplicationMutation__
 *
 * To run a mutation, you first call `useArchiveApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveApplicationMutation, { data, loading, error }] = useArchiveApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>(ArchiveApplicationDocument, options);
      }
export type ArchiveApplicationMutationHookResult = ReturnType<typeof useArchiveApplicationMutation>;
export type ArchiveApplicationMutationResult = Apollo.MutationResult<ArchiveApplicationMutation>;
export type ArchiveApplicationMutationOptions = Apollo.BaseMutationOptions<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>;
export const UnarchiveApplicationDocument = gql`
    mutation UnarchiveApplication($input: UnarchiveApplicationInput!) {
  unarchiveApplication(input: $input) {
    application {
      id
      status
      archivedAt
    }
  }
}
    `;
export type UnarchiveApplicationMutationFn = Apollo.MutationFunction<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>;

/**
 * __useUnarchiveApplicationMutation__
 *
 * To run a mutation, you first call `useUnarchiveApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveApplicationMutation, { data, loading, error }] = useUnarchiveApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>(UnarchiveApplicationDocument, options);
      }
export type UnarchiveApplicationMutationHookResult = ReturnType<typeof useUnarchiveApplicationMutation>;
export type UnarchiveApplicationMutationResult = Apollo.MutationResult<UnarchiveApplicationMutation>;
export type UnarchiveApplicationMutationOptions = Apollo.BaseMutationOptions<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>;
export const ApplicationsDocument = gql`
    query Applications($after: String, $communities: [ID], $search: String, $orderBy: String, $status: [String]) {
  applications(
    after: $after
    communities: $communities
    search: $search
    orderBy: $orderBy
    status: $status
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ApplicationItem
      }
    }
  }
}
    ${ApplicationItemFragmentDoc}`;

/**
 * __useApplicationsQuery__
 *
 * To run a query within a React component, call `useApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
      }
export function useApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
        }
export type ApplicationsQueryHookResult = ReturnType<typeof useApplicationsQuery>;
export type ApplicationsLazyQueryHookResult = ReturnType<typeof useApplicationsLazyQuery>;
export type ApplicationsQueryResult = Apollo.QueryResult<ApplicationsQuery, ApplicationsQueryVariables>;
export const RemindAllApplicantsDocument = gql`
    mutation RemindAllApplicants($communities: [UUID]!) {
  remindAllApplicants(communities: $communities) {
    ok
  }
}
    `;
export type RemindAllApplicantsMutationFn = Apollo.MutationFunction<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>;

/**
 * __useRemindAllApplicantsMutation__
 *
 * To run a mutation, you first call `useRemindAllApplicantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindAllApplicantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindAllApplicantsMutation, { data, loading, error }] = useRemindAllApplicantsMutation({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useRemindAllApplicantsMutation(baseOptions?: Apollo.MutationHookOptions<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>(RemindAllApplicantsDocument, options);
      }
export type RemindAllApplicantsMutationHookResult = ReturnType<typeof useRemindAllApplicantsMutation>;
export type RemindAllApplicantsMutationResult = Apollo.MutationResult<RemindAllApplicantsMutation>;
export type RemindAllApplicantsMutationOptions = Apollo.BaseMutationOptions<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>;
export const BlocksDocument = gql`
    query Blocks($communities: [ID!], $after: String, $search: String) {
  blocks(
    communities: $communities
    after: $after
    search: $search
    orderBy: "name"
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...BlockItem
      }
    }
  }
}
    ${BlockItemFragmentDoc}`;

/**
 * __useBlocksQuery__
 *
 * To run a query within a React component, call `useBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBlocksQuery(baseOptions?: Apollo.QueryHookOptions<BlocksQuery, BlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlocksQuery, BlocksQueryVariables>(BlocksDocument, options);
      }
export function useBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlocksQuery, BlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlocksQuery, BlocksQueryVariables>(BlocksDocument, options);
        }
export type BlocksQueryHookResult = ReturnType<typeof useBlocksQuery>;
export type BlocksLazyQueryHookResult = ReturnType<typeof useBlocksLazyQuery>;
export type BlocksQueryResult = Apollo.QueryResult<BlocksQuery, BlocksQueryVariables>;
export const CommunityHeaderDocument = gql`
    query CommunityHeader($id: UUID!) {
  community(id: $id) {
    id
    avatar
    name
    status
    postcode
  }
}
    `;

/**
 * __useCommunityHeaderQuery__
 *
 * To run a query within a React component, call `useCommunityHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityHeaderQuery(baseOptions: Apollo.QueryHookOptions<CommunityHeaderQuery, CommunityHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityHeaderQuery, CommunityHeaderQueryVariables>(CommunityHeaderDocument, options);
      }
export function useCommunityHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityHeaderQuery, CommunityHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityHeaderQuery, CommunityHeaderQueryVariables>(CommunityHeaderDocument, options);
        }
export type CommunityHeaderQueryHookResult = ReturnType<typeof useCommunityHeaderQuery>;
export type CommunityHeaderLazyQueryHookResult = ReturnType<typeof useCommunityHeaderLazyQuery>;
export type CommunityHeaderQueryResult = Apollo.QueryResult<CommunityHeaderQuery, CommunityHeaderQueryVariables>;
export const CommunitySettingsDocument = gql`
    query CommunitySettings($id: UUID!) {
  community(id: $id) {
    id
    settings {
      ...CommunitySettings
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;

/**
 * __useCommunitySettingsQuery__
 *
 * To run a query within a React component, call `useCommunitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunitySettingsQuery(baseOptions: Apollo.QueryHookOptions<CommunitySettingsQuery, CommunitySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitySettingsQuery, CommunitySettingsQueryVariables>(CommunitySettingsDocument, options);
      }
export function useCommunitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySettingsQuery, CommunitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitySettingsQuery, CommunitySettingsQueryVariables>(CommunitySettingsDocument, options);
        }
export type CommunitySettingsQueryHookResult = ReturnType<typeof useCommunitySettingsQuery>;
export type CommunitySettingsLazyQueryHookResult = ReturnType<typeof useCommunitySettingsLazyQuery>;
export type CommunitySettingsQueryResult = Apollo.QueryResult<CommunitySettingsQuery, CommunitySettingsQueryVariables>;
export const CommunitySettingsDialogDocument = gql`
    query CommunitySettingsDialog($id: UUID!) {
  community(id: $id) {
    id
    name
    status
    deactivatedOn
    avatar
    commentsEnabled
    communityChatEnabled
    marketplaceEnabled
    paymentsEnabled
    officeHoursEnabled
    outOfOfficeMessage
    openPeriods {
      ...CommunityOpenPeriod
    }
  }
}
    ${CommunityOpenPeriodFragmentDoc}`;

/**
 * __useCommunitySettingsDialogQuery__
 *
 * To run a query within a React component, call `useCommunitySettingsDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySettingsDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySettingsDialogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunitySettingsDialogQuery(baseOptions: Apollo.QueryHookOptions<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>(CommunitySettingsDialogDocument, options);
      }
export function useCommunitySettingsDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>(CommunitySettingsDialogDocument, options);
        }
export type CommunitySettingsDialogQueryHookResult = ReturnType<typeof useCommunitySettingsDialogQuery>;
export type CommunitySettingsDialogLazyQueryHookResult = ReturnType<typeof useCommunitySettingsDialogLazyQuery>;
export type CommunitySettingsDialogQueryResult = Apollo.QueryResult<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>;
export const UpdateCommunitySettingsDocument = gql`
    mutation UpdateCommunitySettings($input: UpdateCommunitySettingsInput!) {
  updateCommunitySettings(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateCommunitySettingsMutationFn = Apollo.MutationFunction<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>;

/**
 * __useUpdateCommunitySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCommunitySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunitySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunitySettingsMutation, { data, loading, error }] = useUpdateCommunitySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunitySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>(UpdateCommunitySettingsDocument, options);
      }
export type UpdateCommunitySettingsMutationHookResult = ReturnType<typeof useUpdateCommunitySettingsMutation>;
export type UpdateCommunitySettingsMutationResult = Apollo.MutationResult<UpdateCommunitySettingsMutation>;
export type UpdateCommunitySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>;
export const CommunityStatsDocument = gql`
    query CommunityStats($id: UUID!) {
  community(id: $id) {
    id
    engagementScore
    satisfactionScore
    downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
      id
      value
    }
    downloadRateDifference: statisticDifference(
      statisticType: DOWNLOAD_RATE_PERCENTAGE
    )
    engagementScoreDifference
  }
}
    `;

/**
 * __useCommunityStatsQuery__
 *
 * To run a query within a React component, call `useCommunityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityStatsQuery(baseOptions: Apollo.QueryHookOptions<CommunityStatsQuery, CommunityStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityStatsQuery, CommunityStatsQueryVariables>(CommunityStatsDocument, options);
      }
export function useCommunityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityStatsQuery, CommunityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityStatsQuery, CommunityStatsQueryVariables>(CommunityStatsDocument, options);
        }
export type CommunityStatsQueryHookResult = ReturnType<typeof useCommunityStatsQuery>;
export type CommunityStatsLazyQueryHookResult = ReturnType<typeof useCommunityStatsLazyQuery>;
export type CommunityStatsQueryResult = Apollo.QueryResult<CommunityStatsQuery, CommunityStatsQueryVariables>;
export const CommunityTeamDocument = gql`
    query CommunityTeam($id: UUID!, $after: String) {
  community(id: $id) {
    id
    name
    team(after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges {
        node {
          ...TeamMemberItem
        }
      }
    }
  }
}
    ${TeamMemberItemFragmentDoc}`;

/**
 * __useCommunityTeamQuery__
 *
 * To run a query within a React component, call `useCommunityTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityTeamQuery(baseOptions: Apollo.QueryHookOptions<CommunityTeamQuery, CommunityTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTeamQuery, CommunityTeamQueryVariables>(CommunityTeamDocument, options);
      }
export function useCommunityTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTeamQuery, CommunityTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTeamQuery, CommunityTeamQueryVariables>(CommunityTeamDocument, options);
        }
export type CommunityTeamQueryHookResult = ReturnType<typeof useCommunityTeamQuery>;
export type CommunityTeamLazyQueryHookResult = ReturnType<typeof useCommunityTeamLazyQuery>;
export type CommunityTeamQueryResult = Apollo.QueryResult<CommunityTeamQuery, CommunityTeamQueryVariables>;
export const CommunityDetailsDocument = gql`
    query CommunityDetails($id: ID!, $uuid: UUID!) {
  community(id: $uuid) {
    id
    name
    postcode
    requisiteDate
    engagementScore
    openConversationsCount
    downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
      id
      value
    }
    satisfactionScore
    homeCount
    residentCount
    communityGroups {
      totalCount
    }
    communityEvents {
      totalCount
    }
    team {
      totalCount
    }
  }
  contacts(communities: [$id]) {
    totalCount
  }
  communityUpdates(communities: [$id]) {
    totalCount
  }
  communityDocuments(communities: [$id]) {
    totalCount
  }
  amenities(communities: [$id]) {
    totalCount
  }
  surveys(communities: [$id]) {
    totalCount
  }
  applications(communities: [$id]) {
    totalCount
  }
  communityProducts(communities: [$id]) {
    totalCount
  }
  packages(communities: [$id]) {
    totalCount
  }
  keys(communities: [$id]) {
    totalCount
  }
  communityVisitors(communities: [$id]) {
    totalCount
  }
}
    `;

/**
 * __useCommunityDetailsQuery__
 *
 * To run a query within a React component, call `useCommunityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCommunityDetailsQuery(baseOptions: Apollo.QueryHookOptions<CommunityDetailsQuery, CommunityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityDetailsQuery, CommunityDetailsQueryVariables>(CommunityDetailsDocument, options);
      }
export function useCommunityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityDetailsQuery, CommunityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityDetailsQuery, CommunityDetailsQueryVariables>(CommunityDetailsDocument, options);
        }
export type CommunityDetailsQueryHookResult = ReturnType<typeof useCommunityDetailsQuery>;
export type CommunityDetailsLazyQueryHookResult = ReturnType<typeof useCommunityDetailsLazyQuery>;
export type CommunityDetailsQueryResult = Apollo.QueryResult<CommunityDetailsQuery, CommunityDetailsQueryVariables>;
export const CommunityNameDocument = gql`
    query CommunityName($id: UUID!) {
  community(id: $id) {
    id
    name
    postcode
  }
}
    `;

/**
 * __useCommunityNameQuery__
 *
 * To run a query within a React component, call `useCommunityNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityNameQuery(baseOptions: Apollo.QueryHookOptions<CommunityNameQuery, CommunityNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityNameQuery, CommunityNameQueryVariables>(CommunityNameDocument, options);
      }
export function useCommunityNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityNameQuery, CommunityNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityNameQuery, CommunityNameQueryVariables>(CommunityNameDocument, options);
        }
export type CommunityNameQueryHookResult = ReturnType<typeof useCommunityNameQuery>;
export type CommunityNameLazyQueryHookResult = ReturnType<typeof useCommunityNameLazyQuery>;
export type CommunityNameQueryResult = Apollo.QueryResult<CommunityNameQuery, CommunityNameQueryVariables>;
export const CommunitiesDocument = gql`
    query Communities($after: String, $search: String, $orderBy: String) {
  communities(
    after: $after
    search: $search
    orderBy: $orderBy
    isManager: true
    includeDeactivated: true
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        postcode
        avatar
        homeCount
        residentCount
        engagementScore
        openConversationsCount
        status
        settings {
          ...CommunitySettings
        }
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;

/**
 * __useCommunitiesQuery__
 *
 * To run a query within a React component, call `useCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
      }
export function useCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
        }
export type CommunitiesQueryHookResult = ReturnType<typeof useCommunitiesQuery>;
export type CommunitiesLazyQueryHookResult = ReturnType<typeof useCommunitiesLazyQuery>;
export type CommunitiesQueryResult = Apollo.QueryResult<CommunitiesQuery, CommunitiesQueryVariables>;
export const CommunityProductsDocument = gql`
    query CommunityProducts($active: Boolean, $communities: [ID], $after: String) {
  communityProducts(
    active: $active
    communities: $communities
    after: $after
    orderBy: "-active"
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        description
        active
        communities {
          edges {
            node {
              id
              name
            }
          }
        }
        price
      }
    }
  }
}
    `;

/**
 * __useCommunityProductsQuery__
 *
 * To run a query within a React component, call `useCommunityProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityProductsQuery({
 *   variables: {
 *      active: // value for 'active'
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityProductsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityProductsQuery, CommunityProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityProductsQuery, CommunityProductsQueryVariables>(CommunityProductsDocument, options);
      }
export function useCommunityProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityProductsQuery, CommunityProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityProductsQuery, CommunityProductsQueryVariables>(CommunityProductsDocument, options);
        }
export type CommunityProductsQueryHookResult = ReturnType<typeof useCommunityProductsQuery>;
export type CommunityProductsLazyQueryHookResult = ReturnType<typeof useCommunityProductsLazyQuery>;
export type CommunityProductsQueryResult = Apollo.QueryResult<CommunityProductsQuery, CommunityProductsQueryVariables>;
export const CreateCommunityProductDocument = gql`
    mutation CreateCommunityProduct($input: CreateCommunityProductInput!) {
  createCommunityProduct(input: $input) {
    communityProduct {
      id
      name
      description
      active
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
      price
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCommunityProductMutationFn = Apollo.MutationFunction<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>;

/**
 * __useCreateCommunityProductMutation__
 *
 * To run a mutation, you first call `useCreateCommunityProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityProductMutation, { data, loading, error }] = useCreateCommunityProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>(CreateCommunityProductDocument, options);
      }
export type CreateCommunityProductMutationHookResult = ReturnType<typeof useCreateCommunityProductMutation>;
export type CreateCommunityProductMutationResult = Apollo.MutationResult<CreateCommunityProductMutation>;
export type CreateCommunityProductMutationOptions = Apollo.BaseMutationOptions<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>;
export const DeleteCommunityProductDocument = gql`
    mutation DeleteCommunityProduct($input: DeleteCommunityProductInput!) {
  deleteCommunityProduct(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteCommunityProductMutationFn = Apollo.MutationFunction<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>;

/**
 * __useDeleteCommunityProductMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityProductMutation, { data, loading, error }] = useDeleteCommunityProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommunityProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>(DeleteCommunityProductDocument, options);
      }
export type DeleteCommunityProductMutationHookResult = ReturnType<typeof useDeleteCommunityProductMutation>;
export type DeleteCommunityProductMutationResult = Apollo.MutationResult<DeleteCommunityProductMutation>;
export type DeleteCommunityProductMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>;
export const FindCommunityProductDetailsDocument = gql`
    query FindCommunityProductDetails($id: UUID!) {
  communityProduct(id: $id) {
    id
    name
    description
    active
    communities {
      edges {
        node {
          id
          name
        }
      }
    }
    price
  }
}
    `;

/**
 * __useFindCommunityProductDetailsQuery__
 *
 * To run a query within a React component, call `useFindCommunityProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCommunityProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCommunityProductDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindCommunityProductDetailsQuery(baseOptions: Apollo.QueryHookOptions<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>(FindCommunityProductDetailsDocument, options);
      }
export function useFindCommunityProductDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>(FindCommunityProductDetailsDocument, options);
        }
export type FindCommunityProductDetailsQueryHookResult = ReturnType<typeof useFindCommunityProductDetailsQuery>;
export type FindCommunityProductDetailsLazyQueryHookResult = ReturnType<typeof useFindCommunityProductDetailsLazyQuery>;
export type FindCommunityProductDetailsQueryResult = Apollo.QueryResult<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>;
export const FindCommunityProductPurchasesDocument = gql`
    query FindCommunityProductPurchases($id: UUID!, $after: String) {
  communityProduct(id: $id) {
    purchases(after: $after, status: "SU") {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          createdAt
          user {
            firstName
            lastName
            email
          }
          address
        }
      }
    }
  }
}
    `;

/**
 * __useFindCommunityProductPurchasesQuery__
 *
 * To run a query within a React component, call `useFindCommunityProductPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCommunityProductPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCommunityProductPurchasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFindCommunityProductPurchasesQuery(baseOptions: Apollo.QueryHookOptions<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>(FindCommunityProductPurchasesDocument, options);
      }
export function useFindCommunityProductPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>(FindCommunityProductPurchasesDocument, options);
        }
export type FindCommunityProductPurchasesQueryHookResult = ReturnType<typeof useFindCommunityProductPurchasesQuery>;
export type FindCommunityProductPurchasesLazyQueryHookResult = ReturnType<typeof useFindCommunityProductPurchasesLazyQuery>;
export type FindCommunityProductPurchasesQueryResult = Apollo.QueryResult<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>;
export const UpdateCommunityProductDocument = gql`
    mutation UpdateCommunityProduct($input: UpdateCommunityProductInput!) {
  updateCommunityProduct(input: $input) {
    communityProduct {
      id
      name
      description
      active
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
      price
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateCommunityProductMutationFn = Apollo.MutationFunction<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>;

/**
 * __useUpdateCommunityProductMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityProductMutation, { data, loading, error }] = useUpdateCommunityProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>(UpdateCommunityProductDocument, options);
      }
export type UpdateCommunityProductMutationHookResult = ReturnType<typeof useUpdateCommunityProductMutation>;
export type UpdateCommunityProductMutationResult = Apollo.MutationResult<UpdateCommunityProductMutation>;
export type UpdateCommunityProductMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>;
export const ComplianceBlocksDocument = gql`
    query ComplianceBlocks($communities: [ID!], $after: String, $search: String) {
  blocks(
    communities: $communities
    after: $after
    search: $search
    orderBy: "name"
    hasRequirements: true
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ComplianceBlockItem
      }
    }
  }
}
    ${ComplianceBlockItemFragmentDoc}`;

/**
 * __useComplianceBlocksQuery__
 *
 * To run a query within a React component, call `useComplianceBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceBlocksQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useComplianceBlocksQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>(ComplianceBlocksDocument, options);
      }
export function useComplianceBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>(ComplianceBlocksDocument, options);
        }
export type ComplianceBlocksQueryHookResult = ReturnType<typeof useComplianceBlocksQuery>;
export type ComplianceBlocksLazyQueryHookResult = ReturnType<typeof useComplianceBlocksLazyQuery>;
export type ComplianceBlocksQueryResult = Apollo.QueryResult<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>;
export const CreateBlocksComplianceRequirementDocument = gql`
    mutation CreateBlocksComplianceRequirement($input: CreateBlocksComplianceRequirementInput!) {
  createBlocksComplianceRequirement(input: $input) {
    blocksComplianceRequirement {
      id
      name
      description
      blocks {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;
export type CreateBlocksComplianceRequirementMutationFn = Apollo.MutationFunction<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>;

/**
 * __useCreateBlocksComplianceRequirementMutation__
 *
 * To run a mutation, you first call `useCreateBlocksComplianceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlocksComplianceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlocksComplianceRequirementMutation, { data, loading, error }] = useCreateBlocksComplianceRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlocksComplianceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>(CreateBlocksComplianceRequirementDocument, options);
      }
export type CreateBlocksComplianceRequirementMutationHookResult = ReturnType<typeof useCreateBlocksComplianceRequirementMutation>;
export type CreateBlocksComplianceRequirementMutationResult = Apollo.MutationResult<CreateBlocksComplianceRequirementMutation>;
export type CreateBlocksComplianceRequirementMutationOptions = Apollo.BaseMutationOptions<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>;
export const BlockComplianceRequirementsDocument = gql`
    query BlockComplianceRequirements($blocks: [ID], $search: String, $after: String, $status: [String]) {
  blockComplianceRequirements(
    blocks: $blocks
    search: $search
    orderBy: "action_date"
    after: $after
    status: $status
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...BlockComplianceRequirement
      }
    }
  }
}
    ${BlockComplianceRequirementFragmentDoc}`;

/**
 * __useBlockComplianceRequirementsQuery__
 *
 * To run a query within a React component, call `useBlockComplianceRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockComplianceRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockComplianceRequirementsQuery({
 *   variables: {
 *      blocks: // value for 'blocks'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBlockComplianceRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>(BlockComplianceRequirementsDocument, options);
      }
export function useBlockComplianceRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>(BlockComplianceRequirementsDocument, options);
        }
export type BlockComplianceRequirementsQueryHookResult = ReturnType<typeof useBlockComplianceRequirementsQuery>;
export type BlockComplianceRequirementsLazyQueryHookResult = ReturnType<typeof useBlockComplianceRequirementsLazyQuery>;
export type BlockComplianceRequirementsQueryResult = Apollo.QueryResult<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>;
export const CreateBlockComplianceRequirementItemDocument = gql`
    mutation CreateBlockComplianceRequirementItem($input: CreateBlockComplianceRequirementItemInput!) {
  createBlockComplianceRequirementItem(input: $input) {
    blockComplianceRequirementItem {
      id
      blockComplianceRequirements {
        edges {
          node {
            id
            status
            item {
              id
              expiryDate
              createdAt
              attachments {
                edges {
                  node {
                    id
                    file
                    url
                    createdAt
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateBlockComplianceRequirementItemMutationFn = Apollo.MutationFunction<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>;

/**
 * __useCreateBlockComplianceRequirementItemMutation__
 *
 * To run a mutation, you first call `useCreateBlockComplianceRequirementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockComplianceRequirementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockComplianceRequirementItemMutation, { data, loading, error }] = useCreateBlockComplianceRequirementItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlockComplianceRequirementItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>(CreateBlockComplianceRequirementItemDocument, options);
      }
export type CreateBlockComplianceRequirementItemMutationHookResult = ReturnType<typeof useCreateBlockComplianceRequirementItemMutation>;
export type CreateBlockComplianceRequirementItemMutationResult = Apollo.MutationResult<CreateBlockComplianceRequirementItemMutation>;
export type CreateBlockComplianceRequirementItemMutationOptions = Apollo.BaseMutationOptions<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>;
export const RequirementItemBlocksDocument = gql`
    query RequirementItemBlocks($requirementId: UUID!) {
  blockComplianceRequirement(id: $requirementId) {
    id
    block {
      id
      name
    }
    requirement {
      id
      blockComplianceRequirements {
        edges {
          node {
            id
            block {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRequirementItemBlocksQuery__
 *
 * To run a query within a React component, call `useRequirementItemBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequirementItemBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequirementItemBlocksQuery({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *   },
 * });
 */
export function useRequirementItemBlocksQuery(baseOptions: Apollo.QueryHookOptions<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>(RequirementItemBlocksDocument, options);
      }
export function useRequirementItemBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>(RequirementItemBlocksDocument, options);
        }
export type RequirementItemBlocksQueryHookResult = ReturnType<typeof useRequirementItemBlocksQuery>;
export type RequirementItemBlocksLazyQueryHookResult = ReturnType<typeof useRequirementItemBlocksLazyQuery>;
export type RequirementItemBlocksQueryResult = Apollo.QueryResult<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>;
export const BlockComplianceRequirementDocument = gql`
    query BlockComplianceRequirement($id: UUID!) {
  blockComplianceRequirement(id: $id) {
    ...BlockComplianceRequirement
  }
}
    ${BlockComplianceRequirementFragmentDoc}`;

/**
 * __useBlockComplianceRequirementQuery__
 *
 * To run a query within a React component, call `useBlockComplianceRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockComplianceRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockComplianceRequirementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockComplianceRequirementQuery(baseOptions: Apollo.QueryHookOptions<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>(BlockComplianceRequirementDocument, options);
      }
export function useBlockComplianceRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>(BlockComplianceRequirementDocument, options);
        }
export type BlockComplianceRequirementQueryHookResult = ReturnType<typeof useBlockComplianceRequirementQuery>;
export type BlockComplianceRequirementLazyQueryHookResult = ReturnType<typeof useBlockComplianceRequirementLazyQuery>;
export type BlockComplianceRequirementQueryResult = Apollo.QueryResult<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>;
export const BlockComplianceRequirementStatusFilterDocument = gql`
    query BlockComplianceRequirementStatusFilter($blocks: [ID], $search: String, $status: [String]) {
  blockComplianceRequirements(blocks: $blocks, search: $search, status: $status) {
    totalCount
  }
}
    `;

/**
 * __useBlockComplianceRequirementStatusFilterQuery__
 *
 * To run a query within a React component, call `useBlockComplianceRequirementStatusFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockComplianceRequirementStatusFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockComplianceRequirementStatusFilterQuery({
 *   variables: {
 *      blocks: // value for 'blocks'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBlockComplianceRequirementStatusFilterQuery(baseOptions?: Apollo.QueryHookOptions<BlockComplianceRequirementStatusFilterQuery, BlockComplianceRequirementStatusFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockComplianceRequirementStatusFilterQuery, BlockComplianceRequirementStatusFilterQueryVariables>(BlockComplianceRequirementStatusFilterDocument, options);
      }
export function useBlockComplianceRequirementStatusFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockComplianceRequirementStatusFilterQuery, BlockComplianceRequirementStatusFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockComplianceRequirementStatusFilterQuery, BlockComplianceRequirementStatusFilterQueryVariables>(BlockComplianceRequirementStatusFilterDocument, options);
        }
export type BlockComplianceRequirementStatusFilterQueryHookResult = ReturnType<typeof useBlockComplianceRequirementStatusFilterQuery>;
export type BlockComplianceRequirementStatusFilterLazyQueryHookResult = ReturnType<typeof useBlockComplianceRequirementStatusFilterLazyQuery>;
export type BlockComplianceRequirementStatusFilterQueryResult = Apollo.QueryResult<BlockComplianceRequirementStatusFilterQuery, BlockComplianceRequirementStatusFilterQueryVariables>;
export const ContactConversationsDocument = gql`
    query ContactConversations($contact: UUID!, $after: String) {
  conversations(contact: $contact, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        subject
        latestEvent {
          ... on ConversationMessageType {
            id
            createdAt
          }
          ... on ConversationMediaType {
            id
            createdAt
          }
          ... on ConversationActionModelType {
            id
            createdAt
          }
        }
        closedAt
        snoozedUntil
      }
    }
  }
}
    `;

/**
 * __useContactConversationsQuery__
 *
 * To run a query within a React component, call `useContactConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactConversationsQuery({
 *   variables: {
 *      contact: // value for 'contact'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactConversationsQuery(baseOptions: Apollo.QueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactConversationsQuery, ContactConversationsQueryVariables>(ContactConversationsDocument, options);
      }
export function useContactConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactConversationsQuery, ContactConversationsQueryVariables>(ContactConversationsDocument, options);
        }
export type ContactConversationsQueryHookResult = ReturnType<typeof useContactConversationsQuery>;
export type ContactConversationsLazyQueryHookResult = ReturnType<typeof useContactConversationsLazyQuery>;
export type ContactConversationsQueryResult = Apollo.QueryResult<ContactConversationsQuery, ContactConversationsQueryVariables>;
export const ContactProfileHeaderDetailsDocument = gql`
    query ContactProfileHeaderDetails($id: UUID!) {
  contact(id: $id) {
    id
    firstName
    lastName
    email
    name
    mobile
    lastAppUse
    resident {
      id
      avatar
      averageScore
      currentResidencies {
        id
        startDate
        home {
          id
          address
          community {
            id
            name
          }
        }
      }
    }
    leaseholder {
      id
      leaseholds {
        edges {
          node {
            id
            createdAt
            home {
              id
              address
              community {
                id
                name
              }
            }
          }
        }
      }
    }
    applicant {
      id
      applications {
        edges {
          node {
            ...ContactApplicationItem
          }
        }
      }
    }
    communityGroups {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...CommunityGroupItem
        }
      }
    }
  }
}
    ${ContactApplicationItemFragmentDoc}
${CommunityGroupItemFragmentDoc}`;

/**
 * __useContactProfileHeaderDetailsQuery__
 *
 * To run a query within a React component, call `useContactProfileHeaderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactProfileHeaderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactProfileHeaderDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactProfileHeaderDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>(ContactProfileHeaderDetailsDocument, options);
      }
export function useContactProfileHeaderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>(ContactProfileHeaderDetailsDocument, options);
        }
export type ContactProfileHeaderDetailsQueryHookResult = ReturnType<typeof useContactProfileHeaderDetailsQuery>;
export type ContactProfileHeaderDetailsLazyQueryHookResult = ReturnType<typeof useContactProfileHeaderDetailsLazyQuery>;
export type ContactProfileHeaderDetailsQueryResult = Apollo.QueryResult<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>;
export const ListContactProfilesDocument = gql`
    query ListContactProfiles($communities: [ID], $after: String, $search: String, $downloaded: Boolean, $orderBy: String) {
  contacts(
    communities: $communities
    after: $after
    search: $search
    downloaded: $downloaded
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...ContactPageListItem
      }
    }
  }
}
    ${ContactPageListItemFragmentDoc}`;

/**
 * __useListContactProfilesQuery__
 *
 * To run a query within a React component, call `useListContactProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactProfilesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      downloaded: // value for 'downloaded'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListContactProfilesQuery(baseOptions?: Apollo.QueryHookOptions<ListContactProfilesQuery, ListContactProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContactProfilesQuery, ListContactProfilesQueryVariables>(ListContactProfilesDocument, options);
      }
export function useListContactProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContactProfilesQuery, ListContactProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContactProfilesQuery, ListContactProfilesQueryVariables>(ListContactProfilesDocument, options);
        }
export type ListContactProfilesQueryHookResult = ReturnType<typeof useListContactProfilesQuery>;
export type ListContactProfilesLazyQueryHookResult = ReturnType<typeof useListContactProfilesLazyQuery>;
export type ListContactProfilesQueryResult = Apollo.QueryResult<ListContactProfilesQuery, ListContactProfilesQueryVariables>;
export const NewContactConversationDocument = gql`
    query NewContactConversation($id: UUID!, $contact: UUID!) {
  contact(id: $id) {
    id
    email
    name
  }
  homes(contact: $contact) {
    edges {
      node {
        id
        name
        addressLine1
        community {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useNewContactConversationQuery__
 *
 * To run a query within a React component, call `useNewContactConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewContactConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewContactConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useNewContactConversationQuery(baseOptions: Apollo.QueryHookOptions<NewContactConversationQuery, NewContactConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewContactConversationQuery, NewContactConversationQueryVariables>(NewContactConversationDocument, options);
      }
export function useNewContactConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewContactConversationQuery, NewContactConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewContactConversationQuery, NewContactConversationQueryVariables>(NewContactConversationDocument, options);
        }
export type NewContactConversationQueryHookResult = ReturnType<typeof useNewContactConversationQuery>;
export type NewContactConversationLazyQueryHookResult = ReturnType<typeof useNewContactConversationLazyQuery>;
export type NewContactConversationQueryResult = Apollo.QueryResult<NewContactConversationQuery, NewContactConversationQueryVariables>;
export const CommunityStatusDocument = gql`
    query CommunityStatus($id: UUID!) {
  community(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useCommunityStatusQuery__
 *
 * To run a query within a React component, call `useCommunityStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityStatusQuery(baseOptions: Apollo.QueryHookOptions<CommunityStatusQuery, CommunityStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityStatusQuery, CommunityStatusQueryVariables>(CommunityStatusDocument, options);
      }
export function useCommunityStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityStatusQuery, CommunityStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityStatusQuery, CommunityStatusQueryVariables>(CommunityStatusDocument, options);
        }
export type CommunityStatusQueryHookResult = ReturnType<typeof useCommunityStatusQuery>;
export type CommunityStatusLazyQueryHookResult = ReturnType<typeof useCommunityStatusLazyQuery>;
export type CommunityStatusQueryResult = Apollo.QueryResult<CommunityStatusQuery, CommunityStatusQueryVariables>;
export const ListHomesToMessageDocument = gql`
    query ListHomesToMessage($communityId: UUID) {
  listHomes(communityId: $communityId) {
    id
    name
  }
}
    `;

/**
 * __useListHomesToMessageQuery__
 *
 * To run a query within a React component, call `useListHomesToMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesToMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesToMessageQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useListHomesToMessageQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>(ListHomesToMessageDocument, options);
      }
export function useListHomesToMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>(ListHomesToMessageDocument, options);
        }
export type ListHomesToMessageQueryHookResult = ReturnType<typeof useListHomesToMessageQuery>;
export type ListHomesToMessageLazyQueryHookResult = ReturnType<typeof useListHomesToMessageLazyQuery>;
export type ListHomesToMessageQueryResult = Apollo.QueryResult<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>;
export const ListResidenciesWithResidentsDocument = gql`
    query ListResidenciesWithResidents($communityId: UUID) {
  listResidencies(communityId: $communityId) {
    id
    startDate
    home {
      id
      name
    }
    residents {
      id
      name
      email
      user {
        id
        hasUsedApp
      }
    }
  }
}
    `;

/**
 * __useListResidenciesWithResidentsQuery__
 *
 * To run a query within a React component, call `useListResidenciesWithResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResidenciesWithResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResidenciesWithResidentsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useListResidenciesWithResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>(ListResidenciesWithResidentsDocument, options);
      }
export function useListResidenciesWithResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>(ListResidenciesWithResidentsDocument, options);
        }
export type ListResidenciesWithResidentsQueryHookResult = ReturnType<typeof useListResidenciesWithResidentsQuery>;
export type ListResidenciesWithResidentsLazyQueryHookResult = ReturnType<typeof useListResidenciesWithResidentsLazyQuery>;
export type ListResidenciesWithResidentsQueryResult = Apollo.QueryResult<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>;
export const ActiveResidentCountDocument = gql`
    query ActiveResidentCount($communities: [ID]) {
  communities(ids: $communities) {
    edges {
      node {
        id
        activeResidentCount: statisticDataPoint(statisticType: ACTIVE_RESIDENT_COUNT) {
          id
          value
        }
        activeResidentCountDifference: statisticDifference(
          statisticType: ACTIVE_RESIDENT_COUNT
        )
      }
    }
  }
}
    `;

/**
 * __useActiveResidentCountQuery__
 *
 * To run a query within a React component, call `useActiveResidentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveResidentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveResidentCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useActiveResidentCountQuery(baseOptions?: Apollo.QueryHookOptions<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>(ActiveResidentCountDocument, options);
      }
export function useActiveResidentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>(ActiveResidentCountDocument, options);
        }
export type ActiveResidentCountQueryHookResult = ReturnType<typeof useActiveResidentCountQuery>;
export type ActiveResidentCountLazyQueryHookResult = ReturnType<typeof useActiveResidentCountLazyQuery>;
export type ActiveResidentCountQueryResult = Apollo.QueryResult<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>;
export const ActiveResidentsHistoricalDataDocument = gql`
    query ActiveResidentsHistoricalData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: ACTIVE_RESIDENT_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useActiveResidentsHistoricalDataQuery__
 *
 * To run a query within a React component, call `useActiveResidentsHistoricalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveResidentsHistoricalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveResidentsHistoricalDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useActiveResidentsHistoricalDataQuery(baseOptions?: Apollo.QueryHookOptions<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>(ActiveResidentsHistoricalDataDocument, options);
      }
export function useActiveResidentsHistoricalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>(ActiveResidentsHistoricalDataDocument, options);
        }
export type ActiveResidentsHistoricalDataQueryHookResult = ReturnType<typeof useActiveResidentsHistoricalDataQuery>;
export type ActiveResidentsHistoricalDataLazyQueryHookResult = ReturnType<typeof useActiveResidentsHistoricalDataLazyQuery>;
export type ActiveResidentsHistoricalDataQueryResult = Apollo.QueryResult<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>;
export const AverageDownloadRateDocument = gql`
    query AverageDownloadRate($communities: [ID]) {
  communities(ids: $communities) {
    edges {
      node {
        id
        downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
          id
          value
        }
        downloadRateDifference: statisticDifference(
          statisticType: DOWNLOAD_RATE_PERCENTAGE
        )
      }
    }
  }
}
    `;

/**
 * __useAverageDownloadRateQuery__
 *
 * To run a query within a React component, call `useAverageDownloadRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageDownloadRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageDownloadRateQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useAverageDownloadRateQuery(baseOptions?: Apollo.QueryHookOptions<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>(AverageDownloadRateDocument, options);
      }
export function useAverageDownloadRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>(AverageDownloadRateDocument, options);
        }
export type AverageDownloadRateQueryHookResult = ReturnType<typeof useAverageDownloadRateQuery>;
export type AverageDownloadRateLazyQueryHookResult = ReturnType<typeof useAverageDownloadRateLazyQuery>;
export type AverageDownloadRateQueryResult = Apollo.QueryResult<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>;
export const AveragePackageCollectionTimeDataDocument = gql`
    query AveragePackageCollectionTimeData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: AVERAGE_PACKAGE_COLLECTION_TIME
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useAveragePackageCollectionTimeDataQuery__
 *
 * To run a query within a React component, call `useAveragePackageCollectionTimeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAveragePackageCollectionTimeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAveragePackageCollectionTimeDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useAveragePackageCollectionTimeDataQuery(baseOptions?: Apollo.QueryHookOptions<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>(AveragePackageCollectionTimeDataDocument, options);
      }
export function useAveragePackageCollectionTimeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>(AveragePackageCollectionTimeDataDocument, options);
        }
export type AveragePackageCollectionTimeDataQueryHookResult = ReturnType<typeof useAveragePackageCollectionTimeDataQuery>;
export type AveragePackageCollectionTimeDataLazyQueryHookResult = ReturnType<typeof useAveragePackageCollectionTimeDataLazyQuery>;
export type AveragePackageCollectionTimeDataQueryResult = Apollo.QueryResult<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>;
export const DashboardPageDocument = gql`
    query DashboardPage($communities: [UUID]) {
  dashboard(communities: $communities) {
    openCount
    averageResponseTime
    responseTimeDifference
    allTimeSatisfaction
  }
}
    `;

/**
 * __useDashboardPageQuery__
 *
 * To run a query within a React component, call `useDashboardPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPageQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useDashboardPageQuery(baseOptions?: Apollo.QueryHookOptions<DashboardPageQuery, DashboardPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, options);
      }
export function useDashboardPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPageQuery, DashboardPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, options);
        }
export type DashboardPageQueryHookResult = ReturnType<typeof useDashboardPageQuery>;
export type DashboardPageLazyQueryHookResult = ReturnType<typeof useDashboardPageLazyQuery>;
export type DashboardPageQueryResult = Apollo.QueryResult<DashboardPageQuery, DashboardPageQueryVariables>;
export const DeliveredPackagesCountsDocument = gql`
    query DeliveredPackagesCounts($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: PACKAGE_DELIVERED_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useDeliveredPackagesCountsQuery__
 *
 * To run a query within a React component, call `useDeliveredPackagesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveredPackagesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveredPackagesCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useDeliveredPackagesCountsQuery(baseOptions?: Apollo.QueryHookOptions<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>(DeliveredPackagesCountsDocument, options);
      }
export function useDeliveredPackagesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>(DeliveredPackagesCountsDocument, options);
        }
export type DeliveredPackagesCountsQueryHookResult = ReturnType<typeof useDeliveredPackagesCountsQuery>;
export type DeliveredPackagesCountsLazyQueryHookResult = ReturnType<typeof useDeliveredPackagesCountsLazyQuery>;
export type DeliveredPackagesCountsQueryResult = Apollo.QueryResult<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>;
export const GetDownloadRatePerCommunityDocument = gql`
    query GetDownloadRatePerCommunity($communities: [ID]) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetDownloadRatePerCommunityQuery__
 *
 * To run a query within a React component, call `useGetDownloadRatePerCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadRatePerCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadRatePerCommunityQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetDownloadRatePerCommunityQuery(baseOptions?: Apollo.QueryHookOptions<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>(GetDownloadRatePerCommunityDocument, options);
      }
export function useGetDownloadRatePerCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>(GetDownloadRatePerCommunityDocument, options);
        }
export type GetDownloadRatePerCommunityQueryHookResult = ReturnType<typeof useGetDownloadRatePerCommunityQuery>;
export type GetDownloadRatePerCommunityLazyQueryHookResult = ReturnType<typeof useGetDownloadRatePerCommunityLazyQuery>;
export type GetDownloadRatePerCommunityQueryResult = Apollo.QueryResult<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>;
export const FacilityBookingsCountDocument = gql`
    query FacilityBookingsCount($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: FACILITY_BOOKINGS_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useFacilityBookingsCountQuery__
 *
 * To run a query within a React component, call `useFacilityBookingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityBookingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityBookingsCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useFacilityBookingsCountQuery(baseOptions?: Apollo.QueryHookOptions<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>(FacilityBookingsCountDocument, options);
      }
export function useFacilityBookingsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>(FacilityBookingsCountDocument, options);
        }
export type FacilityBookingsCountQueryHookResult = ReturnType<typeof useFacilityBookingsCountQuery>;
export type FacilityBookingsCountLazyQueryHookResult = ReturnType<typeof useFacilityBookingsCountLazyQuery>;
export type FacilityBookingsCountQueryResult = Apollo.QueryResult<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>;
export const IncomingMessagesCountsDocument = gql`
    query IncomingMessagesCounts($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: INCOMING_MESSAGES_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useIncomingMessagesCountsQuery__
 *
 * To run a query within a React component, call `useIncomingMessagesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingMessagesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingMessagesCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useIncomingMessagesCountsQuery(baseOptions?: Apollo.QueryHookOptions<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>(IncomingMessagesCountsDocument, options);
      }
export function useIncomingMessagesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>(IncomingMessagesCountsDocument, options);
        }
export type IncomingMessagesCountsQueryHookResult = ReturnType<typeof useIncomingMessagesCountsQuery>;
export type IncomingMessagesCountsLazyQueryHookResult = ReturnType<typeof useIncomingMessagesCountsLazyQuery>;
export type IncomingMessagesCountsQueryResult = Apollo.QueryResult<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>;
export const IncomingMessagesHistoricalDataDocument = gql`
    query IncomingMessagesHistoricalData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: INCOMING_MESSAGES_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useIncomingMessagesHistoricalDataQuery__
 *
 * To run a query within a React component, call `useIncomingMessagesHistoricalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingMessagesHistoricalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingMessagesHistoricalDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useIncomingMessagesHistoricalDataQuery(baseOptions?: Apollo.QueryHookOptions<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>(IncomingMessagesHistoricalDataDocument, options);
      }
export function useIncomingMessagesHistoricalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>(IncomingMessagesHistoricalDataDocument, options);
        }
export type IncomingMessagesHistoricalDataQueryHookResult = ReturnType<typeof useIncomingMessagesHistoricalDataQuery>;
export type IncomingMessagesHistoricalDataLazyQueryHookResult = ReturnType<typeof useIncomingMessagesHistoricalDataLazyQuery>;
export type IncomingMessagesHistoricalDataQueryResult = Apollo.QueryResult<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>;
export const KeyOutCountsDocument = gql`
    query KeyOutCounts($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: KEY_OUT_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useKeyOutCountsQuery__
 *
 * To run a query within a React component, call `useKeyOutCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyOutCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyOutCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useKeyOutCountsQuery(baseOptions?: Apollo.QueryHookOptions<KeyOutCountsQuery, KeyOutCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyOutCountsQuery, KeyOutCountsQueryVariables>(KeyOutCountsDocument, options);
      }
export function useKeyOutCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyOutCountsQuery, KeyOutCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyOutCountsQuery, KeyOutCountsQueryVariables>(KeyOutCountsDocument, options);
        }
export type KeyOutCountsQueryHookResult = ReturnType<typeof useKeyOutCountsQuery>;
export type KeyOutCountsLazyQueryHookResult = ReturnType<typeof useKeyOutCountsLazyQuery>;
export type KeyOutCountsQueryResult = Apollo.QueryResult<KeyOutCountsQuery, KeyOutCountsQueryVariables>;
export const KeysGraphDataDocument = gql`
    query KeysGraphData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        keyInStats: statisticDataPoints(
          frequency: DAILY
          statisticType: KEY_IN_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
        keyOutStats: statisticDataPoints(
          frequency: DAILY
          statisticType: KEY_OUT_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useKeysGraphDataQuery__
 *
 * To run a query within a React component, call `useKeysGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeysGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeysGraphDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useKeysGraphDataQuery(baseOptions?: Apollo.QueryHookOptions<KeysGraphDataQuery, KeysGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeysGraphDataQuery, KeysGraphDataQueryVariables>(KeysGraphDataDocument, options);
      }
export function useKeysGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeysGraphDataQuery, KeysGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeysGraphDataQuery, KeysGraphDataQueryVariables>(KeysGraphDataDocument, options);
        }
export type KeysGraphDataQueryHookResult = ReturnType<typeof useKeysGraphDataQuery>;
export type KeysGraphDataLazyQueryHookResult = ReturnType<typeof useKeysGraphDataLazyQuery>;
export type KeysGraphDataQueryResult = Apollo.QueryResult<KeysGraphDataQuery, KeysGraphDataQueryVariables>;
export const KeysOutLiveCountDocument = gql`
    query KeysOutLiveCount($communities: [ID]) {
  keys(communities: $communities, status: "Out", type: "Amenity") {
    totalCount
  }
}
    `;

/**
 * __useKeysOutLiveCountQuery__
 *
 * To run a query within a React component, call `useKeysOutLiveCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeysOutLiveCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeysOutLiveCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useKeysOutLiveCountQuery(baseOptions?: Apollo.QueryHookOptions<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>(KeysOutLiveCountDocument, options);
      }
export function useKeysOutLiveCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>(KeysOutLiveCountDocument, options);
        }
export type KeysOutLiveCountQueryHookResult = ReturnType<typeof useKeysOutLiveCountQuery>;
export type KeysOutLiveCountLazyQueryHookResult = ReturnType<typeof useKeysOutLiveCountLazyQuery>;
export type KeysOutLiveCountQueryResult = Apollo.QueryResult<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>;
export const PackagesGraphDataDocument = gql`
    query PackagesGraphData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        delivered: statisticDataPoints(
          frequency: DAILY
          statisticType: PACKAGE_DELIVERED_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
        collected: statisticDataPoints(
          frequency: DAILY
          statisticType: PACKAGE_COLLECTED_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __usePackagesGraphDataQuery__
 *
 * To run a query within a React component, call `usePackagesGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesGraphDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function usePackagesGraphDataQuery(baseOptions?: Apollo.QueryHookOptions<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>(PackagesGraphDataDocument, options);
      }
export function usePackagesGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>(PackagesGraphDataDocument, options);
        }
export type PackagesGraphDataQueryHookResult = ReturnType<typeof usePackagesGraphDataQuery>;
export type PackagesGraphDataLazyQueryHookResult = ReturnType<typeof usePackagesGraphDataLazyQuery>;
export type PackagesGraphDataQueryResult = Apollo.QueryResult<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>;
export const PackagesHeldCountDocument = gql`
    query PackagesHeldCount($communities: [ID]) {
  packages(status: "DE", communities: $communities) {
    totalCount
  }
}
    `;

/**
 * __usePackagesHeldCountQuery__
 *
 * To run a query within a React component, call `usePackagesHeldCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesHeldCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesHeldCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function usePackagesHeldCountQuery(baseOptions?: Apollo.QueryHookOptions<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>(PackagesHeldCountDocument, options);
      }
export function usePackagesHeldCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>(PackagesHeldCountDocument, options);
        }
export type PackagesHeldCountQueryHookResult = ReturnType<typeof usePackagesHeldCountQuery>;
export type PackagesHeldCountLazyQueryHookResult = ReturnType<typeof usePackagesHeldCountLazyQuery>;
export type PackagesHeldCountQueryResult = Apollo.QueryResult<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>;
export const VisitorsOnsiteCountDocument = gql`
    query VisitorsOnsiteCount($communities: [ID]) {
  communityVisitors(communities: $communities, onSite: true) {
    totalCount
  }
}
    `;

/**
 * __useVisitorsOnsiteCountQuery__
 *
 * To run a query within a React component, call `useVisitorsOnsiteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorsOnsiteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitorsOnsiteCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useVisitorsOnsiteCountQuery(baseOptions?: Apollo.QueryHookOptions<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>(VisitorsOnsiteCountDocument, options);
      }
export function useVisitorsOnsiteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>(VisitorsOnsiteCountDocument, options);
        }
export type VisitorsOnsiteCountQueryHookResult = ReturnType<typeof useVisitorsOnsiteCountQuery>;
export type VisitorsOnsiteCountLazyQueryHookResult = ReturnType<typeof useVisitorsOnsiteCountLazyQuery>;
export type VisitorsOnsiteCountQueryResult = Apollo.QueryResult<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>;
export const ResponseTimeDashboardDocument = gql`
    query ResponseTimeDashboard($communities: [ID], $after: String, $orderBy: String, $hasResponseTime: Boolean) {
  conversations(
    communities: $communities
    after: $after
    orderBy: $orderBy
    hasResponseTime: $hasResponseTime
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        subject
        responseTime
        closedAt
        snoozedUntil
        user {
          id
          firstName
          lastName
        }
        home {
          name
        }
        hasUnread
        latestEvent {
          ... on ConversationMessageType {
            id
            body
            createdAt
          }
          ... on ConversationMediaType {
            id
            createdAt
          }
          ... on ConversationActionModelType {
            id
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useResponseTimeDashboardQuery__
 *
 * To run a query within a React component, call `useResponseTimeDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseTimeDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseTimeDashboardQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      hasResponseTime: // value for 'hasResponseTime'
 *   },
 * });
 */
export function useResponseTimeDashboardQuery(baseOptions?: Apollo.QueryHookOptions<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>(ResponseTimeDashboardDocument, options);
      }
export function useResponseTimeDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>(ResponseTimeDashboardDocument, options);
        }
export type ResponseTimeDashboardQueryHookResult = ReturnType<typeof useResponseTimeDashboardQuery>;
export type ResponseTimeDashboardLazyQueryHookResult = ReturnType<typeof useResponseTimeDashboardLazyQuery>;
export type ResponseTimeDashboardQueryResult = Apollo.QueryResult<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>;
export const GetAverageResponseTimeDocument = gql`
    query GetAverageResponseTime($communities: [UUID]) {
  dashboard(communities: $communities) {
    responseTimeOverTime {
      date
      averageResponseTime
    }
  }
}
    `;

/**
 * __useGetAverageResponseTimeQuery__
 *
 * To run a query within a React component, call `useGetAverageResponseTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageResponseTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageResponseTimeQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetAverageResponseTimeQuery(baseOptions?: Apollo.QueryHookOptions<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>(GetAverageResponseTimeDocument, options);
      }
export function useGetAverageResponseTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>(GetAverageResponseTimeDocument, options);
        }
export type GetAverageResponseTimeQueryHookResult = ReturnType<typeof useGetAverageResponseTimeQuery>;
export type GetAverageResponseTimeLazyQueryHookResult = ReturnType<typeof useGetAverageResponseTimeLazyQuery>;
export type GetAverageResponseTimeQueryResult = Apollo.QueryResult<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>;
export const GetAverageSatisfactionScoresDocument = gql`
    query GetAverageSatisfactionScores($communities: [UUID]) {
  dashboard(communities: $communities) {
    ratingsOverTime {
      date
      averageRating
    }
  }
}
    `;

/**
 * __useGetAverageSatisfactionScoresQuery__
 *
 * To run a query within a React component, call `useGetAverageSatisfactionScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageSatisfactionScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageSatisfactionScoresQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetAverageSatisfactionScoresQuery(baseOptions?: Apollo.QueryHookOptions<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>(GetAverageSatisfactionScoresDocument, options);
      }
export function useGetAverageSatisfactionScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>(GetAverageSatisfactionScoresDocument, options);
        }
export type GetAverageSatisfactionScoresQueryHookResult = ReturnType<typeof useGetAverageSatisfactionScoresQuery>;
export type GetAverageSatisfactionScoresLazyQueryHookResult = ReturnType<typeof useGetAverageSatisfactionScoresLazyQuery>;
export type GetAverageSatisfactionScoresQueryResult = Apollo.QueryResult<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>;
export const GetDownloadRateDocument = gql`
    query GetDownloadRate($communities: [UUID]) {
  dashboard(communities: $communities) {
    downloadRateOverTime {
      date
      downloadRate
    }
  }
}
    `;

/**
 * __useGetDownloadRateQuery__
 *
 * To run a query within a React component, call `useGetDownloadRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadRateQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetDownloadRateQuery(baseOptions?: Apollo.QueryHookOptions<GetDownloadRateQuery, GetDownloadRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadRateQuery, GetDownloadRateQueryVariables>(GetDownloadRateDocument, options);
      }
export function useGetDownloadRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadRateQuery, GetDownloadRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadRateQuery, GetDownloadRateQueryVariables>(GetDownloadRateDocument, options);
        }
export type GetDownloadRateQueryHookResult = ReturnType<typeof useGetDownloadRateQuery>;
export type GetDownloadRateLazyQueryHookResult = ReturnType<typeof useGetDownloadRateLazyQuery>;
export type GetDownloadRateQueryResult = Apollo.QueryResult<GetDownloadRateQuery, GetDownloadRateQueryVariables>;
export const ListDashboardResidentsDocument = gql`
    query ListDashboardResidents($communities: [ID], $after: String, $downloaded: Boolean, $orderBy: String) {
  residents(
    communities: $communities
    after: $after
    downloaded: $downloaded
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        user {
          id
          lastAppUse
        }
        id
        name
        averageScore
        email
        currentResidencies {
          home {
            id
            name
            city
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListDashboardResidentsQuery__
 *
 * To run a query within a React component, call `useListDashboardResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDashboardResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDashboardResidentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      downloaded: // value for 'downloaded'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListDashboardResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>(ListDashboardResidentsDocument, options);
      }
export function useListDashboardResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>(ListDashboardResidentsDocument, options);
        }
export type ListDashboardResidentsQueryHookResult = ReturnType<typeof useListDashboardResidentsQuery>;
export type ListDashboardResidentsLazyQueryHookResult = ReturnType<typeof useListDashboardResidentsLazyQuery>;
export type ListDashboardResidentsQueryResult = Apollo.QueryResult<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>;
export const ListEngagementResidentsDocument = gql`
    query ListEngagementResidents($communities: [ID], $after: String, $downloaded: Boolean, $orderBy: String) {
  residents(
    communities: $communities
    after: $after
    downloaded: $downloaded
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ResidentItem
      }
    }
  }
}
    ${ResidentItemFragmentDoc}`;

/**
 * __useListEngagementResidentsQuery__
 *
 * To run a query within a React component, call `useListEngagementResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEngagementResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEngagementResidentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      downloaded: // value for 'downloaded'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListEngagementResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>(ListEngagementResidentsDocument, options);
      }
export function useListEngagementResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>(ListEngagementResidentsDocument, options);
        }
export type ListEngagementResidentsQueryHookResult = ReturnType<typeof useListEngagementResidentsQuery>;
export type ListEngagementResidentsLazyQueryHookResult = ReturnType<typeof useListEngagementResidentsLazyQuery>;
export type ListEngagementResidentsQueryResult = Apollo.QueryResult<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>;
export const ListEngagementScoresDocument = gql`
    query ListEngagementScores($communities: [UUID]) {
  dashboard(communities: $communities) {
    listEngagementScores {
      score
      createdAt
    }
  }
}
    `;

/**
 * __useListEngagementScoresQuery__
 *
 * To run a query within a React component, call `useListEngagementScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEngagementScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEngagementScoresQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useListEngagementScoresQuery(baseOptions?: Apollo.QueryHookOptions<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>(ListEngagementScoresDocument, options);
      }
export function useListEngagementScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>(ListEngagementScoresDocument, options);
        }
export type ListEngagementScoresQueryHookResult = ReturnType<typeof useListEngagementScoresQuery>;
export type ListEngagementScoresLazyQueryHookResult = ReturnType<typeof useListEngagementScoresLazyQuery>;
export type ListEngagementScoresQueryResult = Apollo.QueryResult<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>;
export const ListSatisfactionScoreResidentsDocument = gql`
    query ListSatisfactionScoreResidents($communities: [ID], $after: String, $orderBy: String, $withRating: Boolean) {
  residents(
    communities: $communities
    after: $after
    withRating: $withRating
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ResidentItem
      }
    }
  }
}
    ${ResidentItemFragmentDoc}`;

/**
 * __useListSatisfactionScoreResidentsQuery__
 *
 * To run a query within a React component, call `useListSatisfactionScoreResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSatisfactionScoreResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSatisfactionScoreResidentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      withRating: // value for 'withRating'
 *   },
 * });
 */
export function useListSatisfactionScoreResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>(ListSatisfactionScoreResidentsDocument, options);
      }
export function useListSatisfactionScoreResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>(ListSatisfactionScoreResidentsDocument, options);
        }
export type ListSatisfactionScoreResidentsQueryHookResult = ReturnType<typeof useListSatisfactionScoreResidentsQuery>;
export type ListSatisfactionScoreResidentsLazyQueryHookResult = ReturnType<typeof useListSatisfactionScoreResidentsLazyQuery>;
export type ListSatisfactionScoreResidentsQueryResult = Apollo.QueryResult<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>;
export const CreateCommunityDocumentDocument = gql`
    mutation CreateCommunityDocument($input: CreateCommunityDocumentInput!) {
  createCommunityDocument(input: $input) {
    communityDocument {
      id
      title
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCommunityDocumentMutationFn = Apollo.MutationFunction<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>;

/**
 * __useCreateCommunityDocumentMutation__
 *
 * To run a mutation, you first call `useCreateCommunityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityDocumentMutation, { data, loading, error }] = useCreateCommunityDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>(CreateCommunityDocumentDocument, options);
      }
export type CreateCommunityDocumentMutationHookResult = ReturnType<typeof useCreateCommunityDocumentMutation>;
export type CreateCommunityDocumentMutationResult = Apollo.MutationResult<CreateCommunityDocumentMutation>;
export type CreateCommunityDocumentMutationOptions = Apollo.BaseMutationOptions<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>;
export const CreateResidencyDocumentDocument = gql`
    mutation CreateResidencyDocument($input: CreateResidencyDocumentInput!) {
  createResidencyDocument(input: $input) {
    residencyDocument {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateResidencyDocumentMutationFn = Apollo.MutationFunction<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>;

/**
 * __useCreateResidencyDocumentMutation__
 *
 * To run a mutation, you first call `useCreateResidencyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResidencyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResidencyDocumentMutation, { data, loading, error }] = useCreateResidencyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResidencyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>(CreateResidencyDocumentDocument, options);
      }
export type CreateResidencyDocumentMutationHookResult = ReturnType<typeof useCreateResidencyDocumentMutation>;
export type CreateResidencyDocumentMutationResult = Apollo.MutationResult<CreateResidencyDocumentMutation>;
export type CreateResidencyDocumentMutationOptions = Apollo.BaseMutationOptions<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>;
export const UpdateCommunityDocumentDocument = gql`
    mutation UpdateCommunityDocument($input: UpdateCommunityDocumentInput!) {
  updateCommunityDocument(input: $input) {
    communityDocument {
      id
      title
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateCommunityDocumentMutationFn = Apollo.MutationFunction<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>;

/**
 * __useUpdateCommunityDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityDocumentMutation, { data, loading, error }] = useUpdateCommunityDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>(UpdateCommunityDocumentDocument, options);
      }
export type UpdateCommunityDocumentMutationHookResult = ReturnType<typeof useUpdateCommunityDocumentMutation>;
export type UpdateCommunityDocumentMutationResult = Apollo.MutationResult<UpdateCommunityDocumentMutation>;
export type UpdateCommunityDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>;
export const UpdateResidencyDocumentDocument = gql`
    mutation UpdateResidencyDocument($input: UpdateResidencyDocumentInput!) {
  updateResidencyDocument(input: $input) {
    residencyDocument {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateResidencyDocumentMutationFn = Apollo.MutationFunction<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>;

/**
 * __useUpdateResidencyDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateResidencyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResidencyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResidencyDocumentMutation, { data, loading, error }] = useUpdateResidencyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResidencyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>(UpdateResidencyDocumentDocument, options);
      }
export type UpdateResidencyDocumentMutationHookResult = ReturnType<typeof useUpdateResidencyDocumentMutation>;
export type UpdateResidencyDocumentMutationResult = Apollo.MutationResult<UpdateResidencyDocumentMutation>;
export type UpdateResidencyDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>;
export const DocumentDocument = gql`
    query Document($id: UUID!, $after: String) {
  document(id: $id) {
    id
    contentObject {
      ...ResidencyDocument
      ...CommunityDocument
    }
  }
}
    ${ResidencyDocumentFragmentDoc}
${CommunityDocumentFragmentDoc}`;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const DocumentsDocument = gql`
    query Documents($communities: [ID!], $search: String, $home: UUID, $after: String) {
  documents(
    communities: $communities
    search: $search
    home: $home
    after: $after
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        contentObject {
          ...ResidencyDocumentListItem
          ...CommunityDocumentListItem
        }
      }
    }
  }
}
    ${ResidencyDocumentListItemFragmentDoc}
${CommunityDocumentListItemFragmentDoc}`;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      home: // value for 'home'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const CommunityEventDocument = gql`
    query communityEvent($id: UUID!, $after: String) {
  communityEvent(id: $id) {
    ...CommunityEventItem
    description
    attendanceFee
    guests(after: $after) {
      totalCount
      edges {
        node {
          id
          name
          email
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${CommunityEventItemFragmentDoc}`;

/**
 * __useCommunityEventQuery__
 *
 * To run a query within a React component, call `useCommunityEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityEventQuery(baseOptions: Apollo.QueryHookOptions<CommunityEventQuery, CommunityEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityEventQuery, CommunityEventQueryVariables>(CommunityEventDocument, options);
      }
export function useCommunityEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityEventQuery, CommunityEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityEventQuery, CommunityEventQueryVariables>(CommunityEventDocument, options);
        }
export type CommunityEventQueryHookResult = ReturnType<typeof useCommunityEventQuery>;
export type CommunityEventLazyQueryHookResult = ReturnType<typeof useCommunityEventLazyQuery>;
export type CommunityEventQueryResult = Apollo.QueryResult<CommunityEventQuery, CommunityEventQueryVariables>;
export const CommunityEventsDocument = gql`
    query communityEvents($communities: [ID!], $after: String) {
  communityEvents(communities: $communities, after: $after, orderBy: "-start") {
    edges {
      node {
        ...CommunityEventItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CommunityEventItemFragmentDoc}`;

/**
 * __useCommunityEventsQuery__
 *
 * To run a query within a React component, call `useCommunityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityEventsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityEventsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityEventsQuery, CommunityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityEventsQuery, CommunityEventsQueryVariables>(CommunityEventsDocument, options);
      }
export function useCommunityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityEventsQuery, CommunityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityEventsQuery, CommunityEventsQueryVariables>(CommunityEventsDocument, options);
        }
export type CommunityEventsQueryHookResult = ReturnType<typeof useCommunityEventsQuery>;
export type CommunityEventsLazyQueryHookResult = ReturnType<typeof useCommunityEventsLazyQuery>;
export type CommunityEventsQueryResult = Apollo.QueryResult<CommunityEventsQuery, CommunityEventsQueryVariables>;
export const SaveCommunityEventDocument = gql`
    mutation SaveCommunityEvent($input: SaveCommunityEventInput!) {
  saveCommunityEvent(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveCommunityEventMutationFn = Apollo.MutationFunction<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>;

/**
 * __useSaveCommunityEventMutation__
 *
 * To run a mutation, you first call `useSaveCommunityEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommunityEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommunityEventMutation, { data, loading, error }] = useSaveCommunityEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommunityEventMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>(SaveCommunityEventDocument, options);
      }
export type SaveCommunityEventMutationHookResult = ReturnType<typeof useSaveCommunityEventMutation>;
export type SaveCommunityEventMutationResult = Apollo.MutationResult<SaveCommunityEventMutation>;
export type SaveCommunityEventMutationOptions = Apollo.BaseMutationOptions<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>;
export const CommunityGroupsDocument = gql`
    query CommunityGroups($communities: [ID!], $after: String) {
  communityGroups(
    communities: $communities
    after: $after
    orderBy: "-deactivated_on"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...CommunityGroupItem
      }
    }
  }
}
    ${CommunityGroupItemFragmentDoc}`;

/**
 * __useCommunityGroupsQuery__
 *
 * To run a query within a React component, call `useCommunityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityGroupsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityGroupsQuery, CommunityGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityGroupsQuery, CommunityGroupsQueryVariables>(CommunityGroupsDocument, options);
      }
export function useCommunityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityGroupsQuery, CommunityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityGroupsQuery, CommunityGroupsQueryVariables>(CommunityGroupsDocument, options);
        }
export type CommunityGroupsQueryHookResult = ReturnType<typeof useCommunityGroupsQuery>;
export type CommunityGroupsLazyQueryHookResult = ReturnType<typeof useCommunityGroupsLazyQuery>;
export type CommunityGroupsQueryResult = Apollo.QueryResult<CommunityGroupsQuery, CommunityGroupsQueryVariables>;
export const CommunityGroupDocument = gql`
    query CommunityGroup($id: UUID!, $homesAfter: String, $contactsAfter: String) {
  communityGroup(id: $id) {
    id
    name
    description
    deactivatedOn
    isAutomatic
    isCommunityManager
    community {
      id
      name
    }
    homes(after: $homesAfter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
    users(after: $contactsAfter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...ContactItem
        }
      }
    }
  }
}
    ${ContactItemFragmentDoc}`;

/**
 * __useCommunityGroupQuery__
 *
 * To run a query within a React component, call `useCommunityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      homesAfter: // value for 'homesAfter'
 *      contactsAfter: // value for 'contactsAfter'
 *   },
 * });
 */
export function useCommunityGroupQuery(baseOptions: Apollo.QueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityGroupQuery, CommunityGroupQueryVariables>(CommunityGroupDocument, options);
      }
export function useCommunityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityGroupQuery, CommunityGroupQueryVariables>(CommunityGroupDocument, options);
        }
export type CommunityGroupQueryHookResult = ReturnType<typeof useCommunityGroupQuery>;
export type CommunityGroupLazyQueryHookResult = ReturnType<typeof useCommunityGroupLazyQuery>;
export type CommunityGroupQueryResult = Apollo.QueryResult<CommunityGroupQuery, CommunityGroupQueryVariables>;
export const CommunityManagerCommunitiesDocument = gql`
    query CommunityManagerCommunities {
  getUser {
    id
    manager {
      id
      community {
        edges {
          node {
            id
          }
        }
      }
    }
    communityManager {
      id
      communities {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCommunityManagerCommunitiesQuery__
 *
 * To run a query within a React component, call `useCommunityManagerCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityManagerCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityManagerCommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityManagerCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>(CommunityManagerCommunitiesDocument, options);
      }
export function useCommunityManagerCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>(CommunityManagerCommunitiesDocument, options);
        }
export type CommunityManagerCommunitiesQueryHookResult = ReturnType<typeof useCommunityManagerCommunitiesQuery>;
export type CommunityManagerCommunitiesLazyQueryHookResult = ReturnType<typeof useCommunityManagerCommunitiesLazyQuery>;
export type CommunityManagerCommunitiesQueryResult = Apollo.QueryResult<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>;
export const ActivateGroupDocument = gql`
    mutation ActivateGroup($input: ActivateGroupInput!) {
  activateGroup(input: $input) {
    communityGroup {
      id
      name
      deactivatedOn
    }
  }
}
    `;
export type ActivateGroupMutationFn = Apollo.MutationFunction<ActivateGroupMutation, ActivateGroupMutationVariables>;

/**
 * __useActivateGroupMutation__
 *
 * To run a mutation, you first call `useActivateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateGroupMutation, { data, loading, error }] = useActivateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateGroupMutation(baseOptions?: Apollo.MutationHookOptions<ActivateGroupMutation, ActivateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateGroupMutation, ActivateGroupMutationVariables>(ActivateGroupDocument, options);
      }
export type ActivateGroupMutationHookResult = ReturnType<typeof useActivateGroupMutation>;
export type ActivateGroupMutationResult = Apollo.MutationResult<ActivateGroupMutation>;
export type ActivateGroupMutationOptions = Apollo.BaseMutationOptions<ActivateGroupMutation, ActivateGroupMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    id
    name
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const DeactivateGroupDocument = gql`
    mutation DeactivateGroup($input: DeactivateGroupInput!) {
  deactivateGroup(input: $input) {
    communityGroup {
      id
      name
      deactivatedOn
    }
  }
}
    `;
export type DeactivateGroupMutationFn = Apollo.MutationFunction<DeactivateGroupMutation, DeactivateGroupMutationVariables>;

/**
 * __useDeactivateGroupMutation__
 *
 * To run a mutation, you first call `useDeactivateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateGroupMutation, { data, loading, error }] = useDeactivateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateGroupMutation, DeactivateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateGroupMutation, DeactivateGroupMutationVariables>(DeactivateGroupDocument, options);
      }
export type DeactivateGroupMutationHookResult = ReturnType<typeof useDeactivateGroupMutation>;
export type DeactivateGroupMutationResult = Apollo.MutationResult<DeactivateGroupMutation>;
export type DeactivateGroupMutationOptions = Apollo.BaseMutationOptions<DeactivateGroupMutation, DeactivateGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    id
    name
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const HomeDetailsDocument = gql`
    query HomeDetails($id: UUID!) {
  home(id: $id) {
    ...HomeItem
    activeResidency {
      id
      residents {
        id
        averageScore
        user {
          id
          firstName
          lastName
          email
          lastAppUse
        }
      }
    }
    leasehold {
      id
      leaseholder {
        edges {
          node {
            id
            user {
              id
              firstName
              lastName
              email
              lastAppUse
            }
          }
        }
      }
    }
    applications {
      edges {
        node {
          ...ApplicationItem
        }
      }
    }
  }
}
    ${HomeItemFragmentDoc}
${ApplicationItemFragmentDoc}`;

/**
 * __useHomeDetailsQuery__
 *
 * To run a query within a React component, call `useHomeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeDetailsQuery(baseOptions: Apollo.QueryHookOptions<HomeDetailsQuery, HomeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeDetailsQuery, HomeDetailsQueryVariables>(HomeDetailsDocument, options);
      }
export function useHomeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeDetailsQuery, HomeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeDetailsQuery, HomeDetailsQueryVariables>(HomeDetailsDocument, options);
        }
export type HomeDetailsQueryHookResult = ReturnType<typeof useHomeDetailsQuery>;
export type HomeDetailsLazyQueryHookResult = ReturnType<typeof useHomeDetailsLazyQuery>;
export type HomeDetailsQueryResult = Apollo.QueryResult<HomeDetailsQuery, HomeDetailsQueryVariables>;
export const ListEntHomesDocument = gql`
    query ListEntHomes($after: String, $communities: [ID!], $icontainsSearch: String) {
  homes(
    after: $after
    communities: $communities
    icontainsSearch: $icontainsSearch
    orderBy: "number_in_address,name"
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        ...HomeItem
      }
    }
  }
}
    ${HomeItemFragmentDoc}`;

/**
 * __useListEntHomesQuery__
 *
 * To run a query within a React component, call `useListEntHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEntHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEntHomesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *      icontainsSearch: // value for 'icontainsSearch'
 *   },
 * });
 */
export function useListEntHomesQuery(baseOptions?: Apollo.QueryHookOptions<ListEntHomesQuery, ListEntHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEntHomesQuery, ListEntHomesQueryVariables>(ListEntHomesDocument, options);
      }
export function useListEntHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEntHomesQuery, ListEntHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEntHomesQuery, ListEntHomesQueryVariables>(ListEntHomesDocument, options);
        }
export type ListEntHomesQueryHookResult = ReturnType<typeof useListEntHomesQuery>;
export type ListEntHomesLazyQueryHookResult = ReturnType<typeof useListEntHomesLazyQuery>;
export type ListEntHomesQueryResult = Apollo.QueryResult<ListEntHomesQuery, ListEntHomesQueryVariables>;
export const KeyCommunityDocument = gql`
    query KeyCommunity($keyId: UUID!) {
  key(id: $keyId) {
    id
    community {
      id
    }
  }
}
    `;

/**
 * __useKeyCommunityQuery__
 *
 * To run a query within a React component, call `useKeyCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyCommunityQuery({
 *   variables: {
 *      keyId: // value for 'keyId'
 *   },
 * });
 */
export function useKeyCommunityQuery(baseOptions: Apollo.QueryHookOptions<KeyCommunityQuery, KeyCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyCommunityQuery, KeyCommunityQueryVariables>(KeyCommunityDocument, options);
      }
export function useKeyCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyCommunityQuery, KeyCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyCommunityQuery, KeyCommunityQueryVariables>(KeyCommunityDocument, options);
        }
export type KeyCommunityQueryHookResult = ReturnType<typeof useKeyCommunityQuery>;
export type KeyCommunityLazyQueryHookResult = ReturnType<typeof useKeyCommunityLazyQuery>;
export type KeyCommunityQueryResult = Apollo.QueryResult<KeyCommunityQuery, KeyCommunityQueryVariables>;
export const OnSiteVisitorsDocument = gql`
    query OnSiteVisitors($after: String, $communities: [ID!]) {
  communityVisitors(after: $after, communities: $communities, onSite: true) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...OnSiteVisitorItem
      }
    }
  }
}
    ${OnSiteVisitorItemFragmentDoc}`;

/**
 * __useOnSiteVisitorsQuery__
 *
 * To run a query within a React component, call `useOnSiteVisitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnSiteVisitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSiteVisitorsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useOnSiteVisitorsQuery(baseOptions?: Apollo.QueryHookOptions<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>(OnSiteVisitorsDocument, options);
      }
export function useOnSiteVisitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>(OnSiteVisitorsDocument, options);
        }
export type OnSiteVisitorsQueryHookResult = ReturnType<typeof useOnSiteVisitorsQuery>;
export type OnSiteVisitorsLazyQueryHookResult = ReturnType<typeof useOnSiteVisitorsLazyQuery>;
export type OnSiteVisitorsQueryResult = Apollo.QueryResult<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>;
export const CreateKeyholderV2Document = gql`
    mutation CreateKeyholderV2($input: CreateKeyholderV2Input!) {
  createKeyholderV2(input: $input) {
    keyholder {
      id
      key {
        id
        keyholders(type: ["Pending", "Rolling", "Single Use"]) {
          pageInfo {
            endCursor
            hasNextPage
          }
          totalCount
          edges {
            node {
              ...KeyholderItem
            }
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    ${KeyholderItemFragmentDoc}`;
export type CreateKeyholderV2MutationFn = Apollo.MutationFunction<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>;

/**
 * __useCreateKeyholderV2Mutation__
 *
 * To run a mutation, you first call `useCreateKeyholderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeyholderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeyholderV2Mutation, { data, loading, error }] = useCreateKeyholderV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKeyholderV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>(CreateKeyholderV2Document, options);
      }
export type CreateKeyholderV2MutationHookResult = ReturnType<typeof useCreateKeyholderV2Mutation>;
export type CreateKeyholderV2MutationResult = Apollo.MutationResult<CreateKeyholderV2Mutation>;
export type CreateKeyholderV2MutationOptions = Apollo.BaseMutationOptions<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>;
export const UpdateKeyholderDocument = gql`
    mutation UpdateKeyholder($input: UpdateKeyholderInput!) {
  updateKeyholder(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateKeyholderMutationFn = Apollo.MutationFunction<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>;

/**
 * __useUpdateKeyholderMutation__
 *
 * To run a mutation, you first call `useUpdateKeyholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyholderMutation, { data, loading, error }] = useUpdateKeyholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKeyholderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>(UpdateKeyholderDocument, options);
      }
export type UpdateKeyholderMutationHookResult = ReturnType<typeof useUpdateKeyholderMutation>;
export type UpdateKeyholderMutationResult = Apollo.MutationResult<UpdateKeyholderMutation>;
export type UpdateKeyholderMutationOptions = Apollo.BaseMutationOptions<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>;
export const KeyDetailsDocument = gql`
    query KeyDetails($id: UUID!, $keyholdersAfter: String, $eventsAfter: String) {
  key(id: $id) {
    id
    name
    reference
    checkoutDate
    notes
    status
    archivedAt
    community {
      id
      name
    }
    image
    home {
      ...KeyHomeItem
    }
    currentKeyholder {
      ...KeyholderItem
    }
    keyholders(after: $keyholdersAfter, type: ["Pending", "Rolling", "Single Use"]) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...KeyholderItem
        }
      }
    }
    events(after: $eventsAfter) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...KeyEventItem
        }
      }
    }
  }
}
    ${KeyHomeItemFragmentDoc}
${KeyholderItemFragmentDoc}
${KeyEventItemFragmentDoc}`;

/**
 * __useKeyDetailsQuery__
 *
 * To run a query within a React component, call `useKeyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      keyholdersAfter: // value for 'keyholdersAfter'
 *      eventsAfter: // value for 'eventsAfter'
 *   },
 * });
 */
export function useKeyDetailsQuery(baseOptions: Apollo.QueryHookOptions<KeyDetailsQuery, KeyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyDetailsQuery, KeyDetailsQueryVariables>(KeyDetailsDocument, options);
      }
export function useKeyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyDetailsQuery, KeyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyDetailsQuery, KeyDetailsQueryVariables>(KeyDetailsDocument, options);
        }
export type KeyDetailsQueryHookResult = ReturnType<typeof useKeyDetailsQuery>;
export type KeyDetailsLazyQueryHookResult = ReturnType<typeof useKeyDetailsLazyQuery>;
export type KeyDetailsQueryResult = Apollo.QueryResult<KeyDetailsQuery, KeyDetailsQueryVariables>;
export const ArchiveKeyDocument = gql`
    mutation ArchiveKey($input: ArchiveKeyInput!) {
  archiveKey(input: $input) {
    key {
      id
      status
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveKeyMutationFn = Apollo.MutationFunction<ArchiveKeyMutation, ArchiveKeyMutationVariables>;

/**
 * __useArchiveKeyMutation__
 *
 * To run a mutation, you first call `useArchiveKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveKeyMutation, { data, loading, error }] = useArchiveKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveKeyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveKeyMutation, ArchiveKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveKeyMutation, ArchiveKeyMutationVariables>(ArchiveKeyDocument, options);
      }
export type ArchiveKeyMutationHookResult = ReturnType<typeof useArchiveKeyMutation>;
export type ArchiveKeyMutationResult = Apollo.MutationResult<ArchiveKeyMutation>;
export type ArchiveKeyMutationOptions = Apollo.BaseMutationOptions<ArchiveKeyMutation, ArchiveKeyMutationVariables>;
export const ArchiveKeyholderDocument = gql`
    mutation ArchiveKeyholder($input: ArchiveKeyholderInput!) {
  archiveKeyholder(input: $input) {
    keyholder {
      id
      archivedAt
      type
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveKeyholderMutationFn = Apollo.MutationFunction<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>;

/**
 * __useArchiveKeyholderMutation__
 *
 * To run a mutation, you first call `useArchiveKeyholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveKeyholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveKeyholderMutation, { data, loading, error }] = useArchiveKeyholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveKeyholderMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>(ArchiveKeyholderDocument, options);
      }
export type ArchiveKeyholderMutationHookResult = ReturnType<typeof useArchiveKeyholderMutation>;
export type ArchiveKeyholderMutationResult = Apollo.MutationResult<ArchiveKeyholderMutation>;
export type ArchiveKeyholderMutationOptions = Apollo.BaseMutationOptions<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>;
export const AuthorisedKeyholdersDocument = gql`
    query AuthorisedKeyholders($id: UUID!, $after: String) {
  key(id: $id) {
    id
    keyholders(isActive: true, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAuthorisedKeyholdersQuery__
 *
 * To run a query within a React component, call `useAuthorisedKeyholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorisedKeyholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorisedKeyholdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAuthorisedKeyholdersQuery(baseOptions: Apollo.QueryHookOptions<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>(AuthorisedKeyholdersDocument, options);
      }
export function useAuthorisedKeyholdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>(AuthorisedKeyholdersDocument, options);
        }
export type AuthorisedKeyholdersQueryHookResult = ReturnType<typeof useAuthorisedKeyholdersQuery>;
export type AuthorisedKeyholdersLazyQueryHookResult = ReturnType<typeof useAuthorisedKeyholdersLazyQuery>;
export type AuthorisedKeyholdersQueryResult = Apollo.QueryResult<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>;
export const CheckInKeyV2Document = gql`
    mutation CheckInKeyV2($input: CheckInKeyV2Input!) {
  checkInKeyV2(input: $input) {
    key {
      id
      checkoutDate
      status
      currentKeyholder {
        ...KeyholderItem
      }
    }
    errors {
      messages
    }
  }
}
    ${KeyholderItemFragmentDoc}`;
export type CheckInKeyV2MutationFn = Apollo.MutationFunction<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>;

/**
 * __useCheckInKeyV2Mutation__
 *
 * To run a mutation, you first call `useCheckInKeyV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInKeyV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInKeyV2Mutation, { data, loading, error }] = useCheckInKeyV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckInKeyV2Mutation(baseOptions?: Apollo.MutationHookOptions<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>(CheckInKeyV2Document, options);
      }
export type CheckInKeyV2MutationHookResult = ReturnType<typeof useCheckInKeyV2Mutation>;
export type CheckInKeyV2MutationResult = Apollo.MutationResult<CheckInKeyV2Mutation>;
export type CheckInKeyV2MutationOptions = Apollo.BaseMutationOptions<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>;
export const CheckOutKeyV2Document = gql`
    mutation CheckOutKeyV2($input: CheckOutKeyV2Input!) {
  checkOutKeyV2(input: $input) {
    key {
      id
      checkoutDate
      status
      currentKeyholder {
        ...KeyholderItem
      }
    }
    errors {
      field
      messages
    }
  }
}
    ${KeyholderItemFragmentDoc}`;
export type CheckOutKeyV2MutationFn = Apollo.MutationFunction<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>;

/**
 * __useCheckOutKeyV2Mutation__
 *
 * To run a mutation, you first call `useCheckOutKeyV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckOutKeyV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkOutKeyV2Mutation, { data, loading, error }] = useCheckOutKeyV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckOutKeyV2Mutation(baseOptions?: Apollo.MutationHookOptions<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>(CheckOutKeyV2Document, options);
      }
export type CheckOutKeyV2MutationHookResult = ReturnType<typeof useCheckOutKeyV2Mutation>;
export type CheckOutKeyV2MutationResult = Apollo.MutationResult<CheckOutKeyV2Mutation>;
export type CheckOutKeyV2MutationOptions = Apollo.BaseMutationOptions<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>;
export const CreateKeyDocument = gql`
    mutation CreateKey($input: CreateKeyV2Input!) {
  createKeyV2(input: $input) {
    key {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateKeyMutationFn = Apollo.MutationFunction<CreateKeyMutation, CreateKeyMutationVariables>;

/**
 * __useCreateKeyMutation__
 *
 * To run a mutation, you first call `useCreateKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeyMutation, { data, loading, error }] = useCreateKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeyMutation, CreateKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeyMutation, CreateKeyMutationVariables>(CreateKeyDocument, options);
      }
export type CreateKeyMutationHookResult = ReturnType<typeof useCreateKeyMutation>;
export type CreateKeyMutationResult = Apollo.MutationResult<CreateKeyMutation>;
export type CreateKeyMutationOptions = Apollo.BaseMutationOptions<CreateKeyMutation, CreateKeyMutationVariables>;
export const EditKeyDocument = gql`
    mutation EditKey($input: EditKeyInput!) {
  editKey(input: $input) {
    key {
      id
      name
      reference
      notes
      community {
        id
        name
      }
      home {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type EditKeyMutationFn = Apollo.MutationFunction<EditKeyMutation, EditKeyMutationVariables>;

/**
 * __useEditKeyMutation__
 *
 * To run a mutation, you first call `useEditKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editKeyMutation, { data, loading, error }] = useEditKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditKeyMutation(baseOptions?: Apollo.MutationHookOptions<EditKeyMutation, EditKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditKeyMutation, EditKeyMutationVariables>(EditKeyDocument, options);
      }
export type EditKeyMutationHookResult = ReturnType<typeof useEditKeyMutation>;
export type EditKeyMutationResult = Apollo.MutationResult<EditKeyMutation>;
export type EditKeyMutationOptions = Apollo.BaseMutationOptions<EditKeyMutation, EditKeyMutationVariables>;
export const UnarchiveKeyDocument = gql`
    mutation UnarchiveKey($input: UnarchiveKeyInput!) {
  unarchiveKey(input: $input) {
    key {
      id
      status
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UnarchiveKeyMutationFn = Apollo.MutationFunction<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>;

/**
 * __useUnarchiveKeyMutation__
 *
 * To run a mutation, you first call `useUnarchiveKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveKeyMutation, { data, loading, error }] = useUnarchiveKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveKeyMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>(UnarchiveKeyDocument, options);
      }
export type UnarchiveKeyMutationHookResult = ReturnType<typeof useUnarchiveKeyMutation>;
export type UnarchiveKeyMutationResult = Apollo.MutationResult<UnarchiveKeyMutation>;
export type UnarchiveKeyMutationOptions = Apollo.BaseMutationOptions<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>;
export const UnarchiveKeyholderDocument = gql`
    mutation UnarchiveKeyholder($input: UnarchiveKeyholderInput!) {
  unarchiveKeyholder(input: $input) {
    keyholder {
      id
      archivedAt
      type
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UnarchiveKeyholderMutationFn = Apollo.MutationFunction<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>;

/**
 * __useUnarchiveKeyholderMutation__
 *
 * To run a mutation, you first call `useUnarchiveKeyholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveKeyholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveKeyholderMutation, { data, loading, error }] = useUnarchiveKeyholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveKeyholderMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>(UnarchiveKeyholderDocument, options);
      }
export type UnarchiveKeyholderMutationHookResult = ReturnType<typeof useUnarchiveKeyholderMutation>;
export type UnarchiveKeyholderMutationResult = Apollo.MutationResult<UnarchiveKeyholderMutation>;
export type UnarchiveKeyholderMutationOptions = Apollo.BaseMutationOptions<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>;
export const KeyholderDocument = gql`
    query Keyholder($keyholderId: UUID!, $keyId: UUID!) {
  keyholder(id: $keyholderId) {
    id
    name
    startDate
    endDate
    phoneNumber
    type
    notes
    email
    company
    archivedAt
  }
  key(id: $keyId) {
    checkoutDate
    name
    home {
      id
      name
    }
    community {
      id
      name
    }
    currentKeyholder {
      id
    }
  }
}
    `;

/**
 * __useKeyholderQuery__
 *
 * To run a query within a React component, call `useKeyholderQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyholderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyholderQuery({
 *   variables: {
 *      keyholderId: // value for 'keyholderId'
 *      keyId: // value for 'keyId'
 *   },
 * });
 */
export function useKeyholderQuery(baseOptions: Apollo.QueryHookOptions<KeyholderQuery, KeyholderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyholderQuery, KeyholderQueryVariables>(KeyholderDocument, options);
      }
export function useKeyholderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyholderQuery, KeyholderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyholderQuery, KeyholderQueryVariables>(KeyholderDocument, options);
        }
export type KeyholderQueryHookResult = ReturnType<typeof useKeyholderQuery>;
export type KeyholderLazyQueryHookResult = ReturnType<typeof useKeyholderLazyQuery>;
export type KeyholderQueryResult = Apollo.QueryResult<KeyholderQuery, KeyholderQueryVariables>;
export const KeysDocument = gql`
    query Keys($communities: [ID!], $after: String, $search: String, $search2: String, $hasCurrentKeyholder: Boolean, $status: [String], $type: [String]) {
  keys(
    communities: $communities
    after: $after
    search: $search
    search2: $search2
    hasCurrentKeyholder: $hasCurrentKeyholder
    status: $status
    orderBy: "checkout_date"
    type: $type
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        reference
        status
        community {
          id
          name
        }
        home {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useKeysQuery__
 *
 * To run a query within a React component, call `useKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeysQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      search2: // value for 'search2'
 *      hasCurrentKeyholder: // value for 'hasCurrentKeyholder'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useKeysQuery(baseOptions?: Apollo.QueryHookOptions<KeysQuery, KeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeysQuery, KeysQueryVariables>(KeysDocument, options);
      }
export function useKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeysQuery, KeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeysQuery, KeysQueryVariables>(KeysDocument, options);
        }
export type KeysQueryHookResult = ReturnType<typeof useKeysQuery>;
export type KeysLazyQueryHookResult = ReturnType<typeof useKeysLazyQuery>;
export type KeysQueryResult = Apollo.QueryResult<KeysQuery, KeysQueryVariables>;
export const ArchiveMarketplaceItemDocument = gql`
    mutation ArchiveMarketplaceItem($input: ArchiveMarketplaceItemInput!) {
  archiveMarketplaceItem(input: $input) {
    marketplaceItem {
      id
      archivedBy {
        id
        name
      }
      archivedOn
      archivedReason
    }
    errors {
      messages
    }
  }
}
    `;
export type ArchiveMarketplaceItemMutationFn = Apollo.MutationFunction<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>;

/**
 * __useArchiveMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useArchiveMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMarketplaceItemMutation, { data, loading, error }] = useArchiveMarketplaceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>(ArchiveMarketplaceItemDocument, options);
      }
export type ArchiveMarketplaceItemMutationHookResult = ReturnType<typeof useArchiveMarketplaceItemMutation>;
export type ArchiveMarketplaceItemMutationResult = Apollo.MutationResult<ArchiveMarketplaceItemMutation>;
export type ArchiveMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>;
export const MarketplaceItemDocument = gql`
    query MarketplaceItem($id: UUID!) {
  marketplaceItem(id: $id) {
    ...MarketplaceItem
  }
}
    ${MarketplaceItemFragmentDoc}`;

/**
 * __useMarketplaceItemQuery__
 *
 * To run a query within a React component, call `useMarketplaceItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceItemQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceItemQuery, MarketplaceItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceItemQuery, MarketplaceItemQueryVariables>(MarketplaceItemDocument, options);
      }
export function useMarketplaceItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceItemQuery, MarketplaceItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceItemQuery, MarketplaceItemQueryVariables>(MarketplaceItemDocument, options);
        }
export type MarketplaceItemQueryHookResult = ReturnType<typeof useMarketplaceItemQuery>;
export type MarketplaceItemLazyQueryHookResult = ReturnType<typeof useMarketplaceItemLazyQuery>;
export type MarketplaceItemQueryResult = Apollo.QueryResult<MarketplaceItemQuery, MarketplaceItemQueryVariables>;
export const MarketplaceItemCommentsDocument = gql`
    query MarketplaceItemComments($id: UUID!, $after: String) {
  marketplaceItem(id: $id) {
    id
    comments(after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          comment
          author {
            id
          }
          name
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useMarketplaceItemCommentsQuery__
 *
 * To run a query within a React component, call `useMarketplaceItemCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceItemCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceItemCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMarketplaceItemCommentsQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>(MarketplaceItemCommentsDocument, options);
      }
export function useMarketplaceItemCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>(MarketplaceItemCommentsDocument, options);
        }
export type MarketplaceItemCommentsQueryHookResult = ReturnType<typeof useMarketplaceItemCommentsQuery>;
export type MarketplaceItemCommentsLazyQueryHookResult = ReturnType<typeof useMarketplaceItemCommentsLazyQuery>;
export type MarketplaceItemCommentsQueryResult = Apollo.QueryResult<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>;
export const MarketplaceItemsDocument = gql`
    query MarketplaceItems($after: String, $search: String, $communities: [ID!], $status: [String]) {
  marketplaceItems(
    after: $after
    search: $search
    communities: $communities
    status: $status
  ) {
    edges {
      node {
        ...MarketplaceItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${MarketplaceItemFragmentDoc}`;

/**
 * __useMarketplaceItemsQuery__
 *
 * To run a query within a React component, call `useMarketplaceItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceItemsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMarketplaceItemsQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>(MarketplaceItemsDocument, options);
      }
export function useMarketplaceItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>(MarketplaceItemsDocument, options);
        }
export type MarketplaceItemsQueryHookResult = ReturnType<typeof useMarketplaceItemsQuery>;
export type MarketplaceItemsLazyQueryHookResult = ReturnType<typeof useMarketplaceItemsLazyQuery>;
export type MarketplaceItemsQueryResult = Apollo.QueryResult<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>;
export const CollectPackagesForHomeDocument = gql`
    mutation CollectPackagesForHome($input: CollectPackagesForHomeInput!) {
  collectPackagesForHome(input: $input) {
    home {
      id
      uncollectedPackageCount
      uncollectedPackages: packages(status: "DE") {
        totalCount
        edges {
          node {
            id
            addressee
            createdAt
          }
        }
      }
      collectedPackages: packages(status: "CO") {
        edges {
          node {
            id
            addressee
            collectedOn
          }
        }
      }
    }
  }
}
    `;
export type CollectPackagesForHomeMutationFn = Apollo.MutationFunction<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>;

/**
 * __useCollectPackagesForHomeMutation__
 *
 * To run a mutation, you first call `useCollectPackagesForHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectPackagesForHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectPackagesForHomeMutation, { data, loading, error }] = useCollectPackagesForHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectPackagesForHomeMutation(baseOptions?: Apollo.MutationHookOptions<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>(CollectPackagesForHomeDocument, options);
      }
export type CollectPackagesForHomeMutationHookResult = ReturnType<typeof useCollectPackagesForHomeMutation>;
export type CollectPackagesForHomeMutationResult = Apollo.MutationResult<CollectPackagesForHomeMutation>;
export type CollectPackagesForHomeMutationOptions = Apollo.BaseMutationOptions<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>;
export const HomePackagesDocument = gql`
    query HomePackages($id: UUID!, $collectedAfter: String, $uncollectedAfter: String) {
  home(id: $id) {
    id
    address
    uncollectedPackages: packages(
      status: "DE"
      after: $uncollectedAfter
      orderBy: "-created_at"
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          addressee
          createdAt
          location
        }
      }
    }
    collectedPackages: packages(
      status: "CO"
      after: $collectedAfter
      orderBy: "-collected_on"
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          addressee
          collectedOn
          location
        }
      }
    }
  }
}
    `;

/**
 * __useHomePackagesQuery__
 *
 * To run a query within a React component, call `useHomePackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePackagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      collectedAfter: // value for 'collectedAfter'
 *      uncollectedAfter: // value for 'uncollectedAfter'
 *   },
 * });
 */
export function useHomePackagesQuery(baseOptions: Apollo.QueryHookOptions<HomePackagesQuery, HomePackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePackagesQuery, HomePackagesQueryVariables>(HomePackagesDocument, options);
      }
export function useHomePackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePackagesQuery, HomePackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePackagesQuery, HomePackagesQueryVariables>(HomePackagesDocument, options);
        }
export type HomePackagesQueryHookResult = ReturnType<typeof useHomePackagesQuery>;
export type HomePackagesLazyQueryHookResult = ReturnType<typeof useHomePackagesLazyQuery>;
export type HomePackagesQueryResult = Apollo.QueryResult<HomePackagesQuery, HomePackagesQueryVariables>;
export const PackageReminderToHomeDocument = gql`
    mutation PackageReminderToHome($input: PackageReminderToHomeInput!) {
  packageReminderToHome(input: $input) {
    home {
      id
    }
  }
}
    `;
export type PackageReminderToHomeMutationFn = Apollo.MutationFunction<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>;

/**
 * __usePackageReminderToHomeMutation__
 *
 * To run a mutation, you first call `usePackageReminderToHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackageReminderToHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packageReminderToHomeMutation, { data, loading, error }] = usePackageReminderToHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePackageReminderToHomeMutation(baseOptions?: Apollo.MutationHookOptions<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>(PackageReminderToHomeDocument, options);
      }
export type PackageReminderToHomeMutationHookResult = ReturnType<typeof usePackageReminderToHomeMutation>;
export type PackageReminderToHomeMutationResult = Apollo.MutationResult<PackageReminderToHomeMutation>;
export type PackageReminderToHomeMutationOptions = Apollo.BaseMutationOptions<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>;
export const CreateApplicantAndApplicationDocument = gql`
    mutation CreateApplicantAndApplication($input: CreateApplicantAndApplicationInput!) {
  createApplicantAndApplication(input: $input) {
    applicant {
      id
      user {
        id
      }
    }
  }
}
    `;
export type CreateApplicantAndApplicationMutationFn = Apollo.MutationFunction<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>;

/**
 * __useCreateApplicantAndApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicantAndApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicantAndApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicantAndApplicationMutation, { data, loading, error }] = useCreateApplicantAndApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicantAndApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>(CreateApplicantAndApplicationDocument, options);
      }
export type CreateApplicantAndApplicationMutationHookResult = ReturnType<typeof useCreateApplicantAndApplicationMutation>;
export type CreateApplicantAndApplicationMutationResult = Apollo.MutationResult<CreateApplicantAndApplicationMutation>;
export type CreateApplicantAndApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>;
export const CollectPackagesDocument = gql`
    mutation CollectPackages($input: CollectPackagesInput!) {
  collectPackages(input: $input) {
    packages {
      id
      status
      collectedOn
      collectedBy {
        id
        name
      }
      home {
        id
        uncollectedPackageCount
      }
    }
  }
}
    `;
export type CollectPackagesMutationFn = Apollo.MutationFunction<CollectPackagesMutation, CollectPackagesMutationVariables>;

/**
 * __useCollectPackagesMutation__
 *
 * To run a mutation, you first call `useCollectPackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectPackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectPackagesMutation, { data, loading, error }] = useCollectPackagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectPackagesMutation(baseOptions?: Apollo.MutationHookOptions<CollectPackagesMutation, CollectPackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectPackagesMutation, CollectPackagesMutationVariables>(CollectPackagesDocument, options);
      }
export type CollectPackagesMutationHookResult = ReturnType<typeof useCollectPackagesMutation>;
export type CollectPackagesMutationResult = Apollo.MutationResult<CollectPackagesMutation>;
export type CollectPackagesMutationOptions = Apollo.BaseMutationOptions<CollectPackagesMutation, CollectPackagesMutationVariables>;
export const PackageDocument = gql`
    query Package($id: UUID!) {
  package(id: $id) {
    id
    createdAt
    status
    image
    home {
      id
      name
      addressLine1
      postcode
      community {
        id
        name
      }
    }
    addressee
    collectedOn
    collectedBy {
      id
      name
    }
    scannedInBy {
      id
      name
    }
    reminders {
      id
      createdAt
      user {
        id
        name
      }
    }
    location
  }
}
    `;

/**
 * __usePackageQuery__
 *
 * To run a query within a React component, call `usePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackageQuery(baseOptions: Apollo.QueryHookOptions<PackageQuery, PackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageQuery, PackageQueryVariables>(PackageDocument, options);
      }
export function usePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageQuery, PackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageQuery, PackageQueryVariables>(PackageDocument, options);
        }
export type PackageQueryHookResult = ReturnType<typeof usePackageQuery>;
export type PackageLazyQueryHookResult = ReturnType<typeof usePackageLazyQuery>;
export type PackageQueryResult = Apollo.QueryResult<PackageQuery, PackageQueryVariables>;
export const RemindResidentDocument = gql`
    mutation RemindResident($input: RemindResidentInput!) {
  remindResident(input: $input) {
    id
  }
}
    `;
export type RemindResidentMutationFn = Apollo.MutationFunction<RemindResidentMutation, RemindResidentMutationVariables>;

/**
 * __useRemindResidentMutation__
 *
 * To run a mutation, you first call `useRemindResidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindResidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindResidentMutation, { data, loading, error }] = useRemindResidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemindResidentMutation(baseOptions?: Apollo.MutationHookOptions<RemindResidentMutation, RemindResidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemindResidentMutation, RemindResidentMutationVariables>(RemindResidentDocument, options);
      }
export type RemindResidentMutationHookResult = ReturnType<typeof useRemindResidentMutation>;
export type RemindResidentMutationResult = Apollo.MutationResult<RemindResidentMutation>;
export type RemindResidentMutationOptions = Apollo.BaseMutationOptions<RemindResidentMutation, RemindResidentMutationVariables>;
export const HomesWithPackagesDocument = gql`
    query HomesWithPackages($after: String, $icontainsSearch: String, $communities: [ID!], $orderBy: String) {
  homes(
    after: $after
    icontainsSearch: $icontainsSearch
    communities: $communities
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        addressLine1
        city
        postcode
        community {
          id
          name
        }
        uncollectedPackageCount
      }
    }
  }
}
    `;

/**
 * __useHomesWithPackagesQuery__
 *
 * To run a query within a React component, call `useHomesWithPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomesWithPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomesWithPackagesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      icontainsSearch: // value for 'icontainsSearch'
 *      communities: // value for 'communities'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useHomesWithPackagesQuery(baseOptions?: Apollo.QueryHookOptions<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>(HomesWithPackagesDocument, options);
      }
export function useHomesWithPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>(HomesWithPackagesDocument, options);
        }
export type HomesWithPackagesQueryHookResult = ReturnType<typeof useHomesWithPackagesQuery>;
export type HomesWithPackagesLazyQueryHookResult = ReturnType<typeof useHomesWithPackagesLazyQuery>;
export type HomesWithPackagesQueryResult = Apollo.QueryResult<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>;
export const ListPackagesDocument = gql`
    query listPackages($after: String, $search: String, $status: String, $communities: [ID!], $orderBy: String) {
  packages(
    after: $after
    search: $search
    status: $status
    communities: $communities
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        status
        collectedOn
        addressee
        home {
          name
          addressLine1
          postcode
          community {
            id
            name
          }
        }
        location
      }
    }
  }
}
    `;

/**
 * __useListPackagesQuery__
 *
 * To run a query within a React component, call `useListPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPackagesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      communities: // value for 'communities'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListPackagesQuery(baseOptions?: Apollo.QueryHookOptions<ListPackagesQuery, ListPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPackagesQuery, ListPackagesQueryVariables>(ListPackagesDocument, options);
      }
export function useListPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPackagesQuery, ListPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPackagesQuery, ListPackagesQueryVariables>(ListPackagesDocument, options);
        }
export type ListPackagesQueryHookResult = ReturnType<typeof useListPackagesQuery>;
export type ListPackagesLazyQueryHookResult = ReturnType<typeof useListPackagesLazyQuery>;
export type ListPackagesQueryResult = Apollo.QueryResult<ListPackagesQuery, ListPackagesQueryVariables>;
export const PackageReminderToAllDocument = gql`
    mutation PackageReminderToAll($communities: [UUID]!) {
  packageReminderToAll(communities: $communities) {
    packages {
      id
      reminders {
        id
        createdAt
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;
export type PackageReminderToAllMutationFn = Apollo.MutationFunction<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>;

/**
 * __usePackageReminderToAllMutation__
 *
 * To run a mutation, you first call `usePackageReminderToAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackageReminderToAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packageReminderToAllMutation, { data, loading, error }] = usePackageReminderToAllMutation({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function usePackageReminderToAllMutation(baseOptions?: Apollo.MutationHookOptions<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>(PackageReminderToAllDocument, options);
      }
export type PackageReminderToAllMutationHookResult = ReturnType<typeof usePackageReminderToAllMutation>;
export type PackageReminderToAllMutationResult = Apollo.MutationResult<PackageReminderToAllMutation>;
export type PackageReminderToAllMutationOptions = Apollo.BaseMutationOptions<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>;
export const AccountTransactionsDocument = gql`
    query AccountTransactions($after: String, $search: String, $communities: [ID!]) {
  accountTransactions(
    after: $after
    search: $search
    orderBy: "-createdAt"
    communities: $communities
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...AccountTransactionItem
      }
    }
  }
}
    ${AccountTransactionItemFragmentDoc}`;

/**
 * __useAccountTransactionsQuery__
 *
 * To run a query within a React component, call `useAccountTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTransactionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useAccountTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<AccountTransactionsQuery, AccountTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountTransactionsQuery, AccountTransactionsQueryVariables>(AccountTransactionsDocument, options);
      }
export function useAccountTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountTransactionsQuery, AccountTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountTransactionsQuery, AccountTransactionsQueryVariables>(AccountTransactionsDocument, options);
        }
export type AccountTransactionsQueryHookResult = ReturnType<typeof useAccountTransactionsQuery>;
export type AccountTransactionsLazyQueryHookResult = ReturnType<typeof useAccountTransactionsLazyQuery>;
export type AccountTransactionsQueryResult = Apollo.QueryResult<AccountTransactionsQuery, AccountTransactionsQueryVariables>;
export const ProfileNotificationSettingsDocument = gql`
    query ProfileNotificationSettings {
  getManager {
    id
    emailPreferences
  }
}
    `;

/**
 * __useProfileNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useProfileNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>(ProfileNotificationSettingsDocument, options);
      }
export function useProfileNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>(ProfileNotificationSettingsDocument, options);
        }
export type ProfileNotificationSettingsQueryHookResult = ReturnType<typeof useProfileNotificationSettingsQuery>;
export type ProfileNotificationSettingsLazyQueryHookResult = ReturnType<typeof useProfileNotificationSettingsLazyQuery>;
export type ProfileNotificationSettingsQueryResult = Apollo.QueryResult<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>;
export const UpdateManagerDocument = gql`
    mutation updateManager($input: UpdateManagerInput!) {
  updateManager(input: $input) {
    manager {
      id
    }
  }
}
    `;
export type UpdateManagerMutationFn = Apollo.MutationFunction<UpdateManagerMutation, UpdateManagerMutationVariables>;

/**
 * __useUpdateManagerMutation__
 *
 * To run a mutation, you first call `useUpdateManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagerMutation, { data, loading, error }] = useUpdateManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagerMutation, UpdateManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManagerMutation, UpdateManagerMutationVariables>(UpdateManagerDocument, options);
      }
export type UpdateManagerMutationHookResult = ReturnType<typeof useUpdateManagerMutation>;
export type UpdateManagerMutationResult = Apollo.MutationResult<UpdateManagerMutation>;
export type UpdateManagerMutationOptions = Apollo.BaseMutationOptions<UpdateManagerMutation, UpdateManagerMutationVariables>;
export const UpdateManagerNotificationSettingsDocument = gql`
    mutation updateManagerNotificationSettings($input: UpdateManagerNotificationSettingsInput!) {
  updateManagerNotificationSettings(input: $input) {
    manager {
      id
      emailPreferences
    }
  }
}
    `;
export type UpdateManagerNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>;

/**
 * __useUpdateManagerNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateManagerNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagerNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagerNotificationSettingsMutation, { data, loading, error }] = useUpdateManagerNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManagerNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>(UpdateManagerNotificationSettingsDocument, options);
      }
export type UpdateManagerNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateManagerNotificationSettingsMutation>;
export type UpdateManagerNotificationSettingsMutationResult = Apollo.MutationResult<UpdateManagerNotificationSettingsMutation>;
export type UpdateManagerNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>;
export const UpdateMobileDocument = gql`
    mutation UpdateMobile($input: UpdateUserMobileNumberInput!) {
  updateMobileNumber(input: $input) {
    error
    user {
      id
      email
      mobile
    }
  }
}
    `;
export type UpdateMobileMutationFn = Apollo.MutationFunction<UpdateMobileMutation, UpdateMobileMutationVariables>;

/**
 * __useUpdateMobileMutation__
 *
 * To run a mutation, you first call `useUpdateMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMobileMutation, { data, loading, error }] = useUpdateMobileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMobileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMobileMutation, UpdateMobileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMobileMutation, UpdateMobileMutationVariables>(UpdateMobileDocument, options);
      }
export type UpdateMobileMutationHookResult = ReturnType<typeof useUpdateMobileMutation>;
export type UpdateMobileMutationResult = Apollo.MutationResult<UpdateMobileMutation>;
export type UpdateMobileMutationOptions = Apollo.BaseMutationOptions<UpdateMobileMutation, UpdateMobileMutationVariables>;
export const ApplicationDetailsDocument = gql`
    query ApplicationDetails($id: UUID!) {
  tenancyApplication(id: $id) {
    id
    applicantNames
    combinedAffordability
    affordabilityStatus
    rentAmount
    completedOn
    status
    home {
      id
      address
      community {
        id
        name
      }
    }
    applicants {
      edges {
        node {
          ...TenancyApplicantItem
        }
      }
    }
  }
}
    ${TenancyApplicantItemFragmentDoc}`;

/**
 * __useApplicationDetailsQuery__
 *
 * To run a query within a React component, call `useApplicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationDetailsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>(ApplicationDetailsDocument, options);
      }
export function useApplicationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>(ApplicationDetailsDocument, options);
        }
export type ApplicationDetailsQueryHookResult = ReturnType<typeof useApplicationDetailsQuery>;
export type ApplicationDetailsLazyQueryHookResult = ReturnType<typeof useApplicationDetailsLazyQuery>;
export type ApplicationDetailsQueryResult = Apollo.QueryResult<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>;
export const CreateTenancyApplicationDocument = gql`
    mutation CreateTenancyApplication($input: CreateTenancyApplicationInput!) {
  createTenancyApplication(input: $input) {
    tenancyApplication {
      id
    }
  }
}
    `;
export type CreateTenancyApplicationMutationFn = Apollo.MutationFunction<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>;

/**
 * __useCreateTenancyApplicationMutation__
 *
 * To run a mutation, you first call `useCreateTenancyApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenancyApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenancyApplicationMutation, { data, loading, error }] = useCreateTenancyApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTenancyApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>(CreateTenancyApplicationDocument, options);
      }
export type CreateTenancyApplicationMutationHookResult = ReturnType<typeof useCreateTenancyApplicationMutation>;
export type CreateTenancyApplicationMutationResult = Apollo.MutationResult<CreateTenancyApplicationMutation>;
export type CreateTenancyApplicationMutationOptions = Apollo.BaseMutationOptions<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>;
export const ReferencingDisabledCommunitiesDocument = gql`
    query ReferencingDisabledCommunities {
  getUser {
    id
    manager {
      id
      community(referencingEnabled: false) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReferencingDisabledCommunitiesQuery__
 *
 * To run a query within a React component, call `useReferencingDisabledCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencingDisabledCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencingDisabledCommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferencingDisabledCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>(ReferencingDisabledCommunitiesDocument, options);
      }
export function useReferencingDisabledCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>(ReferencingDisabledCommunitiesDocument, options);
        }
export type ReferencingDisabledCommunitiesQueryHookResult = ReturnType<typeof useReferencingDisabledCommunitiesQuery>;
export type ReferencingDisabledCommunitiesLazyQueryHookResult = ReturnType<typeof useReferencingDisabledCommunitiesLazyQuery>;
export type ReferencingDisabledCommunitiesQueryResult = Apollo.QueryResult<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>;
export const TenancyApplicationCountsDocument = gql`
    query TenancyApplicationCounts($search: String, $communities: [ID!]) {
  waitingApplications: tenancyApplications(
    status: ["WAITING"]
    search: $search
    communities: $communities
  ) {
    totalCount
  }
  issueApplications: tenancyApplications(
    status: ["CAUTION", "FAILED"]
    search: $search
    communities: $communities
  ) {
    totalCount
  }
  passedApplications: tenancyApplications(
    status: ["COMPLETED"]
    search: $search
    communities: $communities
  ) {
    totalCount
  }
  totalApplications: tenancyApplications(
    search: $search
    communities: $communities
  ) {
    totalCount
  }
}
    `;

/**
 * __useTenancyApplicationCountsQuery__
 *
 * To run a query within a React component, call `useTenancyApplicationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenancyApplicationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenancyApplicationCountsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useTenancyApplicationCountsQuery(baseOptions?: Apollo.QueryHookOptions<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>(TenancyApplicationCountsDocument, options);
      }
export function useTenancyApplicationCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>(TenancyApplicationCountsDocument, options);
        }
export type TenancyApplicationCountsQueryHookResult = ReturnType<typeof useTenancyApplicationCountsQuery>;
export type TenancyApplicationCountsLazyQueryHookResult = ReturnType<typeof useTenancyApplicationCountsLazyQuery>;
export type TenancyApplicationCountsQueryResult = Apollo.QueryResult<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>;
export const TenancyApplicationsDocument = gql`
    query TenancyApplications($after: String, $search: String, $status: [String], $communities: [ID!]) {
  tenancyApplications(
    after: $after
    status: $status
    search: $search
    communities: $communities
  ) {
    edges {
      node {
        ...TenancyApplicationItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${TenancyApplicationItemFragmentDoc}`;

/**
 * __useTenancyApplicationsQuery__
 *
 * To run a query within a React component, call `useTenancyApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenancyApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenancyApplicationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useTenancyApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>(TenancyApplicationsDocument, options);
      }
export function useTenancyApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>(TenancyApplicationsDocument, options);
        }
export type TenancyApplicationsQueryHookResult = ReturnType<typeof useTenancyApplicationsQuery>;
export type TenancyApplicationsLazyQueryHookResult = ReturnType<typeof useTenancyApplicationsLazyQuery>;
export type TenancyApplicationsQueryResult = Apollo.QueryResult<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>;
export const CloseSurveyDocument = gql`
    mutation CloseSurvey($id: UUID!) {
  closeSurvey(id: $id) {
    survey {
      id
      status
    }
  }
}
    `;
export type CloseSurveyMutationFn = Apollo.MutationFunction<CloseSurveyMutation, CloseSurveyMutationVariables>;

/**
 * __useCloseSurveyMutation__
 *
 * To run a mutation, you first call `useCloseSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeSurveyMutation, { data, loading, error }] = useCloseSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CloseSurveyMutation, CloseSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseSurveyMutation, CloseSurveyMutationVariables>(CloseSurveyDocument, options);
      }
export type CloseSurveyMutationHookResult = ReturnType<typeof useCloseSurveyMutation>;
export type CloseSurveyMutationResult = Apollo.MutationResult<CloseSurveyMutation>;
export type CloseSurveyMutationOptions = Apollo.BaseMutationOptions<CloseSurveyMutation, CloseSurveyMutationVariables>;
export const CreateSurveyDocument = gql`
    mutation CreateSurvey($input: CreateSurveyInput!) {
  createSurvey(input: $input) {
    id
    question
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSurveyMutationFn = Apollo.MutationFunction<CreateSurveyMutation, CreateSurveyMutationVariables>;

/**
 * __useCreateSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyMutation, { data, loading, error }] = useCreateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyMutation, CreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, options);
      }
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>;
export type CreateSurveyMutationResult = Apollo.MutationResult<CreateSurveyMutation>;
export type CreateSurveyMutationOptions = Apollo.BaseMutationOptions<CreateSurveyMutation, CreateSurveyMutationVariables>;
export const FindSurveyDocument = gql`
    query FindSurvey($id: UUID!) {
  survey(id: $id) {
    id
    question
    createdAt
    status
    link
    totalResidents
    options {
      id
      option
      totalResidents
      residents {
        id
        user {
          id
          name
          email
        }
      }
    }
    groups {
      edges {
        node {
          id
          name
          community {
            id
            name
          }
        }
      }
    }
    answers {
      id
    }
  }
}
    `;

/**
 * __useFindSurveyQuery__
 *
 * To run a query within a React component, call `useFindSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindSurveyQuery(baseOptions: Apollo.QueryHookOptions<FindSurveyQuery, FindSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveyQuery, FindSurveyQueryVariables>(FindSurveyDocument, options);
      }
export function useFindSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveyQuery, FindSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveyQuery, FindSurveyQueryVariables>(FindSurveyDocument, options);
        }
export type FindSurveyQueryHookResult = ReturnType<typeof useFindSurveyQuery>;
export type FindSurveyLazyQueryHookResult = ReturnType<typeof useFindSurveyLazyQuery>;
export type FindSurveyQueryResult = Apollo.QueryResult<FindSurveyQuery, FindSurveyQueryVariables>;
export const SurveyResultsCsvDocument = gql`
    query SurveyResultsCsv($id: UUID!) {
  survey(id: $id) {
    rawCsv
  }
}
    `;

/**
 * __useSurveyResultsCsvQuery__
 *
 * To run a query within a React component, call `useSurveyResultsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyResultsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyResultsCsvQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyResultsCsvQuery(baseOptions: Apollo.QueryHookOptions<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>(SurveyResultsCsvDocument, options);
      }
export function useSurveyResultsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>(SurveyResultsCsvDocument, options);
        }
export type SurveyResultsCsvQueryHookResult = ReturnType<typeof useSurveyResultsCsvQuery>;
export type SurveyResultsCsvLazyQueryHookResult = ReturnType<typeof useSurveyResultsCsvLazyQuery>;
export type SurveyResultsCsvQueryResult = Apollo.QueryResult<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>;
export const ListResidentSurveyDocument = gql`
    query ListResidentSurvey($communities: [ID], $after: String) {
  surveys(communities: $communities, after: $after, orderBy: "-createdAt") {
    edges {
      node {
        ...SurveyItem
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${SurveyItemFragmentDoc}`;

/**
 * __useListResidentSurveyQuery__
 *
 * To run a query within a React component, call `useListResidentSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResidentSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResidentSurveyQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListResidentSurveyQuery(baseOptions?: Apollo.QueryHookOptions<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>(ListResidentSurveyDocument, options);
      }
export function useListResidentSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>(ListResidentSurveyDocument, options);
        }
export type ListResidentSurveyQueryHookResult = ReturnType<typeof useListResidentSurveyQuery>;
export type ListResidentSurveyLazyQueryHookResult = ReturnType<typeof useListResidentSurveyLazyQuery>;
export type ListResidentSurveyQueryResult = Apollo.QueryResult<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>;
export const CommunityUpdateCommentsDocument = gql`
    query CommunityUpdateComments($id: UUID!, $after: String) {
  communityUpdate(id: $id) {
    comments(after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
          comment
          createdAt
          userType
        }
      }
    }
  }
}
    `;

/**
 * __useCommunityUpdateCommentsQuery__
 *
 * To run a query within a React component, call `useCommunityUpdateCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityUpdateCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityUpdateCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityUpdateCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>(CommunityUpdateCommentsDocument, options);
      }
export function useCommunityUpdateCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>(CommunityUpdateCommentsDocument, options);
        }
export type CommunityUpdateCommentsQueryHookResult = ReturnType<typeof useCommunityUpdateCommentsQuery>;
export type CommunityUpdateCommentsLazyQueryHookResult = ReturnType<typeof useCommunityUpdateCommentsLazyQuery>;
export type CommunityUpdateCommentsQueryResult = Apollo.QueryResult<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>;
export const CreateUpdateCommentDocument = gql`
    mutation CreateUpdateComment($input: CreateUpdateCommentInput!) {
  createUpdateComment(input: $input) {
    communityUpdateComment {
      comment
    }
  }
}
    `;
export type CreateUpdateCommentMutationFn = Apollo.MutationFunction<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>;

/**
 * __useCreateUpdateCommentMutation__
 *
 * To run a mutation, you first call `useCreateUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateCommentMutation, { data, loading, error }] = useCreateUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>(CreateUpdateCommentDocument, options);
      }
export type CreateUpdateCommentMutationHookResult = ReturnType<typeof useCreateUpdateCommentMutation>;
export type CreateUpdateCommentMutationResult = Apollo.MutationResult<CreateUpdateCommentMutation>;
export type CreateUpdateCommentMutationOptions = Apollo.BaseMutationOptions<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>;
export const DeleteUpdateCommentDocument = gql`
    mutation DeleteUpdateComment($input: DeleteCommunityUpdateCommentInput!) {
  deleteUpdateComment(input: $input) {
    id
  }
}
    `;
export type DeleteUpdateCommentMutationFn = Apollo.MutationFunction<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>;

/**
 * __useDeleteUpdateCommentMutation__
 *
 * To run a mutation, you first call `useDeleteUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUpdateCommentMutation, { data, loading, error }] = useDeleteUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>(DeleteUpdateCommentDocument, options);
      }
export type DeleteUpdateCommentMutationHookResult = ReturnType<typeof useDeleteUpdateCommentMutation>;
export type DeleteUpdateCommentMutationResult = Apollo.MutationResult<DeleteUpdateCommentMutation>;
export type DeleteUpdateCommentMutationOptions = Apollo.BaseMutationOptions<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>;
export const CancelScheduledPublishCommunityUpdateDocument = gql`
    mutation CancelScheduledPublishCommunityUpdate($input: CancelScheduledPublishCommunityUpdateInput!) {
  cancelScheduledPublishCommunityUpdate(input: $input) {
    communityUpdate {
      id
      status
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CancelScheduledPublishCommunityUpdateMutationFn = Apollo.MutationFunction<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>;

/**
 * __useCancelScheduledPublishCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useCancelScheduledPublishCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledPublishCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledPublishCommunityUpdateMutation, { data, loading, error }] = useCancelScheduledPublishCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelScheduledPublishCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>(CancelScheduledPublishCommunityUpdateDocument, options);
      }
export type CancelScheduledPublishCommunityUpdateMutationHookResult = ReturnType<typeof useCancelScheduledPublishCommunityUpdateMutation>;
export type CancelScheduledPublishCommunityUpdateMutationResult = Apollo.MutationResult<CancelScheduledPublishCommunityUpdateMutation>;
export type CancelScheduledPublishCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>;
export const LocalesForGroupsDocument = gql`
    query LocalesForGroups($ids: [UUID!]!) {
  communityGroups(ids: $ids) {
    locales
  }
}
    `;

/**
 * __useLocalesForGroupsQuery__
 *
 * To run a query within a React component, call `useLocalesForGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalesForGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalesForGroupsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLocalesForGroupsQuery(baseOptions: Apollo.QueryHookOptions<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>(LocalesForGroupsDocument, options);
      }
export function useLocalesForGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>(LocalesForGroupsDocument, options);
        }
export type LocalesForGroupsQueryHookResult = ReturnType<typeof useLocalesForGroupsQuery>;
export type LocalesForGroupsLazyQueryHookResult = ReturnType<typeof useLocalesForGroupsLazyQuery>;
export type LocalesForGroupsQueryResult = Apollo.QueryResult<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>;
export const PreviewCommunityUpdateVariantsDocument = gql`
    query PreviewCommunityUpdateVariants($id: UUID!) {
  communityUpdate(id: $id) {
    id
    title
    body
    publishedAt
    summary
    category
    image
    attachment
    imageUrl
    stats {
      totalLikes
    }
    variants {
      edges {
        node {
          id
          locale
          title
          summary
          body
          status
        }
      }
    }
  }
}
    `;

/**
 * __usePreviewCommunityUpdateVariantsQuery__
 *
 * To run a query within a React component, call `usePreviewCommunityUpdateVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCommunityUpdateVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCommunityUpdateVariantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewCommunityUpdateVariantsQuery(baseOptions: Apollo.QueryHookOptions<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>(PreviewCommunityUpdateVariantsDocument, options);
      }
export function usePreviewCommunityUpdateVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>(PreviewCommunityUpdateVariantsDocument, options);
        }
export type PreviewCommunityUpdateVariantsQueryHookResult = ReturnType<typeof usePreviewCommunityUpdateVariantsQuery>;
export type PreviewCommunityUpdateVariantsLazyQueryHookResult = ReturnType<typeof usePreviewCommunityUpdateVariantsLazyQuery>;
export type PreviewCommunityUpdateVariantsQueryResult = Apollo.QueryResult<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>;
export const PublishCommunityUpdateDocument = gql`
    mutation PublishCommunityUpdate($input: PublishCommunityUpdateInput!) {
  publishCommunityUpdate(input: $input) {
    communityUpdate {
      id
      status
      publishedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type PublishCommunityUpdateMutationFn = Apollo.MutationFunction<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>;

/**
 * __usePublishCommunityUpdateMutation__
 *
 * To run a mutation, you first call `usePublishCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCommunityUpdateMutation, { data, loading, error }] = usePublishCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>(PublishCommunityUpdateDocument, options);
      }
export type PublishCommunityUpdateMutationHookResult = ReturnType<typeof usePublishCommunityUpdateMutation>;
export type PublishCommunityUpdateMutationResult = Apollo.MutationResult<PublishCommunityUpdateMutation>;
export type PublishCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>;
export const SchedulePublishCommunityUpdateDocument = gql`
    mutation SchedulePublishCommunityUpdate($input: SchedulePublishCommunityUpdateInput!) {
  schedulePublishCommunityUpdate(input: $input) {
    communityUpdate {
      id
      status
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SchedulePublishCommunityUpdateMutationFn = Apollo.MutationFunction<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>;

/**
 * __useSchedulePublishCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useSchedulePublishCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulePublishCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulePublishCommunityUpdateMutation, { data, loading, error }] = useSchedulePublishCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchedulePublishCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>(SchedulePublishCommunityUpdateDocument, options);
      }
export type SchedulePublishCommunityUpdateMutationHookResult = ReturnType<typeof useSchedulePublishCommunityUpdateMutation>;
export type SchedulePublishCommunityUpdateMutationResult = Apollo.MutationResult<SchedulePublishCommunityUpdateMutation>;
export type SchedulePublishCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>;
export const CommunityUpdateDocument = gql`
    query CommunityUpdate($id: UUID!) {
  communityUpdate(id: $id) {
    id
    title
    body
    summary
    category
    image
    attachment
    isArk
    publishedAt
    scheduledFor
    imageUrl
    imageSearchTerm
    groups {
      locales
      edges {
        node {
          id
          name
          community {
            id
            name
            commentsEnabled
          }
        }
      }
    }
    variants {
      edges {
        node {
          id
          locale
        }
      }
    }
    status
    stats {
      totalLikes
      totalReads
      totalComments
    }
  }
}
    `;

/**
 * __useCommunityUpdateQuery__
 *
 * To run a query within a React component, call `useCommunityUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityUpdateQuery(baseOptions: Apollo.QueryHookOptions<CommunityUpdateQuery, CommunityUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityUpdateQuery, CommunityUpdateQueryVariables>(CommunityUpdateDocument, options);
      }
export function useCommunityUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityUpdateQuery, CommunityUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityUpdateQuery, CommunityUpdateQueryVariables>(CommunityUpdateDocument, options);
        }
export type CommunityUpdateQueryHookResult = ReturnType<typeof useCommunityUpdateQuery>;
export type CommunityUpdateLazyQueryHookResult = ReturnType<typeof useCommunityUpdateLazyQuery>;
export type CommunityUpdateQueryResult = Apollo.QueryResult<CommunityUpdateQuery, CommunityUpdateQueryVariables>;
export const DeleteCommunityUpdateDocument = gql`
    mutation DeleteCommunityUpdate($input: DeleteCommunityUpdateInput!) {
  deleteCommunityUpdate(input: $input) {
    id
  }
}
    `;
export type DeleteCommunityUpdateMutationFn = Apollo.MutationFunction<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>;

/**
 * __useDeleteCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityUpdateMutation, { data, loading, error }] = useDeleteCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>(DeleteCommunityUpdateDocument, options);
      }
export type DeleteCommunityUpdateMutationHookResult = ReturnType<typeof useDeleteCommunityUpdateMutation>;
export type DeleteCommunityUpdateMutationResult = Apollo.MutationResult<DeleteCommunityUpdateMutation>;
export type DeleteCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>;
export const SaveCommunityUpdateDocument = gql`
    mutation SaveCommunityUpdate($input: SaveCommunityUpdateInput!) {
  saveCommunityUpdate(input: $input) {
    id
    title
    summary
    body
    category
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveCommunityUpdateMutationFn = Apollo.MutationFunction<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>;

/**
 * __useSaveCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useSaveCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommunityUpdateMutation, { data, loading, error }] = useSaveCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>(SaveCommunityUpdateDocument, options);
      }
export type SaveCommunityUpdateMutationHookResult = ReturnType<typeof useSaveCommunityUpdateMutation>;
export type SaveCommunityUpdateMutationResult = Apollo.MutationResult<SaveCommunityUpdateMutation>;
export type SaveCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>;
export const CommunityUpdatesDocument = gql`
    query CommunityUpdates($communities: [ID], $search: String, $after: String) {
  communityUpdates(
    communities: $communities
    search: $search
    after: $after
    orderBy: "-published_at"
  ) {
    edges {
      node {
        id
        title
        summary
        image
        imageUrl
        category
        publishedAt
        stats {
          totalLikes
          totalReads
          totalComments
        }
        status
        groups {
          edges {
            node {
              id
              name
              community {
                name
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useCommunityUpdatesQuery__
 *
 * To run a query within a React component, call `useCommunityUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityUpdatesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>(CommunityUpdatesDocument, options);
      }
export function useCommunityUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>(CommunityUpdatesDocument, options);
        }
export type CommunityUpdatesQueryHookResult = ReturnType<typeof useCommunityUpdatesQuery>;
export type CommunityUpdatesLazyQueryHookResult = ReturnType<typeof useCommunityUpdatesLazyQuery>;
export type CommunityUpdatesQueryResult = Apollo.QueryResult<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>;
export const SignOutCommunityVisitorDocument = gql`
    mutation SignOutCommunityVisitor($input: SignOutCommunityVisitorInput!) {
  signOutCommunityVisitor(input: $input) {
    communityVisitor {
      id
      signedOutAt
    }
  }
}
    `;
export type SignOutCommunityVisitorMutationFn = Apollo.MutationFunction<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>;

/**
 * __useSignOutCommunityVisitorMutation__
 *
 * To run a mutation, you first call `useSignOutCommunityVisitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutCommunityVisitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutCommunityVisitorMutation, { data, loading, error }] = useSignOutCommunityVisitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignOutCommunityVisitorMutation(baseOptions?: Apollo.MutationHookOptions<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>(SignOutCommunityVisitorDocument, options);
      }
export type SignOutCommunityVisitorMutationHookResult = ReturnType<typeof useSignOutCommunityVisitorMutation>;
export type SignOutCommunityVisitorMutationResult = Apollo.MutationResult<SignOutCommunityVisitorMutation>;
export type SignOutCommunityVisitorMutationOptions = Apollo.BaseMutationOptions<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>;
export const VisitorDocument = gql`
    query Visitor($id: UUID!) {
  communityVisitor(id: $id) {
    id
    name
    email
    mobile
    createdAt
    residentName
    reasonForVisit
    signedOutAt
    vehicleRegistration
    community {
      id
      name
    }
    type
  }
}
    `;

/**
 * __useVisitorQuery__
 *
 * To run a query within a React component, call `useVisitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVisitorQuery(baseOptions: Apollo.QueryHookOptions<VisitorQuery, VisitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorQuery, VisitorQueryVariables>(VisitorDocument, options);
      }
export function useVisitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorQuery, VisitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorQuery, VisitorQueryVariables>(VisitorDocument, options);
        }
export type VisitorQueryHookResult = ReturnType<typeof useVisitorQuery>;
export type VisitorLazyQueryHookResult = ReturnType<typeof useVisitorLazyQuery>;
export type VisitorQueryResult = Apollo.QueryResult<VisitorQuery, VisitorQueryVariables>;
export const VisitorsDocument = gql`
    query Visitors($after: String, $search: String, $communities: [ID!]) {
  communityVisitors(after: $after, search: $search, communities: $communities) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...VisitorItem
      }
    }
  }
}
    ${VisitorItemFragmentDoc}`;

/**
 * __useVisitorsQuery__
 *
 * To run a query within a React component, call `useVisitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitorsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useVisitorsQuery(baseOptions?: Apollo.QueryHookOptions<VisitorsQuery, VisitorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorsQuery, VisitorsQueryVariables>(VisitorsDocument, options);
      }
export function useVisitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorsQuery, VisitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorsQuery, VisitorsQueryVariables>(VisitorsDocument, options);
        }
export type VisitorsQueryHookResult = ReturnType<typeof useVisitorsQuery>;
export type VisitorsLazyQueryHookResult = ReturnType<typeof useVisitorsLazyQuery>;
export type VisitorsQueryResult = Apollo.QueryResult<VisitorsQuery, VisitorsQueryVariables>;
export const SendManagerAmplitudeTestDocument = gql`
    mutation sendManagerAmplitudeTest($input: SendManagerAmplitudeTestInput!) {
  sendManagerAmplitudeTest(input: $input) {
    manager {
      id
    }
  }
}
    `;
export type SendManagerAmplitudeTestMutationFn = Apollo.MutationFunction<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>;

/**
 * __useSendManagerAmplitudeTestMutation__
 *
 * To run a mutation, you first call `useSendManagerAmplitudeTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendManagerAmplitudeTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendManagerAmplitudeTestMutation, { data, loading, error }] = useSendManagerAmplitudeTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendManagerAmplitudeTestMutation(baseOptions?: Apollo.MutationHookOptions<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>(SendManagerAmplitudeTestDocument, options);
      }
export type SendManagerAmplitudeTestMutationHookResult = ReturnType<typeof useSendManagerAmplitudeTestMutation>;
export type SendManagerAmplitudeTestMutationResult = Apollo.MutationResult<SendManagerAmplitudeTestMutation>;
export type SendManagerAmplitudeTestMutationOptions = Apollo.BaseMutationOptions<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>;
export const ReferencingEnabledDocument = gql`
    query ReferencingEnabled {
  getUser {
    id
    manager {
      id
      community(referencingEnabled: true) {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useReferencingEnabledQuery__
 *
 * To run a query within a React component, call `useReferencingEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencingEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencingEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferencingEnabledQuery(baseOptions?: Apollo.QueryHookOptions<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>(ReferencingEnabledDocument, options);
      }
export function useReferencingEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>(ReferencingEnabledDocument, options);
        }
export type ReferencingEnabledQueryHookResult = ReturnType<typeof useReferencingEnabledQuery>;
export type ReferencingEnabledLazyQueryHookResult = ReturnType<typeof useReferencingEnabledLazyQuery>;
export type ReferencingEnabledQueryResult = Apollo.QueryResult<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>;